import {
  Companion_getInstance3f9e8v90vvgdj as Companion_getInstance,
  Level_ERROR_getInstance1195cgr5fzwj1 as Level_ERROR_getInstance,
  Level_TRACE_getInstance3nszimn1b6jmz as Level_TRACE_getInstance,
  Level_INFO_getInstance2u0wredwjoo6m as Level_INFO_getInstance,
  Level_WARN_getInstance2on3idagepyxv as Level_WARN_getInstance,
  Level_DEBUG_getInstance1gtvuokzl9cp4 as Level_DEBUG_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  constructCallableReference23y65rf941mch as constructCallableReference,
  toString1pkumu07cwy4m as toString,
  toString30pk9tzaqopn as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  println2shhhgwwt4c61 as println,
  DurationUnit_MICROSECONDS_getInstance2moeotkerjghe as DurationUnit_MICROSECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  printStackTrace18lnx7a39cni as printStackTrace,
  getKClass3t8tygqu4lcxf as getKClass,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  first58ocm7j58k3q as first,
  CoroutineContext3n9ge8bnnq7z2 as CoroutineContext,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll1k27qatfgp3k5 as addAll,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  Duration5ynfiptaqcrg as Duration,
  listOfvhqybd2zx248 as listOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  isNaNymqb93xtq8w8 as isNaN_0,
  to2cs3ny02qtbcb as to,
  Enum3alwj03lh1n41 as Enum,
  Duration__minus_impl_q5cfm73tf66w97h2wg9 as Duration__minus_impl_q5cfm7,
  Duration__compareTo_impl_pchp0f1g201z2whmah8 as Duration__compareTo_impl_pchp0f,
  DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance,
  CancellationException3b36o9qz53rgr as CancellationException,
  captureStack1fzi4aczwc4hg as captureStack,
  lazy2hsh8ze7j6ikd as lazy,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  emptyList1g2z5xcrvp2zy as emptyList,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  toList383f556t1dixk as toList,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  protoOf180f3jzyo7rfj as protoOf,
  KProperty02ce7r476m8633 as KProperty0,
  getLocalDelegateReference2ls94nvl5ojb2 as getLocalDelegateReference,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  numberToDouble210hrknaofnhf as numberToDouble,
  abs1kdzbjes1idip as abs,
  substringiqarkczpya5m as substring,
  until1jbpn0z3f8lbg as until,
  get_sign1dnxi33u9vk0c as get_sign,
  charCodeAt1yspne1d8erbm as charCodeAt,
  isLetterOrDigit2kuxd9e198haf as isLetterOrDigit,
  ArrayList3it5z8td81qkl as ArrayList,
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance_0,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  Companion_instance1co2nkledm2ru as Companion_instance,
  _Result___init__impl__xyqfz810za1hm0unrcw as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  indexOfa2zokh3tu4p6 as indexOf,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  compareTo3ankvs086tmwq as compareTo,
  sortWith4fnm6b3vw03s as sortWith,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  KtList3hktaavzmj137 as KtList,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  contains1tccixv8iwdcq as contains,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Duration__times_impl_sfuzvpvbfurc6ehsa8 as Duration__times_impl_sfuzvp,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  createFailure8paxfkfa5dc7 as createFailure,
  HashMap1a0ld5kgwhmhv as HashMap,
  DurationUnit_MILLISECONDS_getInstancesewns20u1dyn as DurationUnit_MILLISECONDS_getInstance,
  replace3le3ie7l9k8aq as replace,
  get_lastIndex327lnwnipm748 as get_lastIndex,
  countTrailingZeroBitszhs0313cn11e as countTrailingZeroBits,
  removeAll3o43e67jmwdpc as removeAll,
  Monotonic_instance2att21stfwfpk as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs593ou6p5l5hu as ValueTimeMark__elapsedNow_impl_eonqvs,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_RegisteredImageFormats243xf60qkmjxj as get_RegisteredImageFormats,
  Colors_getInstance3pptco3oesytn as Colors_getInstance,
  RGBA34obx2i62wcl3 as RGBA,
  RGBA__toString_impl_4lw6dphy5yaenoheku as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf61f7mvf3brfggb as RGBA__hashCode_impl_h59qf6,
  readBitmap1mzeobqc4iv0x as readBitmap,
  Bitmaps_instance7rskgm1vqxdg as Bitmaps_instance,
  get_Bitmaps_white37u58wbn8ngk2 as get_Bitmaps_white,
  RGBA__withAd_impl_cralao3tppw6lob1jl8 as RGBA__withAd_impl_cralao,
  Companion_getInstance3k5cs6pucdtn7 as Companion_getInstance_1,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstance1hhdzhwpqlcg8 as Companion_getInstance_2,
  Font2bg7nte760csr as Font,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
  get_bmpevghw2zw2fa7 as get_bmp,
  NativeImageOrBitmap3211fg7set8uiki as NativeImageOrBitmap32,
  slice2pfxfvku0ybgy as slice,
  get_isLow1k7uocm2ojjr8 as get_isLow,
  ShapeBuilderk05da5wk16e9 as ShapeBuilder,
  EmptyShape_instance3meesyokr70ly as EmptyShape_instance,
  readBitmapSlice88s6ccedkid9 as readBitmapSlice,
  HorizontalAlign__getOffsetX_impl_urzzxf1p1rgxoikghn1 as HorizontalAlign__getOffsetX_impl_urzzxf,
  VerticalAlign__getOffsetY_impl_iso0y61qg0x863lloin as VerticalAlign__getOffsetY_impl_iso0y6,
  Text2TextRendererActions1307nbc4pqqhs as Text2TextRendererActions,
  Entry3jfmfe0iy8gwc as Entry,
  FontMetrics1b1o1zbrk6cew as FontMetrics,
  TextMetrics1vfyzci74zdhy as TextMetrics,
  readFont9m5jston0h5k as readFont,
  BitmapFont35unsvaxq1brd as BitmapFont,
  getTextBoundsWithGlyphsa2ggkffutq4d as getTextBoundsWithGlyphs,
  getTextBoundsio1pfpt2q8ze as getTextBounds,
  TextMetricsResult1qr6b0fc6i56z as TextMetricsResult,
  invoke2ot88cm6qcfmr as invoke,
  LineInfo27uw564y6w2d2 as LineInfo,
  _HorizontalAlign___get_ratio__impl__x9wlea3hl94vdjlkzri as _HorizontalAlign___get_ratio__impl__x9wlea,
  _VerticalAlign___get_ratioFake__impl__1h2fwv35o79qpxi74bi as _VerticalAlign___get_ratioFake__impl__1h2fwv,
  Companion_getInstance7ct8khg4zvht as Companion_getInstance_3,
  ColorTransformMul2rawiv5hyxh9p as ColorTransformMul,
  _RGBA___get_hexString__impl__kocngmsbr7v8rutwo8 as _RGBA___get_hexString__impl__kocngm,
  _RGBA___get_rgb__impl__tijaqt35gwtq7wukg16 as _RGBA___get_rgb__impl__tijaqt,
  Companion_getInstance16xj8a4brdtzi as Companion_getInstance_4,
  _RGBA___get_premultiplied__impl__3bulqc1wh24booo6c8s as _RGBA___get_premultiplied__impl__3bulqc,
  Bitmap321klycakvwgb5w as Bitmap32,
  PolylineShape2w5p5crr94b97 as PolylineShape,
  FillShape13c5zk3dmjgcf as FillShape,
  TextShape3u9vrw15swk1x as TextShape,
  CompoundShape2jsp34o6wp7wp as CompoundShape,
  _RgbaPremultipliedArray___init__impl__lx83hy1hj7ki2yedww7 as _RgbaPremultipliedArray___init__impl__lx83hy,
  GradientPaint1uc4xuo0s2w8w as GradientPaint,
  BitmapPaintgyia0tdij0bl as BitmapPaint,
  NonePaint2h93brzruznft as NonePaint,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instance3esksx1cataey as Companion_instance_0,
  Companion_instance3359c3vnzyc2p as Companion_instance_1,
  Companion_getInstance9zqhf8dpcsyh as Companion_getInstance_5,
  DateTime2gld4ho36azq9 as DateTime,
  TimeProvider2j6wl2le6n0p3 as TimeProvider,
  DateTime__minus_impl_10njw82typsv56yegk5 as DateTime__minus_impl_10njw8,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds,
  FastDuration3d3pupg2e5ora as FastDuration,
  FastDuration__plus_impl_q1enab2deeoiodbc4f9 as FastDuration__plus_impl_q1enab,
  FastDuration__compareTo_impl_4fhnj7xnw2bvpwwoqp as FastDuration__compareTo_impl_4fhnj7,
  FastDuration__minus_impl_evs2371up2plcsbrg6i as FastDuration__minus_impl_evs237,
  get_fast37cu8s8qwnuyi as get_fast,
  get_DURATION_NIL2lkiawowwp1us as get_DURATION_NIL,
  FastDuration__times_impl_h6amcp2irgz9v0d229t as FastDuration__times_impl_h6amcp,
  FastDuration__div_impl_rlslck23i2lmaj3isnh as FastDuration__div_impl_rlslck,
  FastDuration__compareTo_impl_4fhnj72w7b7e2su2u98 as FastDuration__compareTo_impl_4fhnj7_0,
  _FastDuration___get_nanoseconds__impl__pxizcbxg17giquiyw7 as _FastDuration___get_nanoseconds__impl__pxizcb,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  get_slowaqovrrnrezzv as get_slow,
  _FastDuration___get_fastMilliseconds__impl__pe68va1resq1b2qoqfm as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds_0,
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  div1s6t4x2ts64sh as div,
  get_fastMicroseconds16wth98xujxdo as get_fastMicroseconds_0,
  _FastDuration___get_fastMicroseconds__impl__e641g1399tvkuf9u7kd as _FastDuration___get_fastMicroseconds__impl__e641g1,
  FastDuration__div_impl_rlslck2qwtwg3kyuov4 as FastDuration__div_impl_rlslck_0,
  toDuration15w5sljvx2ut2 as toDuration_0,
  FastDuration__toString_impl_c9xohb1l0tyd64jtg5n as FastDuration__toString_impl_c9xohb,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Injectorxjyp19tp5mfu as Injector,
  InjectorContextps0ngmjb9onz as InjectorContext,
  InjectorDependency2f8dsqe1kn3nn as InjectorDependency,
  injector2qmvxvrtuuv as injector,
} from './korlibs-inject-root-korlibs-inject.mjs';
import {
  Companion_getInstance3szcobow9wmlz as Companion_getInstance_6,
  DefaultViewport_getInstance1yi7see0bwoat as DefaultViewport_getInstance,
  Quality_PERFORMANCE_getInstancewqiidhb1r9s as Quality_PERFORMANCE_getInstance,
  GameWindowCreationConfigbzmga8g39et1 as GameWindowCreationConfig,
  configure1a7py4k2lj4vi as configure,
  Input3ljaq07eyi73v as Input,
  Statslnkcsgem8jjl as Stats,
  AGPrint2do8iynklt71b as AGPrint,
  GameWindow35197f3hcbh1b as GameWindow,
  KorgeReload_getInstance24edc14rslav7 as KorgeReload_getInstance,
  ResourcesRoot36ooexy6oq69y as ResourcesRoot,
  Kind_MOUSE_getInstance1jabstzrk0ec6 as Kind_MOUSE_getInstance,
  Type_START_getInstance2e0jinmwna1tz as Type_START_getInstance,
  Status_ADD_getInstance2usauldltvrb6 as Status_ADD_getInstance,
  Type_END_getInstance3eao74sd1qd1b as Type_END_getInstance,
  Status_REMOVE_getInstance1xhwemaqv4oj4 as Status_REMOVE_getInstance,
  Type_MOVE_getInstance7m6d8mwpvzbf as Type_MOVE_getInstance,
  Status_KEEP_getInstance159wlrdco02qg as Status_KEEP_getInstance,
  MouseButton_LEFT_getInstance2rob4difvxgbp as MouseButton_LEFT_getInstance,
  Type_DRAG_getInstance12o3o4jlcpnyg as Type_DRAG_getInstance,
  Type_UP_getInstance1o1bb50fkh1c5 as Type_UP_getInstance,
  Type_DOWN_getInstance399xdvliykbx6 as Type_DOWN_getInstance,
  configureLoggerFromPropertiesu0dqbv9031m1 as configureLoggerFromProperties,
  CoroutineKey_getInstance2zy7rqmvlms8 as CoroutineKey_getInstance,
  CreateDefaultGameWindow1l94icsbq4y8h as CreateDefaultGameWindow,
  AG35f0xk1ko87rh as AG,
  TouchEvent37l81isz00qgj as TouchEvent,
  Companion_getInstance1e8yqc9bjwiaq as Companion_getInstance_7,
  Companion_getInstance3hkuu8u35mryl as Companion_getInstance_8,
  Companion_getInstance17vhopkgtvy8p as Companion_getInstance_9,
  Companion_getInstance2l33cri3w6n7a as Companion_getInstance_10,
  Companion_instance3hz0cj4x3xzg2 as Companion_instance_2,
  Companion_instance2rq2pzgkkg46w as Companion_instance_3,
  Companion_instance2no0g6htzdf80 as Companion_instance_4,
  Companion_instance13unj2cvktx31 as Companion_instance_5,
  MouseEventmt8xebywpdp9 as MouseEvent,
  Companion_getInstance13eln6edm6kap as Companion_getInstance_11,
  Companion_getInstance2zuktdr3slbid as Companion_getInstance_12,
  Companion_instance3oj1nwe2awbwp as Companion_instance_6,
  Companion_instance2wc05lywres1 as Companion_instance_7,
  ReshapeEvent3137ki3m95agm as ReshapeEvent,
  Companion_instance2vknezzs3nrp5 as Companion_instance_8,
  Type_TYPE_getInstance1t3x0tyak50a5 as Type_TYPE_getInstance,
  Type_DOWN_getInstance2fsfrrfnfdnkv as Type_DOWN_getInstance_0,
  Type_UP_getInstance1jmusuq8uymiu as Type_UP_getInstance_0,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  Cursor_DEFAULT_getInstance2mvsp8zxmuifx as Cursor_DEFAULT_getInstance,
  Companion_getInstance2ux5z7lx1e789 as Companion_getInstance_13,
  drawText2ld6eqw3mc9xd as drawText,
  ScrollDeltaMode_PIXEL_getInstancev6fz8gd6s4o9 as ScrollDeltaMode_PIXEL_getInstance,
  ScrollDeltaMode_LINE_getInstancehzvmxoik4o8m as ScrollDeltaMode_LINE_getInstance,
  _interpolateRatio2cj6ldbl0g6ae as _interpolateRatio,
  V22su20mpwty0v0 as V2,
  ProgramBuilderDefault3573mhybddt0b as ProgramBuilderDefault,
  get_BB_MAX_TEXTURES19x2awozztfc7 as get_BB_MAX_TEXTURES,
  SDFShaders_getInstance36frvn0k1jot as SDFShaders_getInstance,
  FragmentShader2u3ycaqbgbmdi as FragmentShader,
  TextClipboardDatafimoftc14pmm as TextClipboardData,
  Key_X_getInstance3858vbsixd1dp as Key_X_getInstance,
  Key_BACKSPACE_getInstance2aui6g2v624ea as Key_BACKSPACE_getInstance,
  SoftKeyboardConfig3ue4h4egpkqhq as SoftKeyboardConfig,
  Companion_getInstance13vwvgsvlnrt4 as Companion_getInstance_14,
  Cursor_TEXT_getInstance1jekov1zaao91 as Cursor_TEXT_getInstance,
  ISoftKeyboardConfige7b4czi6ukd7 as ISoftKeyboardConfig,
  Companion_instancexdmb8g1de35k as Companion_instance_9,
  Key_TAB_getInstance29pqd1wanq7uj as Key_TAB_getInstance,
  BaseEventListener6clplq3qhf9k as BaseEventListener,
  Companion_getInstance3jm093zk2b8vy as Companion_getInstance_15,
  TextureBase31xvoisoo1pp7 as TextureBase,
  Texture39uvj3jju6ujd as Texture,
  AGScissor1lpa42gfyr1p2 as AGScissor,
  ProjViewUB_getInstance33tqqx5ip0jsm as ProjViewUB_getInstance,
  get_debugLineRenderContext3s3h9yq8a0rtj as get_debugLineRenderContext,
  Companion_getInstance3nsxj9pk2lmwe as Companion_getInstance_16,
  get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz as get_TEXTURED_ARRAY_QUAD_INDICES,
  TexturedVertexArrayt1cf0uhgxqi1 as TexturedVertexArray,
  BoundsProvideri69utw6h2duh as BoundsProvider,
  readColor21xoh99px3uyk as readColor,
  Basef4lqzcfsxjhi as Base,
  UpdateEvent2wwv3f0im2cby as UpdateEvent,
  RenderContext3l27as458i66g as RenderContext,
  EventResult1qajuo9ssrvv5 as EventResult,
  debugBmpFont3k115pzz5m7bj as debugBmpFont,
  Key_F12_getInstance3u37pwqnwwqw2 as Key_F12_getInstance,
  Key_F7_getInstance34esru10opwar as Key_F7_getInstance,
  StopPropagatingException3fryyzw9pc422 as StopPropagatingException,
  DeviceDimensionsProvider22igvmdnpe2w1 as DeviceDimensionsProvider,
  Eventnral6s6c3h27 as Event,
  UniformBlock2qoqszhm3r9i2 as UniformBlock,
  DefaultShaders_getInstance5rngqjolrj76 as DefaultShaders_getInstance,
  VertexShader26kcg39ndf3s1 as VertexShader,
  AGVertexArrayObjectp6l6cor3jhq8 as AGVertexArrayObject,
  AGVertexDatawn78bdwnwjab as AGVertexData,
  drawfyi5eaogony1 as draw,
  If1av5krmfyt44s as If,
  Shader39o79ur9unxav as Shader,
  Program1hnygp9hph4ry as Program,
  AGTextureUnits3k80ikbk5qbv9 as AGTextureUnits,
  Companion_getInstance2h8aei8glh02n as Companion_getInstance_17,
  AGTextureUnitInfoArray__get_impl_xhvpef1xgn39fbn1382 as AGTextureUnitInfoArray__get_impl_xhvpef,
  Texture2obedkmljq67n as Texture_0,
  Companion_getInstance235mak5rqifor as Companion_getInstance_18,
  Companion_getInstance31zf32wjjcu7m as Companion_getInstance_19,
  toAGScissor50oxbqy8vpfx as toAGScissor,
  plus3tmekjwnqrsa6 as plus,
  _AGColorMask___init__impl__j38ai82qe91ijdfrylk as _AGColorMask___init__impl__j38ai8,
  Companion_getInstance32c4i1xfyu66k as Companion_getInstance_20,
  AGStencilOpFunc__withEnabled_impl_mpcwmr57jgxrqegp7r as AGStencilOpFunc__withEnabled_impl_mpcwmr,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauvyc76n84yfp4k as AGStencilOpFunc__withCompareMode$default_impl_rzbauv,
  Companion_getInstance1zv0hzefhsdqw as Companion_getInstance_21,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo1zgbj1t8zikfh as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo,
  AGStencilReference__withWriteMask$default_impl_b7j7b4hm1mwnctf37u as AGStencilReference__withWriteMask$default_impl_b7j7b4,
  Companion_getInstance17xx2usq1zl9n as Companion_getInstance_22,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1u2ioolcor1me as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at,
  AGStencilReference__withReadMask$default_impl_7mdffxa0e2emtywmjh as AGStencilReference__withReadMask$default_impl_7mdffx,
  AGCompareMode__inverted_impl_7xxk8ma7g7zt6g3nw5 as AGCompareMode__inverted_impl_7xxk8m,
  AGStencilReference__withReferenceValue$default_impl_2trj0v3agbr22op2t8g as AGStencilReference__withReferenceValue$default_impl_2trj0v,
  _AGColorMask___init__impl__j38ai82w30b7s8593rm as _AGColorMask___init__impl__j38ai8_0,
  Companion_getInstancect9znwr3ou7n as Companion_getInstance_23,
  AGDrawType__toString_impl_eonaebdd0n7y5vu3mm as AGDrawType__toString_impl_eonaeb,
  AGColorMask__toString_impl_5i5oqg10xq65e13pz30 as AGColorMask__toString_impl_5i5oqg,
  AGStencilOpFunc__toString_impl_pl8quy3j4r6zq6vwdjv as AGStencilOpFunc__toString_impl_pl8quy,
  AGStencilReference__toString_impl_qu5r8s2jilbrqjeg0uw as AGStencilReference__toString_impl_qu5r8s,
  AGCullFace__toString_impl_7d891w1jhxypgdz5p99 as AGCullFace__toString_impl_7d891w,
  AGDrawType__hashCode_impl_ylaury1blp8g6ll0lbo as AGDrawType__hashCode_impl_ylaury,
  AGColorMask__hashCode_impl_g9082f1zaksn33gbzdg as AGColorMask__hashCode_impl_g9082f,
  AGStencilOpFunc__hashCode_impl_nopebb5539bqxl21c7 as AGStencilOpFunc__hashCode_impl_nopebb,
  AGStencilReference__hashCode_impl_52zufxm053tcvjdifs as AGStencilReference__hashCode_impl_52zufx,
  AGCullFace__hashCode_impl_t4e5ur3uo5n0bzij5mg as AGCullFace__hashCode_impl_t4e5ur,
  AGDrawType11vxw4gf0yugk as AGDrawType,
  AGColorMaskwqd86t1dhpnk as AGColorMask,
  AGStencilOpFunc1juigl5mvjr07 as AGStencilOpFunc,
  AGStencilReference8at184sv64zi as AGStencilReference,
  AGCullFaceff7di2v9k2ne as AGCullFace,
  AgCachedBuffer8k1i505isl6b as AgCachedBuffer,
  applyMatrixBounds3j13fpymjibm6 as applyMatrixBounds,
  AGBatch2bse24318tbhc as AGBatch,
  draw3n7i8s75fp58g as draw_0,
  UniformBlockBuffer2p2oao2ic417b as UniformBlockBuffer,
  VarType_Float2_getInstance2zfvb5etur38n as VarType_Float2_getInstance,
  Attribute3obvnbxr5w4xd as Attribute,
  VarType_Float1_getInstance3muhdxpni8m3z as VarType_Float1_getInstance,
  Precision_MEDIUM_getInstance359tjdlsi6b5f as Precision_MEDIUM_getInstance,
  Varying105nnu9x9j75f as Varying,
  ProgramLayout373hh4xkth3qt as ProgramLayout,
  Companion_instancee8uibjhp9pv1 as Companion_instance_10,
  Companion_getInstance2r3jwgds6cn6e as Companion_getInstance_24,
} from './korge-root-korge-core.mjs';
import {
  Companion_getInstanceqfkejm4vy6f5 as Companion_getInstance_25,
  Signal3nnez3346azzf as Signal,
  AsyncSignal3p186s2w7f15b as AsyncSignal,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  withContextqz5k6d9p9xx5 as withContext,
  coroutineScope39ukucf23mhsm as coroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Key_instancebefxze3q9f64 as Key_instance,
  cancel2en0dn4yvpufo as cancel,
  TimeoutCancellationException198b5zwr3v3uw as TimeoutCancellationException,
  withTimeout1cf9pp7nybo8u as withTimeout,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
  completeWith2hvdlbg1q1mlx as completeWith,
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
} from './kotlinx-coroutines-core.mjs';
import {
  Companion_getInstancep1qxnlu2heww as Companion_getInstance_26,
  Companion_getInstancedn3d4os5eemi as Companion_getInstance_27,
  Companion_getInstancenbsqt92rl0cr as Companion_getInstance_28,
  Size2Dum5ayuyhhau7 as Size2D,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance1mhteccb9s8gp as Companion_getInstance_29,
  Companion_getInstance5n6ipf7m44po as Companion_getInstance_30,
  Marginzmgz0t8x8vn as Margin,
  Rectangle3q03woyn9k8x1 as Rectangle,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  Companion_getInstancepzu5ca8urjqj as Companion_getInstance_31,
  Scale2cm697xlulcp5 as Scale,
  Circle1sk1qi5ph1m23 as Circle,
  Companion_getInstance11dw08y48m2m0 as Companion_getInstance_32,
  BoundsBuilder__plus_impl_cz7f7x16kulpov94zla as BoundsBuilder__plus_impl_cz7f7x,
  _BoundsBuilder___get_bounds__impl__s1l1gxzjc7xpskx0n0 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  Companion_getInstance45f4wj6tp63r as Companion_getInstance_33,
  RoundRectangle271svjyf7w51p as RoundRectangle,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  Companion_getInstance1a9vx2vzoy0c2 as Companion_getInstance_34,
  interpolatewhd2sgxffql5 as interpolate,
  _Angle___get_degrees__impl__qg56vw3rdspcu2c88ii as _Angle___get_degrees__impl__qg56vw,
  _Angle___get_absoluteValue__impl__4qoakv1xrpqzvux2rki as _Angle___get_absoluteValue__impl__4qoakv,
  SizeInte6w85oa6mz6v as SizeInt,
  toFloat3b315y36g90cd as toFloat,
  toIntp2twe4onfbic as toInt,
  BoundsBuilder__plus_impl_cz7f7xgidk87zsybva as BoundsBuilder__plus_impl_cz7f7x_0,
  Companion_getInstance3cokvjrertd3u as Companion_getInstance_35,
  BoundsBuilder__plus_impl_cz7f7x1zfbaumzl4uvg as BoundsBuilder__plus_impl_cz7f7x_1,
  _BoundsBuilder___get_xmax__impl__gsz0km3fdtbfwhjokx as _BoundsBuilder___get_xmax__impl__gsz0km,
  _BoundsBuilder___get_xmin__impl__o2sib01euopgznvvv86 as _BoundsBuilder___get_xmin__impl__o2sib0,
  _BoundsBuilder___get_ymax__impl__oia4uz3likg1inngvx3 as _BoundsBuilder___get_ymax__impl__oia4uz,
  _BoundsBuilder___get_ymin__impl__5n2e8jzy49udpzimry as _BoundsBuilder___get_ymin__impl__5n2e8j,
  MarginInt3jiec8xsxkfd as MarginInt,
  Vector4F1clr35ctch8js as Vector4F,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance2q13golofn64 as Companion_getInstance_36,
  Ratio136tf4z2t0p2d as Ratio,
  Companion_getInstancevp821koktwyg as Companion_getInstance_37,
  Ratio__toString_impl_mfgt3e3j0h64ug0009v as Ratio__toString_impl_mfgt3e,
  Ratio__compareTo_impl_z2ienc31uw6ixghmhkm as Ratio__compareTo_impl_z2ienc,
  Ratio__toFloat_impl_1ftup51oeiehdv33vam as Ratio__toFloat_impl_1ftup5,
  clamp31lhm66c28ic8 as clamp,
  clampdicp8njiht45 as clamp_0,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio,
  toLongRound7crzegvo2qbo as toLongRound,
  toIntCeil3h286vm49zgwd as toIntCeil,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  roundDecimalPlacespck2j5mpzhqn as roundDecimalPlaces,
  convertRange24n2xnngpze54 as convertRange,
  convertRange1a6ancvyn151r as convertRange_0,
  convertRange378kqy75r4gq5 as convertRange_1,
  niceStr1ftz2qvn4gdyq as niceStr,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
  toIntRoundjnzmk86x1qp5 as toIntRound,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_immutablepxpdoj6e54ll as get_immutable,
  Bezier1nrnsph9esuxa as Bezier,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  toShape2D2vgft60vvvqgq as toShape2D,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  MMatrix1y71lv7vv6y8t as MMatrix,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  HitTestDirection_ANY_getInstance3eco03bn1ccpo as HitTestDirection_ANY_getInstance,
  get_mutable10c8ws0x48eez as get_mutable,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstanceao6xlizlaldg as StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance,
  toStrokePointsList2dojuc3rfktd4 as toStrokePointsList,
  get_cachedPoints16ehjcv6uuio1 as get_cachedPoints,
  getPoints2List1zux0vi6zk0wt as getPoints2List,
  Winding_NON_ZERO_getInstance1fdn4b7o3qufp as Winding_NON_ZERO_getInstance,
  LineScaleMode_NONE_getInstance1f32tfs7crl87 as LineScaleMode_NONE_getInstance,
  LineCap_BUTT_getInstance1x8jd0g8nody4 as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstancenxlz621uxkch as LineJoin_MITER_getInstance,
} from './korlibs-math-root-korlibs-math.mjs';
import {
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance_38,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  cancel1n0qjc93h2v6w as cancel_0,
  Closeable2m9yv0b0gma2l as Closeable,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_instanceubj3e1ju0kss as Companion_instance_11,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  PerformanceCounter_getInstance1nd7bgkclrcrv as PerformanceCounter_getInstance,
  toFrequency3flbtmp5xney7 as toFrequency,
  _Frequency___get_hertz__impl__9m7k6x3nl1kcmlovnv7 as _Frequency___get_hertz__impl__9m7k6x,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediately11za8mkid9pxu as launchImmediately,
  Companion_instance3ss15cv8qszpj as Companion_instance_12,
  get_workerImpl14jb6v5ie8q11 as get_workerImpl,
  get_DEBUG_WORKER2r7zp31jch3ip as get_DEBUG_WORKER,
  get_localCurrentDirVfs2lka1gsv26an5 as get_localCurrentDirVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately_0,
  Once1q3lxlgflq3fq as Once,
  launchUnscopedAndWait1ewqmsm0exr55 as launchUnscopedAndWait,
  launchUnscopedpyoa01nqmf1z as launchUnscoped,
  launchUnscoped2lqe6wwpvfo83 as launchUnscoped_0,
  get_length100spxmnpj7nb as get_length,
  StandardPaths_instance2erw5i1zlu9ki as StandardPaths_instance,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  Companion_instance3jiiepme2p8r1 as Companion_instance_13,
  Dyn__set_impl_2ozvx818vme2zcjk7w3 as Dyn__set_impl_2ozvx8,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import { get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider } from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  Property1m5vulkepgwzd as Property,
  Mixin3lmkm5hum2vdj as Mixin,
  getExtra307y0o9pd6mp3 as getExtra,
  toFastList1btvvxvv57pw as toFastList,
  Resourceable38whwgli3ts8g as Resourceable,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import { atomic$int$11d5swdyn6j0pu as atomic$int$1 } from './kotlinx-atomicfu.mjs';
import {
  withoutRangetvtevgxw4fe7 as withoutRange,
  withoutIndex1982826lx7knb as withoutIndex,
  withInsertion32qy0wb7w2f46 as withInsertion,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  HistoryStack2mrikkhc0etuj as HistoryStack,
  PointArrayList281mrsgyr6ua1 as PointArrayList,
  IntArrayList3liuagbdnwmna as IntArrayList,
  getCyclicOrNull12fem85bj0m7u as getCyclicOrNull,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  Ref2y4j4snnxo6gs as Ref,
  IntDeque2ebok66x2sofm as IntDeque,
  Pool1zbsw0zhvh8ca as Pool,
  toRef3av6zm8yavumw as toRef,
  Ref11k43t82thcp3 as Ref_0,
  floatArrayListOfa8snvg2p0fhc as floatArrayListOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  arrayfill2iqmyqqqfwuaf as arrayfill,
  arraycopy3uxsqjlixmnz3 as arraycopy,
  arrayequal25g4om83vd8w1 as arrayequal,
  _Float32Buffer___init__impl__403k2m26kpmn3jn9766 as _Float32Buffer___init__impl__403k2m,
  _Float32Buffer___get_buffer__impl__x5nu9x318r0i4ytjupn as _Float32Buffer___get_buffer__impl__x5nu9x,
} from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_14 = this;
    this.nhi_1 = Companion_getInstance().pb5('Korge');
    this.ohi_1 = 'korlibs.korge.unknown';
  }
}
class Korge {
  constructor(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    Companion_getInstance_39();
    var tmp;
    if (args === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = args;
    }
    args = tmp;
    imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
    gameWindow = gameWindow === VOID ? null : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    injector = injector === VOID ? new Injector() : injector;
    var tmp_0;
    if (configInjector === VOID) {
      tmp_0 = Korge$_init_$lambda_95dffl;
    } else {
      tmp_0 = configInjector;
    }
    configInjector = tmp_0;
    debug = debug === VOID ? false : debug;
    trace = trace === VOID ? false : trace;
    context = context === VOID ? null : context;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    blocking = blocking === VOID ? true : blocking;
    gameId = gameId === VOID ? Companion_getInstance_39().ohi_1 : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().og8_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? DefaultViewport_getInstance().zg5_1 : windowSize;
    virtualSize = virtualSize === VOID ? windowSize : virtualSize;
    displayMode = displayMode === VOID ? Companion_getInstance_40().cat() : displayMode;
    title = title === VOID ? 'Game' : title;
    backgroundColor = backgroundColor === VOID ? Colors_getInstance().ac3_1 : backgroundColor;
    quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
    icon = icon === VOID ? null : icon;
    multithreaded = multithreaded === VOID ? null : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? new GameWindowCreationConfig(multithreaded, VOID, VOID, VOID, VOID, VOID, fullscreen) : windowCreationConfig;
    var tmp_1;
    if (main === VOID) {
      tmp_1 = Korge$_init_$slambda_ys8r4w();
    } else {
      tmp_1 = main;
    }
    main = tmp_1;
    debugAg = debugAg === VOID ? false : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? Colors_getInstance().zc2_1 : debugFontColor;
    var tmp_2;
    if (stageBuilder === VOID) {
      tmp_2 = Korge$_init_$lambda_95dffl_0;
    } else {
      tmp_2 = stageBuilder;
    }
    stageBuilder = tmp_2;
    targetFps = targetFps === VOID ? 0.0 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
    unit = unit === VOID ? Unit_instance : unit;
    this.fhl_1 = args;
    this.ghl_1 = imageFormats;
    this.hhl_1 = gameWindow;
    this.ihl_1 = mainSceneClass;
    this.jhl_1 = timeProvider;
    this.khl_1 = injector;
    this.lhl_1 = configInjector;
    this.mhl_1 = debug;
    this.nhl_1 = trace;
    this.ohl_1 = context;
    this.phl_1 = fullscreen;
    this.qhl_1 = blocking;
    this.rhl_1 = gameId;
    this.shl_1 = settingsFolder;
    this.thl_1 = batchMaxQuads;
    this.uhl_1 = windowSize;
    this.vhl_1 = virtualSize;
    this.whl_1 = displayMode;
    this.xhl_1 = title;
    this.yhl_1 = backgroundColor;
    this.zhl_1 = quality;
    this.ahm_1 = icon;
    this.bhm_1 = multithreaded;
    this.chm_1 = forceRenderEveryFrame;
    this.dhm_1 = windowCreationConfig;
    this.ehm_1 = main;
    this.fhm_1 = debugAg;
    this.ghm_1 = debugFontExtraScale;
    this.hhm_1 = debugFontColor;
    this.ihm_1 = stageBuilder;
    this.jhm_1 = targetFps;
    this.khm_1 = preferSyncIo;
    this.lhm_1 = debugCoroutines;
    this.mhm_1 = unit;
  }
  *thm(entry, $completion) {
    var tmp = Companion_getInstance_25().j9y(this.khm_1);
    yield* withContext(tmp, Korge$start$slambda(this, entry), $completion);
    return Unit_instance;
  }
  uhm(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit) {
    return new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
  }
  nhm(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit, $super) {
    args = args === VOID ? this.fhl_1 : args;
    imageFormats = imageFormats === VOID ? this.ghl_1 : imageFormats;
    gameWindow = gameWindow === VOID ? this.hhl_1 : gameWindow;
    mainSceneClass = mainSceneClass === VOID ? this.ihl_1 : mainSceneClass;
    timeProvider = timeProvider === VOID ? this.jhl_1 : timeProvider;
    injector = injector === VOID ? this.khl_1 : injector;
    configInjector = configInjector === VOID ? this.lhl_1 : configInjector;
    debug = debug === VOID ? this.mhl_1 : debug;
    trace = trace === VOID ? this.nhl_1 : trace;
    context = context === VOID ? this.ohl_1 : context;
    fullscreen = fullscreen === VOID ? this.phl_1 : fullscreen;
    blocking = blocking === VOID ? this.qhl_1 : blocking;
    gameId = gameId === VOID ? this.rhl_1 : gameId;
    settingsFolder = settingsFolder === VOID ? this.shl_1 : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? this.thl_1 : batchMaxQuads;
    windowSize = windowSize === VOID ? this.uhl_1 : windowSize;
    virtualSize = virtualSize === VOID ? this.vhl_1 : virtualSize;
    displayMode = displayMode === VOID ? this.whl_1 : displayMode;
    title = title === VOID ? this.xhl_1 : title;
    backgroundColor = backgroundColor === VOID ? this.yhl_1 : backgroundColor;
    quality = quality === VOID ? this.zhl_1 : quality;
    icon = icon === VOID ? this.ahm_1 : icon;
    multithreaded = multithreaded === VOID ? this.bhm_1 : multithreaded;
    forceRenderEveryFrame = forceRenderEveryFrame === VOID ? this.chm_1 : forceRenderEveryFrame;
    windowCreationConfig = windowCreationConfig === VOID ? this.dhm_1 : windowCreationConfig;
    main = main === VOID ? this.ehm_1 : main;
    debugAg = debugAg === VOID ? this.fhm_1 : debugAg;
    debugFontExtraScale = debugFontExtraScale === VOID ? this.ghm_1 : debugFontExtraScale;
    debugFontColor = debugFontColor === VOID ? this.hhm_1 : debugFontColor;
    stageBuilder = stageBuilder === VOID ? this.ihm_1 : stageBuilder;
    targetFps = targetFps === VOID ? this.jhm_1 : targetFps;
    preferSyncIo = preferSyncIo === VOID ? this.khm_1 : preferSyncIo;
    debugCoroutines = debugCoroutines === VOID ? this.lhm_1 : debugCoroutines;
    unit = unit === VOID ? this.mhm_1 : unit;
    var tmp;
    if ($super === VOID) {
      tmp = this.uhm(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, unit);
    } else {
      var tmp_0 = $super.uhm;
      var tmp_1 = backgroundColor;
      var tmp_2 = tmp_1 == null ? null : new RGBA(tmp_1);
      tmp = tmp_0.call(this, args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, tmp_2, quality, icon, multithreaded, forceRenderEveryFrame, windowCreationConfig, main, debugAg, debugFontExtraScale, new RGBA(debugFontColor), stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance);
    }
    return tmp;
  }
  toString() {
    var tmp = toString(this.fhl_1);
    var tmp_0 = this.ghl_1.toString();
    var tmp_1 = toString_0(this.hhl_1);
    var tmp_2 = toString_0(this.ihl_1);
    var tmp_3 = toString(this.jhl_1);
    var tmp_4 = this.khl_1.toString();
    var tmp_5 = toString(this.lhl_1);
    var tmp_6 = toString_0(this.ohl_1);
    var tmp_7 = this.uhl_1.toString();
    var tmp_8 = this.vhl_1.toString();
    var tmp_9 = this.whl_1.toString();
    var tmp_10 = this.yhl_1;
    return 'Korge(args=' + tmp + ', imageFormats=' + tmp_0 + ', gameWindow=' + tmp_1 + ', mainSceneClass=' + tmp_2 + ', timeProvider=' + tmp_3 + ', injector=' + tmp_4 + ', configInjector=' + tmp_5 + ', debug=' + this.mhl_1 + ', trace=' + this.nhl_1 + ', context=' + tmp_6 + ', fullscreen=' + this.phl_1 + ', blocking=' + this.qhl_1 + ', gameId=' + this.rhl_1 + ', settingsFolder=' + this.shl_1 + ', batchMaxQuads=' + this.thl_1 + ', windowSize=' + tmp_7 + ', virtualSize=' + tmp_8 + ', displayMode=' + tmp_9 + ', title=' + this.xhl_1 + ', backgroundColor=' + toString_0(tmp_10 == null ? null : new RGBA(tmp_10)) + ', quality=' + toString(this.zhl_1) + ', icon=' + this.ahm_1 + ', multithreaded=' + this.bhm_1 + ', forceRenderEveryFrame=' + this.chm_1 + ', windowCreationConfig=' + this.dhm_1.toString() + ', main=' + toString(this.ehm_1) + ', debugAg=' + this.fhm_1 + ', debugFontExtraScale=' + this.ghm_1 + ', debugFontColor=' + RGBA__toString_impl_4lw6dp(this.hhm_1) + ', stageBuilder=' + toString(this.ihm_1) + ', targetFps=' + this.jhm_1 + ', preferSyncIo=' + this.khm_1 + ', debugCoroutines=' + this.lhm_1 + ', unit=' + this.mhm_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.fhl_1);
    result = imul(result, 31) + hashCode(this.ghl_1) | 0;
    result = imul(result, 31) + (this.hhl_1 == null ? 0 : hashCode(this.hhl_1)) | 0;
    result = imul(result, 31) + (this.ihl_1 == null ? 0 : this.ihl_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.jhl_1) | 0;
    result = imul(result, 31) + hashCode(this.khl_1) | 0;
    result = imul(result, 31) + hashCode(this.lhl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.mhl_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.nhl_1) | 0;
    result = imul(result, 31) + (this.ohl_1 == null ? 0 : hashCode(this.ohl_1)) | 0;
    result = imul(result, 31) + (this.phl_1 == null ? 0 : getBooleanHashCode(this.phl_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.qhl_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.rhl_1) | 0;
    result = imul(result, 31) + (this.shl_1 == null ? 0 : getStringHashCode(this.shl_1)) | 0;
    result = imul(result, 31) + this.thl_1 | 0;
    result = imul(result, 31) + this.uhl_1.hashCode() | 0;
    result = imul(result, 31) + this.vhl_1.hashCode() | 0;
    result = imul(result, 31) + this.whl_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.xhl_1) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.yhl_1;
    if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = RGBA__hashCode_impl_h59qf6(this.yhl_1);
    }
    result = tmp + tmp_0 | 0;
    result = imul(result, 31) + this.zhl_1.hashCode() | 0;
    result = imul(result, 31) + (this.ahm_1 == null ? 0 : getStringHashCode(this.ahm_1)) | 0;
    result = imul(result, 31) + (this.bhm_1 == null ? 0 : getBooleanHashCode(this.bhm_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.chm_1) | 0;
    result = imul(result, 31) + this.dhm_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ehm_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fhm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ghm_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.hhm_1) | 0;
    result = imul(result, 31) + hashCode(this.ihm_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.jhm_1) | 0;
    result = imul(result, 31) + (this.khm_1 == null ? 0 : getBooleanHashCode(this.khm_1)) | 0;
    result = imul(result, 31) + (this.lhm_1 == null ? 0 : getBooleanHashCode(this.lhm_1)) | 0;
    var tmp_2 = imul(result, 31);
    result = tmp_2 + hashCode(Unit_instance) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Korge))
      return false;
    var tmp0_other_with_cast = other instanceof Korge ? other : THROW_CCE();
    if (!equals(this.fhl_1, tmp0_other_with_cast.fhl_1))
      return false;
    if (!equals(this.ghl_1, tmp0_other_with_cast.ghl_1))
      return false;
    if (!equals(this.hhl_1, tmp0_other_with_cast.hhl_1))
      return false;
    if (!equals(this.ihl_1, tmp0_other_with_cast.ihl_1))
      return false;
    if (!equals(this.jhl_1, tmp0_other_with_cast.jhl_1))
      return false;
    if (!equals(this.khl_1, tmp0_other_with_cast.khl_1))
      return false;
    if (!equals(this.lhl_1, tmp0_other_with_cast.lhl_1))
      return false;
    if (!(this.mhl_1 === tmp0_other_with_cast.mhl_1))
      return false;
    if (!(this.nhl_1 === tmp0_other_with_cast.nhl_1))
      return false;
    if (!equals(this.ohl_1, tmp0_other_with_cast.ohl_1))
      return false;
    if (!(this.phl_1 == tmp0_other_with_cast.phl_1))
      return false;
    if (!(this.qhl_1 === tmp0_other_with_cast.qhl_1))
      return false;
    if (!(this.rhl_1 === tmp0_other_with_cast.rhl_1))
      return false;
    if (!(this.shl_1 == tmp0_other_with_cast.shl_1))
      return false;
    if (!(this.thl_1 === tmp0_other_with_cast.thl_1))
      return false;
    if (!this.uhl_1.equals(tmp0_other_with_cast.uhl_1))
      return false;
    if (!this.vhl_1.equals(tmp0_other_with_cast.vhl_1))
      return false;
    if (!this.whl_1.equals(tmp0_other_with_cast.whl_1))
      return false;
    if (!(this.xhl_1 === tmp0_other_with_cast.xhl_1))
      return false;
    var tmp = this.yhl_1;
    var tmp_0 = tmp == null ? null : new RGBA(tmp);
    var tmp_1 = tmp0_other_with_cast.yhl_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new RGBA(tmp_1)))
      return false;
    if (!this.zhl_1.equals(tmp0_other_with_cast.zhl_1))
      return false;
    if (!(this.ahm_1 == tmp0_other_with_cast.ahm_1))
      return false;
    if (!(this.bhm_1 == tmp0_other_with_cast.bhm_1))
      return false;
    if (!(this.chm_1 === tmp0_other_with_cast.chm_1))
      return false;
    if (!this.dhm_1.equals(tmp0_other_with_cast.dhm_1))
      return false;
    if (!equals(this.ehm_1, tmp0_other_with_cast.ehm_1))
      return false;
    if (!(this.fhm_1 === tmp0_other_with_cast.fhm_1))
      return false;
    if (!equals(this.ghm_1, tmp0_other_with_cast.ghm_1))
      return false;
    if (!(this.hhm_1 === tmp0_other_with_cast.hhm_1))
      return false;
    if (!equals(this.ihm_1, tmp0_other_with_cast.ihm_1))
      return false;
    if (!equals(this.jhm_1, tmp0_other_with_cast.jhm_1))
      return false;
    if (!(this.khm_1 == tmp0_other_with_cast.khm_1))
      return false;
    if (!(this.lhm_1 == tmp0_other_with_cast.lhm_1))
      return false;
    if (!equals(Unit_instance, Unit_instance))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_15 = this;
    this.phm_1 = new KorgeDisplayMode(Companion_getInstance_26().v9r_1, Companion_getInstance_27().o9g(), true);
    this.qhm_1 = new KorgeDisplayMode(Companion_getInstance_26().v9r_1, Companion_getInstance_27().o9g(), false);
    this.rhm_1 = new KorgeDisplayMode(Companion_getInstance_26().v9r_1, Companion_getInstance_27().c9g_1, false);
    this.shm_1 = new KorgeDisplayMode(Companion_getInstance_26().x9r_1, Companion_getInstance_27().c9g_1, false);
  }
  cat() {
    return this.phm_1;
  }
}
class KorgeDisplayMode {
  constructor(scaleMode, scaleAnchor, clipBorders) {
    Companion_getInstance_40();
    this.vhm_1 = scaleMode;
    this.whm_1 = scaleAnchor;
    this.xhm_1 = clipBorders;
  }
  toString() {
    return 'KorgeDisplayMode(scaleMode=' + this.vhm_1.toString() + ', scaleAnchor=' + this.whm_1.toString() + ', clipBorders=' + this.xhm_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.vhm_1);
    result = imul(result, 31) + this.whm_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xhm_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KorgeDisplayMode))
      return false;
    var tmp0_other_with_cast = other instanceof KorgeDisplayMode ? other : THROW_CCE();
    if (!equals(this.vhm_1, tmp0_other_with_cast.vhm_1))
      return false;
    if (!this.whm_1.equals(tmp0_other_with_cast.whm_1))
      return false;
    if (!(this.xhm_1 === tmp0_other_with_cast.xhm_1))
      return false;
    return true;
  }
}
class KorgeRunner {
  *ohm(config, $completion) {
    // Inline function 'kotlin.run' call
    beforeStartingKorge(config);
    if (null == null) {
      $l$block: {
        // Inline function 'korlibs.io.worker.Companion.init' call
        get_workerImpl().tby();
        if (get_workerImpl().uby()) {
          if (get_DEBUG_WORKER()) {
            println('INSIDE WORKER');
          }
          break $l$block;
        } else {
          if (get_DEBUG_WORKER()) {
            println('**NOT** INSIDE WORKER');
          }
        }
        get_nativeSoundProvider();
        get_RegisteredImageFormats().xdg([config.ghl_1]);
        var iconPath = config.ahm_1;
        var imageFormats = config.ghl_1;
        var entry = config.ehm_1;
        var windowSize = config.uhl_1;
        if (!Companion_getInstance_38().ib1()) {
          yield* configureLoggerFromProperties(get_localCurrentDirVfs().wi('klogger.properties'), $completion);
        }
        var tmp0_elvis_lhs = config.hhl_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.js.getCoroutineContext' call
          tmp = $completion.od().ae(CoroutineKey_getInstance());
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp1_elvis_lhs = tmp;
        var realGameWindow = tmp1_elvis_lhs == null ? CreateDefaultGameWindow(config.dhm_1.bgm(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, config.xhl_1)) : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = config.yhl_1;
        var tmp_0;
        var tmp_1 = tmp2_elvis_lhs;
        if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
          tmp_0 = Colors_getInstance().ac3_1;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        realGameWindow.ogk(tmp_0);
        yield* realGameWindow.ygk(KorgeRunner$invoke$slambda(realGameWindow, windowSize, config, iconPath, imageFormats, entry), $completion);
      }
    }
    return Unit_instance;
  }
  rhu(views, eventDispatcher, clearEachFrame, bgcolor, fixedSizeStep, forceRenderEveryFrame, configInjector) {
    var injector = views.fhn_1;
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    injector.qe4(getKClass(Views), views);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance = views.ehn_1;
    injector.qe4(getKClass(AG), instance);
    injector.qe4(getKClass(Resources), views.whu());
    var tmp = getKClass(ResourcesRoot);
    injector.te4(tmp, KorgeRunner$prepareViewsBase$lambda);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_0 = views.ghn_1;
    injector.qe4(getKClass(Input), instance_0);
    // Inline function 'korlibs.inject.Injector.mapInstance' call
    var instance_1 = views.ihn_1;
    injector.qe4(getKClass(Stats), instance_1);
    injector.qe4(getKClass(CoroutineContext), views.dhn_1);
    var tmp_0 = getKClass(EmptyScene);
    injector.ue4(tmp_0, KorgeRunner$prepareViewsBase$lambda_0);
    injector.qe4(getKClass(TimeProvider), views.hhn_1);
    configInjector(injector);
    var input = views.ghn_1;
    var ag = views.ehn_1;
    var downPos = {_v: Companion_getInstance_29().g9h_1};
    var upPos = {_v: Companion_getInstance_29().g9h_1};
    var downTime = {_v: new DateTime(Companion_getInstance_5().t9v_1)};
    var moveTime = {_v: new DateTime(Companion_getInstance_5().t9v_1)};
    var upTime = Companion_getInstance_5().t9v_1;
    var moveMouseOutsideInNextFrame = {_v: false};
    var mouseTouchId = -1;
    views.xhu(forceRenderEveryFrame);
    var mouseTouchEvent = new TouchEvent();
    var tmp_1 = Companion_getInstance_7().le9_1.slice();
    eventDispatcher.xe7(tmp_1, KorgeRunner$prepareViewsBase$lambda_1(views, input, downPos, downTime, mouseTouchEvent, upPos, moveTime, moveMouseOutsideInNextFrame));
    var tmp_2 = Companion_getInstance_8().ve8_1.slice();
    eventDispatcher.xe7(tmp_2, KorgeRunner$prepareViewsBase$lambda_2(views));
    var tmp_3 = Companion_getInstance_9().oe8_1.slice();
    eventDispatcher.xe7(tmp_3, KorgeRunner$prepareViewsBase$lambda_3(views));
    var tmp_4 = Companion_getInstance_10().hec_1.slice();
    eventDispatcher.xe7(tmp_4, KorgeRunner$prepareViewsBase$lambda_4(views));
    var tmp_5 = Companion_instance_2;
    eventDispatcher.le7(tmp_5, KorgeRunner$prepareViewsBase$lambda_5(views));
    var tmp_6 = Companion_instance_3;
    eventDispatcher.le7(tmp_6, KorgeRunner$prepareViewsBase$lambda_6(views));
    var tmp_7 = Companion_instance_4;
    eventDispatcher.le7(tmp_7, KorgeRunner$prepareViewsBase$lambda_7(views));
    var tmp_8 = Companion_instance_5;
    eventDispatcher.le7(tmp_8, KorgeRunner$prepareViewsBase$lambda_8(views));
    var touchMouseEvent = new MouseEvent();
    var tmp_9 = Companion_getInstance_11().zea_1.slice();
    eventDispatcher.xe7(tmp_9, KorgeRunner$prepareViewsBase$lambda_9(input, views, touchMouseEvent, moveMouseOutsideInNextFrame, downPos, downTime, upPos, moveTime));
    var tmp_10 = Companion_getInstance_12().aee_1.slice();
    eventDispatcher.xe7(tmp_10, KorgeRunner$prepareViewsBase$lambda_10(views));
    var tmp_11 = Companion_instance_6;
    eventDispatcher.le7(tmp_11, KorgeRunner$prepareViewsBase$lambda_11(views, input));
    var tmp_12 = Companion_instance_7;
    eventDispatcher.le7(tmp_12, KorgeRunner$prepareViewsBase$lambda_12(views, ag));
    eventDispatcher.we7(new ReshapeEvent(0, 0, views.yhu(), views.zhu()));
    var tmp_13 = Companion_instance_8;
    eventDispatcher.le7(tmp_13, KorgeRunner$prepareViewsBase$lambda_13(views));
    var renderShown = {_v: false};
    views.dho_1 = clearEachFrame;
    views.eho_1 = bgcolor;
    var firstRenderDeferred = CompletableDeferred();
    views.jhn_1.fgk(KorgeRunner$prepareViewsBase$lambda_14(views, renderShown, firstRenderDeferred, fixedSizeStep, moveMouseOutsideInNextFrame));
    return firstRenderDeferred;
  }
}
class ViewStageComponent {
  constructor(view) {
    this.ahv_1 = view;
    this.bhv_1 = new Signal();
    this.chv_1 = new Signal();
  }
}
class KeysEvents {
  constructor(view) {
    this.ehv_1 = view;
    this.ghv_1 = new AsyncSignal();
    this.hhv_1 = new AsyncSignal();
    this.ihv_1 = new AsyncSignal();
    this.jhv_1 = new CancellableGroup();
    var tmp = Type_TYPE_getInstance();
    this.ehv_1.le7(tmp, KeysEvents$lambda(this));
    var tmp_0 = Type_DOWN_getInstance_0();
    this.ehv_1.le7(tmp_0, KeysEvents$lambda_0(this));
    var tmp_1 = Type_UP_getInstance_0();
    this.ehv_1.le7(tmp_1, KeysEvents$lambda_1(this));
  }
  lhv() {
    var tmp = this.fhv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  mhv(_this__u8e3s4, key, keys, dt, type) {
    _this__u8e3s4.ye8_1 = type;
    _this__u8e3s4.ae9_1 = key;
    _this__u8e3s4.be9_1 = key.w1_1;
    _this__u8e3s4.de9_1 = keys.fg4_1;
    _this__u8e3s4.ee9_1 = keys.gg4_1;
    _this__u8e3s4.fe9_1 = keys.hg4_1;
    _this__u8e3s4.ge9_1 = keys.ig4_1;
    _this__u8e3s4.ie9_1 = dt;
    return _this__u8e3s4;
  }
  khv(_this__u8e3s4, key, keys, dt, type, $super) {
    type = type === VOID ? Type_DOWN_getInstance_0() : type;
    return $super === VOID ? this.mhv(_this__u8e3s4, key, keys, dt, type) : $super.mhv.call(this, _this__u8e3s4, key, keys, new Duration(dt), type);
  }
  nhv(keys, callback) {
    var ke = new KeyEvent();
    return addUpdaterWithViews(this.ehv_1, KeysEvents$justDown$lambda(keys, callback, this, ke));
  }
  ohv(key, callback) {
    return this.nhv(listOf(key), callback);
  }
  phv(callback) {
    return this.ghv_1.i9z(KeysEvents$down$slambda(callback));
  }
  qhv(key, callback) {
    return this.ghv_1.i9z(KeysEvents$down$slambda_0(key, callback));
  }
  rhv(key, callback) {
    return this.hhv_1.i9z(KeysEvents$up$slambda(key, callback));
  }
  shv(callback) {
    return this.ihv_1.i9z(KeysEvents$typed$slambda(callback));
  }
  f7() {
    this.jhv_1.f7();
  }
}
class MouseDragInfo {
  constructor(view, dx, dy, start, end, startTime, time, sx, sy, cx, cy) {
    dx = dx === VOID ? 0.0 : dx;
    dy = dy === VOID ? 0.0 : dy;
    start = start === VOID ? false : start;
    end = end === VOID ? false : end;
    startTime = startTime === VOID ? Companion_getInstance_5().t9v_1 : startTime;
    time = time === VOID ? Companion_getInstance_5().t9v_1 : time;
    sx = sx === VOID ? 0.0 : sx;
    sy = sy === VOID ? 0.0 : sy;
    cx = cx === VOID ? 0.0 : cx;
    cy = cy === VOID ? 0.0 : cy;
    this.thv_1 = view;
    this.uhv_1 = dx;
    this.vhv_1 = dy;
    this.whv_1 = start;
    this.xhv_1 = end;
    this.yhv_1 = startTime;
    this.zhv_1 = time;
    this.ahw_1 = sx;
    this.bhw_1 = sy;
    this.chw_1 = cx;
    this.dhw_1 = cy;
    this.fhw_1 = NaN;
    this.ghw_1 = NaN;
    this.hhw_1 = 0.0;
    this.ihw_1 = 0.0;
  }
  toString() {
    return 'MouseDragInfo(start=' + this.whv_1 + ', end=' + this.xhv_1 + ', sx=' + this.ahw_1 + ', sy=' + this.bhw_1 + ', cx=' + this.chw_1 + ', cy=' + this.dhw_1 + ')';
  }
  ra8() {
    this.fhw_1 = NaN;
    this.ghw_1 = NaN;
    this.hhw_1 = 0.0;
    this.ihw_1 = 0.0;
    this.uhv_1 = 0.0;
    this.vhv_1 = 0.0;
    this.ahw_1 = 0.0;
    this.bhw_1 = 0.0;
    this.chw_1 = 0.0;
    this.dhw_1 = 0.0;
  }
  jhw(dx, dy, start, end, time, sx, sy, cx, cy) {
    this.uhv_1 = dx;
    this.vhv_1 = dy;
    this.ahw_1 = sx;
    this.bhw_1 = sy;
    this.chw_1 = cx;
    this.dhw_1 = cy;
    if (!isNaN_0(this.fhw_1) && !isNaN_0(this.ghw_1)) {
      this.hhw_1 = this.fhw_1 - dx;
      this.ihw_1 = this.ghw_1 - dy;
    }
    this.fhw_1 = dx;
    this.ghw_1 = dy;
    this.whv_1 = start;
    this.xhv_1 = end;
    if (start)
      this.yhv_1 = time;
    this.zhv_1 = time;
    return this;
  }
}
class OnMouseDragCloseable {
  constructor(onDownCloseable, onUpAnywhereCloseable, onMoveAnywhereCloseable) {
    this.khw_1 = onDownCloseable;
    this.lhw_1 = onUpAnywhereCloseable;
    this.mhw_1 = onMoveAnywhereCloseable;
  }
  f7() {
    this.khw_1.f7();
    this.lhw_1.f7();
    this.mhw_1.f7();
  }
  toString() {
    return 'OnMouseDragCloseable(onDownCloseable=' + toString(this.khw_1) + ', onUpAnywhereCloseable=' + toString(this.lhw_1) + ', onMoveAnywhereCloseable=' + toString(this.mhw_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.khw_1);
    result = imul(result, 31) + hashCode(this.lhw_1) | 0;
    result = imul(result, 31) + hashCode(this.mhw_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof OnMouseDragCloseable))
      return false;
    var tmp0_other_with_cast = other instanceof OnMouseDragCloseable ? other : THROW_CCE();
    if (!equals(this.khw_1, tmp0_other_with_cast.khw_1))
      return false;
    if (!equals(this.lhw_1, tmp0_other_with_cast.lhw_1))
      return false;
    if (!equals(this.mhw_1, tmp0_other_with_cast.mhw_1))
      return false;
    return true;
  }
}
class MouseDragState extends Enum {
  xeb() {
    return this.equals(MouseDragState_START_getInstance());
  }
  yeb() {
    return this.equals(MouseDragState_END_getInstance());
  }
}
class Companion_1 {
  nhy(views) {
    // Inline function 'korlibs.io.util.Once.invoke' call
    var this_0 = get_mouseDebugHandlerOnce(views);
    if (!this_0.ybx_1) {
      this_0.ybx_1 = true;
      var tmp0 = views.vho_1;
      // Inline function 'kotlin.collections.plusAssign' call
      var element = MouseEvents$Companion$installDebugExtensionOnce$lambda(views);
      tmp0.d2(element);
    }
  }
}
class MouseEventsUpdate {
  constructor($outer, view) {
    this.qhy_1 = $outer;
    this.ohy_1 = new Mixin();
    this.phy_1 = view;
    addUpdaterWithViews(this.phy_1, MouseEvents$MouseEventsUpdate$lambda(this.qhy_1));
  }
  o9u(value) {
    this.ohy_1.o9u(value);
  }
  p9u() {
    return this.ohy_1.p9u();
  }
}
class MouseEvents {
  constructor(view) {
    this.rhw_1 = new Mixin();
    this.shw_1 = view;
    this.shw_1.thy(true);
    this.uhw_1 = new Signal();
    this.vhw_1 = new Signal();
    this.whw_1 = new Signal();
    this.xhw_1 = new Signal();
    this.yhw_1 = new Signal();
    this.zhw_1 = new Signal();
    this.ahx_1 = new Signal();
    this.bhx_1 = new Signal();
    this.chx_1 = new Signal();
    this.dhx_1 = new Signal();
    this.ehx_1 = new Signal();
    this.fhx_1 = new Signal();
    this.ghx_1 = new Signal();
    this.hhx_1 = new Signal();
    this.ihx_1 = new Signal();
    this.jhx_1 = new Signal();
    this.khx_1 = new Signal();
    this.lhx_1 = new Signal();
    this.mhx_1 = new Signal();
    this.nhx_1 = null;
    this.ohx_1 = false;
    this.phx_1 = false;
    this.qhx_1 = false;
    this.rhx_1 = PerformanceCounter_getInstance().le5();
    this.shx_1 = PerformanceCounter_getInstance().le5();
    this.thx_1 = Vector2D.y9j();
    this.uhx_1 = Vector2D.y9j();
    this.vhx_1 = Vector2D.y9j();
    this.whx_1 = Vector2D.y9j();
    this.xhx_1 = Vector2D.y9j();
    this.yhx_1 = 0;
    this.zhx_1 = false;
    this.ahy_1 = null;
    this.bhy_1 = new MouseEvent();
    this.chy_1 = false;
    this.dhy_1 = new MouseEvent();
    var tmp = this;
    var tmp_0 = Companion_getInstance_7().le9_1.slice();
    tmp.ehy_1 = this.shw_1.xe7(tmp_0, MouseEvents$closeable$lambda(this));
    this.fhy_1 = new MouseEventsUpdate(this, this.shw_1);
  }
  phw() {
    var tmp = this.thw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  ghy() {
    return this.phw().dhn_1;
  }
  uhy() {
    return this.shw_1.vhy(this.xhx_1);
  }
  why() {
    var tmp0_safe_receiver = this.ahy_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ie8();
    }
  }
  shy() {
    var tmp0_safe_receiver = this.nhx_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, this.shw_1);
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  xhy() {
    return this.bhy_1.we9_1;
  }
  yhy() {
    // Inline function 'korlibs.event.MouseEvent.scrollDeltaYPixels' call
    return this.bhy_1.lea(ScrollDeltaMode_PIXEL_getInstance());
  }
  zhy() {
    // Inline function 'korlibs.event.MouseEvent.scrollDeltaYLines' call
    return this.bhy_1.lea(ScrollDeltaMode_LINE_getInstance());
  }
  ahz() {
    return !(this.phw().ghn_1.zg4_1 === 0);
  }
  toString() {
    return this.bhy_1.toString();
  }
  mhy(views, dt) {
    if (!this.shw_1.rhy())
      return Unit_instance;
    this.thw_1 = views;
    Companion_instance_16.nhy(views);
    this.nhx_1 = mouseHitTest(Companion_instance_16, views);
    var over = this.shy();
    var inside = views.ghn_1.bg5_1;
    if (over) {
      set_mouseHitResultUsed(views.ghn_1, this.shw_1);
    }
    var overChanged = !(this.ohx_1 === over);
    var insideChanged = !(this.phx_1 === inside);
    var pressingChanged = !(this.ahz() === this.qhx_1);
    this.xhx_1 = views.ghn_1.pg5();
    if (!overChanged && over && !this.xhx_1.equals(this.whx_1)) {
      this.ghx_1.x9y(this);
    }
    if (!overChanged && !over && !this.xhx_1.equals(this.whx_1)) {
      this.ihx_1.x9y(this);
    }
    if (!this.xhx_1.equals(this.whx_1)) {
      this.hhx_1.x9y(this);
    }
    if (overChanged && over) {
      this.whw_1.x9y(this);
    }
    if (overChanged && !over) {
      this.xhw_1.x9y(this);
    }
    if (pressingChanged && this.ahz()) {
      this.vhx_1 = this.xhx_1;
      if (over) {
        this.yhw_1.x9y(this);
      }
      if (!over) {
        this.zhw_1.x9y(this);
      }
    }
    if (overChanged && this.ahz()) {
      this.ahx_1.x9y(this);
    }
    if (pressingChanged && !this.ahz()) {
      var tmp = this.dhy_1;
      temporalLastEvent(this, tmp, MouseEvents$update$lambda(over, this));
    }
    over && this.yhx_1 > 0;
    if (insideChanged && !inside) {
      this.ihx_1.x9y(this);
      this.xhw_1.x9y(this);
      this.dhx_1.x9y(this);
      this.ehx_1.x9y(this);
      this.jhx_1.x9y(this);
    }
    this.ohx_1 = over;
    this.phx_1 = inside;
    this.qhx_1 = this.ahz();
    this.whx_1 = this.xhx_1;
    this.yhx_1 = 0;
  }
  f7() {
    this.ehy_1.f7();
  }
  o9u(value) {
    this.rhw_1.o9u(value);
  }
  p9u() {
    return this.rhw_1.p9u();
  }
}
class SceneCancellationException extends CancellationException {
  constructor(scene) {
    return new.target.hhz(scene);
  }
  static hhz(scene) {
    var $this = this.n('Scene.sceneAfterDestroyInternal:' + toString(scene));
    captureStack($this, $this.ghz_1);
    $this.fhz_1 = scene;
    return $this;
  }
}
class Scene {
  constructor() {
    this.ihz_1 = new Mixin();
    this.nhz_1 = Container.fi2();
    this.ohz_1 = new CancellableGroup();
    var tmp = this;
    tmp.phz_1 = lazy(Scene$coroutineContext$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.qhz_1 = lazy(Scene$sceneView$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.rhz_1 = lazy(Scene$resources$delegate$lambda(this));
  }
  shz() {
    var tmp = this.jhz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('injector');
    }
  }
  gi2(_set____db54di) {
    this.khz_1 = _set____db54di;
  }
  phw() {
    var tmp = this.khz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('views');
    }
  }
  thz() {
    var tmp = this.lhz_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('sceneContainer');
    }
  }
  d1m() {
    var tmp0 = this.phz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coroutineContext', 1, tmp, Scene$_get_coroutineContext_$ref_9kwv17(), null);
    return tmp0.k3();
  }
  ei2() {
    var tmp0 = this.qhz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('sceneView', 1, tmp, Scene$_get_sceneView_$ref_gy0cev(), null);
    return tmp0.k3();
  }
  uhz(size) {
    return SContainer.si4(size);
  }
  be5(injector) {
    this.jhz_1 = injector;
    // Inline function 'korlibs.inject.Injector.get' call
    var tmp$ret$0 = injector.ze4(getKClass(Views));
    this.gi2(tmp$ret$0);
    var tmp = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp.lhz_1 = injector.ze4(getKClass(SceneContainer));
    var tmp_0 = this;
    // Inline function 'korlibs.inject.Injector.get' call
    tmp_0.mhz_1 = injector.ze4(getKClass(ResourcesRoot));
  }
  *ti4(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  *ui4(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
  *vi4($completion) {
    return Unit_instance;
  }
  *wi4($completion) {
    return Unit_instance;
  }
  *xi4($completion) {
    return Unit_instance;
  }
  yi4() {
    cancel_0(this.ohz_1);
    this.shz().ce5();
  }
  *zi4($completion) {
    return Unit_instance;
  }
  *ai5($completion) {
    yield* this.zi4($completion);
    try {
      cancel(this.d1m(), SceneCancellationException.hhz(this));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        if (e instanceof CancellationException)
          throw e;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  bi5(size) {
    size_0(this.ei2(), size);
  }
  o9u(value) {
    this.ihz_1.o9u(value);
  }
  p9u() {
    return this.ihz_1.p9u();
  }
}
class EmptyScene extends Scene {
  *ui4(_this__u8e3s4, $completion) {
    return Unit_instance;
  }
}
class VisitEntry {
  constructor(clazz, injects) {
    this.pi5_1 = clazz;
    this.qi5_1 = injects;
  }
  toString() {
    return 'VisitEntry(clazz=' + toString(this.pi5_1) + ', injects=' + toString(this.qi5_1) + ')';
  }
  hashCode() {
    var result = this.pi5_1.hashCode();
    result = imul(result, 31) + hashCode(this.qi5_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof VisitEntry))
      return false;
    var tmp0_other_with_cast = other instanceof VisitEntry ? other : THROW_CCE();
    if (!this.pi5_1.equals(tmp0_other_with_cast.pi5_1))
      return false;
    if (!equals(this.qi5_1, tmp0_other_with_cast.qi5_1))
      return false;
    return true;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_17 = this;
    this.mi5_1 = Companion_getInstance().pb5('SceneContainer');
    var tmp = this;
    var tmp_0 = getKClass(EmptyScene);
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    tmp.ni5_1 = new VisitEntry(tmp_0, tmp$ret$0);
  }
}
class BaseView extends BaseEventListener {
  static xjj($box) {
    return this.je7($box);
  }
  hie() {
  }
}
class View extends BaseView {
  static rjs(isContainer, $box) {
    var $this = this.xjj($box);
    $this.qhp_1 = isContainer;
    var tmp = $this;
    tmp.rhp_1 = lazy(View$bviewAll$delegate$lambda($this));
    $this.shp_1 = true;
    $this.thp_1 = null;
    $this.uhp_1 = null;
    $this.vhp_1 = null;
    $this.whp_1 = 0;
    $this.xhp_1 = null;
    $this.yhp_1 = 1.0;
    $this.zhp_1 = null;
    $this.ahq_1 = null;
    $this.bhq_1 = null;
    $this.chq_1 = Companion_getInstance_13().pg0_1;
    $this.dhq_1 = 0.0;
    $this.ehq_1 = 0.0;
    $this.fhq_1 = 1.0;
    $this.ghq_1 = 1.0;
    $this.hhq_1 = Companion_getInstance_34().x9g_1;
    $this.ihq_1 = Companion_getInstance_34().x9g_1;
    $this.jhq_1 = Companion_getInstance_34().x9g_1;
    $this.khq_1 = 0.0;
    var tmp_0 = $this;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = View$_get_scale_$ref_5ah2s7($this);
    tmp_0.lhq_1 = getPropertyCallableRef('scale', 0, tmp_1, tmp_2, View$_set_scale_$ref_o0ddmd($this));
    $this.mhq_1 = false;
    $this.nhq_1 = true;
    $this.ohq_1 = true;
    $this.phq_1 = true;
    $this.qhq_1 = true;
    $this.rhq_1 = Companion_getInstance_33().v9k_1;
    $this.shq_1 = Companion_getInstance_33().v9k_1;
    $this.thq_1 = -1;
    $this.uhq_1 = Companion_getInstance_33().v9k_1;
    $this.vhq_1 = -1;
    $this.whq_1 = new ColorTransformMul();
    $this.xhq_1 = new ColorTransformMul();
    $this.yhq_1 = -1;
    $this.zhq_1 = Companion_getInstance_13().pg0_1;
    $this.ahr_1 = -1;
    $this.bhr_1 = true;
    $this.chr_1 = 0;
    $this.dhr_1 = 0;
    $this.ehr_1 = false;
    $this.fhr_1 = false;
    $this.ghr_1 = null;
    $this.hhr_1 = false;
    $this.ihr_1 = null;
    $this.jhr_1 = 0;
    $this.khr_1 = true;
    $this.lhr_1 = null;
    return $this;
  }
  eif() {
    var tmp0 = this.rhp_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('bviewAll', 1, tmp, View$_get_bviewAll_$ref_htso7z(), null);
    return tmp0.k3();
  }
  static ojy($box) {
    return this.rjs(false, $box);
  }
  fif() {
    return 0.0;
  }
  gif() {
    return 0.0;
  }
  kie() {
    return null;
  }
  wjj(_set____db54di) {
    this.uhp_1 = _set____db54di;
  }
  hif() {
    return this.uhp_1;
  }
  iif() {
    return this.vhp_1;
  }
  wjp(value) {
    this.thp_1 = value;
  }
  jif(value) {
    this.whp_1 = value;
  }
  yed() {
    return this.whp_1;
  }
  kif(value) {
    if (this.zhp_1 === value)
      return Unit_instance;
    this.zhp_1 = value;
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.kie();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.u2(_unary__edvuaz).kif(value);
      }
      tmp = Unit_instance;
    }
    this.lif();
  }
  lif() {
  }
  mif(value) {
    if (this.ahq_1 === value)
      return Unit_instance;
    this.ahq_1 = value;
    var parent = this.iie();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.kie();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.u2(_unary__edvuaz).mif(parent);
      }
      tmp = Unit_instance;
    }
  }
  iie() {
    return this.ahq_1;
  }
  nif() {
    var tmp0_safe_receiver = this.xhp_1;
    this.mif(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iie());
  }
  oif(value) {
    if (this.xhp_1 === value)
      return Unit_instance;
    this.xhp_1 = value;
    var tmp0_safe_receiver = this.xhp_1;
    this.kif(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zhp_1);
    this.nif();
    this.hih();
    this.ke7(value);
  }
  x1m() {
    return this.xhp_1;
  }
  uit(value) {
    if (!this.chq_1.equals(value)) {
      this.chq_1 = value;
      this.lie();
    }
  }
  pif() {
    return !(this.x1m() == null) ? ensureNotNull(this.x1m()).pif() * this.yhp_1 : this.yhp_1;
  }
  qif(x, y) {
    this.wig();
    if (!(this.dhq_1 === x) || !(this.ehq_1 === y)) {
      this.dhq_1 = x;
      this.ehq_1 = y;
      this.fih();
    }
  }
  fcw(value) {
    return this.qif(value.r9g_1, value.s9g_1);
  }
  wb5() {
    return Vector2D.t9g(this.wea(), this.xea());
  }
  rif(v) {
    this.qif(v, this.xea());
  }
  wea() {
    this.wig();
    return this.dhq_1;
  }
  sif(v) {
    this.qif(this.wea(), v);
  }
  xea() {
    this.wig();
    return this.ehq_1;
  }
  tif() {
    return this.khq_1;
  }
  uif(v) {
    this.aig(Scale.e9p(v, v));
  }
  vif() {
    return this.big().a9n();
  }
  wif(v) {
    this.wig();
    if (!(this.fhq_1 === v)) {
      this.fhq_1 = v;
      this.fih();
    }
  }
  xif() {
    this.wig();
    return this.fhq_1;
  }
  yif(v) {
    this.wig();
    if (!(this.ghq_1 === v)) {
      this.ghq_1 = v;
      this.fih();
    }
  }
  zif() {
    this.wig();
    return this.ghq_1;
  }
  aig(value) {
    this.wif(value.c9p_1);
    this.yif(value.d9p_1);
  }
  big() {
    return Scale.e9p(this.xif(), this.zif());
  }
  cig() {
    this.wig();
    return this.hhq_1;
  }
  dig() {
    this.wig();
    return this.ihq_1;
  }
  eig(v) {
    this.wig();
    if (!equals(this.jhq_1, v)) {
      this.jhq_1 = v;
      this.fih();
    }
  }
  fig() {
    this.wig();
    return this.jhq_1;
  }
  gig() {
    var tmp0_safe_receiver = this.x1m();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.oih(Vector2D.t9g(this.wea(), this.xea()));
    return tmp1_elvis_lhs == null ? Vector2D.t9g(this.wea(), this.xea()) : tmp1_elvis_lhs;
  }
  hig(value) {
    this.lib(value);
  }
  s2() {
    return this.mib();
  }
  lib(value) {
    var size = this.s2();
    this.aig(Scale.e9p((this.xif() === 0.0 ? 1.0 : this.xif()) * (value.j9i_1 / size.j9i_1), (this.zif() === 0.0 ? 1.0 : this.zif()) * (value.k9i_1 / size.k9i_1)));
  }
  mib() {
    return this.ihy().s2();
  }
  iig(value) {
    this.lib(this.mib().n9s(value));
  }
  jig() {
    return this.mib().j9i_1;
  }
  kig(value) {
    this.lib(this.mib().n9s(VOID, value));
  }
  lig() {
    return this.mib().k9i_1;
  }
  mig(value) {
    this.lib(Size2D.y9p(this.xif() === 0.0 ? value.j9i_1 : value.j9i_1 / this.xif(), this.zif() === 0.0 ? value.k9i_1 : value.k9i_1 / this.zif()));
  }
  nig() {
    return Size2D.y9p(this.pig(), this.rig());
  }
  oig(value) {
    this.iig(this.xif() === 0.0 ? value : value / this.xif());
  }
  pig() {
    return this.jig() * this.xif();
  }
  qig(value) {
    this.kig(this.zif() === 0.0 ? value : value / this.zif());
  }
  rig() {
    return this.lig() * this.zif();
  }
  w9z() {
    return this.jig();
  }
  x9z() {
    return this.lig();
  }
  kci(v) {
    if (!(v === this.whq_1.mci())) {
      this.whq_1.kci(v);
      this.mie();
    }
  }
  mci() {
    return this.whq_1.mci();
  }
  sig(v) {
    this.uig(v);
  }
  tig() {
    return this.vig();
  }
  uig(v) {
    if (!(this.whq_1.jci() === v)) {
      this.whq_1.ici(v);
      this.mie();
    }
  }
  vig() {
    return this.whq_1.jci();
  }
  wig() {
    if (this.phq_1)
      return Unit_instance;
    this.phq_1 = true;
    var t = this.rhq_1.i9m();
    this.dhq_1 = t.o9m_1;
    this.ehq_1 = t.p9m_1;
    this.fhq_1 = t.q9m_1;
    this.ghq_1 = t.r9m_1;
    this.hhq_1 = t.s9m_1;
    this.ihq_1 = t.t9m_1;
    this.jhq_1 = t.u9m_1;
  }
  wbg() {
    var tmp0_safe_receiver = this.x1m();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wbg();
    return tmp1_elvis_lhs == null ? this : tmp1_elvis_lhs;
  }
  dhv() {
    return this.zhp_1;
  }
  thy(_set____db54di) {
    this.mhq_1 = _set____db54di;
  }
  rhy() {
    return this.mhq_1;
  }
  xig() {
    return this.nhq_1;
  }
  ngk(value) {
    if (!(this.ohq_1 === value)) {
      this.ohq_1 = value;
      this.lie();
    }
  }
  yig() {
    return this.ohq_1;
  }
  zig() {
    if (!this.qhq_1) {
      this.qhq_1 = true;
      this.ehr_1 = true;
      this.rhq_1 = Companion_getInstance_33().h9l(this.wea(), this.xea(), this.fig(), this.xif(), this.zif(), this.cig(), this.dig(), 0.0, 0.0);
    }
    return this.rhq_1;
  }
  khy() {
    if (!(this.thq_1 === this.chr_1)) {
      this.thq_1 = this.chr_1;
      this.ehr_1 = true;
      this.shq_1 = !(this.x1m() == null) ? this.zig().j9l(ensureNotNull(this.x1m()).khy()) : this.zig();
    }
    return this.shq_1;
  }
  aih() {
    if (!(this.vhq_1 === this.chr_1)) {
      this.vhq_1 = this.chr_1;
      this.ehr_1 = true;
      this.uhq_1 = this.khy().h9m();
    }
    return this.uhq_1;
  }
  bih() {
    updateRenderColorTransformIfRequired(this);
    return this.xhq_1;
  }
  cih() {
    updateRenderBlendModeIfRequired(this);
    return this.zhq_1;
  }
  dih() {
    updateRenderColorTransformIfRequired(this);
    return this.xhq_1.mci();
  }
  eih(views) {
    return this.vhy(views.ghn_1.pg5());
  }
  fih() {
    this.qhq_1 = false;
    this.lie();
  }
  lie() {
    this.chr_1 = this.chr_1 + 1 | 0;
    this.ehr_1 = false;
    this.bhr_1 = true;
    this.hie();
  }
  gih() {
    if (!(this.ghr_1 == null)) {
      this.ghr_1 = null;
      var tmp0_safe_receiver = this.x1m();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.gih();
      }
    }
  }
  hih() {
    this.pib();
  }
  iih() {
    this.pib();
  }
  pib() {
  }
  hie() {
    var tmp0_safe_receiver = this.ahq_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jie(this);
    }
    this.gih();
  }
  mie() {
    this.dhr_1 = this.dhr_1 + 1 | 0;
    this.fhr_1 = false;
    this.bhr_1 = true;
    this.hie();
  }
  jih(phase) {
    if (this.ihr_1 == null)
      this.ihr_1 = fastArrayListOf([]);
    var tmp0_safe_receiver = this.ihr_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.d2(phase);
    var tmp1_safe_receiver = this.ihr_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.sortBy' call
      if (tmp1_safe_receiver.s2() > 1) {
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp = View$addRenderPhase$lambda;
        var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp);
        sortWith(tmp1_safe_receiver, tmp$ret$1);
      }
    }
  }
  nib(ctx) {
    if (!this.yig())
      return Unit_instance;
    var tmp0_safe_receiver = this.ihr_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = tmp0_safe_receiver.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].wkf(this, ctx);
      }
    }
    try {
      this.kih(ctx);
    }finally {
      var tmp1_safe_receiver = this.ihr_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array_0 = tmp1_safe_receiver.d9v_1;
        var n_0 = 0;
        while (n_0 < array_0.length) {
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          array_0[(tmp1_safe_receiver.s2() - n_0 | 0) - 1 | 0].xkf(this, ctx);
          n_0 = n_0 + 1 | 0;
        }
      }
    }
  }
  kih(ctx) {
    var oldPhase = this.jhr_1;
    try {
      this.jhr_1 = 0;
      this.lih(ctx);
    }finally {
      this.jhr_1 = oldPhase;
    }
  }
  lih(ctx) {
    var stages = this.ihr_1;
    if (!(stages == null) && this.jhr_1 < stages.s2()) {
      var _unary__edvuaz = this.jhr_1;
      this.jhr_1 = _unary__edvuaz + 1 | 0;
      stages.u2(_unary__edvuaz).ykf(this, ctx);
    } else {
      var tmp = this.jhr_1;
      var tmp1_elvis_lhs = stages == null ? null : stages.s2();
      if (equals(tmp, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs)) {
        this.rib(ctx);
        this.jhr_1 = this.jhr_1 + 1 | 0;
      }
    }
  }
  wie(ctx) {
    if (this.hhr_1 || this === get_debugAnnotateView(ctx)) {
      this.mih(ctx);
    }
  }
  mih(ctx) {
    var local = this.ihy();
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_0 = get_debugLineRenderContext(ctx);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_1 = this_0.kgb_1;
    if (!(this_1.lg2_1 === this_0)) {
      this_1.lg2_1 = this_0;
      this_1.vg3();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_2 = get_debugLineRenderContext(ctx);
    var tmp = KMutableProperty0;
    var tmp_0 = LineRenderBatcher$_get_currentMatrix_$ref_6vk8sh(this_2);
    var tmp0 = getPropertyCallableRef('currentMatrix', 0, tmp, tmp_0, LineRenderBatcher$_set_currentMatrix_$ref_eu8nhv(this_2));
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var temp = tmp0.get();
      try {
        if (!(null == null))
          this_2.wgb_1 = null;
        var tmp2 = Companion_getInstance_13().yg0_1;
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var doUpdate = !(this_0.vgb_1 === tmp2);
          var old = this_0.vgb_1;
          try {
            if (doUpdate) {
              this_0.kgb_1.vg3();
              this_0.vgb_1 = tmp2;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
            var color = Colors_getInstance().bc3_1;
            var m = this_0.wgb_1;
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var oldColor = this_0.ngb_1;
            this_0.ngb_1 = color;
            try {
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
              // Inline function 'kotlin.apply' call
              var this_3 = new VectorPath();
              this_3.sas(this.bii());
              this_0.cgc(this_3, m);
            }finally {
              this_0.ngb_1 = oldColor;
            }
            break $l$block;
          }finally {
            if (doUpdate) {
              this_0.kgb_1.vg3();
            }
            this_0.vgb_1 = old;
          }
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_0 = Colors_getInstance().bc3_1;
        var m_0 = this_0.wgb_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_0 = this_0.ngb_1;
        this_0.ngb_1 = color_0;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_4 = new VectorPath();
          this_4.gah(this.oih(Vector2D.t9g(local.v9h(), local.x9h())));
          this_4.iah(this.oih(Vector2D.t9g(local.w9h(), local.x9h())));
          this_4.iah(this.oih(Vector2D.t9g(local.w9h(), local.y9h())));
          this_4.iah(this.oih(Vector2D.t9g(local.v9h(), local.y9h())));
          this_4.f7();
          this_0.cgc(this_4, m_0);
        }finally {
          this_0.ngb_1 = oldColor_0;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_1 = Colors_getInstance().pc8_1;
        var m_1 = this_0.wgb_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_1 = this_0.ngb_1;
        this_0.ngb_1 = color_1;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_5 = new VectorPath();
          var anchorSize = 6.0 * ensureNotNull(get_views(ctx)).dgb();
          this_5.oab(this.oih(local.n9i()), anchorSize);
          this_5.oab(this.oih(local.d9q()), anchorSize);
          this_5.oab(this.oih(local.p9i()), anchorSize);
          this_5.oab(this.oih(local.e9q()), anchorSize);
          this_5.oab(this.oih(interpolate(Companion_getInstance_37().y9f_1, local.n9i(), local.d9q())), anchorSize);
          this_5.oab(this.oih(interpolate(Companion_getInstance_37().y9f_1, local.d9q(), local.p9i())), anchorSize);
          this_5.oab(this.oih(interpolate(Companion_getInstance_37().y9f_1, local.p9i(), local.e9q())), anchorSize);
          this_5.oab(this.oih(interpolate(Companion_getInstance_37().y9f_1, local.e9q(), local.n9i())), anchorSize);
          this_0.cgc(this_5, m_1);
        }finally {
          this_0.ngb_1 = oldColor_1;
        }
        // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
        var color_2 = Colors_getInstance().dc3_1;
        var m_2 = this_0.wgb_1;
        // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
        var oldColor_2 = this_0.ngb_1;
        this_0.ngb_1 = color_2;
        try {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector' call
          // Inline function 'kotlin.apply' call
          var this_6 = new VectorPath();
          var center = this.gig();
          this_6.qas(Vector2D.t9g(center.r9g_1, center.s9g_1 - 5), Vector2D.t9g(center.r9g_1, center.s9g_1 + 5));
          this_6.qas(Vector2D.t9g(center.r9g_1 - 5, center.s9g_1), Vector2D.t9g(center.r9g_1 + 5, center.s9g_1));
          this_0.cgc(this_6, m_2);
        }finally {
          this_0.ngb_1 = oldColor_2;
        }
        break $l$block_0;
      }finally {
        tmp0.set(temp);
      }
    }
  }
  toString() {
    var out = get_portableSimpleName(getKClassFromExpression(this));
    if (!(this.wea() === 0.0) || !(this.xea() === 0.0))
      out = out + (':pos=(' + this.nih(this.wea()) + ',' + this.nih(this.xea()) + ')');
    if (!(this.xif() === 1.0) || !(this.zif() === 1.0))
      out = out + (':scale=(' + this.nih(this.xif()) + ',' + this.nih(this.zif()) + ')');
    if (!equals(this.cig(), Companion_getInstance_34().x9g_1) || !equals(this.dig(), Companion_getInstance_34().x9g_1))
      out = out + (':skew=(' + this.nih(_Angle___get_degrees__impl__qg56vw(this.cig())) + ',' + this.nih(_Angle___get_degrees__impl__qg56vw(this.dig())) + ')');
    if (!equals(_Angle___get_absoluteValue__impl__4qoakv(this.fig()), Companion_getInstance_34().x9g_1))
      out = out + (':rotation=(' + this.nih(_Angle___get_degrees__impl__qg56vw(this.fig())) + '\xBA)');
    if (!(this.bhq_1 == null))
      out = out + (':name=(' + this.bhq_1 + ')');
    if (!this.chq_1.equals(Companion_getInstance_13().pg0_1))
      out = out + (':blendMode=(' + this.chq_1.toString() + ')');
    if (!this.yig())
      out = out + (':visible=' + this.yig());
    if (!(this.vig() === 1.0))
      out = out + (':alpha=' + niceStr(this.vig(), 2));
    if (!(_RGBA___get_rgb__impl__tijaqt(this.mci()) === _RGBA___get_rgb__impl__tijaqt(Colors_getInstance().zc2_1)))
      out = out + (':colorMul=' + _RGBA___get_hexString__impl__kocngm(this.mci()));
    return out;
  }
  nih(_this__u8e3s4) {
    return toStringDecimal(_this__u8e3s4, 2, true);
  }
  vhy(p) {
    var tmp0 = this.aih();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (tmp0.t9h()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(tmp0.m9l(p.r9g_1, p.s9g_1), tmp0.p9l(p.r9g_1, p.s9g_1));
    }
    return tmp$ret$0;
  }
  oih(p) {
    var tmp0 = this.khy();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      if (tmp0.t9h()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.t9g(tmp0.m9l(p.r9g_1, p.s9g_1), tmp0.p9l(p.r9g_1, p.s9g_1));
    }
    return tmp$ret$0;
  }
  pih(globalPos, direction) {
    if (!this.khr_1)
      return null;
    if (!this.yig())
      return null;
    var tmp0_safe_receiver = this.kie();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
      var n = 0;
      while (n < tmp0_safe_receiver.s2()) {
        var tmp0_safe_receiver_0 = tmp0_safe_receiver.u2((tmp0_safe_receiver.s2() - n | 0) - 1 | 0).pih(globalPos, direction);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver_0;
        }
        n = n + 1 | 0;
      }
    }
    var res = this.tih(globalPos);
    if (!(res == null))
      return res;
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  qih(globalPos, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.pih(globalPos, direction) : $super.pih.call(this, globalPos, direction);
  }
  hhy(p) {
    if (!this.khr_1)
      return null;
    if (!this.yig())
      return null;
    if (this.xig()) {
      var tmp0_safe_receiver = this.kie();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEachReverse' call
        var n = 0;
        while (n < tmp0_safe_receiver.s2()) {
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.u2((tmp0_safe_receiver.s2() - n | 0) - 1 | 0).hhy(p);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            return tmp0_safe_receiver_0;
          }
          n = n + 1 | 0;
        }
      }
    }
    if (!this.rhy())
      return null;
    var tmp1_safe_receiver = this.tih(p);
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var area = this.rih();
      if (!area.t9h() && !area.k9j(p))
        return null;
      return tmp1_safe_receiver;
    }
    var tmp;
    if (this instanceof Stage) {
      tmp = this;
    } else {
      tmp = null;
    }
    return tmp;
  }
  rih() {
    var out = Companion_getInstance_31().b9i_1;
    var count = 0;
    // Inline function 'korlibs.korge.view.forEachAscendant' call
    var view = this;
    if (!true) {
      var tmp0_safe_receiver = view;
      view = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1m();
    }
    while (!(view == null)) {
      var it = view;
      var tmp;
      var tmp_0;
      if (!(it instanceof Stage)) {
        tmp_0 = it instanceof FixedSizeContainer;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = it.mds();
      } else {
        tmp = false;
      }
      if (tmp) {
        var _localBounds = it.dii();
        if (count === 0) {
          out = _localBounds;
        } else {
          out = out.m9q(_localBounds);
        }
        count = count + 1 | 0;
      }
      view = view.x1m();
    }
    return count === 0 ? Companion_getInstance_31().d9i() : out;
  }
  sih(p, direction) {
    if (!this.khr_1)
      return null;
    var ll = this.vhy(p);
    var bounds = this.ihy();
    if (!bounds.k9j(ll)) {
      return null;
    }
    // Inline function 'korlibs.math.geom.Vector2D.plus' call
    var that = Vector2D.d9m(this.fif(), this.gif());
    var l = Vector2D.t9g(ll.r9g_1 + that.r9g_1, ll.s9g_1 + that.s9g_1);
    if (this.lhr_1 === false)
      return this;
    var hitShape = this.hif();
    var hitShapes = this.iif();
    if (this.lhr_1 == null && (!(hitShape == null) || !(hitShapes == null))) {
      if (hitShapes == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < hitShapes.s2()) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          if (hitShapes.u2(_unary__edvuaz).oat(l))
            return this;
        }
      }
      if (!(hitShape == null) && hitShape.oat(l))
        return this;
      return null;
    } else {
      return this;
    }
  }
  tih(p, direction, $super) {
    direction = direction === VOID ? HitTestDirection_ANY_getInstance() : direction;
    return $super === VOID ? this.sih(p, direction) : $super.sih.call(this, p, direction);
  }
  uih() {
    var tmp0_safe_receiver = this.x1m();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.cif(this);
  }
  vih(target, inclusive) {
    var tmp;
    if (target === this.x1m()) {
      tmp = this.zig();
    } else if (target === this) {
      tmp = Companion_getInstance_33().v9k_1;
    } else {
      var commonAncestor = Companion_instance_23.tkf(this, target);
      var tmp_0;
      if (!(commonAncestor === null)) {
        if (target.x1m() == null && inclusive) {
          return this.khy();
        }
        tmp_0 = this.khy().j9l(target.aih());
      } else {
        tmp_0 = Companion_getInstance_33().v9k_1;
      }
      tmp = tmp_0;
    }
    var out = tmp;
    if (inclusive) {
      out = out.j9l(target.zig());
    }
    return out;
  }
  wih() {
    var tmp0_elvis_lhs = this.xih();
    return tmp0_elvis_lhs == null ? this.dii() : tmp0_elvis_lhs;
  }
  xih() {
    var stage = this.wbg();
    if (!(stage instanceof Stage))
      return null;
    return this.yih(stage);
  }
  yih(bp) {
    return this.dii().v9q(bp.zga());
  }
  zih(ctx) {
    return ctx.kgc() ? this.yih(ctx) : this.dii();
  }
  aii(ctx) {
    return this.zih(ctx);
  }
  bii() {
    return this.dii();
  }
  cii(includeFilters) {
    return this.gii(this.wbg(), VOID, true, includeFilters);
  }
  dii(includeFilters, $super) {
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.cii(includeFilters) : $super.cii.call(this, includeFilters);
  }
  eii(concat, doAnchoring, includeFilters) {
    var out = this.hii(doAnchoring, includeFilters);
    if (concat.u9h() && !concat.k9l()) {
      var tmp = Companion_getInstance_32();
      var tmp2 = out.n9i();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        if (concat.t9h()) {
          tmp$ret$0 = tmp2;
          break $l$block;
        }
        tmp$ret$0 = Vector2D.t9g(concat.m9l(tmp2.r9g_1, tmp2.s9g_1), concat.p9l(tmp2.r9g_1, tmp2.s9g_1));
      }
      var tmp_0 = tmp$ret$0;
      var tmp2_0 = out.d9q();
      var tmp$ret$1;
      $l$block_0: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        if (concat.t9h()) {
          tmp$ret$1 = tmp2_0;
          break $l$block_0;
        }
        tmp$ret$1 = Vector2D.t9g(concat.m9l(tmp2_0.r9g_1, tmp2_0.s9g_1), concat.p9l(tmp2_0.r9g_1, tmp2_0.s9g_1));
      }
      var tmp_1 = tmp$ret$1;
      var tmp2_1 = out.p9i();
      var tmp$ret$2;
      $l$block_1: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        if (concat.t9h()) {
          tmp$ret$2 = tmp2_1;
          break $l$block_1;
        }
        tmp$ret$2 = Vector2D.t9g(concat.m9l(tmp2_1.r9g_1, tmp2_1.s9g_1), concat.p9l(tmp2_1.r9g_1, tmp2_1.s9g_1));
      }
      var tmp_2 = tmp$ret$2;
      var tmp2_2 = out.e9q();
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'korlibs.math.geom.Matrix.transform' call
        if (concat.t9h()) {
          tmp$ret$3 = tmp2_2;
          break $l$block_2;
        }
        tmp$ret$3 = Vector2D.t9g(concat.m9l(tmp2_2.r9g_1, tmp2_2.s9g_1), concat.p9l(tmp2_2.r9g_1, tmp2_2.s9g_1));
      }
      out = _BoundsBuilder___get_bounds__impl__s1l1gx(tmp.f9i(tmp_0, tmp_1, tmp_2, tmp$ret$3));
    }
    return out;
  }
  fii(target, doAnchoring, inclusive, includeFilters) {
    return this.eii(this.vih(target == null ? this : target, inclusive), doAnchoring, includeFilters);
  }
  gii(target, doAnchoring, inclusive, includeFilters, $super) {
    target = target === VOID ? this : target;
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    inclusive = inclusive === VOID ? false : inclusive;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.fii(target, doAnchoring, inclusive, includeFilters) : $super.fii.call(this, target, doAnchoring, inclusive, includeFilters);
  }
  hii(doAnchoring, includeFilters) {
    var tmp0_elvis_lhs = this.ghr_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.oib();
      this.ghr_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var out = tmp;
    if (!doAnchoring) {
      out = out.y9l(Vector2D.d9m(this.fif(), this.gif()));
    }
    if (includeFilters) {
      var tmp1_safe_receiver = get_filter(this);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        out = expandedBorderRectangle(tmp1_safe_receiver, out);
      }
    }
    return out;
  }
  ihy(doAnchoring, includeFilters, $super) {
    doAnchoring = doAnchoring === VOID ? true : doAnchoring;
    includeFilters = includeFilters === VOID ? false : includeFilters;
    return $super === VOID ? this.hii(doAnchoring, includeFilters) : $super.hii.call(this, doAnchoring, includeFilters);
  }
  oib() {
    return Companion_getInstance_31().d9i();
  }
  se7(type, event, result) {
    var tmp0_safe_receiver = this.x1m();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.ze7(type, event, result);
  }
}
class Container extends View {
  constructor(cull) {
    return new.target.fi2(cull);
  }
  static fi2(cull, $box) {
    cull = cull === VOID ? false : cull;
    var $this = this.rjs(true, $box);
    $this.vi1_1 = cull;
    $this.wi1_1 = FastArrayList.f9v();
    $this.xi1_1 = new ContainerCollection($this, $this.wi1_1);
    $this.yi1_1 = null;
    $this.zi1_1 = new MMatrix();
    $this.ai2_1 = false;
    $this.bi2_1 = false;
    $this.ci2_1 = FastArrayList.f9v();
    return $this;
  }
  kie() {
    return this.wi1_1;
  }
  lie() {
    super.lie();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.xi1_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var child = this_0.u2(_unary__edvuaz);
      if (child.ehr_1) {
        child.lie();
      }
    }
  }
  mie() {
    super.mie();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.xi1_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var child = this_0.u2(_unary__edvuaz);
      if (child.fhr_1) {
        child.mie();
      }
    }
  }
  nie() {
    return this.wi1_1.s2();
  }
  oie(view) {
  }
  pie(view) {
  }
  pib() {
    super.pib();
    // Inline function 'korlibs.korge.view.View.forEachChild' call
    var tmp0_safe_receiver = this.kie();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp0_safe_receiver.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp0_safe_receiver.u2(_unary__edvuaz).iih();
      }
      tmp = Unit_instance;
    }
  }
  qie(index) {
    return this.wi1_1.u2(index);
  }
  rie(index) {
    return this.sie(index, 1) === 1;
  }
  sie(index, count) {
    if (count <= 0 || index < 0)
      return 0;
    var from = index;
    var tmp0 = index + count | 0;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = this.nie();
    var to = Math.min(tmp0, b);
    var inductionVariable = from;
    if (inductionVariable < to)
      do {
        var removedIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var view = this.qie(removedIndex);
        view.oif(null);
        view.jif(-1);
      }
       while (inductionVariable < to);
    this.wi1_1.k8(from, to);
    var inductionVariable_0 = index;
    var last = this.nie();
    if (inductionVariable_0 < last)
      do {
        var i = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.wi1_1.u2(i).jif(i);
      }
       while (inductionVariable_0 < last);
    this.yie();
    this.zie();
    this.gih();
    return to - from | 0;
  }
  tie() {
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.xi1_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var child = this_0.u2(_unary__edvuaz);
      child.oif(null);
      child.jif(-1);
    }
    this.wi1_1.a5();
    this.yie();
  }
  uie(view) {
    return this.bif(view, this.nie());
  }
  di2(view) {
    this.bif(view, this.nie());
  }
  u2(index) {
    return this.qie(index);
  }
  rib(ctx) {
    if (!this.yig())
      return Unit_instance;
    this.vie(ctx);
  }
  vie(ctx) {
    if (!this.vi1_1) {
      // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
      if (!this.ai2_1) {
        this.ai2_1 = true;
        this.ci2_1.a5();
        this.ci2_1.t2(this.xi1_1);
        if (this.xie())
          this.bi2_1 = false;
      }
      if (!this.bi2_1) {
        this.bi2_1 = true;
        sortWith(this.ci2_1, ZIndexComparator_instance);
      }
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.ci2_1.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].nib(ctx);
      }
      return Unit_instance;
    }
    var tmp = findFirstAscendant(this, Container$renderChildrenInternal$lambda);
    var clippingContainer = (tmp == null ? true : tmp instanceof FixedSizeContainer) ? tmp : null;
    var renderedCount = 0;
    var culledCount = 0;
    var tmp1_elvis_lhs = clippingContainer == null ? null : clippingContainer.dii();
    var bounds = tmp1_elvis_lhs == null ? Companion_getInstance_31().d9i() : tmp1_elvis_lhs;
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ai2_1) {
      this.ai2_1 = true;
      this.ci2_1.a5();
      this.ci2_1.t2(this.xi1_1);
      if (this.xie())
        this.bi2_1 = false;
    }
    if (!this.bi2_1) {
      this.bi2_1 = true;
      sortWith(this.ci2_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = this.ci2_1.d9v_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var child = array_0[_unary__edvuaz_0];
      if (bounds.t9h() || bounds.j9q(child.cii(true))) {
        child.nib(ctx);
        renderedCount = renderedCount + 1 | 0;
      } else {
        culledCount = culledCount + 1 | 0;
      }
    }
  }
  wie(ctx) {
    // Inline function 'korlibs.korge.view.Container.fastForEachChildRender' call
    if (!this.ai2_1) {
      this.ai2_1 = true;
      this.ci2_1.a5();
      this.ci2_1.t2(this.xi1_1);
      if (this.xie())
        this.bi2_1 = false;
    }
    if (!this.bi2_1) {
      this.bi2_1 = true;
      sortWith(this.ci2_1, ZIndexComparator_instance);
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.ci2_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].wie(ctx);
    }
    super.wie(ctx);
  }
  oib() {
    var bb = Companion_getInstance_32().e9i();
    // Inline function 'korlibs.korge.view.Container.fastForEachChild' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.xi1_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var child = this_0.u2(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, child.gii(this));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  xie() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.wi1_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      if (!(array[_unary__edvuaz].tif() === 0.0)) {
        return true;
      }
    }
    return false;
  }
  yie() {
    this.ai2_1 = false;
    this.zie();
  }
  zie() {
    var tmp0_safe_receiver = this.dhv();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.phw();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.jie(this);
    }
  }
  aif(child) {
    var parent = this;
    if (parent === child) {
      invalidOp("Can't addChild to itself");
    }
    if (hasAncestor(parent, child)) {
      invalidOp("Can't addChild to an ancestor");
    }
  }
  bif(view, index) {
    this.aif(view);
    var tmp0_safe_receiver = view.x1m();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.yie();
    }
    view.uih();
    var aindex = clamp(index, 0, this.nie());
    var children = this.wi1_1;
    children.f5(aindex, view);
    var inductionVariable = aindex;
    var last = this.nie();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        children.u2(n).jif(n);
      }
       while (inductionVariable < last);
    view.oif(this);
    view.lie();
    this.oie(view);
    this.yie();
    this.zie();
    this.gih();
  }
  cif(view) {
    if (!((view == null ? null : view.x1m()) === this))
      return false;
    return this.rie(view.yed());
  }
  dif(old, new_0) {
    if (old === new_0)
      return false;
    if (!equals(old.x1m(), this))
      return false;
    this.zie();
    this.yie();
    var tmp0_safe_receiver = new_0.x1m();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wi1_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.z4(new_0);
    ensureNotNull(old.x1m()).wi1_1.e5(old.yed(), new_0);
    new_0.jif(old.yed());
    new_0.oif(old.x1m());
    old.oif(null);
    new_0.lie();
    old.jif(-1);
    this.gih();
    return true;
  }
  pe7(type, event, result) {
    if (this.yi1_1 == null)
      this.yi1_1 = FastArrayList.e9v(this.xi1_1.s2());
    var tmp0 = this.wi1_1;
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
    var temp = ensureNotNull(this.yi1_1);
    toFastList(tmp0, temp);
    try {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = temp.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz].ye7(type, event, result);
      }
    }finally {
      temp.a5();
    }
  }
}
class CachedContainer extends Container {
  static yjj(cache, renderQuality) {
    cache = cache === VOID ? true : cache;
    renderQuality = renderQuality === VOID ? null : renderQuality;
    var $this = this.fi2();
    $this.aie_1 = cache;
    $this.bie_1 = renderQuality;
    $this.cie_1 = null;
    $this.die_1 = true;
    $this.eie_1 = -1.0;
    $this.fie_1 = Companion_getInstance_31().y9k();
    $this.gie_1 = Scale.p9r(1);
    return $this;
  }
  hie() {
    super.hie();
    this.die_1 = true;
  }
  rib(ctx) {
    if (!this.yig())
      return Unit_instance;
    if (!this.aie_1) {
      return super.rib(ctx);
    }
    if (this.cie_1 == null) {
      this.cie_1 = new CacheTexture(this, ctx);
      this.die_1 = true;
    }
    var cache = ensureNotNull(this.cie_1);
    ctx.ogc(cache);
    var renderScale = ctx.fgc().w1_1 === 0 ? 1.0 : ctx.wgc();
    var tmp1_elvis_lhs = this.bie_1;
    var doExpensiveScaling = !get_isLow(tmp1_elvis_lhs == null ? ctx.fgc() : tmp1_elvis_lhs);
    if (this.die_1 || !(this.eie_1 === renderScale)) {
      this.eie_1 = renderScale;
      this.fie_1 = this.ihy(VOID, false);
      this.gie_1 = doExpensiveScaling ? this.wih().s2().r9r(this.fie_1.s2()) : Scale.p9r(1);
      this.die_1 = false;
      var texWidth = coerceAtLeast(numberToInt(this.fie_1.q9h_1 * renderScale * this.gie_1.c9p_1), 1);
      var texHeight = coerceAtLeast(numberToInt(this.fie_1.r9h_1 * renderScale * this.gie_1.d9p_1), 1);
      cache.ejk(texWidth, texHeight);
      ctx.vg3();
      // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
      var frameBuffer = cache.ajk_1;
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.tgc(frameBuffer);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_0 = ctx.hg2_1;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var this_1 = this_0.qg2_1;
        if (!(this_1.lg2_1 === this_0)) {
          this_1.lg2_1 = this_0;
          this_1.vg3();
        }
        var tmp2 = AGScissor.beq(0, 0, frameBuffer.seg_1, frameBuffer.teg_1);
        $l$block_0: {
          // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
          var temp = this_0.og3_1;
          this_0.zg9();
          this_0.og3_1 = tmp2;
          try {
            if (true) {
              ctx.mgc(Colors_getInstance().ec3_1);
            }
            // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
            var matrix = this.aih().a9m(-this.fie_1.o9h_1, -this.fie_1.p9h_1).u9l(renderScale * this.gie_1.c9p_1, renderScale * this.gie_1.d9p_1);
            ctx.vg3();
            var temp4 = ctx.wg1_1;
            var temp2d = ctx.xg1_1;
            ctx.xg1_1 = matrix;
            ctx.wg1_1 = toMatrix4(matrix);
            var tmp0 = ctx.ieo(ProjViewUB_getInstance());
            $l$block: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz = tmp0.z6x();
              tmp0.efc(_unary__edvuaz + 1 | 0);
              tmp0.ffc(tmp0.z6x() + 1 | 0);
              var blockSize = tmp0.beo_1;
              var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
              var index1 = imul(tmp0.z6x(), blockSize);
              var texBlockSize = tmp0.yen_1.wev().s2();
              var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
              var texIndex1 = imul(tmp0.z6x(), texBlockSize);
              if (tmp0.z6x() > 0) {
                arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
              } else {
                arrayfill(tmp0.deo_1, 0, 0, blockSize);
              }
              var tmp0_0 = tmp0.yen_1;
              tmp0.eeo_1.rfc(tmp0_0.kev(), ctx.wg1_1);
              if (true && tmp0.z6x() >= 1) {
                var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
                if (equals) {
                  var _unary__edvuaz_0 = tmp0.z6x();
                  tmp0.efc(_unary__edvuaz_0 - 1 | 0);
                  break $l$block;
                }
              }
            }
            try {
              super.rib(ctx);
            }finally {
              ctx.vg3();
              ctx.wg1_1 = temp4;
              ctx.xg1_1 = temp2d;
              ctx.ieo(ProjViewUB_getInstance()).gfc();
            }
            break $l$block_0;
          }finally {
            this_0.zg9();
            this_0.og3_1 = temp;
          }
        }
      }finally {
        ctx.ugc();
      }
    }
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_2 = ctx.hg2_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_3 = this_2.qg2_1;
    if (!(this_3.lg2_1 === this_2)) {
      this_3.lg2_1 = this_2;
      this_3.vg3();
    }
    this_2.xg3(cache.cjk_1, VOID, VOID, VOID, VOID, this.khy().e9m(this.fie_1.o9h_1, this.fie_1.p9h_1).w9l(1.0 / (renderScale * this.gie_1.c9p_1), 1.0 / (renderScale * this.gie_1.d9p_1)), VOID, this.dih(), this.chq_1);
  }
  iie() {
    return this;
  }
  jie(view) {
    this.die_1 = true;
    var tmp0_safe_receiver = this.x1m();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ahq_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.jie(view);
    }
  }
}
class FixedSizeCachedContainer extends CachedContainer {
  static hjb(size, cache, clip) {
    size = size === VOID ? Size2D.l9i(100, 100) : size;
    cache = cache === VOID ? true : cache;
    clip = clip === VOID ? true : clip;
    var $this = this.yjj(cache);
    $this.ejb_1 = clip;
    $this.fjb_1 = size;
    $this.gjb_1 = Ref(false);
    return $this;
  }
  lib(_set____db54di) {
    this.fjb_1 = _set____db54di;
  }
  mib() {
    return this.fjb_1;
  }
  oib() {
    return new Rectangle(0.0, 0.0, this.w9z(), this.x9z());
  }
  rib(ctx) {
    var tmp6 = this.ejb_1;
    var tmp8 = this.gjb_1;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      if (tmp8.k3()) {
        super.rib(ctx);
        break $l$block_0;
      }
      if (tmp6) {
        var m = this.khy();
        var hasRotation = !(m.b9l_1 === 0.0) || !(m.c9l_1 === 0.0);
        if (hasRotation) {
          var old = tmp8.k3();
          try {
            tmp8.pa9(true);
            renderFiltered(this, ctx, Companion_getInstance_53());
          }finally {
            tmp8.pa9(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.hg2_1;
        if (!(ctx.lg2_1 === batcher)) {
          ctx.lg2_1 = batcher;
          ctx.vg3();
        }
        var c2d = ctx.jg2_1;
        var bounds = this.aii(ctx).v9q(ctx.xg1_1).w9q();
        var rect = c2d.agd_1.jg9().jeq();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j9q(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().eeq(bounds);
          var tmp0 = c2d.agd_1;
          var tmp2 = c2d.lgd(scissor);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var temp = tmp0.og3_1;
            tmp0.zg9();
            tmp0.og3_1 = tmp2;
            try {
              super.rib(ctx);
              break $l$block_1;
            }finally {
              tmp0.zg9();
              tmp0.og3_1 = temp;
            }
          }
        } else {
          super.rib(ctx);
        }
      } else {
        super.rib(ctx);
      }
    }
  }
}
class UIView extends FixedSizeCachedContainer {
  static ti8(size, cache) {
    Companion_getInstance_43();
    size = size === VOID ? Companion_getInstance_43().oj8_1 : size;
    cache = cache === VOID ? false : cache;
    var $this = this.hjb(size, cache, false);
    $this.ri8_1 = size;
    $this.si8_1 = false;
    return $this;
  }
  lib(value) {
    if (!this.ri8_1.equals(value)) {
      this.ri8_1 = value;
      this.gib();
    }
  }
  mib() {
    return this.ri8_1;
  }
  oib() {
    return new Rectangle(0.0, 0.0, this.w9z(), this.x9z());
  }
  gib() {
    var tmp0_safe_receiver = this.x1m();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pie(this);
    }
  }
  pib() {
    super.pib();
    this.qib();
  }
  qib() {
    this.lie();
  }
  rib(ctx) {
    registerUISupportOnce(this);
    super.rib(ctx);
  }
}
class SceneContainer extends UIView {
  constructor(views, defaultTransition, name, size) {
    return new.target.mhu(views, defaultTransition, name, size);
  }
  static mhu(views, defaultTransition, name, size) {
    Companion_getInstance_42();
    defaultTransition = defaultTransition === VOID ? withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_36())) : defaultTransition;
    name = name === VOID ? 'sceneContainer' : name;
    size = size === VOID ? views.pho_1.s2() : size;
    var $this = this.ti8(size);
    $this.ghu_1 = views;
    $this.hhu_1 = defaultTransition;
    $this.bhq_1 = name;
    var tmp = $this;
    // Inline function 'kotlin.also' call
    var this_0 = TransitionView.fib();
    $this.di2(this_0);
    tmp.ihu_1 = this_0;
    $this.jhu_1 = null;
    var tmp_0 = Companion_instance_8;
    $this.le7(tmp_0, SceneContainer$lambda($this));
    $this.khu_1 = arrayListOf([Companion_getInstance_42().ni5_1]);
    $this.lhu_1 = 0;
    return $this;
  }
  gib() {
    var tmp0_safe_receiver = this.jhu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.bi5(Size2D.y9p(this.w9z(), this.x9z()));
    }
  }
  *hib(clazz, injects, time, transition, $completion) {
    this.iib(new VisitEntry(clazz, toList(injects)));
    return yield* /*#__NOINLINE__*/_changeTo(this, clazz, injects.slice(), time, transition, $completion);
  }
  nhu(clazz, injects, time, transition, $completion, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    transition = transition === VOID ? this.hhu_1 : transition;
    return $super === VOID ? this.hib(clazz, injects, time, transition, $completion) : $super.hib.call(this, clazz, injects, new Duration(time), transition, $completion);
  }
  *oi5(newScene, time, transition, $completion) {
    var oldScene = this.jhu_1;
    this.jhu_1 = newScene;
    this.ihu_1.jib(newScene.nhz_1, transition);
    try {
      var tmp = newScene.d1m();
      yield* launchUnscopedAndWait(tmp, SceneContainer$_changeTo$slambda(newScene), $completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        if (e instanceof CancellationException)
          throw e;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    finally {
    }
    launchUnscoped(newScene, SceneContainer$_changeTo$slambda_0(newScene));
    if (!(oldScene == null)) {
      var tmp_0 = oldScene.d1m();
      yield* launchUnscopedAndWait(tmp_0, SceneContainer$_changeTo$slambda_1(oldScene), $completion);
    }
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(time, tmp$ret$2) > 0) {
      var tmp0 = this.ihu_1;
      var tmp_1 = KMutableProperty0;
      var tmp_2 = TransitionView$_get_ratio_$ref_1lub6z(tmp0);
      var tmp0_0 = getPropertyCallableRef('ratio', 0, tmp_1, tmp_2, TransitionView$_set_ratio_$ref_rp057l(tmp0));
      var tmp2 = Companion_getInstance_37().w9f_1;
      // Inline function 'korlibs.korge.tween.get' call
      var end = Companion_getInstance_37().z9f_1;
      var tmp$ret$4 = new V2(tmp0_0, new Ratio(tmp2), new Ratio(end), _interpolateRatio$ref(), true);
      yield* tween(this.ihu_1, [tmp$ret$4], time, VOID, VOID, VOID, VOID, VOID, $completion);
    } else {
      this.ihu_1.cib_1 = Companion_getInstance_37().z9f_1;
    }
    this.ihu_1.kib();
    if (!(oldScene == null)) {
      var tmp_3 = oldScene.d1m();
      yield* launchUnscopedAndWait(tmp_3, SceneContainer$_changeTo$slambda_2(oldScene), $completion);
      launchUnscoped(oldScene, SceneContainer$_changeTo$slambda_3(oldScene));
    }
    var tmp_4 = newScene.d1m();
    launchUnscoped_0(tmp_4, SceneContainer$_changeTo$slambda_4(newScene));
    return newScene;
  }
  iib(entry) {
    while (this.khu_1.s2() <= this.lhu_1) {
      this.khu_1.d2(Companion_getInstance_42().ni5_1);
    }
    this.khu_1.e5(this.lhu_1, entry);
  }
  d1m() {
    return this.ghu_1.dhn_1;
  }
}
class TransitionProcess {}
function start(prev, next) {
  return Unit_instance;
}
function end(prev, next) {
  return Unit_instance;
}
function render(ctx, prev, next, ratio) {
  return Unit_instance;
}
class TransitionView extends Container {
  constructor() {
    return new.target.fib();
  }
  static fib() {
    var $this = this.fi2();
    dummyView($this);
    dummyView($this);
    $this.cib_1 = Companion_getInstance_37().w9f_1;
    $this.dib_1 = get_AlphaTransition();
    return $this;
  }
  x20() {
    return this.u2(0);
  }
  u20() {
    return this.u2(1);
  }
  jib(next, transition) {
    this.dib_1 = transition;
    this.cib_1 = Companion_getInstance_37().w9f_1;
    this.eib_1 = transition.lii();
    this.mii(this.u20(), next);
    _get_transitionProcess__5hlux5(this).iii(this.x20(), this.u20());
  }
  toString() {
    return super.toString() + (':ratio=' + Ratio__toString_impl_mfgt3e(this.cib_1) + ':transition=' + toString(this.dib_1));
  }
  kib() {
    this.cib_1 = Companion_getInstance_37().z9f_1;
    _get_transitionProcess__5hlux5(this).jii(this.x20(), this.u20());
    this.mii(dummyView(this), this.u20());
  }
  mii(prev, next) {
    this.tie();
    this.uie(prev);
    this.uie(next);
  }
  rib(ctx) {
    if (Ratio__compareTo_impl_z2ienc(this.cib_1, Companion_getInstance_37().w9f_1) <= 0) {
      this.x20().nib(ctx);
    } else if (Ratio__compareTo_impl_z2ienc(this.cib_1, Companion_getInstance_37().z9f_1) >= 0) {
      this.u20().nib(ctx);
    } else {
      _get_transitionProcess__5hlux5(this).kii(ctx, this.x20(), this.u20(), this.cib_1);
    }
  }
}
class Transition$1 {
  constructor($render, $name) {
    this.nii_1 = $render;
    this.oii_1 = $name;
  }
  lii() {
    return this;
  }
  kii(ctx, prev, next, ratio) {
    return this.nii_1(ctx, prev, next, new Ratio(ratio));
  }
  toString() {
    return this.oii_1;
  }
}
class withEasing$1$create$1 {
  constructor($process, $easing) {
    this.pii_1 = $process;
    this.qii_1 = $easing;
  }
  iii(prev, next) {
    return this.pii_1.iii(prev, next);
  }
  jii(prev, next) {
    return this.pii_1.jii(prev, next);
  }
  kii(ctx, prev, next, ratio) {
    return this.pii_1.kii(ctx, prev, next, this.qii_1.q9f(ratio));
  }
}
class withEasing$1 {
  constructor($this_withEasing, $easing) {
    this.rii_1 = $this_withEasing;
    this.sii_1 = $easing;
  }
  toString() {
    return toString(this.rii_1) + '.withEasing';
  }
  lii() {
    var process = this.rii_1.lii();
    return new withEasing$1$create$1(process, this.sii_1);
  }
}
class ViewStyles {
  constructor(view) {
    this.tii_1 = view;
    this.uii_1 = null;
    this.vii_1 = atomic$int$1(0);
  }
  wii(prop, default_0) {
    var tmp0_safe_receiver = this.uii_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w4(prop.callableName);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.tii_1.x1m();
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : get_styles(tmp2_safe_receiver);
      tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.wii(prop, default_0);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp;
    return tmp4_elvis_lhs == null ? default_0 : tmp4_elvis_lhs;
  }
  xii(updating) {
    if (updating === 0) {
      var tmp = this.tii_1;
      var tmp0_safe_receiver = isInterface(tmp, StyleableView) ? tmp : null;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.yii();
      }
    }
  }
  zii(updating, $super) {
    updating = updating === VOID ? this.vii_1.kotlinx$atomicfu$value : updating;
    var tmp;
    if ($super === VOID) {
      this.xii(updating);
      tmp = Unit_instance;
    } else {
      tmp = $super.xii.call(this, updating);
    }
    return tmp;
  }
}
class ViewStyle {
  constructor(default_0) {
    this.aij_1 = default_0;
  }
}
class StyleableView {}
function updatedStyles() {
}
class MsdfRender {
  constructor() {
    MsdfRender_instance = this;
    this.bij_1 = this.fij(true, VOID, false);
    this.cij_1 = this.fij(true, VOID, true);
    this.dij_1 = this.gij(false, 'r', false);
    this.eij_1 = this.gij(false, 'a', false);
  }
  gij(msdf, sdf, inverted) {
    // Inline function 'korlibs.korge.view.Companion.buildShader' call
    var name = 'PROGRAM_msdf=' + msdf + ',sdf=' + sdf + ',inverted=' + inverted;
    var tmp1_$this = Companion_getInstance_6().vg8_1;
    var tmp2_name = name == null ? Companion_getInstance_6().vg8_1.ueo_1 : name;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    var tmp = this_0.xez();
    var tmp_0 = this_0.xez();
    var tmp_1 = this_0.xez();
    var tmp_2 = this_0.xez();
    var median$delegate = this_0.iez(tmp, tmp_0, tmp_1, VOID, tmp_2, MsdfRender$createProgram$lambda).mew(null, getLocalDelegateReference('median', KProperty0, false));
    var tmp_3 = Companion_getInstance_6().sg8_1;
    var tmp_4 = get_BB_MAX_TEXTURES() - 1 | 0;
    this_0.pez(tmp_3, 0, tmp_4, MsdfRender$createProgram$lambda_0(this_0));
    var d = this_0.pf0(this_0.vey());
    var alpha = this_0.qf0(this_0.vey());
    this_0.jey(this_0.mey(), this_0.uf0(this_0.mey(), this_0.qey([this_0.pey(0.5)])));
    if (msdf) {
      this_0.jey(d, this_0.nez(createProgram$lambda(median$delegate), this_0.sey(this_0.mey(), 'r'), this_0.sey(this_0.mey(), 'g'), this_0.sey(this_0.mey(), 'b')));
    } else {
      this_0.jey(d, this_0.sey(this_0.mey(), sdf));
    }
    this_0.jey(alpha, this_0.lez(SDFShaders_getInstance().mge(), d));
    if (inverted) {
      this_0.jey(alpha, this_0.uf0(this_0.pey(1.0), alpha));
    }
    this_0.jey(this_0.mey(), this_0.ney(this_0.key(), alpha));
    var tmp3_fragment = FragmentShader(this_0.rey());
    return tmp1_$this.wfl(VOID, tmp3_fragment, tmp2_name);
  }
  fij(msdf, sdf, inverted, $super) {
    sdf = sdf === VOID ? 'a' : sdf;
    inverted = inverted === VOID ? false : inverted;
    return $super === VOID ? this.gij(msdf, sdf, inverted) : $super.gij.call(this, msdf, sdf, inverted);
  }
}
class TextSnapshot {
  constructor(text, selectionRange) {
    this.hij_1 = text;
    this.iij_1 = selectionRange;
  }
  jij(out) {
    setTextNoSnapshot(out, this.hij_1);
    out.hik(this.iij_1);
  }
  toString() {
    return 'TextSnapshot(text=' + this.hij_1 + ', selectionRange=' + this.iij_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.hij_1);
    result = imul(result, 31) + this.iij_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextSnapshot))
      return false;
    var tmp0_other_with_cast = other instanceof TextSnapshot ? other : THROW_CCE();
    if (!(this.hij_1 === tmp0_other_with_cast.hij_1))
      return false;
    if (!this.iij_1.equals(tmp0_other_with_cast.iij_1))
      return false;
    return true;
  }
}
class UIFocusable {}
class TextEditController {
  constructor(textView, caretContainer, eventHandler, bg) {
    caretContainer = caretContainer === VOID ? textView : caretContainer;
    eventHandler = eventHandler === VOID ? textView : eventHandler;
    bg = bg === VOID ? null : bg;
    this.kij_1 = new SoftKeyboardConfig();
    this.lij_1 = textView;
    this.mij_1 = caretContainer;
    this.nij_1 = eventHandler;
    this.oij_1 = bg;
    set_focusable(this.lij_1, this);
    this.pij_1 = this.lij_1.dio();
    this.qij_1 = new CancellableGroup();
    this.rij_1 = new Signal();
    this.sij_1 = new Signal();
    this.tij_1 = new Signal();
    this.uij_1 = new Signal();
    this.vij_1 = new Signal();
    this.wij_1 = new Signal();
    this.xij_1 = new Signal();
    this.yij_1 = new Signal();
    var tmp = this;
    // Inline function 'korlibs.korge.view.debug.debugVertexView' call
    var this_0 = this.mij_1;
    // Inline function 'kotlin.collections.listOf' call
    var pointsList = emptyList();
    var color = Colors_getInstance().zc2_1;
    var type = Companion_getInstance_14().ner_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = DebugVertexView.tit(pointsList, color, type);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.also' call
    this_2.uit(Companion_getInstance_13().yg0_1);
    this_2.ngk(false);
    tmp.zij_1 = this_2;
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    tmp_0.aik_1 = new Margin(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    this.qij_1.uay(onNewAttachDetach(this.lij_1, TextEditController$lambda));
    this.yij_1.x9y(this);
    this.bik_1 = new HistoryStack();
    var tmp_1 = this;
    var tmp0 = this.lij_1;
    var tmp_2 = KMutableProperty0;
    var tmp_3 = Text$_get_color_$ref_w55kt6(tmp0);
    tmp_1.cik_1 = getPropertyCallableRef('color', 0, tmp_2, tmp_3, Text$_set_color_$ref_9l40re(tmp0));
    this.dik_1 = this.pij_1.length;
    this.eik_1 = this.dik_1;
    this.fik_1 = 0;
    var tmp_4 = this;
    tmp_4.gik_1 = TextEditController$acceptTextChange$lambda;
    set_cursor(this.nij_1, Cursor_TEXT_getInstance());
    var tmp_5 = get_timers(this.nij_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp_6 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
    this.qij_1.uay(tmp_5.aiu(tmp_6, TextEditController$lambda_0(this)));
    // Inline function 'korlibs.korge.input.newKeys' call
    var this_3 = this.nij_1;
    // Inline function 'kotlin.also' call
    var this_4 = new KeysEvents(this_3);
    this_4.shv(TextEditController$slambda(this));
    this_4.phv(TextEditController$slambda_0(this));
    this.qij_1.uay(this_4);
    // Inline function 'korlibs.korge.input.newMouse' call
    var this_5 = this.nij_1;
    // Inline function 'kotlin.also' call
    var this_6 = new MouseEvents(this_5);
    var dragging = {_v: false};
    var tmp0_safe_receiver = this.oij_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jir_1 = false;
    }
    this.xij_1.x9y(this);
    this_6.whw_1.w9y(TextEditController$lambda_1(this));
    this_6.xhw_1.w9y(TextEditController$lambda_2(this));
    this_6.uhw_1.w9y(TextEditController$lambda_3(this, dragging));
    this_6.yhw_1.w9y(TextEditController$lambda_4(this, dragging));
    this_6.zhw_1.w9y(TextEditController$lambda_5(dragging, this));
    this_6.hhx_1.w9y(TextEditController$lambda_6(this, dragging));
    this_6.chx_1.w9y(TextEditController$lambda_7(dragging, this));
    doubleClick(this_6, TextEditController$lambda_8(this));
    this.qij_1.uay(this_6);
    this.biu();
  }
  dhv() {
    return this.lij_1.dhv();
  }
  ciu(_this__u8e3s4) {
    return this.lij_1;
  }
  fio(value) {
    var snapshot = setTextNoSnapshot(this, value);
    if (!(snapshot == null)) {
      this.bik_1.ca6(snapshot);
    }
  }
  dio() {
    return this.lij_1.dio();
  }
  mio() {
    var tmp0_safe_receiver = this.bik_1.da6();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jij(this);
    }
  }
  nio() {
    var tmp0_safe_receiver = this.bik_1.ea6();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jij(this);
    }
  }
  lio(substr) {
    var tmp = withoutRange(this.dio(), this.eio());
    var tmp0 = this.gio();
    // Inline function 'kotlin.math.min' call
    var b = this.hio();
    var tmp$ret$0 = Math.min(tmp0, b);
    this.fio(withInsertion(tmp, tmp$ret$0, substr));
    this.tio(this.sio() + substr.length | 0);
  }
  diu(value) {
    this.lij_1.eiu(value);
    this.biu();
  }
  ccw() {
    var tmp = this.lij_1.yim_1;
    return isInterface(tmp, Font) ? tmp : THROW_CCE();
  }
  fiu(value) {
    this.lij_1.fiu(value);
    this.biu();
  }
  giu() {
    return this.lij_1.zim_1;
  }
  jio(value) {
    this.dik_1 = clampIndex(this, value);
    this.biu();
  }
  gio() {
    return this.dik_1;
  }
  mir(value) {
    this.eik_1 = clampIndex(this, value);
    this.biu();
  }
  hio() {
    return this.eik_1;
  }
  tio(value) {
    var value_0 = clampIndex(this, value);
    this.dik_1 = value_0;
    this.eik_1 = value_0;
    this.biu();
  }
  sio() {
    return this.gio();
  }
  iio(start, end) {
    this.dik_1 = clampIndex(this, start);
    this.eik_1 = clampIndex(this, end);
    this.biu();
  }
  hik(range) {
    this.iio(range.n3_1, range.o3_1 + 1 | 0);
  }
  qio() {
    this.iio(0, this.dio().length);
  }
  kio() {
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.hio() - this.gio() | 0;
    return abs(this_0);
  }
  oio() {
    var tmp = this.dio();
    var tmp0 = this.gio();
    // Inline function 'kotlin.math.min' call
    var b = this.hio();
    var tmp_0 = Math.min(tmp0, b);
    var tmp0_0 = this.gio();
    // Inline function 'kotlin.math.max' call
    var b_0 = this.hio();
    var tmp$ret$1 = Math.max(tmp0_0, b_0);
    return substring(tmp, tmp_0, tmp$ret$1);
  }
  hiu(value) {
    this.hik(value);
  }
  eio() {
    var tmp0 = this.gio();
    // Inline function 'kotlin.math.min' call
    var b = this.hio();
    var tmp = Math.min(tmp0, b);
    var tmp0_0 = this.gio();
    // Inline function 'kotlin.math.max' call
    var b_0 = this.hio();
    var tmp$ret$1 = Math.max(tmp0_0, b_0);
    return until(tmp, tmp$ret$1);
  }
  iiu(index) {
    var glyphPositions = this.lij_1.jiu().mcr_1;
    if (glyphPositions.n1())
      return Bezier.zae(Vector2D.y9j(), Vector2D.y9j());
    // Inline function 'kotlin.math.min' call
    var b = glyphPositions.s2() - 1 | 0;
    var tmp$ret$0 = Math.min(index, b);
    var glyph = glyphPositions.u2(tmp$ret$0);
    return index < glyphPositions.s2() ? glyph.fcr() : glyph.gcr();
  }
  lir(pos) {
    var glyphPositions = this.lij_1.jiu().mcr_1;
    var index = 0;
    var minDist = Infinity;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!glyphPositions.n1()) {
      var inductionVariable = 0;
      var last = glyphPositions.s2();
      if (inductionVariable <= last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0 = glyphPositions.s2() - 1 | 0;
          // Inline function 'kotlin.math.min' call
          var b = n;
          var tmp$ret$1 = Math.min(tmp0, b);
          var glyph = glyphPositions.u2(tmp$ret$1);
          var dist = glyph.jcr(pos);
          if (minDist > dist) {
            minDist = dist;
            index = n >= (glyphPositions.s2() - 1 | 0) && !(dist === 0.0) && glyph.icr(pos, false) < glyph.icr(pos, true) ? n + 1 | 0 : n;
          }
        }
         while (!(n === last));
    }
    return index;
  }
  biu() {
    var range = this.eio();
    var array = new PointArrayList(range.n1() ? 2 : imul(get_length(range) + 1 | 0, 2));
    if (range.n1()) {
      var last = range.n3_1 >= this.dio().length;
      var caret = this.iiu(range.n3_1);
      var sign = last ? -1.0 : +1.0;
      var tmp0 = caret.pac(Companion_getInstance_37().w9f_1);
      // Inline function 'korlibs.math.geom.Vector2D.times' call
      var scale = 2.0 * sign;
      var normal = Vector2D.t9g(tmp0.r9g_1 * scale, tmp0.s9g_1 * scale);
      var p0 = caret.gad_1.ma4();
      var p1 = caret.gad_1.na4();
      array.uaa(p0);
      array.uaa(p1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$1 = Vector2D.t9g(p0.r9g_1 + normal.r9g_1, p0.s9g_1 + normal.s9g_1);
      array.uaa(tmp$ret$1);
      // Inline function 'korlibs.math.geom.Vector2D.plus' call
      var tmp$ret$2 = Vector2D.t9g(p1.r9g_1 + normal.r9g_1, p1.s9g_1 + normal.s9g_1);
      array.uaa(tmp$ret$2);
    } else {
      var inductionVariable = range.n3_1;
      var last_0 = range.o3_1 + 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var caret_0 = this.iiu(n);
          array.uaa(caret_0.gad_1.ma4());
          array.uaa(caret_0.gad_1.na4());
        }
         while (!(n === last_0));
    }
    this.zij_1.kci(Colors_getInstance().zc2_1);
    this.zij_1.kiu(listOf(array));
    this.zij_1.ngk(get_focused(this));
    this.lij_1.hie();
  }
  pio(selection, index) {
    if (selection) {
      this.jio(index);
    } else {
      this.tio(index);
    }
  }
  liu(index, direction, word) {
    var dir = get_sign(direction);
    if (word) {
      var sidx = index + dir | 0;
      var idx = sidx;
      while (true) {
        if (!(0 <= idx ? idx <= (charSequenceLength(this.dio()) - 1 | 0) : false)) {
          return dir < 0 ? idx - dir | 0 : idx;
        }
        if (!isLetterOrDigit(charCodeAt(this.dio(), idx))) {
          return dir < 0 ? idx === sidx ? idx : idx - dir | 0 : idx;
        }
        idx = idx + dir | 0;
      }
    }
    return index + dir | 0;
  }
  vio(index, word) {
    return this.liu(index, -1, word);
  }
  xio(index, word) {
    return this.liu(index, 1, word);
  }
  miu() {
    return this.fik_1;
  }
  niu() {
    return true;
  }
  oiu(value) {
    var tmp0_safe_receiver = this.oij_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.iir_1 = value;
    }
    if (value) {
      this.zij_1.ngk(true);
      var tmp1_safe_receiver = this.dhv();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_uiFocusManager(tmp1_safe_receiver);
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.siu(true, this);
      }
    } else {
      this.zij_1.ngk(false);
      var tmp5_safe_receiver = this.dhv();
      var tmp = tmp5_safe_receiver == null ? null : get_uiFocusedView(tmp5_safe_receiver);
      if (!(!(tmp == null) ? isInterface(tmp, ISoftKeyboardConfig) : false)) {
        var tmp3_safe_receiver = this.dhv();
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : get_uiFocusManager(tmp3_safe_receiver);
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.siu(false, null);
        }
      }
    }
    if (value) {
      this.uij_1.x9y(this);
    } else {
      this.vij_1.x9y(this);
    }
  }
  uio(_this__u8e3s4) {
    return Companion_getInstance_38().zb0().wb0() ? _this__u8e3s4.fe9_1 : _this__u8e3s4.ee9_1;
  }
  wio(_this__u8e3s4) {
    return _this__u8e3s4.ge9_1 && Companion_getInstance_38().zb0().wb0();
  }
  rio(_this__u8e3s4) {
    return _this__u8e3s4.ke9();
  }
  f7() {
    set_cursor(this.lij_1, null);
    cancel_0(this.qij_1);
    set_focusable(this.lij_1, null);
  }
}
class TimerComponents {
  constructor(view) {
    this.vit_1 = view;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.wit_1 = ArrayList.p2();
    this.xit_1 = IntArrayList.za1();
    this.yit_1 = IntArrayList.za1();
    this.zit_1 = null;
  }
  aiu(time, callback) {
    return this.uiu(get_fast(time), callback);
  }
  uiu(time, callback) {
    return _interval(this, time, true, callback);
  }
}
class TimerRef {
  constructor(index) {
    this.tiu_1 = index;
  }
  toString() {
    return TimerRef__toString_impl_8hh2j7(this.tiu_1);
  }
  hashCode() {
    return TimerRef__hashCode_impl_d9ou9o(this.tiu_1);
  }
  equals(other) {
    return TimerRef__equals_impl_2fvpr4(this.tiu_1, other);
  }
}
class TweenComponent {
  constructor(view, vs, fastTime, easing, callback, c, fastWaitTime, autoInvalidate) {
    fastTime = fastTime === VOID ? Companion_instance_1.d9w() : fastTime;
    easing = easing === VOID ? get_DEFAULT_EASING() : easing;
    fastWaitTime = fastWaitTime === VOID ? Companion_instance_1.d9w() : fastWaitTime;
    autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
    this.viu_1 = view;
    this.wiu_1 = vs;
    this.xiu_1 = fastTime;
    this.yiu_1 = easing;
    this.ziu_1 = callback;
    this.aiv_1 = c;
    this.biv_1 = fastWaitTime;
    this.civ_1 = autoInvalidate;
    this.div_1 = Companion_instance_1.c9w();
    var tmp = this;
    var tmp_0;
    if (!equals(this.xiu_1, Companion_instance_1.d9w())) {
      tmp_0 = this.xiu_1;
    } else {
      // Inline function 'kotlin.collections.map' call
      var this_0 = this.wiu_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.p1();
      while (_iterator__ex2g4s.q1()) {
        var item = _iterator__ex2g4s.r1();
        var tmp$ret$2 = _FastDuration___get_nanoseconds__impl__pxizcb(item.wgf_1);
        destination.d2(tmp$ret$2);
      }
      var tmp0_elvis_lhs = maxOrNull(destination);
      tmp_0 = get_fastNanoseconds(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    tmp.eiv_1 = tmp_0;
    this.fiv_1 = false;
    this.giv_1 = false;
    this.hiv_1 = false;
    var tmp_1 = this;
    var tmp_2 = Companion_instance_9;
    tmp_1.iiv_1 = this.viu_1.le7(tmp_2, TweenComponent$updater$lambda(this));
    var tmp0_safe_receiver = this.aiv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.y1q(TweenComponent$lambda(this));
    }
    _update(this, Companion_instance_1.c9w());
  }
  piv() {
    return get_slow(this.biv_1);
  }
  qiv() {
    if (this.hiv_1)
      return Unit_instance;
    this.hiv_1 = true;
    var tmp0_safe_receiver = this.aiv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
      tmp0_safe_receiver.qd(tmp$ret$1);
    }
  }
  oiv() {
    if (this.giv_1)
      return Unit_instance;
    this.giv_1 = true;
    var tmp0_safe_receiver = this.iiv_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f7();
    }
    this.iiv_1 = null;
    this.qiv();
  }
  jiv(elapsed) {
    if (equals(elapsed, Companion_instance_1.c9w())) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_0 = this.wiu_1;
      var n = 0;
      while (n < this_0.s2()) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        this_0.u2(_unary__edvuaz).tby();
      }
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.wiu_1;
    var n_0 = 0;
    while (n_0 < this_1.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var v = this_1.u2(_unary__edvuaz_0);
      var durationInTween = equals(v.ugf_1, Companion_instance_1.d9w()) ? FastDuration__minus_impl_evs237(this.eiv_1, v.tgf_1) : v.ugf_1;
      var elapsedInTween = get_fastMilliseconds_0(clamp_1(_FastDuration___get_fastMilliseconds__impl__pe68va(FastDuration__minus_impl_evs237(elapsed, v.tgf_1)), 0.0, _FastDuration___get_fastMilliseconds__impl__pe68va(durationInTween)));
      var ratioInTween = FastDuration__compareTo_impl_4fhnj7_0(durationInTween, Companion_getInstance_0().jk_1) <= 0 || FastDuration__compareTo_impl_4fhnj7(elapsedInTween, durationInTween) >= 0 ? 1.0 : FastDuration__div_impl_rlslck(elapsedInTween, durationInTween);
      var easedRatioInTween = this.yiu_1.p9f(ratioInTween);
      v.zgf(toRatio(easedRatioInTween));
    }
  }
  toString() {
    return 'TweenComponent(' + toString(this.viu_1) + ')';
  }
}
class Scope {}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.siv_1 = function_0;
  }
  pj(a, b) {
    return this.siv_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.siv_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class UIFocusManager {
  constructor(view) {
    this.piu_1 = view;
    this.qiu_1 = this.piu_1;
    this.riu_1 = null;
    var tmp = Type_DOWN_getInstance_0();
    this.piu_1.le7(tmp, UIFocusManager$lambda(this));
  }
  phw() {
    return this.qiu_1.phw();
  }
  uiv() {
    return this.piu_1.uiv();
  }
  riv(value) {
    if (equals(this.riu_1, value))
      return Unit_instance;
    var tmp0_safe_receiver = this.riu_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.oiu(false);
    }
    this.riu_1 = value;
    var tmp1_safe_receiver = this.riu_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.oiu(true);
    }
    if (!(value == null)) {
      this.phw().viv(_get_rfocusView__qys03k(this, value), true);
    }
  }
  siu(show, view) {
    if (show) {
      if (view == null)
        null;
      else {
        // Inline function 'kotlin.apply' call
        this.uiv().vgj(view.ciu(Scope_instance).yih(this.qiu_1).x9p());
      }
      var tmp = this.uiv();
      tmp.xgj(VOID, (view == null ? true : isInterface(view, ISoftKeyboardConfig)) ? view : null);
    } else {
      this.uiv().ygj();
    }
  }
  tiv(dir) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = descendantsWith(this.qiu_1, VOID, UIFocusManager$changeFocusIndex$lambda);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList.p2();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp0_safe_receiver = get_focusable(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.d2(tmp0_safe_receiver);
      }
    }
    var focusables = destination;
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = UIFocusManager$changeFocusIndex$lambda_0;
    var tmp$ret$8 = new sam$kotlin_Comparator$0(tmp);
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = sortedWith(focusables, tmp$ret$8);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (element_0.niu()) {
        destination_0.d2(element_0);
      }
    }
    var sortedFocusables = destination_0;
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(sortedFocusables, this.riu_1);
    var tmp_0;
    if (this_0 >= 0) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var index = tmp_0;
    var tmp0_safe_receiver_0 = getCyclicOrNull(sortedFocusables, !(index == null) ? index + dir | 0 : dir < 0 ? -1 : 0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.also' call
      focus(tmp0_safe_receiver_0);
      scrollParentsToMakeVisible(_get_rfocusView__qys03k(this, tmp0_safe_receiver_0));
    }
  }
}
class UIObservable {
  constructor(initial, observe) {
    this.wiv_1 = initial;
    this.xiv_1 = observe;
    this.yiv_1 = this.wiv_1;
  }
  ziv(obj, prop) {
    return this.yiv_1;
  }
  aiw(obj, prop, value) {
    if (!equals(this.yiv_1, value)) {
      this.yiv_1 = value;
      this.xiv_1(value);
    }
  }
}
class UIScrollable extends UIView {
  miz() {
    return this.x9z() * this.liz_1;
  }
  niz() {
    return this.w9z() * this.liz_1;
  }
  oiz() {
    return this.miz();
  }
  piz() {
    return this.miz();
  }
  qiz() {
    return this.niz();
  }
  riz() {
    return this.niz();
  }
  siz(rect, anchor) {
    this.kiz_1.tiz(rect.v9h(), rect.w9h(), anchor.l9g_1);
    this.jiz_1.tiz(rect.x9h(), rect.y9h(), anchor.m9g_1);
  }
  uiz(view, anchor) {
    this.siz(view.gii(this), anchor);
    scrollParentsToMakeVisible(this);
  }
  viz(view, anchor, $super) {
    anchor = anchor === VOID ? Companion_getInstance_27().o9g() : anchor;
    var tmp;
    if ($super === VOID) {
      this.uiz(view, anchor);
      tmp = Unit_instance;
    } else {
      tmp = $super.uiz.call(this, view, anchor);
    }
    return tmp;
  }
}
class ViewRenderer {}
class sam$korlibs_korge_view_ViewRenderer$0 {
  constructor(function_0) {
    this.wiz_1 = function_0;
  }
  xiz(_this__u8e3s4) {
    return this.wiz_1(_this__u8e3s4);
  }
  p5() {
    return this.wiz_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class UITextInput extends UIView {
  constructor(initialText, size) {
    return new.target.kj3(initialText, size);
  }
  static kj3(initialText, size) {
    initialText = initialText === VOID ? '' : initialText;
    size = size === VOID ? Size2D.l9i(128, 24) : size;
    var $this = this.ti8(size);
    $this.sj2_1 = new SoftKeyboardConfig();
    var tmp = $this;
    // Inline function 'korlibs.korge.view.renderableView' call
    var viewRenderer = UITextInput$bg$lambda;
    tmp.tj2_1 = addTo(RenderableView.lj3(size, new sam$korlibs_korge_view_ViewRenderer$0(viewRenderer)), $this);
    var tmp_0 = $this;
    var tmp0 = $this.tj2_1;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = RenderableView$_get_viewRenderer_$ref_kgwm7(tmp0);
    tmp_0.uj2_1 = getPropertyCallableRef('viewRenderer', 0, tmp_1, tmp_2, RenderableView$_set_viewRenderer_$ref_tnl5oz(tmp0));
    var tmp_3 = $this;
    // Inline function 'korlibs.korge.view.clipContainer' call
    var size_0 = Companion_getInstance_28().c9s_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = ClipContainer.xj5(size_0);
    // Inline function 'kotlin.apply' call
    tmp_3.vj2_1 = addTo(this_0, $this);
    var tmp_4 = $this;
    var tmp0_0 = $this.vj2_1;
    var tmp6 = Colors_getInstance().ac3_1;
    // Inline function 'korlibs.korge.view.text' call
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_2().ucr_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance_22.zj5_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Text.aj6(initialText, numberToDouble(16.0), tmp6, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    tmp_4.wj2_1 = addTo(this_1, tmp0_0);
    $this.xj2_1 = new TextEditController($this.wj2_1, $this.wj2_1, $this, $this.tj2_1);
    var tmp_5 = $this;
    var tmp0_1 = $this.xj2_1;
    var tmp_6 = KMutableProperty0;
    var tmp_7 = TextEditController$_get_text_$ref_8pfnni(tmp0_1);
    tmp_5.yj2_1 = getPropertyCallableRef('text', 0, tmp_6, tmp_7, TextEditController$_set_text_$ref_libz4a(tmp0_1));
    var tmp_8 = $this;
    var tmp0_2 = $this.xj2_1;
    var tmp_9 = KMutableProperty0;
    var tmp_10 = TextEditController$_get_textSize_$ref_hra1rx(tmp0_2);
    tmp_8.zj2_1 = getPropertyCallableRef('textSize', 0, tmp_9, tmp_10, TextEditController$_set_textSize_$ref_27jb7t(tmp0_2));
    var tmp_11 = $this;
    var tmp0_3 = $this.xj2_1;
    var tmp_12 = KMutableProperty0;
    var tmp_13 = TextEditController$_get_font_$ref_edfa4(tmp0_3);
    tmp_11.aj3_1 = getPropertyCallableRef('font', 0, tmp_12, tmp_13, TextEditController$_set_font_$ref_d79qqw(tmp0_3));
    var tmp_14 = $this;
    var tmp_15 = KProperty0;
    tmp_14.bj3_1 = getPropertyCallableRef('onReturnPressed', 0, tmp_15, TextEditController$_get_onReturnPressed_$ref_s5777o($this.xj2_1), null);
    var tmp_16 = $this;
    var tmp_17 = KProperty0;
    tmp_16.cj3_1 = getPropertyCallableRef('onEscPressed', 0, tmp_17, TextEditController$_get_onEscPressed_$ref_j0dpnl($this.xj2_1), null);
    var tmp_18 = $this;
    var tmp_19 = KProperty0;
    tmp_18.dj3_1 = getPropertyCallableRef('onFocusLost', 0, tmp_19, TextEditController$_get_onFocusLost_$ref_i4znle($this.xj2_1), null);
    var tmp_20 = $this;
    var tmp0_4 = $this.xj2_1;
    var tmp_21 = KMutableProperty0;
    var tmp_22 = TextEditController$_get_selectionRange_$ref_24yo2u(tmp0_4);
    tmp_20.ej3_1 = getPropertyCallableRef('selectionRange', 0, tmp_21, tmp_22, TextEditController$_set_selectionRange_$ref_vswn1i(tmp0_4));
    var tmp_23 = $this;
    var tmp0_5 = $this.xj2_1;
    var tmp_24 = KMutableProperty0;
    var tmp_25 = TextEditController$_get_selectionStart_$ref_1v2ufp(tmp0_5);
    tmp_23.fj3_1 = getPropertyCallableRef('selectionStart', 0, tmp_24, tmp_25, TextEditController$_set_selectionStart_$ref_z85wf3(tmp0_5));
    var tmp_26 = $this;
    var tmp0_6 = $this.xj2_1;
    var tmp_27 = KMutableProperty0;
    var tmp_28 = TextEditController$_get_selectionEnd_$ref_67w5ks(tmp0_6);
    tmp_26.gj3_1 = getPropertyCallableRef('selectionEnd', 0, tmp_27, tmp_28, TextEditController$_set_selectionEnd_$ref_mv83i0(tmp0_6));
    var tmp_29 = $this;
    var tmp_30 = KProperty0;
    tmp_29.hj3_1 = getPropertyCallableRef('selectionLength', 0, tmp_30, TextEditController$_get_selectionLength_$ref_fphy6b($this.xj2_1), null);
    var tmp_31 = $this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_30();
    tmp_31.ij3_1 = new Margin(numberToDouble(3.0), numberToDouble(2.0), numberToDouble(2.0), numberToDouble(2.0));
    $this.gib();
    return $this;
  }
  fio(_set____db54di) {
    var tmp0 = this.yj2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = UITextInput$_get_text_$ref_iy7m14();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('text', 1, tmp, tmp_0, UITextInput$_set_text_$ref_vr3xhw());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  dio() {
    var tmp0 = this.yj2_1;
    var tmp = KMutableProperty1;
    var tmp_0 = UITextInput$_get_text_$ref_iy7m14();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('text', 1, tmp, tmp_0, UITextInput$_set_text_$ref_vr3xhw());
    return tmp0.get();
  }
  jj3() {
    var tmp0 = this.bj3_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('onReturnPressed', 1, tmp, UITextInput$_get_onReturnPressed_$ref_y9lky6(), null);
    return tmp0.get();
  }
  gib() {
    size(this.tj2_1, this.w9z(), this.x9z());
    bounds(this.vj2_1, (new Rectangle(0.0, 0.0, this.w9z(), this.x9z())).i9q(this.ij3_1));
  }
}
class sam$korlibs_korge_view_ViewRenderer$0_0 {
  constructor(function_0) {
    this.bj6_1 = function_0;
  }
  xiz(_this__u8e3s4) {
    return this.bj6_1(_this__u8e3s4);
  }
  p5() {
    return this.bj6_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ViewRenderer) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_18 = this;
    this.mj8_1 = 90.0;
    this.nj8_1 = 32.0;
    this.oj8_1 = Size2D.t9p(90.0, 32.0);
  }
}
class Anchorable {}
class InternalViewAutoscaling {
  constructor() {
    this.rjg_1 = 1.0;
    this.sjg_1 = 1.0;
    this.tjg_1 = 1.0;
    this.ujg_1 = 1.0;
    this.vjg_1 = 1.0;
    this.wjg_1 = MatrixTransform.y9m();
  }
  xjg(autoScaling, autoScalingPrecise, globalMatrix) {
    if (autoScaling) {
      this.wjg_1 = globalMatrix.i9m();
      // Inline function 'kotlin.math.abs' call
      var x = this.wjg_1.q9m_1;
      var sx = Math.abs(x);
      // Inline function 'kotlin.math.abs' call
      var x_0 = this.wjg_1.r9m_1;
      var sy = Math.abs(x_0);
      // Inline function 'kotlin.math.max' call
      var sxy = Math.max(sx, sy);
      // Inline function 'kotlin.math.abs' call
      var x_1 = sx / this.tjg_1 - 1.0;
      var diffX = Math.abs(x_1);
      // Inline function 'kotlin.math.abs' call
      var x_2 = sy / this.ujg_1 - 1.0;
      var diffY = Math.abs(x_2);
      var tmp;
      switch (autoScalingPrecise) {
        case true:
          tmp = diffX > 0.0 || diffY > 0.0;
          break;
        case false:
          tmp = diffX >= 0.1 || diffY >= 0.1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var shouldUpdate = tmp;
      if (shouldUpdate) {
        this.tjg_1 = sx;
        this.ujg_1 = sy;
        this.vjg_1 = sxy;
        this.rjg_1 = 1.0 / sx;
        this.sjg_1 = 1.0 / sy;
        return true;
      }
    } else {
      this.tjg_1 = 1.0;
      this.ujg_1 = 1.0;
      this.vjg_1 = 1.0;
      this.rjg_1 = 1.0;
      this.sjg_1 = 1.0;
    }
    return false;
  }
}
class RectBase extends View {
  static ljw(anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ojy();
    $this.hjj_1 = smoothing;
    $this.wjj(hitShape);
    var tmp = $this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
    tmp.ijj_1 = get_Bitmaps_white();
    $this.jjj_1 = anchor;
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.render.Companion.QUAD_INDICES' call
    Companion_getInstance_16();
    var tmp$ret$1 = get_TEXTURED_ARRAY_QUAD_INDICES();
    tmp_0.kjj_1 = new TexturedVertexArray(4, tmp$ret$1);
    $this.ljj_1 = null;
    $this.mjj_1 = null;
    return $this;
  }
  tjj(v) {
    if (!(this.ijj_1 === v)) {
      this.ijj_1 = v;
      this.bhr_1 = true;
      this.hie();
    }
  }
  ijb(v) {
    if (!this.jjj_1.equals(v)) {
      this.jjj_1 = v;
      this.bhr_1 = true;
      this.hie();
    }
  }
  jjb() {
    return this.jjj_1;
  }
  fjh() {
    return 0.0;
  }
  gjh() {
    return 0.0;
  }
  fif() {
    return this.jjb().l9g_1 * this.fjh();
  }
  gif() {
    return this.jjb().m9g_1 * this.gjh();
  }
  njj() {
    return -this.fif();
  }
  ojj() {
    return -this.gif();
  }
  rib(ctx) {
    if (!this.yig())
      return Unit_instance;
    var tmp = this.ijj_1;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    if (tmp === get_Bitmaps_transparent())
      return Unit_instance;
    if (this.bhr_1) {
      this.bhr_1 = false;
      this.vjj();
    }
    this.ujj(ctx);
  }
  ujj(ctx) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.hg2_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_1 = this_0.qg2_1;
    if (!(this_1.lg2_1 === this_0)) {
      this_1.lg2_1 = this_0;
      this_1.vg3();
    }
    var tmp0_safe_receiver = this.mjj_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(ctx);
    var tmp2 = this.kjj_1;
    var tmp4 = ctx.ngc(this.ijj_1).qak();
    var tmp6 = this.hjj_1;
    var tmp8 = this.cih();
    var tmp12 = this.ljj_1;
    // Inline function 'korlibs.korge.render.BatchBuilder2D.drawVertices' call
    var vcount = tmp2.tg9_1;
    var icount = tmp2.ug9_1;
    var matrix = Companion_getInstance_33().w9k_1;
    var tmp2_0 = tmp4.tg6_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      this_0.mg9(icount, vcount);
      var pprogram = tmp12 == null ? Companion_getInstance_6().vg8_1 : tmp12;
      if (this_0.bga(tmp2_0, tmp6, tmp8, pprogram)) {
        break $l$block;
      }
      this_0.dg9();
      if (!contains(this_0.gg3_1, tmp2_0)) {
        this_0.fg3_1 = 0;
        this_0.gg3_1[0] = tmp2_0;
      }
      this_0.hg3_1 = tmp6;
      this_0.ig3_1 = tmp8;
      this_0.jg3_1 = pprogram;
    }
    this_0.yg9(tmp2, matrix, vcount, icount);
  }
  vjj() {
    this.kjj_1.yge(0, this.njj(), this.ojj(), this.fjh(), this.gjh(), this.khy(), this.ijj_1, this.dih());
  }
  oib() {
    return Companion_getInstance_31().s9p(this.njj(), this.ojj(), this.fjh(), this.gjh());
  }
  toString() {
    var out = super.toString();
    if (!this.jjb().equals(Companion_getInstance_27().c9g_1))
      out = out + (':anchor=(' + this.nih(this.jjb().l9g_1) + ', ' + this.nih(this.jjb().m9g_1) + ')');
    return out;
  }
}
class BaseImage extends RectBase {
  static jk7(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.ljw(anchor, hitShape, smoothing);
    $this.ojg_1 = false;
    $this.pjg_1 = bitmap;
    $this.qjj();
    return $this;
  }
  static zjg(bmpCoords, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.jk7(Resourceable(bmpCoords), anchor, hitShape, smoothing);
  }
  ejh(value) {
    if (equals(this.ijj_1, value))
      return Unit_instance;
    this.ojg_1 = true;
    this.tjj(value);
  }
  gde() {
    return this.ijj_1;
  }
  qjj() {
    if (this.ojg_1)
      return Unit_instance;
    trySetSourceActually(this);
  }
  rib(ctx) {
    this.qjj();
    super.rib(ctx);
  }
  fjh() {
    return this.ijj_1.w9z();
  }
  gjh() {
    return this.ijj_1.x9z();
  }
  jal() {
    return this.ijj_1.jal();
  }
  kal() {
    return this.ijj_1.kal();
  }
  tak() {
    return this.ijj_1.tak();
  }
  uak() {
    return this.ijj_1.uak();
  }
  rjj() {
    return this.jjb().l9g_1 * this.tak();
  }
  sjj() {
    return this.jjb().m9g_1 * this.uak();
  }
  fif() {
    return this.rjj() - this.jal();
  }
  gif() {
    return this.sjj() - this.kal();
  }
  oib() {
    return Companion_getInstance_31().s9p(-this.rjj(), -this.sjj(), this.tak(), this.uak());
  }
  toString() {
    return super.toString() + (':bitmap=' + toString(this.gde()));
  }
}
class BaseGraphics extends BaseImage {
  static yjg(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    var $this = this.zjg(tmp$ret$0);
    $this.sjd_1 = autoScaling;
    $this.tjd_1 = true;
    $this.ujd_1 = false;
    $this.vjd_1 = false;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.wjd_1 = ArrayList.p2();
    $this.xjd_1 = new InternalViewAutoscaling();
    $this.yjd_1 = 1;
    $this.zjd_1 = true;
    $this.aje_1 = true;
    $this.bje_1 = null;
    $this.cje_1 = 1.0;
    $this.dje_1 = 1.0;
    $this.eje_1 = true;
    $this.fje_1 = true;
    $this.gje_1 = Companion_getInstance_31().y9k();
    $this.hje_1 = Companion_getInstance_31().y9k();
    return $this;
  }
  ajh(value) {
    this.tjd_1 = value;
    this.bjh();
  }
  bjh() {
    this.zjd_1 = true;
    this.aje_1 = true;
    this.gih();
  }
  pib() {
    super.pib();
    if (this.x1m() == null || this.dhv() == null) {
      var tmp = this.gde().qak();
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      if (!equals(tmp, get_bmp(tmp$ret$0))) {
        this.wjd_1.d2(this.gde().qak());
      }
      clearBitmaps(this, true);
    }
  }
  rib(ctx) {
    this.bje_1 = ctx;
    clearBitmaps(this, false);
    this.cjh();
    super.rib(ctx);
  }
  cjh() {
    if (this.xjd_1.xjg(this.sjd_1, this.ujd_1, this.khy())) {
      this.zjd_1 = true;
    }
    if (!this.zjd_1)
      return false;
    this.zjd_1 = false;
    var boundsWithShapes = boundsUnsafe(this, true);
    // Inline function 'kotlin.run' call
    this.wjd_1.d2(this.gde().qak());
    // Inline function 'kotlin.run' call
    var imageWidth = coerceAtLeast(toIntCeil(boundsWithShapes.q9h_1 * this.xjd_1.tjg_1), 1);
    var imageHeight = coerceAtLeast(toIntCeil(boundsWithShapes.r9h_1 * this.xjd_1.ujg_1), 1);
    var image = NativeImageOrBitmap32(imageWidth + this.yjd_1 | 0, imageHeight + this.yjd_1 | 0, this.tjd_1, true);
    this.cje_1 = this.xjd_1.tjg_1;
    this.dje_1 = this.xjd_1.ujg_1;
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = image.wc1_1;
    if (true) {
      image.fc2();
    }
    var result;
    try {
      var ctx = image.oc9(true);
      try {
        ctx.vdc(this.cje_1, this.dje_1);
        ctx.zcv(-boundsWithShapes.o9h_1, -boundsWithShapes.p9h_1);
        this.djh(ctx);
      }finally {
        ctx.u1o();
      }
    }finally {
      result = true ? image.hc2(rect) : 0;
    }
    this.ejh(slice(image));
    return true;
  }
  fjh() {
    return _get_bitmapWidth__ndy7bu(this) / this.cje_1;
  }
  gjh() {
    return _get_bitmapHeight__5t1vx1(this) / this.dje_1;
  }
  tak() {
    return this.fjh();
  }
  uak() {
    return this.gjh();
  }
  fif() {
    return this.jjb().l9g_1 * this.fjh();
  }
  gif() {
    return this.jjb().m9g_1 * this.gjh();
  }
  njj() {
    return _getLocalBoundsInternal(this, this.eje_1).o9h_1;
  }
  ojj() {
    return _getLocalBoundsInternal(this, this.eje_1).p9h_1;
  }
  oib() {
    return _getLocalBoundsInternal(this);
  }
  pjj(value) {
    this.fje_1 = value;
    this.gih();
  }
}
class CacheTexture {
  constructor($outer, ctx) {
    this.djk_1 = $outer;
    this.zjj_1 = ctx;
    this.ajk_1 = this.zjj_1.rgc(16, 16, VOID, VOID, VOID, false);
    this.bjk_1 = TextureBase.wg6(this.ajk_1.jek(), 16, 16);
    this.cjk_1 = Texture(this.bjk_1);
  }
  ejk(width, height) {
    this.ajk_1.lek(0, 0, width, height);
    this.bjk_1.xg6(width);
    this.bjk_1.yg6(height);
    this.cjk_1 = Texture(this.bjk_1);
  }
  f7() {
    this.djk_1.cie_1 = null;
    this.zjj_1.sgc(this.ajk_1);
  }
}
class ShapeView extends Container {
  static bjq(shape, fill, stroke, strokeThickness, autoScaling, renderer) {
    shape = shape === VOID ? null : shape;
    fill = fill === VOID ? new RGBA(Colors_getInstance().zc2_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().zc2_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 1.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.fi2();
    $this.njm_1 = addTo(Graphics.pk4(VOID, renderer), $this);
    $this.njm_1.tk4(autoScaling);
    var tmp = $this;
    var tmp0 = $this.njm_1;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = Graphics$_get_anchor_$ref_omu6ke(tmp0);
    tmp.ojm_1 = getPropertyCallableRef('anchor', 0, tmp_0, tmp_1, Graphics$_set_anchor_$ref_vc1a9i(tmp0));
    var tmp_2 = $this;
    var tmp0_0 = $this.njm_1;
    var tmp_3 = KMutableProperty0;
    var tmp_4 = Graphics$_get_antialiased_$ref_lyxmqu(tmp0_0);
    tmp_2.pjm_1 = getPropertyCallableRef('antialiased', 0, tmp_3, tmp_4, Graphics$_set_antialiased_$ref_w2nu9e(tmp0_0));
    var tmp_5 = $this;
    var tmp0_1 = $this.njm_1;
    var tmp_6 = KMutableProperty0;
    var tmp_7 = Graphics$_get_autoScaling_$ref_ph0c29(tmp0_1);
    tmp_5.qjm_1 = getPropertyCallableRef('autoScaling', 0, tmp_6, tmp_7, Graphics$_set_autoScaling_$ref_zgdieb(tmp0_1));
    var tmp_8 = $this;
    var tmp0_2 = $this.njm_1;
    var tmp_9 = KMutableProperty0;
    var tmp_10 = Graphics$_get_renderer_$ref_f00p9s(tmp0_2);
    tmp_8.rjm_1 = getPropertyCallableRef('renderer', 0, tmp_9, tmp_10, Graphics$_set_renderer_$ref_jq1ac(tmp0_2));
    var tmp_11 = $this;
    var tmp0_3 = $this.njm_1;
    var tmp_12 = KMutableProperty0;
    var tmp_13 = Graphics$_get_smoothing_$ref_6lbr1p(tmp0_3);
    tmp_11.sjm_1 = getPropertyCallableRef('smoothing', 0, tmp_12, tmp_13, Graphics$_set_smoothing_$ref_8mfrgn(tmp0_3));
    var tmp_14 = $this;
    var tmp0_4 = $this.njm_1;
    var tmp_15 = KMutableProperty0;
    var tmp_16 = Graphics$_get_boundsIncludeStrokes_$ref_pp8zhx(tmp0_4);
    tmp_14.tjm_1 = getPropertyCallableRef('boundsIncludeStrokes', 0, tmp_15, tmp_16, Graphics$_set_boundsIncludeStrokes_$ref_u7m755(tmp0_4));
    $this.ujm_1 = shape;
    $this.vjm_1 = fill;
    $this.wjm_1 = stroke;
    $this.xjm_1 = numberToDouble(strokeThickness);
    $this.xjp();
    $this.yjm_1 = new VectorPath();
    return $this;
  }
  ijb(_set____db54di) {
    var tmp0 = this.ojm_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ShapeView$_get_anchor_$ref_rn1mgt();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('anchor', 1, tmp, tmp_0, ShapeView$_set_anchor_$ref_ckt1bl());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  jjb() {
    var tmp0 = this.ojm_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ShapeView$_get_anchor_$ref_rn1mgt();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('anchor', 1, tmp, tmp_0, ShapeView$_set_anchor_$ref_ckt1bl());
    return tmp0.get();
  }
  fif() {
    return this.njm_1.fif();
  }
  gif() {
    return this.njm_1.gif();
  }
  obf() {
    return this.ujm_1;
  }
  cjq(value) {
    if (equals(this.vjm_1, value))
      return Unit_instance;
    this.vjm_1 = value;
    this.xjp();
  }
  djq(value) {
    if (equals(this.wjm_1, value))
      return Unit_instance;
    this.wjm_1 = value;
    this.xjp();
  }
  ska(value) {
    if (this.xjm_1 === value)
      return Unit_instance;
    this.xjm_1 = value;
    this.xjp();
  }
  xjp() {
    // Inline function 'korlibs.korge.view.Graphics.updateShape' call
    var this_0 = this.njm_1;
    var result;
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_1 = new ShapeBuilder(null, null);
    var shapeView = this;
    var shape = shapeView.obf();
    if (!(shape == null) && shape.o9j()) {
      if (!(shapeView.xjm_1 === 0.0)) {
        var tmp2 = shapeView.vjm_1;
        var tmp4 = shapeView.wjm_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var strokeInfo = new StrokeInfo(shapeView.xjm_1);
        this_1.udc(shape);
        if (!(tmp2 == null)) {
          this_1.acu(tmp2);
        }
        if (!(tmp4 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (tmp4 == null || strokeInfo == null) {
                break $l$block;
              }
              var tmp4_0 = strokeInfo.pab_1;
              var tmp6 = strokeInfo.sab_1;
              var tmp8 = strokeInfo.uab_1;
              var tmp10 = strokeInfo.vab_1;
              var tmp12 = strokeInfo.wab_1;
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineDashOffset = strokeInfo.xab_1;
              if (false) {
                this_1.rct();
              }
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              this_1.hcu();
              try {
                this_1.icu(numberToDouble(tmp4_0));
                this_1.jcu(tmp6);
                this_1.kcu(tmp8);
                this_1.lcu(numberToDouble(tmp10));
                this_1.mcu(tmp12);
                this_1.ncu(numberToDouble(lineDashOffset));
                this_1.ocu(tmp4);
              }finally {
                this_1.pcu();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth = this_1.bcu();
            var lineCap = this_1.ccu();
            var lineJoin = this_1.dcu();
            var miterLimit = this_1.ecu();
            var lineDash = this_1.fcu();
            var lineDashOffset_0 = this_1.gcu();
            if (false) {
              this_1.rct();
            }
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            this_1.hcu();
            try {
              this_1.icu(numberToDouble(lineWidth));
              this_1.jcu(lineCap);
              this_1.kcu(lineJoin);
              this_1.lcu(numberToDouble(miterLimit));
              this_1.mcu(lineDash);
              this_1.ncu(numberToDouble(lineDashOffset_0));
              this_1.ocu(tmp4);
            }finally {
              this_1.pcu();
            }
          }
        }
      } else {
        // Inline function 'korlibs.image.vector.Context2d.fill' call
        var paint = shapeView.vjm_1;
        if (true) {
          this_1.rct();
        }
        this_1.udc(shape);
        this_1.wdq(paint, null);
      }
    }
    result = Unit_instance;
    var tmp$ret$1 = this_1.rcq();
    this_0.nk4(tmp$ret$1);
  }
}
class Circle_0 extends ShapeView {
  constructor(radius, fill, stroke, strokeThickness, autoScaling, renderer) {
    return new.target.ajq(radius, fill, stroke, strokeThickness, autoScaling, renderer);
  }
  static ajq(radius, fill, stroke, strokeThickness, autoScaling, renderer) {
    radius = radius === VOID ? 16.0 : radius;
    fill = fill === VOID ? new RGBA(Colors_getInstance().zc2_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().zc2_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.bjq(new VectorPath(), fill, stroke, strokeThickness, autoScaling, renderer);
    var tmp = $this;
    var tmp0 = numberToDouble(radius);
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe = Circle$radius$delegate$lambda($this);
    tmp.tjp_1 = new UIObservable(tmp0, observe);
    var tmp_0 = $this;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = Circle$_get_colorMul_$ref_517rfx($this);
    tmp_0.ujp_1 = getPropertyCallableRef('colorMul', 0, tmp_1, tmp_2, Circle$_set_colorMul_$ref_aiiz47($this));
    updateGraphics($this);
    return $this;
  }
  yjp(_set____db54di) {
    var tmp = KMutableProperty1;
    var tmp_0 = Circle$_get_radius_$ref_oq96jg();
    return this.tjp_1.aiw(this, getPropertyCallableRef('radius', 1, tmp, tmp_0, Circle$_set_radius_$ref_v8maag()), _set____db54di);
  }
  vjp() {
    var tmp = KMutableProperty1;
    var tmp_0 = Circle$_get_radius_$ref_oq96jg();
    return this.tjp_1.ziv(this, getPropertyCallableRef('radius', 1, tmp, tmp_0, Circle$_set_radius_$ref_v8maag()));
  }
  zjp(_set____db54di) {
    var tmp0 = this.ujp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Circle$_get_color_$ref_y7a19z();
    getPropertyCallableRef('color', 1, tmp, tmp_0, Circle$_set_color_$ref_7izkal());
    // Inline function 'kotlin.setValue' call
    var value = new RGBA(_set____db54di);
    tmp0.set(value);
    return Unit_instance;
  }
  qd9() {
    var tmp0 = this.ujp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Circle$_get_color_$ref_y7a19z();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('color', 1, tmp, tmp_0, Circle$_set_color_$ref_7izkal());
    return tmp0.get().sci_1;
  }
}
class FixedSizeContainer extends Container {
  constructor(size, clip) {
    return new.target.pjs(size, clip);
  }
  static pjs(size, clip) {
    size = size === VOID ? Size2D.l9i(100, 100) : size;
    clip = clip === VOID ? false : clip;
    var $this = this.fi2();
    $this.mjs_1 = clip;
    $this.njs_1 = size;
    $this.ojs_1 = Ref(false);
    return $this;
  }
  mds() {
    return this.mjs_1;
  }
  lib(_set____db54di) {
    this.njs_1 = _set____db54di;
  }
  mib() {
    return this.njs_1;
  }
  oib() {
    return new Rectangle(0.0, 0.0, this.w9z(), this.x9z());
  }
  toString() {
    var out = super.toString();
    out = out + (':size=(' + get_niceStr(this.w9z()) + 'x' + get_niceStr(this.x9z()) + ')');
    return out;
  }
  rib(ctx) {
    var tmp6 = this.mds();
    var tmp8 = this.ojs_1;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.Companion.renderClipped' call
      if (tmp8.k3()) {
        super.rib(ctx);
        break $l$block_0;
      }
      if (tmp6) {
        var m = this.khy();
        var hasRotation = !(m.b9l_1 === 0.0) || !(m.c9l_1 === 0.0);
        if (hasRotation) {
          var old = tmp8.k3();
          try {
            tmp8.pa9(true);
            renderFiltered(this, ctx, Companion_getInstance_53());
          }finally {
            tmp8.pa9(old);
          }
          break $l$block_0;
        }
        // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var batcher = ctx.hg2_1;
        if (!(ctx.lg2_1 === batcher)) {
          ctx.lg2_1 = batcher;
          ctx.vg3();
        }
        var c2d = ctx.jg2_1;
        var bounds = this.aii(ctx).v9q(ctx.xg1_1).w9q();
        var rect = c2d.agd_1.jg9().jeq();
        var intersects = true;
        if (!(rect == null)) {
          intersects = bounds.j9q(rect);
        }
        if (intersects) {
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          // Inline function 'korlibs.korge.render.RenderContext2D.scissor' call
          var scissor = Companion_getInstance_15().eeq(bounds);
          var tmp0 = c2d.agd_1;
          var tmp2 = c2d.lgd(scissor);
          $l$block_1: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var temp = tmp0.og3_1;
            tmp0.zg9();
            tmp0.og3_1 = tmp2;
            try {
              super.rib(ctx);
              break $l$block_1;
            }finally {
              tmp0.zg9();
              tmp0.og3_1 = temp;
            }
          }
        } else {
          super.rib(ctx);
        }
      } else {
        super.rib(ctx);
      }
    }
  }
}
class ClipContainer extends FixedSizeContainer {
  constructor(size) {
    return new.target.xj5(size);
  }
  static xj5(size) {
    size = size === VOID ? Size2D.l9i(100, 100) : size;
    return this.pjs(size, true);
  }
}
class ZIndexComparator {
  qjs(a, b) {
    return compareTo(a.tif(), b.tif());
  }
  compare(a, b) {
    var tmp = a instanceof View ? a : THROW_CCE();
    return this.qjs(tmp, b instanceof View ? b : THROW_CCE());
  }
}
class ContainerCollection$iterator$1 {
  constructor(this$0) {
    this.vjs_1 = this$0;
    this.ujs_1 = 0;
  }
  q1() {
    return this.ujs_1 < this.vjs_1.tjs_1.nie();
  }
  r1() {
    var _unary__edvuaz = this.ujs_1;
    this.ujs_1 = _unary__edvuaz + 1 | 0;
    return this.vjs_1.tjs_1.qie(_unary__edvuaz);
  }
  s7() {
    this.ujs_1 = this.ujs_1 - 1 | 0;
    this.vjs_1.tjs_1.rie(this.ujs_1);
  }
}
class ContainerCollection {
  constructor(container, children) {
    this.sjs_1 = children;
    this.tjs_1 = container;
  }
  s2() {
    return this.tjs_1.nie();
  }
  wjs(element) {
    return element.x1m() === this.tjs_1;
  }
  w2(element) {
    if (!(element instanceof View))
      return false;
    return this.wjs(element instanceof View ? element : THROW_CCE());
  }
  xjs(elements) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!(element.x1m() === this.tjs_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  r4(elements) {
    return this.xjs(elements);
  }
  n1() {
    return this.tjs_1.nie() === 0;
  }
  yjs(element) {
    this.tjs_1.uie(element);
    return true;
  }
  d2(element) {
    return this.yjs(element instanceof View ? element : THROW_CCE());
  }
  zjs(elements) {
    if (elements.n1())
      return false;
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      this.tjs_1.uie(element);
    }
    return true;
  }
  t2(elements) {
    return this.zjs(elements);
  }
  p1() {
    return new ContainerCollection$iterator$1(this);
  }
  ajt(element) {
    return this.tjs_1.cif(element);
  }
  z4(element) {
    if (!(element instanceof View))
      return false;
    return this.ajt(element instanceof View ? element : THROW_CCE());
  }
  u2(index) {
    return this.sjs_1.u2(index);
  }
  bjt(element) {
    return this.sjs_1.y2(element);
  }
  y2(element) {
    if (!(element instanceof View))
      return -1;
    return this.bjt(element instanceof View ? element : THROW_CCE());
  }
  s4() {
    return this.sjs_1.s4();
  }
  x2(index) {
    return this.sjs_1.x2(index);
  }
  t4(fromIndex, toIndex) {
    return this.sjs_1.t4(fromIndex, toIndex);
  }
}
class CpuGraphics extends BaseGraphics {
  constructor(autoScaling) {
    return new.target.ijw(autoScaling);
  }
  static ijw(autoScaling) {
    autoScaling = autoScaling === VOID ? false : autoScaling;
    var $this = this.yjg(autoScaling);
    $this.ajw_1 = 0;
    $this.bjw_1 = null;
    $this.cjw_1 = true;
    $this.djw_1 = -1;
    $this.ejw_1 = -1;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.fjw_1 = ArrayList.p2();
    $this.gjw_1 = null;
    $this.hjw_1 = null;
    $this.lhr_1 = true;
    return $this;
  }
  jjw(value) {
    this.bjw_1 = value;
    this.ajw_1 = this.ajw_1 + 1 | 0;
    this.bjh();
  }
  wjj(value) {
    var tmp = this;
    var tmp_0;
    if (value == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = listOf(value);
    }
    tmp.hjw_1 = tmp_0;
  }
  hif() {
    var tmp0_safe_receiver = this.iif();
    return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
  }
  iif() {
    if (!(this.hjw_1 == null))
      return this.hjw_1;
    if (!(this.djw_1 === this.ajw_1)) {
      this.djw_1 = this.ajw_1;
      this.fjw_1.a5();
      var tmp = this.fjw_1;
      var tmp0_safe_receiver = this.bjw_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lcx();
      tmp.d2(tmp1_elvis_lhs == null ? new VectorPath() : tmp1_elvis_lhs);
    }
    return this.fjw_1;
  }
  djh(ctx) {
    var tmp0_safe_receiver = this.bjw_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.scw(ctx);
    }
  }
  qjg(includeStrokes) {
    var tmp0_safe_receiver = this.bjw_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zdr(includeStrokes);
    return tmp1_elvis_lhs == null ? Companion_getInstance_31().a9i_1 : tmp1_elvis_lhs;
  }
}
class CustomContextRenderizableView extends RectBase {
  static kjw(size) {
    var $this = this.ljw();
    $this.ij8_1 = size;
    return $this;
  }
  lib(value) {
    if (!this.ij8_1.equals(value)) {
      this.ij8_1 = value;
      this.bhr_1 = true;
    }
  }
  mib() {
    return this.ij8_1;
  }
  lj8() {
    var tmp = this.kj8_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('ctx2d');
    }
  }
  rib(ctx) {
    if (!this.yig())
      return Unit_instance;
    this.jj8_1 = ctx;
    // Inline function 'korlibs.korge.render.renderCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useCtx2d' call
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var batcher = ctx.hg2_1;
    if (!(ctx.lg2_1 === batcher)) {
      ctx.lg2_1 = batcher;
      ctx.vg3();
    }
    var context = ctx.jg2_1;
    // Inline function 'korlibs.korge.render.RenderContext2D.keep' call
    $l$block_3: {
      // Inline function 'korlibs.korge.render.RenderContext2D.keepMatrix' call
      var old = context.egd_1;
      try {
        $l$block_2: {
          // Inline function 'korlibs.korge.render.RenderContext2D.keepBlendMode' call
          var oldBlendFactors = context.fgd_1;
          try {
            $l$block_1: {
              // Inline function 'korlibs.korge.render.RenderContext2D.keepColor' call
              var multiplyColor = context.ggd_1;
              try {
                $l$block_0: {
                  // Inline function 'korlibs.korge.render.RenderContext2D.keepFiltering' call
                  var filtering = context.hgd_1;
                  try {
                    $l$block: {
                      // Inline function 'korlibs.korge.render.RenderContext2D.keepSize' call
                      var size = context.cgd_1;
                      try {
                        context.cgd_1 = Size2D.y9p(this.w9z(), this.x9z());
                        context.fgd_1 = this.cih();
                        context.ggd_1 = this.dih();
                        context.igd(this.khy());
                        this.kj8_1 = context;
                        this.mjw(context, Size2D.y9p(this.w9z(), this.x9z()));
                        break $l$block;
                      }finally {
                        context.cgd_1 = size;
                      }
                    }
                    break $l$block_0;
                  }finally {
                    context.hgd_1 = filtering;
                  }
                }
                break $l$block_1;
              }finally {
                context.ggd_1 = multiplyColor;
              }
            }
            break $l$block_2;
          }finally {
            context.fgd_1 = oldBlendFactors;
          }
        }
        break $l$block_3;
      }finally {
        context.egd_1 = old;
      }
    }
  }
}
class DummyView extends View {
  constructor() {
    return new.target.njy();
  }
  static njy() {
    return this.ojy();
  }
  rib(ctx) {
    return Unit_instance;
  }
}
class Companion_4 {}
class SContainer extends FixedSizeContainer {
  constructor(size, clip) {
    return new.target.si4(size, clip);
  }
  static si4(size, clip) {
    size = size === VOID ? Size2D.l9i(100, 100) : size;
    clip = clip === VOID ? false : clip;
    return this.pjs(size, clip);
  }
}
class TimeSlidingWindow {
  constructor(capacity) {
    this.qjy_1 = capacity;
    this.rjy_1 = IntDeque.ba5(this.qjy_1);
    this.sjy_1 = 0;
  }
  s2() {
    return this.rjy_1.s2();
  }
  tjy() {
    return this.rjy_1.s2() === 0 ? get_fastSeconds(0) : get_fastMicroseconds(this.sjy_1 / this.rjy_1.s2());
  }
  ujy() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(1, DurationUnit_SECONDS_getInstance());
    return div(tmp$ret$0, this.tjy());
  }
  vjy(index) {
    return get_fastMicroseconds_0(this.rjy_1.u2(index));
  }
  wjy(value) {
    var intValue = numberToInt(_FastDuration___get_fastMicroseconds__impl__e641g1(value));
    this.rjy_1.ga5(intValue);
    this.sjy_1 = this.sjy_1 + intValue | 0;
    if (this.rjy_1.s2() > this.qjy_1) {
      this.sjy_1 = this.sjy_1 - this.rjy_1.zl() | 0;
    }
  }
}
class GraphicsRenderer extends Enum {}
class Graphics extends Container {
  constructor(shape, renderer) {
    return new.target.pk4(shape, renderer);
  }
  static pk4(shape, renderer) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    renderer = renderer === VOID ? GraphicsRenderer_GPU_getInstance() : renderer;
    var $this = this.fi2();
    $this.fk1_1 = null;
    $this.gk1_1 = null;
    $this.hk1_1 = true;
    $this.ik1_1 = false;
    $this.jk1_1 = true;
    $this.kk1_1 = true;
    $this.lk1_1 = EmptyShape_instance;
    $this.mk1_1 = renderer;
    $this.nk4(shape);
    return $this;
  }
  qk4() {
    var tmp0_elvis_lhs = this.fk1_1;
    return ensureNotNull(tmp0_elvis_lhs == null ? this.gk1_1 : tmp0_elvis_lhs);
  }
  pjj(value) {
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pjj(value);
    }
    var tmp1_safe_receiver = this.gk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.pjj(value);
    }
    this.hie();
    this.gih();
  }
  rk4() {
    var tmp0_safe_receiver = this.fk1_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fje_1;
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = this.gk1_1;
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.qk3_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp;
    return tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  }
  ijb(value) {
    _get_anchorable__ebfoik(this).ijb(value);
    this.hie();
  }
  jjb() {
    return _get_anchorable__ebfoik(this).jjb();
  }
  fif() {
    return this.qk4().fif();
  }
  gif() {
    return this.qk4().gif();
  }
  ok4(value) {
    if (this.hk1_1 === value)
      return Unit_instance;
    this.hk1_1 = value;
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.cjw_1 = value;
    }
    var tmp1_safe_receiver = this.gk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.ok4(value);
    }
    this.hie();
  }
  sk4(value) {
    if (this.jk1_1 === value)
      return Unit_instance;
    this.jk1_1 = value;
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hjj_1 = value;
    }
    var tmp1_safe_receiver = this.gk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.pk3_1 = value;
    }
    this.hie();
  }
  tk4(value) {
    if (this.kk1_1 === value)
      return Unit_instance;
    this.kk1_1 = value;
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sjd_1 = value;
    }
    var tmp1_safe_receiver = this.gk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.nk3_1 = value;
    }
    this.hie();
  }
  nk4(value) {
    if (this.lk1_1 === value)
      return Unit_instance;
    this.lk1_1 = value;
    ensure(this);
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jjw(value);
    }
    var tmp1_safe_receiver = this.gk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.nk4(value);
    }
    this.hie();
  }
  uk4(value) {
    if (this.mk1_1 === value)
      return Unit_instance;
    this.mk1_1 = value;
    this.vk4();
  }
  vk4() {
    ensure(this);
    var tmp0_safe_receiver = this.fk1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.bjh();
    }
    var tmp1_safe_receiver = this.fk1_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver.cjh();
  }
}
class ViewFileRef {}
function forceLoadSourceFile$default(views, currentVfs, sourceFile, $completion, $super) {
  currentVfs = currentVfs === VOID ? views.aho_1 : currentVfs;
  sourceFile = sourceFile === VOID ? null : sourceFile;
  return $super === VOID ? this.nk7(views, currentVfs, sourceFile, $completion) : $super.nk7.call(this, views, currentVfs, sourceFile, $completion);
}
class Image extends BaseImage {
  constructor(bitmap, anchor, hitShape, smoothing) {
    return new.target.ik7(bitmap, anchor, hitShape, smoothing);
  }
  static ik7(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    var $this = this.jk7(bitmap, anchor, hitShape, smoothing);
    $this.ek7_1 = new Mixin_0();
    var tmp = $this;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = Image$_get_sourceFile_$ref_qb7578($this);
    tmp.fk7_1 = getPropertyCallableRef('sourceFile', 0, tmp_0, tmp_1, Image$_set_sourceFile_$ref_j6tgqg($this));
    return $this;
  }
  static kk7(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.ik7(Resourceable(bitmap), anchor, hitShape, smoothing);
  }
  static lk7(bitmap, anchor, hitShape, smoothing) {
    anchor = anchor === VOID ? Companion_getInstance_27().c9g_1 : anchor;
    hitShape = hitShape === VOID ? null : hitShape;
    smoothing = smoothing === VOID ? true : smoothing;
    return this.kk7(slice(bitmap), anchor, hitShape, smoothing);
  }
  rib(ctx) {
    this.mk7(ctx, this);
    super.rib(ctx);
  }
  *nk7(views, currentVfs, sourceFile, $completion) {
    yield* this.ok7(this, views, currentVfs, sourceFile, $completion);
    try {
      this.ejh(yield* readBitmapSlice(currentVfs.wi('' + sourceFile), VOID, VOID, VOID, $completion));
      this.uif(1.0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
        var tmp$ret$0 = get_Bitmaps_white();
        this.ejh(tmp$ret$0);
        this.uif(100.0);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  qk7(_set____db54di) {
    this.ek7_1.rk7_1 = _set____db54di;
  }
  hk7(_set____db54di) {
    this.ek7_1.hk7(_set____db54di);
  }
  gk7() {
    return this.ek7_1.sk7_1;
  }
  *ok7(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    yield* this.ek7_1.ok7(_this__u8e3s4, views, currentVfs, sourceFile, $completion);
    return Unit_instance;
  }
  mk7(ctx, view) {
    this.ek7_1.mk7(ctx, view);
  }
}
class RenderableView extends CustomContextRenderizableView {
  constructor(size, viewRenderer) {
    return new.target.lj3(size, viewRenderer);
  }
  static lj3(size, viewRenderer) {
    var $this = this.kjw(size);
    $this.hir_1 = viewRenderer;
    $this.iir_1 = false;
    $this.jir_1 = false;
    $this.kir_1 = false;
    return $this;
  }
  mjw(context, size) {
    // Inline function 'kotlin.apply' call
    this.hir_1.xiz(this);
  }
}
class RoundRect extends ShapeView {
  constructor(size, radius, fill, stroke, strokeThickness, autoScaling) {
    return new.target.rka(size, radius, fill, stroke, strokeThickness, autoScaling);
  }
  static rka(size, radius, fill, stroke, strokeThickness, autoScaling) {
    fill = fill === VOID ? new RGBA(Colors_getInstance().zc2_1) : fill;
    stroke = stroke === VOID ? new RGBA(Colors_getInstance().zc2_1) : stroke;
    strokeThickness = strokeThickness === VOID ? 0.0 : strokeThickness;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.bjq(new VectorPath(), fill, stroke, strokeThickness, autoScaling);
    var tmp = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe = RoundRect$unscaledSize$delegate$lambda($this);
    tmp.nka_1 = new UIObservable(size, observe);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.ui.uiObservable' call
    var observe_0 = RoundRect$radius$delegate$lambda($this);
    tmp_0.oka_1 = new UIObservable(radius, observe_0);
    var tmp_1 = $this;
    var tmp_2 = KMutableProperty0;
    var tmp_3 = RoundRect$_get_colorMul_$ref_6jrgtn($this);
    tmp_1.pka_1 = getPropertyCallableRef('colorMul', 0, tmp_2, tmp_3, RoundRect$_set_colorMul_$ref_8zz9qh($this));
    updateGraphics_0($this);
    return $this;
  }
  lib(_set____db54di) {
    var tmp = KMutableProperty1;
    var tmp_0 = RoundRect$_get_unscaledSize_$ref_h95i3c();
    return this.nka_1.aiw(this, getPropertyCallableRef('unscaledSize', 1, tmp, tmp_0, RoundRect$_set_unscaledSize_$ref_btyqzg()), _set____db54di);
  }
  mib() {
    var tmp = KMutableProperty1;
    var tmp_0 = RoundRect$_get_unscaledSize_$ref_h95i3c();
    return this.nka_1.ziv(this, getPropertyCallableRef('unscaledSize', 1, tmp, tmp_0, RoundRect$_set_unscaledSize_$ref_btyqzg()));
  }
  qka(_set____db54di) {
    var tmp = KMutableProperty1;
    var tmp_0 = RoundRect$_get_radius_$ref_f18u7a();
    return this.oka_1.aiw(this, getPropertyCallableRef('radius', 1, tmp, tmp_0, RoundRect$_set_radius_$ref_zqxy()), _set____db54di);
  }
  vjp() {
    var tmp = KMutableProperty1;
    var tmp_0 = RoundRect$_get_radius_$ref_f18u7a();
    return this.oka_1.ziv(this, getPropertyCallableRef('radius', 1, tmp, tmp_0, RoundRect$_set_radius_$ref_zqxy()));
  }
}
class CoordsType extends Enum {}
class Companion_5 {}
class ShadedView extends RectBase {
  static ckd(program, size, coordsType) {
    size = size === VOID ? Size2D.t9p(100.0, 100.0) : size;
    coordsType = coordsType === VOID ? CoordsType_D_0_1_getInstance() : coordsType;
    var $this = this.ljw(Companion_getInstance_27().c9g_1);
    $this.zkc_1 = size;
    $this.ljj_1 = program;
    $this.akd_1 = Companion_getInstance_30().f9k_1;
    $this.bkd_1 = coordsType;
    return $this;
  }
  lib(value) {
    if (this.zkc_1.equals(value))
      return Unit_instance;
    this.zkc_1 = value;
    this.bhr_1 = true;
  }
  mib() {
    return this.zkc_1;
  }
  fjh() {
    return this.w9z();
  }
  gjh() {
    return this.x9z();
  }
  vjj() {
    var L = this.njj() - this.akd_1.j9k_1;
    var T = this.ojj() - this.akd_1.g9k_1;
    var R = this.fjh() + this.akd_1.l9k();
    var B = this.gjh() + this.akd_1.m9k();
    var l = -this.akd_1.j9k_1;
    var t = -this.akd_1.g9k_1;
    var r = this.fjh() + this.akd_1.h9k_1;
    var b = this.gjh() + this.akd_1.i9k_1;
    var tmp;
    switch (this.bkd_1.w1_1) {
      case 0:
        tmp = 0.0;
        break;
      case 1:
        tmp = -1.0;
        break;
      case 2:
        tmp = 0.0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var lmin = tmp;
    var lmax = 1.0;
    switch (this.bkd_1.w1_1) {
      case 0:
      case 1:
        l = convertRange_1(l, 0.0, this.fjh(), lmin, lmax);
        r = convertRange_1(r, 0.0, this.fjh(), lmin, lmax);
        t = convertRange_1(t, 0.0, this.gjh(), lmin, lmax);
        b = convertRange_1(b, 0.0, this.gjh(), lmin, lmax);
        break;
      default:
        break;
    }
    this.kjj_1.zge(0, L, T, R, B, this.khy(), l, t, r, t, l, b, r, b, this.dih());
  }
  dkd(ctx) {
  }
  rib(ctx) {
    if (!this.yig())
      return Unit_instance;
    this.dkd(ctx);
    super.rib(ctx);
  }
}
class Companion_6 {
  ekd(width, height, color) {
    return SolidRect.mkf(Size2D.y9p(width, height), color);
  }
}
class SolidRect extends RectBase {
  constructor(size, color) {
    return new.target.mkf(size, color);
  }
  static mkf(size, color) {
    color = color === VOID ? Colors_getInstance().zc2_1 : color;
    var $this = this.ljw();
    $this.lkf_1 = size;
    $this.kci(color);
    return $this;
  }
  lib(value) {
    if (this.lkf_1.equals(value))
      return Unit_instance;
    this.lkf_1 = value;
    this.bhr_1 = true;
    this.hie();
  }
  mib() {
    return this.lkf_1;
  }
  fjh() {
    return this.w9z();
  }
  gjh() {
    return this.x9z();
  }
  zjp(value) {
    this.kci(value);
  }
  qd9() {
    return this.mci();
  }
}
class Stage extends FixedSizeContainer {
  constructor(views) {
    return new.target.ehl(views);
  }
  static ehl(views) {
    var $this = this.pjs();
    $this.ahl_1 = views.nhn_1;
    $this.bhl_1 = views;
    var tmp = $this;
    var tmp0 = $this.phw();
    var tmp_0 = KMutableProperty0;
    var tmp_1 = Views$_get_clipBorders_$ref_ey1djh(tmp0);
    tmp.chl_1 = getPropertyCallableRef('clipBorders', 0, tmp_0, tmp_1, Views$_set_clipBorders_$ref_p1rl21(tmp0));
    var tmp_2 = $this;
    var tmp0_0 = $this.phw();
    var tmp_3 = KMutableProperty0;
    var tmp_4 = Views$_get_virtualSizeDouble_$ref_h1wx65(tmp0_0);
    tmp_2.dhl_1 = getPropertyCallableRef('virtualSizeDouble', 0, tmp_3, tmp_4, Views$_set_virtualSizeDouble_$ref_n7j9lt(tmp0_0));
    $this.kif($this);
    $this.mif($this);
    return $this;
  }
  phw() {
    return this.bhl_1;
  }
  nkf(_set____db54di) {
    var tmp0 = this.chl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Stage$_get_clip_$ref_cmaivk();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('clip', 1, tmp, tmp_0, Stage$_set_clip_$ref_6lsl8());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  mds() {
    var tmp0 = this.chl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Stage$_get_clip_$ref_cmaivk();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('clip', 1, tmp, tmp_0, Stage$_set_clip_$ref_6lsl8());
    return tmp0.get();
  }
  lib(_set____db54di) {
    var tmp0 = this.dhl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Stage$_get_unscaledSize_$ref_rdy7l8();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('unscaledSize', 1, tmp, tmp_0, Stage$_set_unscaledSize_$ref_1p61hk());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  mib() {
    var tmp0 = this.dhl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Stage$_get_unscaledSize_$ref_rdy7l8();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('unscaledSize', 1, tmp, tmp_0, Stage$_set_unscaledSize_$ref_1p61hk());
    return tmp0.get();
  }
  uiv() {
    return this.phw().jhn_1;
  }
  dhv() {
    return this;
  }
  iie() {
    return this;
  }
  pg5() {
    return this.eih(this.phw());
  }
  jie(view) {
    this.phw().jie(view);
  }
  toString() {
    return 'Stage';
  }
  d1m() {
    return this.bhl_1.dhn_1;
  }
  fgb(pos) {
    return this.ahl_1.fgb(pos);
  }
  uga(value) {
    this.ahl_1.uga(value);
  }
  vga() {
    return this.ahl_1.vga();
  }
  wga(value) {
    this.ahl_1.wga(value);
  }
  xga() {
    return this.ahl_1.xga();
  }
  yga(value) {
    this.ahl_1.yga(value);
  }
  zga() {
    return this.ahl_1.zga();
  }
  agb(value) {
    this.ahl_1.agb(value);
  }
  bgb() {
    return this.ahl_1.bgb();
  }
  cgb(value) {
    this.ahl_1.cgb(value);
  }
  dgb() {
    return this.ahl_1.dgb();
  }
  egb() {
    return this.ahl_1.egb();
  }
}
class Companion_7 {
  constructor() {
    this.yj5_1 = 16.0;
    this.zj5_1 = true;
  }
}
class IText {}
class Text extends Container {
  constructor(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    return new.target.aj6(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke);
  }
  static aj6(text, textSize, color, font, alignment, renderer, autoScaling, fill, stroke) {
    textSize = textSize === VOID ? Companion_instance_22.yj5_1 : textSize;
    color = color === VOID ? Colors_getInstance().zc2_1 : color;
    font = font === VOID ? get_DefaultTtfFontAsBitmap() : font;
    alignment = alignment === VOID ? Companion_getInstance_2().ucr_1 : alignment;
    renderer = renderer === VOID ? get_DefaultStringTextRenderer() : renderer;
    autoScaling = autoScaling === VOID ? Companion_instance_22.zj5_1 : autoScaling;
    fill = fill === VOID ? null : fill;
    stroke = stroke === VOID ? null : stroke;
    var $this = this.fi2();
    $this.qim_1 = true;
    $this.rim_1 = -1;
    $this.sim_1 = -1;
    $this.tim_1 = 0;
    $this.uim_1 = 0;
    $this.vim_1 = text;
    updateLineCount($this);
    var tmp = $this;
    tmp.wim_1 = fill == null ? new RGBA(color) : fill;
    $this.xim_1 = stroke;
    $this.yim_1 = font;
    $this.zim_1 = numberToDouble(textSize);
    var tmp_0 = $this;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = Text$_get_textSize_$ref_mcnl5v($this);
    tmp_0.ain_1 = getPropertyCallableRef('textSize', 0, tmp_1, tmp_2, Text$_set_textSize_$ref_6swulr($this));
    $this.bin_1 = 0;
    $this.cin_1 = 2147483647;
    $this.din_1 = renderer;
    $this.ein_1 = alignment;
    var tmp_3 = $this;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Container.fi2(false);
    // Inline function 'kotlin.apply' call
    tmp_3.fin_1 = addTo(this_0, $this);
    $this.gin_1 = new Text2TextRendererActions();
    $this.hin_1 = false;
    $this.iin_1 = autoScaling;
    $this.jin_1 = false;
    $this.kin_1 = null;
    $this.lin_1 = Companion_getInstance_31().r9p(0, 0, 2048, 2048);
    $this.min_1 = true;
    $this.nin_1 = -1;
    $this.oin_1 = new MMatrix();
    $this.pin_1 = -1;
    $this.qin_1 = null;
    $this.rin_1 = new Entry();
    $this.sin_1 = new FontMetrics();
    $this.tin_1 = new TextMetrics();
    $this.uin_1 = null;
    $this.vin_1 = null;
    $this.win_1 = null;
    $this.xin_1 = null;
    $this.yin_1 = new MMatrix();
    $this.zin_1 = GraphicsRenderer_SYSTEM_getInstance();
    $this.aio_1 = true;
    $this.bio_1 = null;
    var tmp_4 = $this;
    var tmp_5 = KMutableProperty0;
    var tmp_6 = Text$_get_fontSource_$ref_bq5hbb($this);
    tmp_4.cio_1 = getPropertyCallableRef('fontSource', 0, tmp_5, tmp_6, Text$_set_fontSource_$ref_dsxyq5($this));
    return $this;
  }
  fio(value) {
    if (!(this.vim_1 === value)) {
      this.vim_1 = value;
      updateLineCount(this);
      this.lie();
      this.hie();
    }
  }
  dio() {
    return this.vim_1;
  }
  rkf(value) {
    if (!equals(this.wim_1, value)) {
      this.wim_1 = value;
      this.lie();
    }
  }
  zjp(value) {
    this.rkf(new RGBA(value));
  }
  qd9() {
    var tmp = this.wim_1;
    var tmp_0;
    if (tmp == null ? true : tmp instanceof RGBA) {
      var tmp_1 = tmp;
      tmp_0 = tmp_1 == null ? null : tmp_1.sci_1;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp0_elvis_lhs;
    if ((tmp_3 == null ? null : new RGBA(tmp_3)) == null) {
      tmp_2 = Colors_getInstance().zc2_1;
    } else {
      tmp_2 = tmp0_elvis_lhs;
    }
    return tmp_2;
  }
  eiu(value) {
    if (!equals(this.yim_1, value)) {
      this.yim_1 = value;
      this.lie();
    }
  }
  fiu(value) {
    if (!(this.zim_1 === value)) {
      this.zim_1 = value;
      this.lie();
    }
  }
  okf(_set____db54di) {
    var tmp0 = this.ain_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Text$_get_fontSize_$ref_hdbrpb();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('fontSize', 1, tmp, tmp_0, Text$_set_fontSize_$ref_wx2i9f());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  eck() {
    var tmp0 = this.ain_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Text$_get_fontSize_$ref_hdbrpb();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fontSize', 1, tmp, tmp_0, Text$_set_fontSize_$ref_wx2i9f());
    return tmp0.get();
  }
  lie() {
    this.tim_1 = this.tim_1 + 1 | 0;
    super.lie();
  }
  qdq() {
    return this.ein_1.ict_1;
  }
  hdn() {
    return this.ein_1.jct_1;
  }
  qkf(value) {
    this.kin_1 = value;
    this.hin_1 = false;
    this.lie();
  }
  *pkf(currentVfs, sourceFile, $completion) {
    this.qkf(sourceFile);
    this.hin_1 = true;
    if (!(sourceFile == null)) {
      this.eiu(yield* readFont(currentVfs.wi('' + sourceFile), VOID, VOID, VOID, $completion));
    }
    return Unit_instance;
  }
  oib() {
    this.skf(null);
    if (!(get_filter(this) == null) || !(get_backdropFilter(this) == null)) {
      return super.oib();
    } else {
      return this.lin_1;
    }
  }
  rib(ctx) {
    this.skf(ctx);
    var tva = this.xin_1;
    if (!(tva == null)) {
      this.oin_1.pau(this.khy());
      this.oin_1.tau(this.fin_1.wea(), this.fin_1.xea());
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.hg2_1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var this_1 = this_0.qg2_1;
      if (!(this_1.lg2_1 === this_0)) {
        this_1.lg2_1 = this_0;
        this_1.vg3();
      }
      var tmp = this.yim_1;
      var bmpfont = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
      var tex = bmpfont.jck();
      this_0.dga(tex, this.qim_1, this.cih(), get_agProgram(bmpfont), tva.ug9_1, tva.tg9_1);
      this_0.yg9(tva, this.oin_1.x9p());
    } else {
      super.rib(ctx);
    }
  }
  jiu() {
    this.skf(null);
    if (!(this.pin_1 === this.tim_1)) {
      this.pin_1 = this.tim_1;
      var tmp = this;
      var tmp0_safe_receiver = this.yim_1.q9v();
      tmp.qin_1 = tmp0_safe_receiver == null ? null : getTextBoundsWithGlyphs(tmp0_safe_receiver, this.eck(), this.dio(), this.din_1, this.ein_1);
    }
    var tmp1_elvis_lhs = this.qin_1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Must ensure font is resolved before calling getGlyphMetrics';
      throw IllegalStateException.o(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  skf(ctx) {
    if (!(ctx == null)) {
      var fontSource = this.kin_1;
      if (!this.hin_1 && !(fontSource == null)) {
        this.hin_1 = true;
        launchImmediately_0(ctx.ng1_1, Text$_renderInternal$slambda(this, ctx, fontSource));
      }
    }
    var font = this.yim_1.q9v();
    var tmp;
    var tmp_0;
    if (this.min_1) {
      tmp_0 = !(font == null) ? isInterface(font, Font) : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(this.nin_1 === this.tim_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.nin_1 = this.tim_1;
      var metrics = getTextBounds(font, this.zim_1, this.dio(), this.tin_1, this.din_1, this.ein_1);
      this.lin_1 = new Rectangle(metrics.v9h(), VerticalAlign__getOffsetY_impl_iso0y6(this.ein_1.jct_1, metrics.x9z(), -metrics.qct()), metrics.w9z(), font.nck(this.zim_1, this.sin_1).fck() * this.uim_1);
    }
    if (font != null) {
      if (!(font == null) ? isInterface(font, BitmapFont) : false) {
        var rversion = this.din_1.d87();
        if (!(this.vin_1 === this.qim_1) || !(this.rim_1 === this.tim_1) || !(this.sim_1 === rversion)) {
          this.vin_1 = this.qim_1;
          this.sim_1 = rversion;
          this.rim_1 = this.tim_1;
          if (!(this.bio_1 == null)) {
            this.bio_1 = null;
            this.fin_1.tie();
          }
          this.gin_1.ldn();
          this.gin_1.ydm_1 = Companion_getInstance_2().ycr_1;
          invoke(this.din_1, this.gin_1, this.dio(), this.zim_1, font);
          while (this.fin_1.nie() < this.gin_1.s2()) {
            var tmp0 = this.fin_1;
            // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
            // Inline function 'korlibs.korge.view.image' call
            var texture = get_Bitmaps_transparent();
            var anchor_0 = Companion_getInstance_27().c9g_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_0 = Image.kk7(texture, anchor_0);
            // Inline function 'kotlin.apply' call
            addTo(this_0, tmp0);
          }
          while (this.fin_1.nie() > this.gin_1.s2()) {
            this.fin_1.u2(this.fin_1.nie() - 1 | 0).uih();
          }
          var bounds = this.gin_1.faf();
          var firstBounds = this.gin_1.jdn(0);
          var lineInfos = this.gin_1.idn();
          var tmp1_elvis_lhs = firstOrNull(lineInfos);
          var firstLineInfos = tmp1_elvis_lhs == null ? new LineInfo() : tmp1_elvis_lhs;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0;
          var _iterator__ex2g4s = lineInfos.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_1 = sum;
            sum = tmp_1 + element.hdm_1;
          }
          var totalHeight = sum;
          var textWidth = bounds.q9h_1;
          var textHeight = bounds.r9h_1;
          var dx = this.min_1 ? this.lin_1.o9h_1 : this.lin_1.o9h_1 + 1 + (this.lin_1.q9h_1 - textWidth) * _HorizontalAlign___get_ratio__impl__x9wlea(this.qdq());
          var tmp_2;
          if (this.min_1) {
            tmp_2 = this.lin_1.p9h_1 + firstLineInfos.fdm_1;
          } else {
            var tmp2_subject = this.hdn();
            tmp_2 = equals(tmp2_subject, Companion_getInstance_3().zdl_1) ? this.lin_1.p9h_1 : this.lin_1.p9h_1 + firstLineInfos.fdm_1 + (this.lin_1.r9h_1 - totalHeight) * _VerticalAlign___get_ratioFake__impl__1h2fwv(this.hdn());
          }
          var dy = tmp_2;
          var program = get_agProgram(font);
          var inductionVariable = 0;
          var last = this.gin_1.s2();
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var entry = this.gin_1.kdn(n, this.rin_1);
              var tmp_3 = this.fin_1.u2(n);
              var it = tmp_3 instanceof Image ? tmp_3 : THROW_CCE();
              it.ljj_1 = program;
              it.kci(this.qd9());
              // Inline function 'korlibs.korge.view.anchor' call
              anchor(it, Anchor2D.p9g(numberToDouble(0), numberToDouble(0)));
              it.hjj_1 = this.qim_1;
              it.ejh(entry.idm_1);
              it.fcw(Vector2D.t9g(entry.jdm_1 + dx, entry.kdm_1 + dy));
              it.aig(Scale.e9p(entry.ldm_1, entry.mdm_1));
              it.eig(entry.ndm_1);
              var containsLower = this.bin_1;
              it.ngk(n < this.cin_1 ? containsLower <= n : false);
            }
             while (inductionVariable < last);
        }
      } else {
        if (!(this.vin_1 === this.qim_1) || !(this.win_1 === this.aio_1)) {
          this.tim_1 = this.tim_1 + 1 | 0;
          this.win_1 = this.aio_1;
          this.uin_1 = this.iin_1;
          this.vin_1 = this.qim_1;
        }
        if (!(this.rim_1 === this.tim_1)) {
          this.rim_1 = this.tim_1;
          var realTextSize = this.zim_1;
          if (this.bio_1 == null) {
            this.fin_1.tie();
            var tmp_4 = this;
            var tmp0_0 = this.fin_1;
            // Inline function 'korlibs.korge.view.graphics' call
            var renderer = this.zin_1;
            // Inline function 'kotlin.also' call
            var this_1 = addTo(Graphics.pk4(EmptyShape_instance, renderer), tmp0_0);
            // Inline function 'korlibs.korge.view.Graphics.updateShape' call
            var result;
            // Inline function 'korlibs.image.vector.buildShape' call
            // Inline function 'kotlin.apply' call
            var this_2 = new ShapeBuilder(null, null);
            result = Unit_instance;
            var tmp$ret$12 = this_2.rcq();
            this_1.nk4(tmp$ret$12);
            this_1.vk4();
            tmp_4.bio_1 = this_1;
            var tmp3_safe_receiver = this.bio_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              tmp3_safe_receiver.tk4(true);
            }
          }
          // Inline function 'korlibs.korge.view.Graphics.updateShape' call
          var this_3 = ensureNotNull(this.bio_1);
          var result_0;
          // Inline function 'korlibs.image.vector.buildShape' call
          // Inline function 'kotlin.apply' call
          var this_4 = new ShapeBuilder(null, null);
          var tmp0_text = this.dio();
          var tmp1_pos = Companion_getInstance_29().g9h_1;
          var tmp2_paint = this.qd9();
          var tmp3_renderer = this.din_1;
          var tmp4_align = this.ein_1;
          var tmp5_outMetrics = new TextMetricsResult();
          var tmp6_fillStyle = this.wim_1;
          var tmp7_stroke = this.xim_1;
          var tmp8_textRangeStart = this.bin_1;
          var tmp9_textRangeEnd = this.cin_1;
          result_0 = this_4.adr(tmp0_text, tmp1_pos, VOID, new RGBA(tmp2_paint), font, realTextSize, tmp3_renderer, tmp4_align, tmp5_outMetrics, tmp6_fillStyle, tmp7_stroke, tmp8_textRangeStart, tmp9_textRangeEnd);
          var tmp$ret$18 = this_4.rcq();
          this_3.nk4(tmp$ret$18);
          var metrics_0 = result_0;
          this.pin_1 = this.tim_1;
          this.qin_1 = metrics_0;
          setContainerPosition(this, Companion_getInstance_29().g9h_1, font.nck(this.eck(), this.sin_1).rck_1);
        }
        var tmp4_safe_receiver = this.bio_1;
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.sk4(this.qim_1);
        }
      }
    }
  }
}
class ColorReference {}
class Companion_8 {
  tkf(left, right) {
    var l = left;
    var r = right;
    var lCount = get_ancestorCount(l);
    var rCount = get_ancestorCount(r);
    while (lCount >= 0 || rCount >= 0) {
      if (equals(l, r))
        return l;
      var ldec = lCount >= rCount;
      var rdec = rCount >= lCount;
      if (ldec) {
        lCount = lCount - 1 | 0;
        var tmp0_safe_receiver = l;
        l = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1m();
      }
      if (rdec) {
        rCount = rCount - 1 | 0;
        var tmp1_safe_receiver = r;
        r = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.x1m();
      }
    }
    return null;
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.ukf_1 = function_0;
  }
  pj(a, b) {
    return this.ukf_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.ukf_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class ViewRenderPhase {}
function get_priority() {
  return 0;
}
function render_0(view, ctx) {
  return view.lih(ctx);
}
function beforeRender(view, ctx) {
  return Unit_instance;
}
function afterRender(view, ctx) {
  return Unit_instance;
}
class Mixin_0 {
  constructor() {
    this.rk7_1 = true;
    this.sk7_1 = null;
  }
  qk7(_set____db54di) {
    this.rk7_1 = _set____db54di;
  }
  hk7(value) {
    this.rk7_1 = false;
    this.sk7_1 = value;
  }
  *ok7(_this__u8e3s4, views, currentVfs, sourceFile, $completion) {
    _this__u8e3s4.hk7(sourceFile);
    _this__u8e3s4.qk7(true);
    return Unit_instance;
  }
  *nk7(views, currentVfs, sourceFile, $completion) {
    // Inline function 'kotlin.TODO' call
    var reason = 'Must override this';
    throw NotImplementedError.le('An operation is not implemented: ' + reason);
  }
  mk7(ctx, view) {
    if (this.rk7_1)
      return Unit_instance;
    this.ekg(ctx, view);
  }
  ekg(ctx, view) {
    if (!this.rk7_1 && !(this.sk7_1 == null)) {
      this.rk7_1 = true;
      launchImmediately_0(ctx.ng1_1, ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda(view, ctx, this));
    }
  }
}
class Views extends BaseEventListener {
  constructor(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    return new.target.ohu(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder);
  }
  static ohu(coroutineContext, ag, injector, input, timeProvider, stats, gameWindow, gameId, settingsFolder, batchMaxQuads, bp, stageBuilder) {
    injector = injector === VOID ? new Injector() : injector;
    input = input === VOID ? new Input() : input;
    timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
    stats = stats === VOID ? new Stats() : stats;
    gameId = gameId === VOID ? 'korgegame' : gameId;
    settingsFolder = settingsFolder === VOID ? null : settingsFolder;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().og8_1 : batchMaxQuads;
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (stageBuilder === VOID) {
      tmp = Views$_init_$lambda_jivasj;
    } else {
      tmp = stageBuilder;
    }
    stageBuilder = tmp;
    var $this = this.je7();
    $this.chn_1 = new Mixin();
    $this.dhn_1 = coroutineContext;
    $this.ehn_1 = ag;
    $this.fhn_1 = injector;
    $this.ghn_1 = input;
    $this.hhn_1 = timeProvider;
    $this.ihn_1 = stats;
    $this.jhn_1 = gameWindow;
    $this.khn_1 = gameId;
    $this.lhn_1 = settingsFolder;
    $this.mhn_1 = batchMaxQuads;
    $this.nhn_1 = bp;
    $this.ohn_1 = stageBuilder;
    var tmp_0 = $this;
    var tmp0 = $this.jhn_1;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = GameWindow$_get_quality_$ref_imgvhb(tmp0);
    tmp_0.phn_1 = getPropertyCallableRef('quality', 0, tmp_1, tmp_2, GameWindow$_set_quality_$ref_bnxaul(tmp0));
    $this.qhn_1 = $this;
    $this.rhn_1 = false;
    var tmp_3 = $this;
    var tmp0_0 = $this.jhn_1;
    var tmp_4 = KMutableProperty0;
    var tmp_5 = GameWindow$_get_continuousRenderMode_$ref_vajq30(tmp0_0);
    tmp_3.shn_1 = getPropertyCallableRef('continuousRenderMode', 0, tmp_4, tmp_5, GameWindow$_set_continuousRenderMode_$ref_z8748w(tmp0_0));
    $this.thn_1 = new ReshapeEvent(0, 0);
    $this.uhn_1 = new UpdateEvent();
    $this.vhn_1 = new ViewsUpdateEvent($this);
    $this.whn_1 = new ViewsResizedEvent($this);
    var tmp_6 = $this;
    tmp_6.xhn_1 = lazy(Views$realSettingsFolder$delegate$lambda($this));
    $this.zhn_1 = null;
    $this.aho_1 = get_resourcesVfs();
    $this.bho_1 = get_RegisteredImageFormats();
    $this.cho_1 = new RenderContext($this.ehn_1, $this, $this.jhn_1, $this.ihn_1, $this.dhn_1, $this.mhn_1, $this.jhn_1);
    $this.dho_1 = true;
    $this.eho_1 = Colors_getInstance().ac3_1;
    var tmp_7 = $this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_7.fho_1 = HashMap.s9();
    var tmp_8 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp_8.gho_1 = toDuration(100.0, DurationUnit_MILLISECONDS_getInstance());
    $this.hho_1 = new Resources($this.dhn_1, $this.aho_1);
    $this.iho_1 = false;
    $this.jho_1 = 1280;
    $this.kho_1 = 720;
    var tmp_9 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_9.lho_1 = ArrayList.p2();
    $this.mho_1 = Companion_getInstance_26().v9r_1;
    $this.nho_1 = Companion_getInstance_27().g9g_1;
    $this.oho_1 = true;
    $this.pho_1 = $this.ohn_1($this);
    $this.qho_1 = $this.pho_1;
    $this.rho_1 = true;
    $this.sho_1 = false;
    var tmp_10 = $this;
    var tmp0_1 = $this.cho_1;
    var tmp_11 = KMutableProperty0;
    var tmp_12 = RenderContext$_get_debugExtraFontScale_$ref_b93nih(tmp0_1);
    tmp_10.tho_1 = getPropertyCallableRef('debugExtraFontScale', 0, tmp_11, tmp_12, RenderContext$_set_debugExtraFontScale_$ref_981qqz(tmp0_1));
    var tmp_13 = $this;
    var tmp0_2 = $this.cho_1;
    var tmp_14 = KMutableProperty0;
    var tmp_15 = RenderContext$_get_debugExtraFontColor_$ref_lqxcua(tmp0_2);
    tmp_13.uho_1 = getPropertyCallableRef('debugExtraFontColor', 0, tmp_14, tmp_15, RenderContext$_set_debugExtraFontColor_$ref_19ryku(tmp0_2));
    $this.vho_1 = FastArrayList.f9v();
    $this.who_1 = $this.hhn_1.x9v();
    var tmp_16 = $this;
    tmp_16.xho_1 = Pool.ha8(VOID, Views$tempViewsPool$lambda);
    $this.yho_1 = SizeInt.r9s();
    $this.zho_1 = SizeInt.r9s();
    $this.ahp_1 = SizeInt.r9s();
    $this.bhp_1 = new Signal();
    $this.chp_1 = new Signal();
    $this.dhp_1 = -1.0;
    $this.fhn_1.qe4(getKClass(CoroutineContext), $this.dhn_1);
    $this.fhn_1.qe4(getKClass(AG), $this.ehn_1);
    $this.fhn_1.qe4(getKClass(Views), $this);
    $this.chp_1.w9y(Views$lambda($this));
    $this.bhp_1.w9y(Views$lambda_0($this));
    installFpsDebugOverlay($this);
    $this.ehp_1 = Companion_instance_11.wi('SHOW_FRAME_UPDATE_AND_RENDER') === 'true';
    $this.fhp_1 = new EventResult();
    $this.ghp_1 = new Signal();
    $this.hhp_1 = Companion_getInstance().pb5('debugHightlightView');
    $this.ihp_1 = new Signal();
    $this.jhp_1 = new Signal();
    $this.khp_1 = ArrayList.p2();
    var tmp_17 = $this;
    var tmp0_3 = $this.jhn_1;
    var tmp_18 = KMutableProperty0;
    var tmp_19 = GameWindow$_get_updatedSinceFrame_$ref_kl09hs(tmp0_3);
    tmp_17.lhp_1 = getPropertyCallableRef('updatedSinceFrame', 0, tmp_18, tmp_19, GameWindow$_set_updatedSinceFrame_$ref_qqmlxg(tmp0_3));
    return $this;
  }
  d1m() {
    return this.dhn_1;
  }
  phw() {
    return this.qhn_1;
  }
  xhu(_set____db54di) {
    var tmp0 = this.shn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_forceRenderEveryFrame_$ref_9piv07();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('forceRenderEveryFrame', 1, tmp, tmp_0, Views$_set_forceRenderEveryFrame_$ref_byddyj());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  uhu() {
    var tmp0 = this.shn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_forceRenderEveryFrame_$ref_9piv07();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('forceRenderEveryFrame', 1, tmp, tmp_0, Views$_set_forceRenderEveryFrame_$ref_byddyj());
    return tmp0.get();
  }
  x4() {
    return this.ghn_1.dg5_1;
  }
  fkg() {
    return replace(replace(replace(this.khn_1, '\\', ''), '/', ''), '..', '');
  }
  lhy() {
    var tmp = this.yhn_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('debugBmpFont');
    }
  }
  *tbf($completion) {
    this.yhn_1 = yield* debugBmpFont($completion);
    return Unit_instance;
  }
  whu() {
    return this.hho_1;
  }
  yhu() {
    return this.ehn_1.zeg().seg_1;
  }
  zhu() {
    return this.ehn_1.zeg().teg_1;
  }
  lkg(value) {
    this.jho_1 = numberToInt(value);
  }
  mkg() {
    return this.jho_1;
  }
  nkg(value) {
    this.kho_1 = numberToInt(value);
  }
  okg() {
    return this.kho_1;
  }
  pkg(value) {
    this.lkg(value.j9i_1);
    this.nkg(value.k9i_1);
  }
  qkg() {
    return Size2D.y9p(this.mkg(), this.okg());
  }
  f7() {
    launchImmediately(this, Views$close$slambda(this));
  }
  *gkg($completion) {
    KorgeReload_getInstance().ig0();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.lho_1;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      yield* this_0.u2(_unary__edvuaz).lb6($completion);
    }
    this.lho_1.a5();
    cancel(this.dhn_1);
    this.jhn_1.wgk();
    return Unit_instance;
  }
  qhw() {
    return this.pho_1.pg5();
  }
  phu(_set____db54di) {
    var tmp0 = this.tho_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_debugFontExtraScale_$ref_i9zsk2();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('debugFontExtraScale', 1, tmp, tmp_0, Views$_set_debugFontExtraScale_$ref_275lpe());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  hkg() {
    var tmp0 = this.tho_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_debugFontExtraScale_$ref_i9zsk2();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('debugFontExtraScale', 1, tmp, tmp_0, Views$_set_debugFontExtraScale_$ref_275lpe());
    return tmp0.get();
  }
  qhu(_set____db54di) {
    var tmp0 = this.uho_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_debugFontColor_$ref_r1314f();
    getPropertyCallableRef('debugFontColor', 1, tmp, tmp_0, Views$_set_debugFontColor_$ref_a25pqd());
    // Inline function 'kotlin.setValue' call
    var value = new RGBA(_set____db54di);
    tmp0.set(value);
    return Unit_instance;
  }
  ikg() {
    var tmp0 = this.uho_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_debugFontColor_$ref_r1314f();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('debugFontColor', 1, tmp, tmp_0, Views$_set_debugFontColor_$ref_a25pqd());
    return tmp0.get().sci_1;
  }
  pjy(block) {
    this.vho_1.d2(block);
  }
  ne7(type, event, result, up, down) {
    event.ge8(false);
    var result_0 = super.ne7(type, event, result, up, down);
    var e = event;
    e.fe8(this.qhn_1);
    if (e instanceof KeyEvent) {
      this.ghn_1.wg5(e);
      this.ghn_1.dg5_1.ng4(e);
      if (e.ye8_1.equals(Type_UP_getInstance_0()) && this.rho_1 && (e.ae9_1.equals(Key_F12_getInstance()) || e.ae9_1.equals(Key_F7_getInstance()))) {
        this.sho_1 = !this.sho_1;
        this.jhn_1.rgk(this.sho_1);
        this.jie(this.pho_1);
      }
    }
    try {
      return this.pho_1.we7(e);
    } catch ($p) {
      if ($p instanceof StopPropagatingException) {
        var e_0 = $p;
      } else {
        throw $p;
      }
    }
    return result_0;
  }
  rkg(frameBuffer) {
    this.cho_1.mg2_1 = frameBuffer;
    if (this.dho_1) {
      var tmp0_$this = this.cho_1;
      var tmp1_color = this.eho_1;
      tmp0_$this.mgc(tmp1_color, 1.0, 0, true, true, true);
    }
    this.bhp_1.x9y(this.cho_1);
    this.cho_1.vg3();
    this.pho_1.nib(this.cho_1);
    this.cho_1.vg3();
    this.pho_1.wie(this.cho_1);
    if (this.sho_1) {
      // Inline function 'kotlin.run' call
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this.vho_1.d9v_1;
      var n = 0;
      while (n < array.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        array[_unary__edvuaz](this, this.cho_1);
      }
    }
    this.chp_1.x9y(this.cho_1);
    this.cho_1.vg3();
  }
  skg(frameBuffer, $super) {
    frameBuffer = frameBuffer === VOID ? this.ehn_1.zeg() : frameBuffer;
    var tmp;
    if ($super === VOID) {
      this.rkg(frameBuffer);
      tmp = Unit_instance;
    } else {
      tmp = $super.rkg.call(this, frameBuffer);
    }
    return tmp;
  }
  tkg() {
    this.ehn_1.ceh();
    this.skg();
  }
  vhu(fixedSizeStep, forceRender, doUpdate, doRender) {
    var currentTime = this.hhn_1.x9v();
    this.qhn_1.ihn_1.ceh();
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'ag.onRender';
      tmp0.pbj(level, tmp$ret$2);
    }
    var delta = DateTime__minus_impl_10njw8(currentTime, this.who_1);
    var adelta = Duration__compareTo_impl_pchp0f(delta, this.qhn_1.gho_1) > 0 ? this.qhn_1.gho_1 : delta;
    this.who_1 = currentTime;
    if (doUpdate) {
      if (!equals(fixedSizeStep, Companion_instance_1.d9w())) {
        this.vkg(fixedSizeStep);
      } else {
        this.ukg(adelta);
      }
    }
    var doRender2 = doRender && (forceRender || this.jkg() > 0);
    if (doRender2) {
      if (this.ehp_1) {
        println('Views.frameUpdateAndRender[' + Companion_getInstance_5().z9v().toString() + ']: doRender=' + doRender2 + ' -> [forceRender=' + forceRender + ', updatedSinceFrame=' + this.jkg() + ']');
      }
      this.tkg();
      this.ceh();
    }
  }
  ukg(elapsed) {
    return this.vkg(get_fast(elapsed));
  }
  vkg(elapsed) {
    this.ghn_1.ug5(elapsed);
    this.fhp_1.ra8();
    updateSingleViewWithViewsAll(this.pho_1, this, elapsed);
    this.ghn_1.vg5(elapsed);
  }
  shu() {
  }
  thu(width, height) {
    var actualWidth = width;
    var actualHeight = height;
    this.zho_1 = SizeInt.q9s(actualWidth, actualHeight);
    this.wkg();
  }
  wkg() {
    var tmp = Size2D.l9i(this.jho_1, this.kho_1);
    var tmp_0 = toFloat(this.zho_1);
    var tmp_1 = this.mho_1;
    var tmp_2 = this.nho_1;
    var tmp_3 = KMutableProperty0;
    var tmp_4 = Views$_get_virtualSize_$ref_agbw1q(this);
    var tmp_5 = toRef(getPropertyCallableRef('virtualSize', 0, tmp_3, tmp_4, Views$_set_virtualSize_$ref_cloj6(this)));
    var tmp_6 = KMutableProperty0;
    var tmp_7 = Views$_get_targetSize_$ref_pp11ni(this);
    setBoundsInfo(this.nhn_1, tmp, tmp_0, tmp_1, tmp_2, tmp_5, toRef(getPropertyCallableRef('targetSize', 0, tmp_6, tmp_7, Views$_set_targetSize_$ref_5xlm2(this))));
    this.cho_1.tg1_1 = this.nhn_1.zga();
    this.cho_1.ug1_1 = this.nhn_1.vga();
    // Inline function 'kotlin.also' call
    var this_0 = this.thn_1;
    this_0.eec_1 = this.zho_1.o9s_1;
    this_0.fec_1 = this.zho_1.p9s_1;
    this.we7(this_0);
    // Inline function 'kotlin.also' call
    var this_1 = this.whn_1;
    this_1.akh_1 = this.yho_1;
    this.we7(this_1);
    this.pho_1.lie();
  }
  viv(viewToHightlight, onlyIfDebuggerOpened) {
    if (onlyIfDebuggerOpened && !this.jhn_1.sgk())
      return Unit_instance;
    // Inline function 'korlibs.logger.Logger.debug' call
    var tmp0 = this.hhp_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_DEBUG_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'debugHightlightView: ' + toString_0(viewToHightlight);
      tmp0.pbj(level, tmp$ret$2);
    }
    this.ghp_1.x9y(viewToHightlight);
  }
  jhy(viewToHightlight, onlyIfDebuggerOpened, $super) {
    onlyIfDebuggerOpened = onlyIfDebuggerOpened === VOID ? false : onlyIfDebuggerOpened;
    var tmp;
    if ($super === VOID) {
      this.viv(viewToHightlight, onlyIfDebuggerOpened);
      tmp = Unit_instance;
    } else {
      tmp = $super.viv.call(this, viewToHightlight, onlyIfDebuggerOpened);
    }
    return tmp;
  }
  kkg(_set____db54di) {
    var tmp0 = this.lhp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_updatedSinceFrame_$ref_ww8j3w();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('updatedSinceFrame', 1, tmp, tmp_0, Views$_set_updatedSinceFrame_$ref_vz96fk());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  jkg() {
    var tmp0 = this.lhp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = Views$_get_updatedSinceFrame_$ref_ww8j3w();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('updatedSinceFrame', 1, tmp, tmp_0, Views$_set_updatedSinceFrame_$ref_vz96fk());
    return tmp0.get();
  }
  ceh() {
    this.jhn_1.ceh();
  }
  jie(view) {
    this.jhn_1.ggl();
  }
  o9u(value) {
    this.chn_1.o9u(value);
  }
  p9u() {
    return this.chn_1.p9u();
  }
  fgb(pos) {
    return this.nhn_1.fgb(pos);
  }
  uga(value) {
    this.nhn_1.uga(value);
  }
  vga() {
    return this.nhn_1.vga();
  }
  wga(value) {
    this.nhn_1.wga(value);
  }
  xga() {
    return this.nhn_1.xga();
  }
  yga(value) {
    this.nhn_1.yga(value);
  }
  zga() {
    return this.nhn_1.zga();
  }
  agb(value) {
    this.nhn_1.agb(value);
  }
  bgb() {
    return this.nhn_1.bgb();
  }
  cgb(value) {
    this.nhn_1.cgb(value);
  }
  dgb() {
    return this.nhn_1.dgb();
  }
  egb() {
    return this.nhn_1.egb();
  }
  wgc() {
    return this.jhn_1.wgc();
  }
  xgc() {
    return this.jhn_1.xgc();
  }
  ygc() {
    return this.jhn_1.ygc();
  }
  hgc() {
    return this.jhn_1.hgc();
  }
}
class Companion_9 {}
class ViewsUpdateEvent extends Event {
  constructor(views, fastDelta) {
    fastDelta = fastDelta === VOID ? Companion_instance_1.c9w() : fastDelta;
    super();
    this.bkg_1 = views;
    this.ckg_1 = fastDelta;
  }
  dkg() {
    return toDuration_0(this.ckg_1);
  }
  d8o() {
    return Companion_instance_24;
  }
  toString() {
    return 'ViewsUpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.ckg_1) + ')';
  }
}
class Companion_10 {}
class ViewsResizedEvent extends Event {
  constructor(views, size) {
    size = size === VOID ? SizeInt.q9s(0, 0) : size;
    super();
    this.zkg_1 = views;
    this.akh_1 = size;
  }
  d8o() {
    return Companion_instance_25;
  }
  toString() {
    return 'ViewsResizedEvent(size=' + this.akh_1.toString() + ')';
  }
}
class UB extends UniformBlock {
  constructor() {
    UB_instance = null;
    super(6);
    UB_instance = this;
    var tmp = this;
    var tmp_0 = this.few();
    var tmp_1 = KProperty1;
    tmp.fkh_1 = tmp_0.vev(this, getPropertyCallableRef('u_Col', 1, tmp_1, DebugVertexView$UB$_get_u_Col_$ref_3asquz(), null));
    var tmp_2 = this;
    var tmp_3 = this.lev();
    var tmp_4 = KProperty1;
    tmp_2.gkh_1 = tmp_3.vev(this, getPropertyCallableRef('u_Matrix', 1, tmp_4, DebugVertexView$UB$_get_u_Matrix_$ref_ynv9qa(), null));
  }
  hkh() {
    var tmp = KProperty1;
    return this.fkh_1.yq(this, getPropertyCallableRef('u_Col', 1, tmp, DebugVertexView$UB$_get_u_Col_$ref_3asquz(), null));
  }
  ikh() {
    var tmp = KProperty1;
    return this.gkh_1.yq(this, getPropertyCallableRef('u_Matrix', 1, tmp, DebugVertexView$UB$_get_u_Matrix_$ref_ynv9qa(), null));
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_26 = this;
    var tmp = this;
    var tmp_0 = DefaultShaders_getInstance().fet_1;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    this_0.jey(this_0.mey(), this_0.ney(this_0.ney(this_0.ney(this_0.jev(), this_0.kev()), UB_getInstance().ikh()), this_0.qey([this_0.oey(), this_0.pey(0.0), this_0.pey(1.0)])));
    var tmp_1 = VertexShader(this_0.rey());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder = ProgramBuilderDefault.eey();
    builder.jey(builder.mey(), UB_getInstance().hkh());
    var tmp$ret$3 = FragmentShader(builder.rey());
    tmp.jkh_1 = tmp_0.wfl(tmp_1, tmp$ret$3);
  }
}
class Batch {
  constructor(offset, count) {
    this.kkh_1 = offset;
    this.lkh_1 = count;
  }
}
class DebugVertexView extends View {
  constructor(pointsList, color, type) {
    return new.target.tit(pointsList, color, type);
  }
  static tit(pointsList, color, type) {
    Companion_getInstance_51();
    color = color === VOID ? Colors_getInstance().zc2_1 : color;
    type = type === VOID ? Companion_getInstance_14().ner_1 : type;
    var $this = this.ojy();
    $this.kci(color);
    var tmp = $this;
    var tmp_0 = KMutableProperty0;
    var tmp_1 = DebugVertexView$_get_colorMul_$ref_xduhb5($this);
    tmp.nit_1 = getPropertyCallableRef('colorMul', 0, tmp_0, tmp_1, DebugVertexView$_set_colorMul_$ref_hu3qr1($this));
    $this.oit_1 = pointsList;
    $this.pit_1 = type;
    var tmp_2 = $this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.qit_1 = new Float32Array([0.0, 0.0, 100.0, 0.0, 0.0, 100.0, 100.0, 100.0]);
    var tmp_3 = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_3.rit_1 = ArrayList.p2();
    $this.sit_1 = Companion_getInstance_32().e9i();
    updatedPoints($this);
    return $this;
  }
  kiu(value) {
    if (!(this.oit_1 === value)) {
      this.oit_1 = value;
      updatedPoints(this);
    }
  }
  oib() {
    return _BoundsBuilder___get_bounds__impl__s1l1gx(this.sit_1);
  }
  rib(ctx) {
    ctx.vg3();
    ctx.iga();
    var tmp0 = ctx.ieo(UB_getInstance());
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = tmp0.z6x();
      tmp0.efc(_unary__edvuaz + 1 | 0);
      tmp0.ffc(tmp0.z6x() + 1 | 0);
      var blockSize = tmp0.beo_1;
      var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
      var index1 = imul(tmp0.z6x(), blockSize);
      var texBlockSize = tmp0.yen_1.wev().s2();
      var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0.z6x(), texBlockSize);
      if (tmp0.z6x() > 0) {
        arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      } else {
        arrayfill(tmp0.deo_1, 0, 0, blockSize);
      }
      var tmp0_0 = tmp0.yen_1;
      var it = tmp0.eeo_1;
      it.nfc(tmp0_0.hkh(), this.dih());
      it.rfc(tmp0_0.ikh(), toMatrix4(this.khy()));
      if (true && tmp0.z6x() >= 1) {
        var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = tmp0.z6x();
          tmp0.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    var tmp0_1 = ctx.ig2_1;
    $l$block_0: {
      // Inline function 'korlibs.datastructure.Pool.alloc' call
      var temp = tmp0_1.ja8();
      try {
        temp.men(this.qit_1);
        var vData = AGVertexArrayObject.yer([new AGVertexData(DefaultShaders_getInstance().det_1, temp)], true);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.rit_1;
        var n = 0;
        while (n < this_0.s2()) {
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var batch = this_0.u2(_unary__edvuaz_1);
          var tmp0_$receiver = ctx.jg1_1;
          var tmp1_frameBuffer = ctx.mg2_1;
          var tmp2_drawType = this.pit_1;
          var tmp3_program = Companion_getInstance_51().jkh_1;
          var tmp4_uniformBlocks = ctx.dgc(Companion_getInstance_51().jkh_1);
          var tmp5_textureUnits = ctx.sg1_1.g9m();
          var tmp6_vertexCount = batch.lkh_1;
          var tmp7_drawOffset = batch.kkh_1;
          var tmp8_blending = this.cih().yg3_1;
          draw(tmp0_$receiver, tmp1_frameBuffer, vData, tmp3_program, tmp2_drawType, tmp6_vertexCount, VOID, VOID, tmp7_drawOffset, tmp8_blending, tmp4_uniformBlocks, tmp5_textureUnits);
        }
        break $l$block_0;
      }finally {
        tmp0_1.ka8(temp);
      }
    }
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.doubleArrayOf' call
    tmp.mkh_1 = new Float64Array([0.03125, 0.0625, 0.125, 0.25, 0.5, 0.75, 1.0]);
  }
  nkh(scale) {
    var tmp0 = this.mkh_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.minByOrNull' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (tmp0.length === 0) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var minElem = tmp0[0];
      var lastIndex = get_lastIndex(tmp0);
      if (lastIndex === 0) {
        tmp$ret$0 = minElem;
        break $l$block_0;
      }
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = scale - minElem;
      var minValue = Math.abs(this_0);
      var inductionVariable = 1;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var e = tmp0[i];
          // Inline function 'kotlin.math.absoluteValue' call
          var this_1 = scale - e;
          var v = Math.abs(this_1);
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (!(i === lastIndex));
      tmp$ret$0 = minElem;
    }
    return ensureNotNull(tmp$ret$0);
  }
}
class Filter {}
function get_recommendedFilterScale() {
  return 1.0;
}
function computeBorder(texWidth, texHeight) {
  return Companion_getInstance_35().n9k_1;
}
class RenderToTextureResult {
  constructor() {
    this.rkh_1 = null;
    this.skh_1 = 0;
    this.tkh_1 = 0;
    this.ukh_1 = 0;
    this.vkh_1 = 0;
    this.wkh_1 = 1.0;
    this.xkh_1 = Companion_getInstance_33().v9k_1;
    this.ykh_1 = null;
    this.zkh_1 = null;
    this.aki_1 = null;
    this.bki_1 = null;
  }
  u1o() {
    if (this.zkh_1 == null || this.bki_1 == null)
      return Unit_instance;
    var tmp0_safe_receiver = this.zkh_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = this.bki_1;
      var tmp;
      if (tmp0_safe_receiver_0 == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver_0.sgc(tmp0_safe_receiver);
        tmp = Unit_instance;
      }
    }
    this.rkh_1 = null;
    this.ykh_1 = null;
    this.zkh_1 = null;
    this.bki_1 = null;
    this.aki_1 = null;
  }
}
class IdentityFilter {
  constructor(smoothing) {
    Companion_getInstance_53();
    this.cki_1 = smoothing;
  }
  qkh(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.hg2_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_1 = this_0.qg2_1;
    if (!(this_1.lg2_1 === this_0)) {
      this_1.lg2_1 = this_0;
      this_1.vg3();
    }
    this_0.xg3(texture, VOID, VOID, VOID, VOID, matrix, this.cki_1, renderColorMul, blendMode, Companion_getInstance_6().vg8_1);
  }
}
class Companion_13 extends IdentityFilter {
  constructor() {
    Companion_instance_28 = null;
    super(true);
    Companion_instance_28 = this;
  }
}
class BaseProgramProvider {
  constructor() {
    Companion_getInstance_54();
    this.pki_1 = Companion_getInstance_6().vg8_1.seo_1;
    this.qki_1 = Companion_getInstance_55().vki_1;
    var tmp = this;
    tmp.rki_1 = lazy(ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this));
  }
  ski(vertex, fragment) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.graphics.shader.appending' call
      if (fragment.afn()) {
        tmp$ret$0 = fragment;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = ProgramBuilderDefault.eey().rez(fragment);
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this_0.ff1(this_0.sey(this_0.mey(), 'a'), this_0.pey(0.0));
      var body = this_0.yey();
      body.tez();
      var stmIf = new If(cond, body.aez());
      // Inline function 'kotlin.collections.plusAssign' call
      this_0.iey_1.d2(stmIf);
      var pair = this_0.rey();
      tmp$ret$0 = new Shader(fragment.nfe_1, pair.pm_1, pair.qm_1);
    }
    return new Program(vertex, tmp$ret$0);
  }
  tki() {
    return this.pki_1;
  }
  x7u() {
    return this.qki_1;
  }
  uki() {
    return _get__program__9g4ap2(this);
  }
}
class Companion_14 extends BaseProgramProvider {
  constructor() {
    Companion_instance_29 = null;
    super();
    Companion_instance_29 = this;
  }
}
class TexInfoUB extends UniformBlock {
  constructor() {
    TexInfoUB_instance = null;
    super(4);
    TexInfoUB_instance = this;
    var tmp = this;
    var tmp_0 = this.dew();
    var tmp_1 = KProperty1;
    tmp.hki_1 = tmp_0.vev(this, getPropertyCallableRef('u_TextureSize', 1, tmp_1, ShaderFilter$TexInfoUB$_get_u_TextureSize_$ref_p65vff(), null));
    var tmp_2 = this;
    var tmp_3 = this.dew();
    var tmp_4 = KProperty1;
    tmp_2.iki_1 = tmp_3.vev(this, getPropertyCallableRef('u_MaxTexCoords', 1, tmp_4, ShaderFilter$TexInfoUB$_get_u_MaxTexCoords_$ref_oxvt6w(), null));
    var tmp_5 = this;
    var tmp_6 = this.dew();
    var tmp_7 = KProperty1;
    tmp_5.jki_1 = tmp_6.vev(this, getPropertyCallableRef('u_StdTexDerivates', 1, tmp_7, ShaderFilter$TexInfoUB$_get_u_StdTexDerivates_$ref_k07hom(), null));
    var tmp_8 = this;
    var tmp_9 = this.bew();
    var tmp_10 = KProperty1;
    tmp_8.kki_1 = tmp_9.vev(this, getPropertyCallableRef('u_filterScale', 1, tmp_10, ShaderFilter$TexInfoUB$_get_u_filterScale_$ref_epvjxt(), null));
  }
  lki() {
    var tmp = KProperty1;
    return this.hki_1.yq(this, getPropertyCallableRef('u_TextureSize', 1, tmp, ShaderFilter$TexInfoUB$_get_u_TextureSize_$ref_p65vff(), null));
  }
  mki() {
    var tmp = KProperty1;
    return this.iki_1.yq(this, getPropertyCallableRef('u_MaxTexCoords', 1, tmp, ShaderFilter$TexInfoUB$_get_u_MaxTexCoords_$ref_oxvt6w(), null));
  }
  nki() {
    var tmp = KProperty1;
    return this.jki_1.yq(this, getPropertyCallableRef('u_StdTexDerivates', 1, tmp, ShaderFilter$TexInfoUB$_get_u_StdTexDerivates_$ref_k07hom(), null));
  }
  oki() {
    var tmp = KProperty1;
    return this.kki_1.yq(this, getPropertyCallableRef('u_filterScale', 1, tmp, ShaderFilter$TexInfoUB$_get_u_filterScale_$ref_epvjxt(), null));
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_30 = this;
    this.vki_1 = Companion_getInstance_6().vg8_1.teo_1;
  }
  wki(_this__u8e3s4) {
    return _this__u8e3s4.sey(DefaultShaders_getInstance().qes_1, 'xy');
  }
  xki(_this__u8e3s4) {
    return _this__u8e3s4.ney(this.wki(_this__u8e3s4), TexInfoUB_getInstance().lki());
  }
  yki(_this__u8e3s4, coords) {
    return _this__u8e3s4.tey(DefaultShaders_getInstance().iew(), _this__u8e3s4.wey(coords, TexInfoUB_getInstance().lki()));
  }
  zki(_this__u8e3s4) {
    return _this__u8e3s4.wey(_this__u8e3s4.sey(DefaultShaders_getInstance().qes_1, 'xy'), TexInfoUB_getInstance().mki());
  }
}
class ShaderFilter {
  constructor() {
    Companion_getInstance_55();
    this.akj_1 = true;
    this.bkj_1 = Vector2D.y9j();
    this.ckj_1 = Vector2D.y9j();
    this.dkj_1 = Vector2D.y9j();
    this.ekj_1 = Companion_getInstance_54();
    this.fkj_1 = AGTextureUnits.jem();
    this.gkj_1 = 0;
  }
  ikj() {
    return this.akj_1;
  }
  pkh(texWidth, texHeight) {
    return Companion_getInstance_35().n9k_1;
  }
  jkj() {
    return this.ekj_1;
  }
  hkj(ctx, filterScale) {
  }
  k9l() {
    return false;
  }
  qkh(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale) {
    if (this.k9l())
      return Companion_getInstance_53().qkh(ctx, matrix, texture, texWidth, texHeight, renderColorMul, blendMode, filterScale);
    var _margin = getBorder(this, texWidth, texHeight);
    var marginLeft = toIntCeil(_margin.r9k_1 * filterScale);
    var marginRight = toIntCeil(_margin.p9k_1 * filterScale);
    var marginTop = toIntCeil(_margin.o9k_1 * filterScale);
    var marginBottom = toIntCeil(_margin.q9k_1 * filterScale);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.hg2_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_1 = this_0.qg2_1;
    if (!(this_1.lg2_1 === this_0)) {
      this_1.lg2_1 = this_0;
      this_1.vg3();
    }
    var slice = texture.wak(-marginLeft | 0, -marginTop | 0, texture.qaj_1 + marginRight | 0, texture.raj_1 + marginBottom | 0, VOID, false);
    var tmp2 = DefaultShaders_getInstance().iew();
    var tmp4 = slice.haj_1.tg6_1;
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.temporalTextureUnit' call
      var info = Companion_getInstance_17().pem_1;
      var oldTex = this_0.qg2_1.sg1_1.hem_1[tmp2.cen_1];
      var oldInfo = AGTextureUnitInfoArray__get_impl_xhvpef(this_0.qg2_1.sg1_1.iem_1, tmp2.cen_1);
      this_0.qg2_1.sg1_1.qem(tmp2, tmp4, info);
      try {
        _updateUniforms(this, ctx, filterScale, texture, texWidth, texHeight);
        this_0.xg3(slice, -marginLeft, -marginTop, VOID, VOID, matrix, this.ikj(), renderColorMul, blendMode, this.jkj().uki());
        break $l$block;
      }finally {
        this_0.dg9();
        this_0.qg2_1.sg1_1.qem(tmp2, oldTex, oldInfo);
      }
    }
    _restoreUniforms(this, ctx, filterScale);
  }
}
class ViewRenderPhaseBackdropFilter {}
class Companion_16 {
  constructor() {
    this.mkj_1 = -200;
  }
}
class ViewRenderPhaseFilter {
  constructor(filter) {
    filter = filter === VOID ? null : filter;
    this.lkj_1 = filter;
  }
  vkf() {
    return -200;
  }
  ykf(view, ctx) {
    if (!(this.lkj_1 == null)) {
      renderFiltered(view, ctx, ensureNotNull(this.lkj_1), false);
    } else {
      render_0.call(this, view, ctx);
    }
  }
}
class PointsResult {
  constructor(bounds, vertexCount, vertexStart, vertexEnd) {
    this.xkk_1 = bounds;
    this.ykk_1 = vertexCount;
    this.zkk_1 = vertexStart;
    this.akl_1 = vertexEnd;
  }
}
class GpuShapeView extends View {
  constructor(shape, antialiased, autoScaling) {
    return new.target.mk4(shape, antialiased, autoScaling);
  }
  static mk4(shape, antialiased, autoScaling) {
    shape = shape === VOID ? EmptyShape_instance : shape;
    antialiased = antialiased === VOID ? true : antialiased;
    autoScaling = autoScaling === VOID ? true : autoScaling;
    var $this = this.ojy();
    $this.nk3_1 = autoScaling;
    $this.ok3_1 = true;
    $this.pk3_1 = true;
    $this.qk3_1 = true;
    $this.rk3_1 = new GpuShapeViewCommands();
    $this.sk3_1 = 1000;
    $this.tk3_1 = 1000;
    $this.uk3_1 = Companion_getInstance_27().c9g_1;
    $this.vk3_1 = true;
    $this.wk3_1 = false;
    $this.xk3_1 = antialiased;
    $this.yk3_1 = shape;
    $this.zk3_1 = false;
    $this.ak4_1 = false;
    $this.bk4_1 = false;
    $this.ck4_1 = 0;
    $this.dk4_1 = Companion_getInstance_31().y9k();
    $this.ek4_1 = Companion_getInstance_31().y9k();
    $this.fk4_1 = false;
    $this.gk4_1 = 1.0;
    $this.hk4_1 = NaN;
    $this.ik4_1 = Companion_getInstance_33().y9k();
    $this.jk4_1 = 100000;
    $this.kk4_1 = false;
    $this.lk4_1 = 10000.0;
    invalidateShape($this);
    return $this;
  }
  pjj(value) {
    this.qk3_1 = value;
    this.gih();
  }
  ijb(value) {
    this.uk3_1 = value;
    this.lie();
  }
  jjb() {
    return this.uk3_1;
  }
  ok4(value) {
    this.xk3_1 = value;
    invalidateShape(this);
  }
  nk4(value) {
    this.yk3_1 = value;
    invalidateShape(this);
  }
  fif() {
    return _get_shapeBounds__actvvf(this).q9h_1 * this.jjb().l9g_1;
  }
  gif() {
    return _get_shapeBounds__actvvf(this).r9h_1 * this.jjb().m9g_1;
  }
  lie() {
    super.lie();
    invalidateShape(this);
  }
  oib() {
    return new Rectangle(_get_shapeBounds__actvvf(this).o9h_1 - this.fif(), _get_shapeBounds__actvvf(this).p9h_1 - this.gif(), _get_shapeBounds__actvvf(this).q9h_1, _get_shapeBounds__actvvf(this).r9h_1);
  }
  ckl(_this__u8e3s4) {
    var tmp;
    if (equals(_this__u8e3s4, EmptyShape_instance)) {
      tmp = false;
    } else {
      if (_this__u8e3s4 instanceof CompoundShape) {
        var tmp0 = _this__u8e3s4.ads_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp_0;
          if (isInterface(tmp0, Collection)) {
            tmp_0 = tmp0.n1();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (this.ckl(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof TextShape) {
          tmp = this.ckl(_this__u8e3s4.cds());
        } else {
          if (_this__u8e3s4 instanceof FillShape) {
            tmp = !_this__u8e3s4.nds();
          } else {
            if (_this__u8e3s4 instanceof PolylineShape) {
              tmp = false;
            } else {
              tmp = true;
            }
          }
        }
      }
    }
    return tmp;
  }
  rib(ctx) {
    this.gk4_1 = this.khy().i9m().a9n() * ctx.kg1_1.egb();
    if (!(this.hk4_1 === this.gk4_1)) {
      invalidateShape(this);
    }
    ctx.vg3();
    var doRequireTexture = this.ckl(this.yk3_1);
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.time.measureTime' call
    var mark = Monotonic_instance.ck();
    if (doRequireTexture) {
      var currentFrameBuffer = ctx.jg1_1.zeg();
      this.sk3_1 = currentFrameBuffer.seg_1;
      this.tk3_1 = currentFrameBuffer.teg_1;
      var tmp2 = this.sk3_1;
      // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
      var height = this.tk3_1;
      ctx.vg3();
      // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
      var rb = ctx.rgc(tmp2, height, false, true, 1);
      try {
        // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        ctx.tgc(rb);
        try {
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
          var this_0 = ctx.hg2_1;
          // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
          var this_1 = this_0.qg2_1;
          if (!(this_1.lg2_1 === this_0)) {
            this_1.lg2_1 = this_0;
            this_1.vg3();
          }
          var tmp2_0 = AGScissor.beq(0, 0, rb.seg_1, rb.teg_1);
          $l$block: {
            // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
            var temp = this_0.og3_1;
            this_0.zg9();
            this_0.og3_1 = tmp2_0;
            try {
              if (true) {
                ctx.mgc(Colors_getInstance().ec3_1);
              }
              renderCommands(this, ctx, doRequireTexture);
              break $l$block;
            }finally {
              this_0.zg9();
              this_0.og3_1 = temp;
            }
          }
        }finally {
          ctx.ugc();
        }
        var texture = Texture_0(rb).yak(0, 0, tmp2, height);
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_2 = ctx.hg2_1;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var this_3 = this_2.qg2_1;
        if (!(this_3.lg2_1 === this_2)) {
          this_3.lg2_1 = this_2;
          this_3.vg3();
        }
        this_2.xg3(texture, VOID, VOID, VOID, VOID, get_immutable(ctx.kg1_1.vga()));
        ctx.vg3();
      }finally {
        ctx.sgc(rb);
      }
    } else {
      renderCommands(this, ctx, doRequireTexture);
    }
    var time = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
  }
}
class ScissorCommand {
  constructor(scissor) {
    this.dkl_1 = scissor;
  }
  toString() {
    return 'ScissorCommand(scissor=' + this.dkl_1.toString() + ')';
  }
  hashCode() {
    return this.dkl_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ScissorCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ScissorCommand ? other : THROW_CCE();
    if (!this.dkl_1.equals(tmp0_other_with_cast.dkl_1))
      return false;
    return true;
  }
}
class ClearCommand {
  constructor(i) {
    this.ekl_1 = i;
  }
  toString() {
    return 'ClearCommand(i=' + this.ekl_1 + ')';
  }
  hashCode() {
    return this.ekl_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ClearCommand ? other : THROW_CCE();
    if (!(this.ekl_1 === tmp0_other_with_cast.ekl_1))
      return false;
    return true;
  }
}
class ShapeCommand {
  constructor(drawType, vertexIndex, vertexEnd, paintShader, program, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace) {
    drawType = drawType === VOID ? Companion_getInstance_14().jer_1 : drawType;
    vertexIndex = vertexIndex === VOID ? 0 : vertexIndex;
    vertexEnd = vertexEnd === VOID ? 0 : vertexEnd;
    program = program === VOID ? null : program;
    colorMask = colorMask === VOID ? Companion_getInstance_23().dej_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().aej_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().yei_1 : stencilRef;
    blendMode = blendMode === VOID ? null : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().oej_1 : cullFace;
    this.fkl_1 = drawType;
    this.gkl_1 = vertexIndex;
    this.hkl_1 = vertexEnd;
    this.ikl_1 = paintShader;
    this.jkl_1 = program;
    this.kkl_1 = colorMask;
    this.lkl_1 = stencilOpFunc;
    this.mkl_1 = stencilRef;
    this.nkl_1 = blendMode;
    this.okl_1 = cullFace;
  }
  hg9() {
    return this.hkl_1 - this.gkl_1 | 0;
  }
  toString() {
    return 'ShapeCommand(drawType=' + AGDrawType__toString_impl_eonaeb(this.fkl_1) + ', vertexIndex=' + this.gkl_1 + ', vertexEnd=' + this.hkl_1 + ', paintShader=' + toString_0(this.ikl_1) + ', program=' + toString_0(this.jkl_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.kkl_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.lkl_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.mkl_1) + ', blendMode=' + toString_0(this.nkl_1) + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.okl_1) + ')';
  }
  hashCode() {
    var result = AGDrawType__hashCode_impl_ylaury(this.fkl_1);
    result = imul(result, 31) + this.gkl_1 | 0;
    result = imul(result, 31) + this.hkl_1 | 0;
    result = imul(result, 31) + (this.ikl_1 == null ? 0 : this.ikl_1.hashCode()) | 0;
    result = imul(result, 31) + (this.jkl_1 == null ? 0 : this.jkl_1.hashCode()) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.kkl_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.lkl_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.mkl_1) | 0;
    result = imul(result, 31) + (this.nkl_1 == null ? 0 : this.nkl_1.hashCode()) | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.okl_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ShapeCommand))
      return false;
    var tmp0_other_with_cast = other instanceof ShapeCommand ? other : THROW_CCE();
    if (!(this.fkl_1 === tmp0_other_with_cast.fkl_1))
      return false;
    if (!(this.gkl_1 === tmp0_other_with_cast.gkl_1))
      return false;
    if (!(this.hkl_1 === tmp0_other_with_cast.hkl_1))
      return false;
    if (!equals(this.ikl_1, tmp0_other_with_cast.ikl_1))
      return false;
    if (!equals(this.jkl_1, tmp0_other_with_cast.jkl_1))
      return false;
    if (!(this.kkl_1 === tmp0_other_with_cast.kkl_1))
      return false;
    if (!(this.lkl_1 === tmp0_other_with_cast.lkl_1))
      return false;
    if (!equals(this.mkl_1, tmp0_other_with_cast.mkl_1))
      return false;
    if (!equals(this.nkl_1, tmp0_other_with_cast.nkl_1))
      return false;
    if (!(this.okl_1 === tmp0_other_with_cast.okl_1))
      return false;
    return true;
  }
}
class GpuShapeViewCommands {
  constructor() {
    this.nkj_1 = 0;
    this.okj_1 = floatArrayListOf(new Float32Array([]));
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.pkj_1 = ArrayList.p2();
    this.qkj_1 = null;
    this.rkj_1 = FastArrayList.f9v();
    this.skj_1 = 0;
    this.tkj_1 = 0;
    this.ukj_1 = MatrixTransform.y9m();
    this.vkj_1 = FastArrayList.f9v();
    this.wkj_1 = AGTextureUnits.jem();
  }
  a5() {
    this.nkj_1 = 0;
    this.okj_1.a5();
    this.pkj_1.a5();
  }
  bkk(x, y, len, maxLen) {
    var tmp;
    if (maxLen <= 0.0) {
      var _unary__edvuaz = this.skj_1;
      this.skj_1 = _unary__edvuaz + 1 | 0;
      tmp = _unary__edvuaz <= 0;
    } else {
      tmp = false;
    }
    if (tmp) {
      println('Invalid maxLen=' + maxLen);
    }
    this.okj_1.ya2(x, y, len, maxLen);
    var _unary__edvuaz_0 = this.nkj_1;
    this.nkj_1 = _unary__edvuaz_0 + 1 | 0;
    return _unary__edvuaz_0;
  }
  akk() {
    this.tkj_1 = this.nkj_1;
    return this.tkj_1;
  }
  ckk() {
    return this.nkj_1;
  }
  bkl(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex) {
    var tmp0 = this.pkj_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new ShapeCommand(drawType, startIndex, endIndex, paintShader, VOID, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace);
    tmp0.d2(element);
  }
  wkk(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex, $super) {
    colorMask = colorMask === VOID ? Companion_getInstance_23().dej_1 : colorMask;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().aej_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_19().yei_1 : stencilRef;
    blendMode = blendMode === VOID ? Companion_getInstance_13().og0_1 : blendMode;
    cullFace = cullFace === VOID ? Companion_getInstance_22().oej_1 : cullFace;
    startIndex = startIndex === VOID ? this.tkj_1 : startIndex;
    endIndex = endIndex === VOID ? this.nkj_1 : endIndex;
    var tmp;
    if ($super === VOID) {
      this.bkl(drawType, paintShader, colorMask, stencilOpFunc, stencilRef, blendMode, cullFace, startIndex, endIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.bkl.call(this, new AGDrawType(drawType), paintShader, new AGColorMask(colorMask), new AGStencilOpFunc(stencilOpFunc), new AGStencilReference(stencilRef), blendMode, new AGCullFace(cullFace), startIndex, endIndex);
    }
    return tmp;
  }
  yf7(i) {
    var tmp0 = this.pkj_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new ClearCommand(i);
    tmp0.d2(element);
  }
  xkj(i, $super) {
    i = i === VOID ? 0 : i;
    var tmp;
    if ($super === VOID) {
      this.yf7(i);
      tmp = Unit_instance;
    } else {
      tmp = $super.yf7.call(this, i);
    }
    return tmp;
  }
  ykj(scissor) {
    var tmp0 = this.pkj_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new ScissorCommand(scissor);
    tmp0.d2(element);
  }
  v7e() {
    var tmp0_safe_receiver = this.qkj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.plusAssign' call
      this.rkj_1.d2(tmp0_safe_receiver);
    }
    this.qkj_1 = new AgCachedBuffer(_Float32Buffer___get_buffer__impl__x5nu9x(_Float32Buffer___init__impl__403k2m(this.okj_1.da3())));
  }
  zkj(ctx, globalMatrix, localMatrix, applyScissor, colorMul, doRequireTexture) {
    var tmp0_elvis_lhs = this.qkj_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vertices = tmp;
    ctx.dg2_1.lg8(this.rkj_1);
    this.rkj_1.a5();
    ctx.vg3();
    var ag = ctx.jg1_1;
    var vao = AGVertexArrayObject.xer(fastArrayListOf([new AGVertexData(GpuShapeViewPrograms_getInstance().mkk_1, ctx.ig8(vertices))]), true);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
    var this_0 = ctx.hg2_1;
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_1 = this_0.qg2_1;
    if (!(this_1.lg2_1 === this_0)) {
      this_1.lg2_1 = this_0;
      this_1.vg3();
    }
    this_0.iga();
    var tempMat = (doRequireTexture ? Companion_getInstance_33().v9k_1 : this_0.fg9()).f9m(globalMatrix);
    // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
    // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
    var this_2 = this_0.qg2_1;
    this_2.vg3();
    var temp4 = this_2.wg1_1;
    var temp2d = this_2.xg1_1;
    this_2.xg1_1 = tempMat;
    this_2.wg1_1 = toMatrix4(tempMat);
    var tmp0 = this_2.ieo(ProjViewUB_getInstance());
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = tmp0.z6x();
      tmp0.efc(_unary__edvuaz + 1 | 0);
      tmp0.ffc(tmp0.z6x() + 1 | 0);
      var blockSize = tmp0.beo_1;
      var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
      var index1 = imul(tmp0.z6x(), blockSize);
      var texBlockSize = tmp0.yen_1.wev().s2();
      var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(tmp0.z6x(), texBlockSize);
      if (tmp0.z6x() > 0) {
        arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      } else {
        arrayfill(tmp0.deo_1, 0, 0, blockSize);
      }
      var tmp0_0 = tmp0.yen_1;
      tmp0.eeo_1.rfc(tmp0_0.kev(), this_2.wg1_1);
      if (true && tmp0.z6x() >= 1) {
        var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = tmp0.z6x();
          tmp0.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    try {
      this.ukj_1 = globalMatrix.i9m();
      var program = GpuShapeViewPrograms_getInstance().tkk_1;
      var scissor = Companion_getInstance_15().mej_1;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_3 = this.pkj_1;
      var n = 0;
      while (n < this_3.s2()) {
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var cmd = this_3.u2(_unary__edvuaz_1);
        if (cmd instanceof ScissorCommand) {
          scissor = cmd.dkl_1;
        } else {
          if (cmd instanceof ClearCommand) {
            var tmp1_stencil = cmd.ekl_1;
            ctx.mgc(VOID, VOID, tmp1_stencil, false, false, true);
          } else {
            if (cmd instanceof ShapeCommand) {
              var paintShader = cmd.ikl_1;
              this_0.oga(cmd.hg9());
              var pixelScale = this.ukj_1.a9n() / ctx.kg1_1.egb();
              if (!(paintShader == null)) {
                var tmp0_1 = this_0.qg2_1.ieo(ShapeViewUB_getInstance());
                $l$block_0: {
                  // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
                  var _unary__edvuaz_2 = tmp0_1.z6x();
                  tmp0_1.efc(_unary__edvuaz_2 + 1 | 0);
                  tmp0_1.ffc(tmp0_1.z6x() + 1 | 0);
                  var blockSize_0 = tmp0_1.beo_1;
                  var index0_0 = imul(tmp0_1.z6x() - 1 | 0, blockSize_0);
                  var index1_0 = imul(tmp0_1.z6x(), blockSize_0);
                  var texBlockSize_0 = tmp0_1.yen_1.wev().s2();
                  var texIndex0_0 = imul(tmp0_1.z6x() - 1 | 0, texBlockSize_0);
                  var texIndex1_0 = imul(tmp0_1.z6x(), texBlockSize_0);
                  if (tmp0_1.z6x() > 0) {
                    arraycopy(tmp0_1.deo_1, index0_0, tmp0_1.deo_1, index1_0, blockSize_0);
                  } else {
                    arrayfill(tmp0_1.deo_1, 0, 0, blockSize_0);
                  }
                  var tmp0_2 = tmp0_1.yen_1;
                  var it = tmp0_1.eeo_1;
                  it.ifc(paintShader.pkl_1);
                  it.jfc(tmp0_2.ekm(), pixelScale);
                  it.pfc(tmp0_2.fkm(), _RGBA___get_premultiplied__impl__3bulqc(colorMul));
                  if (true && tmp0_1.z6x() >= 1) {
                    var equals_0 = arrayequal(tmp0_1.deo_1, index0_0, tmp0_1.deo_1, index1_0, blockSize_0);
                    if (equals_0) {
                      var _unary__edvuaz_3 = tmp0_1.z6x();
                      tmp0_1.efc(_unary__edvuaz_3 - 1 | 0);
                      break $l$block_0;
                    }
                  }
                }
                if (!(paintShader.qkl_1 == null)) {
                  var tex = ctx.zg1_1.ja8();
                  tex.bel(paintShader.qkl_1);
                  this.wkj_1.een(DefaultShaders_getInstance().iew(), tex);
                  this.vkj_1.d2(tex);
                }
              }
              var tmp2_elvis_lhs = cmd.jkl_1;
              var _program = tmp2_elvis_lhs == null ? program : tmp2_elvis_lhs;
              var tmp4_frameBuffer = ctx.mg2_1.leg_1;
              var tmp5_frameBufferInfo = ctx.mg2_1.sej();
              var tmp6_scissor = applyMatrixBounds(scissor, tempMat);
              var tmp7_uniformBlocks = ctx.dgc(_program);
              var tmp8_textureUnits = this.wkj_1.g9m();
              var tmp9_stencilOpFunc = cmd.lkl_1;
              var tmp10_stencilRef = cmd.mkl_1;
              var tmp11_colorMask = cmd.kkl_1;
              var tmp3_elvis_lhs = cmd.nkl_1;
              var tmp12_blending = (tmp3_elvis_lhs == null ? Companion_getInstance_13().og0_1 : tmp3_elvis_lhs).yg3_1;
              var tmp13_cullFace = cmd.okl_1;
              var tmp14_drawType = cmd.fkl_1;
              var tmp15_drawOffset = cmd.gkl_1;
              var tmp16_vertexCount = cmd.hg9();
              draw_0(ag, new AGBatch(tmp4_frameBuffer, tmp5_frameBufferInfo, vao, VOID, VOID, _program, tmp7_uniformBlocks, tmp8_textureUnits, tmp12_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp6_scissor, tmp13_cullFace, tmp14_drawType, tmp15_drawOffset, tmp16_vertexCount));
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }finally {
      this_2.vg3();
      this_2.wg1_1 = temp4;
      this_2.xg1_1 = temp2d;
      this_2.ieo(ProjViewUB_getInstance()).gfc();
    }
    var _iterator__ex2g4s = this.vkj_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var tex_0 = _iterator__ex2g4s.r1();
      ctx.zg1_1.ka8(tex_0);
    }
    this.vkj_1.a5();
  }
}
class ShapeViewUB extends UniformBlock {
  constructor() {
    ShapeViewUB_instance = null;
    super(5);
    ShapeViewUB_instance = this;
    var tmp = this;
    var tmp_0 = this.bew();
    var tmp_1 = KProperty1;
    tmp.wkl_1 = tmp_0.vev(this, getPropertyCallableRef('u_ProgramType', 1, tmp_1, GpuShapeViewPrograms$ShapeViewUB$_get_u_ProgramType_$ref_gtfuu8(), null));
    var tmp_2 = this;
    var tmp_3 = this.few();
    var tmp_4 = KProperty1;
    tmp_2.xkl_1 = tmp_3.vev(this, getPropertyCallableRef('u_Color', 1, tmp_4, GpuShapeViewPrograms$ShapeViewUB$_get_u_Color_$ref_m1fq11(), null));
    var tmp_5 = this;
    var tmp_6 = this.few();
    var tmp_7 = KProperty1;
    tmp_5.ykl_1 = tmp_6.vev(this, getPropertyCallableRef('u_ColorMul', 1, tmp_7, GpuShapeViewPrograms$ShapeViewUB$_get_u_ColorMul_$ref_2t2a63(), null));
    var tmp_8 = this;
    var tmp_9 = this.bew();
    var tmp_10 = KProperty1;
    tmp_8.zkl_1 = tmp_9.vev(this, getPropertyCallableRef('u_GlobalAlpha', 1, tmp_10, GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalAlpha_$ref_ww8199(), null));
    var tmp_11 = this;
    var tmp_12 = this.bew();
    var tmp_13 = KProperty1;
    tmp_11.akm_1 = tmp_12.vev(this, getPropertyCallableRef('u_GlobalPixelScale', 1, tmp_13, GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalPixelScale_$ref_gal705(), null));
    var tmp_14 = this;
    var tmp_15 = this.lev();
    var tmp_16 = KProperty1;
    tmp_14.bkm_1 = tmp_15.vev(this, getPropertyCallableRef('u_Transform', 1, tmp_16, GpuShapeViewPrograms$ShapeViewUB$_get_u_Transform_$ref_nvbejy(), null));
    var tmp_17 = this;
    var tmp_18 = this.few();
    var tmp_19 = KProperty1;
    tmp_17.ckm_1 = tmp_18.vev(this, getPropertyCallableRef('u_Gradientp0', 1, tmp_19, GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp0_$ref_kf5l2s(), null));
    var tmp_20 = this;
    var tmp_21 = this.few();
    var tmp_22 = KProperty1;
    tmp_20.dkm_1 = tmp_21.vev(this, getPropertyCallableRef('u_Gradientp1', 1, tmp_22, GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp1_$ref_jy3yol(), null));
  }
  gkm() {
    var tmp = KProperty1;
    return this.wkl_1.yq(this, getPropertyCallableRef('u_ProgramType', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_ProgramType_$ref_gtfuu8(), null));
  }
  hkm() {
    var tmp = KProperty1;
    return this.xkl_1.yq(this, getPropertyCallableRef('u_Color', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_Color_$ref_m1fq11(), null));
  }
  fkm() {
    var tmp = KProperty1;
    return this.ykl_1.yq(this, getPropertyCallableRef('u_ColorMul', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_ColorMul_$ref_2t2a63(), null));
  }
  ikm() {
    var tmp = KProperty1;
    return this.zkl_1.yq(this, getPropertyCallableRef('u_GlobalAlpha', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalAlpha_$ref_ww8199(), null));
  }
  ekm() {
    var tmp = KProperty1;
    return this.akm_1.yq(this, getPropertyCallableRef('u_GlobalPixelScale', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalPixelScale_$ref_gal705(), null));
  }
  jkm() {
    var tmp = KProperty1;
    return this.bkm_1.yq(this, getPropertyCallableRef('u_Transform', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_Transform_$ref_nvbejy(), null));
  }
  kkm() {
    var tmp = KProperty1;
    return this.ckm_1.yq(this, getPropertyCallableRef('u_Gradientp0', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp0_$ref_kf5l2s(), null));
  }
  lkm() {
    var tmp = KProperty1;
    return this.dkm_1.yq(this, getPropertyCallableRef('u_Gradientp1', 1, tmp, GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp1_$ref_jy3yol(), null));
  }
}
class PaintShader {
  constructor(uniforms, texture, program) {
    uniforms = uniforms === VOID ? new UniformBlockBuffer(ShapeViewUB_getInstance()) : uniforms;
    program = program === VOID ? GpuShapeViewPrograms_getInstance().tkk_1 : program;
    this.pkl_1 = uniforms;
    this.qkl_1 = texture;
    this.rkl_1 = program;
  }
  toString() {
    return 'PaintShader(uniforms=' + this.pkl_1.toString() + ', texture=' + toString_0(this.qkl_1) + ', program=' + this.rkl_1.toString() + ')';
  }
  hashCode() {
    var result = hashCode(this.pkl_1);
    result = imul(result, 31) + (this.qkl_1 == null ? 0 : hashCode(this.qkl_1)) | 0;
    result = imul(result, 31) + this.rkl_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PaintShader))
      return false;
    var tmp0_other_with_cast = other instanceof PaintShader ? other : THROW_CCE();
    if (!equals(this.pkl_1, tmp0_other_with_cast.pkl_1))
      return false;
    if (!equals(this.qkl_1, tmp0_other_with_cast.qkl_1))
      return false;
    if (!this.rkl_1.equals(tmp0_other_with_cast.rkl_1))
      return false;
    return true;
  }
}
class GpuShapeViewPrograms {
  constructor() {
    GpuShapeViewPrograms_instance = this;
    this.dkk_1 = Attribute.dex('a_MaxDist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 4);
    this.ekk_1 = Attribute.dex('a_Dist', VarType_Float1_getInstance(), false, Precision_MEDIUM_getInstance(), 5);
    this.fkk_1 = Varying.pex('v_MaxDist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.gkk_1 = Varying.pex('v_Dist', VarType_Float1_getInstance(), Precision_MEDIUM_getInstance());
    this.hkk_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1]);
    this.ikk_1 = ProgramLayout.hes([DefaultShaders_getInstance().oes_1]);
    this.jkk_1 = ProgramLayout.hes([this.ekk_1]);
    this.kkk_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1, DefaultShaders_getInstance().oes_1]);
    this.lkk_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1, this.ekk_1]);
    this.mkk_1 = ProgramLayout.hes([DefaultShaders_getInstance().nes_1, this.ekk_1, this.dkk_1]);
    this.nkk_1 = 0;
    this.okk_1 = 1;
    this.pkk_1 = 2;
    this.qkk_1 = 3;
    this.rkk_1 = 4;
    this.skk_1 = 5;
    var tmp = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.eey();
    this_0.jey(this_0.mey(), this_0.ney(this_0.ney(this_0.jev(), this_0.kev()), this_0.qey([this_0.oey(), this_0.pey(0.0), this_0.pey(1.0)])));
    this_0.jey(this_0.fey(), DefaultShaders_getInstance().nes_1);
    this_0.jey(GpuShapeViewPrograms_getInstance().gkk_1, GpuShapeViewPrograms_getInstance().ekk_1);
    this_0.jey(GpuShapeViewPrograms_getInstance().fkk_1, GpuShapeViewPrograms_getInstance().dkk_1);
    var tmp0_vertex = VertexShader(this_0.rey());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_1 = ProgramBuilderDefault.eey();
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_1.df1(GpuShapeViewPrograms_getInstance().gkm(), this_1.pey(5));
    var body = this_1.yey();
    body.jey(body.mey(), body.qey([body.pey(1.0), body.pey(0.0), body.pey(0.0), body.pey(1.0)]));
    body.vez();
    var stmIf = new If(cond, body.aez());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.iey_1.d2(stmIf);
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond_0 = this_1.gf1(this_1.cf0(GpuShapeViewPrograms_getInstance().gkk_1), GpuShapeViewPrograms_getInstance().fkk_1);
    var body_0 = this_1.yey();
    body_0.tez();
    var stmIf_0 = new If(cond_0, body_0.aez());
    // Inline function 'kotlin.collections.plusAssign' call
    this_1.iey_1.d2(stmIf_0);
    var tmp_0 = GpuShapeViewPrograms_getInstance().gkm();
    this_1.qez(tmp_0, 0, 4, GpuShapeViewPrograms$PROGRAM_COMBINED$lambda(this_1));
    var aaAlpha = this_1.uf0(this_1.pey(1.0), this_1.jf0(this_1.uf0(this_1.ney(GpuShapeViewPrograms_getInstance().fkk_1, GpuShapeViewPrograms_getInstance().ekm()), this_1.pey(1.5)), this_1.ney(GpuShapeViewPrograms_getInstance().fkk_1, GpuShapeViewPrograms_getInstance().ekm()), this_1.cf0(this_1.ney(GpuShapeViewPrograms_getInstance().gkk_1, GpuShapeViewPrograms_getInstance().ekm()))));
    this_1.jey(this_1.mey(), this_1.ney(this_1.ney(this_1.ney(this_1.mey(), GpuShapeViewPrograms_getInstance().fkm()), GpuShapeViewPrograms_getInstance().ikm()), aaAlpha));
    var tmp1_fragment = FragmentShader(this_1.rey());
    tmp.tkk_1 = new Program(tmp0_vertex, tmp1_fragment, 'GpuShapeViewPrograms.Combined');
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.Companion.single' call
    var block = ShapeViewUB_getInstance();
    // Inline function 'kotlin.also' call
    var this_2 = new UniformBlockBuffer(block);
    this_2.ra8();
    // Inline function 'kotlin.also' call
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var _unary__edvuaz = this_2.z6x();
      this_2.efc(_unary__edvuaz + 1 | 0);
      this_2.ffc(this_2.z6x() + 1 | 0);
      var blockSize = this_2.beo_1;
      var index0 = imul(this_2.z6x() - 1 | 0, blockSize);
      var index1 = imul(this_2.z6x(), blockSize);
      var texBlockSize = this_2.yen_1.wev().s2();
      var texIndex0 = imul(this_2.z6x() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_2.z6x(), texBlockSize);
      if (this_2.z6x() > 0) {
        arraycopy(this_2.deo_1, index0, this_2.deo_1, index1, blockSize);
      } else {
        arrayfill(this_2.deo_1, 0, 0, blockSize);
      }
      this_2.yen_1;
      this_2.eeo_1.kfc(ShapeViewUB_getInstance().gkm(), 5);
      if (true && this_2.z6x() >= 1) {
        var equals = arrayequal(this_2.deo_1, index0, this_2.deo_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_2.z6x();
          this_2.efc(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
    tmp_1.ukk_1 = new PaintShader(this_2, null);
  }
  gkm() {
    return ShapeViewUB_getInstance().gkm().rep_1;
  }
  hkm() {
    return ShapeViewUB_getInstance().hkm().rep_1;
  }
  fkm() {
    return ShapeViewUB_getInstance().fkm().rep_1;
  }
  ikm() {
    return ShapeViewUB_getInstance().ikm().rep_1;
  }
  ekm() {
    return ShapeViewUB_getInstance().ekm().rep_1;
  }
  jkm() {
    return ShapeViewUB_getInstance().jkm().rep_1;
  }
  kkm() {
    return ShapeViewUB_getInstance().kkm().rep_1;
  }
  lkm() {
    return ShapeViewUB_getInstance().lkm().rep_1;
  }
  mkm(_this__u8e3s4) {
    // Inline function 'korlibs.graphics.shader.Companion.invoke' call
    var $this$ExpressionBuilder = Companion_getInstance_24().vfj_1;
    return $this$ExpressionBuilder.zez(_this__u8e3s4, $this$ExpressionBuilder.pey(2.0));
  }
  vkk(stateTransform, paint, globalAlpha, lineWidth) {
    var tmp;
    if (paint instanceof NonePaint) {
      tmp = null;
    } else {
      if (paint instanceof RGBA) {
        // Inline function 'korlibs.graphics.shader.Companion.single' call
        var block = ShapeViewUB_getInstance();
        // Inline function 'kotlin.also' call
        var this_0 = new UniformBlockBuffer(block);
        this_0.ra8();
        // Inline function 'kotlin.also' call
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = this_0.z6x();
          this_0.efc(_unary__edvuaz + 1 | 0);
          this_0.ffc(this_0.z6x() + 1 | 0);
          var blockSize = this_0.beo_1;
          var index0 = imul(this_0.z6x() - 1 | 0, blockSize);
          var index1 = imul(this_0.z6x(), blockSize);
          var texBlockSize = this_0.yen_1.wev().s2();
          var texIndex0 = imul(this_0.z6x() - 1 | 0, texBlockSize);
          var texIndex1 = imul(this_0.z6x(), texBlockSize);
          if (this_0.z6x() > 0) {
            arraycopy(this_0.deo_1, index0, this_0.deo_1, index1, blockSize);
          } else {
            arrayfill(this_0.deo_1, 0, 0, blockSize);
          }
          var tmp0 = this_0.yen_1;
          var it = this_0.eeo_1;
          it.kfc(tmp0.gkm(), 0);
          it.pfc(tmp0.hkm(), _RGBA___get_premultiplied__impl__3bulqc(paint.sci_1));
          it.kfc(tmp0.ikm(), globalAlpha);
          if (true && this_0.z6x() >= 1) {
            var equals = arrayequal(this_0.deo_1, index0, this_0.deo_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = this_0.z6x();
              this_0.efc(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        tmp = new PaintShader(this_0, null);
      } else {
        if (paint instanceof BitmapPaint) {
          var mat = Companion_getInstance_33().v9k_1.n9m(paint.wdk_1).n9m(stateTransform).h9m().u9l(1.0 / paint.vdk_1.sc1_1, 1.0 / paint.vdk_1.tc1_1);
          // Inline function 'korlibs.graphics.shader.Companion.single' call
          var block_0 = ShapeViewUB_getInstance();
          // Inline function 'kotlin.also' call
          var this_1 = new UniformBlockBuffer(block_0);
          this_1.ra8();
          // Inline function 'kotlin.also' call
          $l$block_0: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz_1 = this_1.z6x();
            this_1.efc(_unary__edvuaz_1 + 1 | 0);
            this_1.ffc(this_1.z6x() + 1 | 0);
            var blockSize_0 = this_1.beo_1;
            var index0_0 = imul(this_1.z6x() - 1 | 0, blockSize_0);
            var index1_0 = imul(this_1.z6x(), blockSize_0);
            var texBlockSize_0 = this_1.yen_1.wev().s2();
            var texIndex0_0 = imul(this_1.z6x() - 1 | 0, texBlockSize_0);
            var texIndex1_0 = imul(this_1.z6x(), texBlockSize_0);
            if (this_1.z6x() > 0) {
              arraycopy(this_1.deo_1, index0_0, this_1.deo_1, index1_0, blockSize_0);
            } else {
              arrayfill(this_1.deo_1, 0, 0, blockSize_0);
            }
            var tmp0_0 = this_1.yen_1;
            var it_0 = this_1.eeo_1;
            it_0.kfc(tmp0_0.gkm(), 1);
            it_0.rfc(tmp0_0.jkm(), toMatrix4(mat));
            it_0.kfc(tmp0_0.ikm(), globalAlpha);
            if (true && this_1.z6x() >= 1) {
              var equals_0 = arrayequal(this_1.deo_1, index0_0, this_1.deo_1, index1_0, blockSize_0);
              if (equals_0) {
                var _unary__edvuaz_2 = this_1.z6x();
                this_1.efc(_unary__edvuaz_2 - 1 | 0);
                break $l$block_0;
              }
            }
          }
          tmp = new PaintShader(this_1, paint.vdk_1);
        } else {
          if (paint instanceof GradientPaint) {
            var gradientBitmap = Bitmap32.lc1(256, 1, VOID, true);
            // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
            var rect = gradientBitmap.wc1_1;
            if (true) {
              gradientBitmap.fc2();
            }
            var result;
            try {
              paint.hdk(_RgbaPremultipliedArray___init__impl__lx83hy(gradientBitmap.ic1_1));
            }finally {
              result = true ? gradientBitmap.hc2(rect) : 0;
            }
            var npaint = paint.idk(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_33().v9k_1.n9m(paint.ed8_1).n9m(stateTransform));
            var mat_0 = paint.ud7_1.w1_1 === 0 ? npaint.kd8_1 : npaint.ed8_1.h9m();
            // Inline function 'korlibs.graphics.shader.Companion.single' call
            var block_1 = ShapeViewUB_getInstance();
            // Inline function 'kotlin.also' call
            var this_2 = new UniformBlockBuffer(block_1);
            this_2.ra8();
            // Inline function 'kotlin.also' call
            $l$block_1: {
              // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
              var _unary__edvuaz_3 = this_2.z6x();
              this_2.efc(_unary__edvuaz_3 + 1 | 0);
              this_2.ffc(this_2.z6x() + 1 | 0);
              var blockSize_1 = this_2.beo_1;
              var index0_1 = imul(this_2.z6x() - 1 | 0, blockSize_1);
              var index1_1 = imul(this_2.z6x(), blockSize_1);
              var texBlockSize_1 = this_2.yen_1.wev().s2();
              var texIndex0_1 = imul(this_2.z6x() - 1 | 0, texBlockSize_1);
              var texIndex1_1 = imul(this_2.z6x(), texBlockSize_1);
              if (this_2.z6x() > 0) {
                arraycopy(this_2.deo_1, index0_1, this_2.deo_1, index1_1, blockSize_1);
              } else {
                arrayfill(this_2.deo_1, 0, 0, blockSize_1);
              }
              var tmp0_1 = this_2.yen_1;
              var it_1 = this_2.eeo_1;
              var tmp_0 = tmp0_1.gkm();
              var tmp0_2 = paint.ud7_1.w1_1;
              it_1.kfc(tmp_0, tmp0_2 === 1 ? 3 : tmp0_2 === 2 ? 4 : 2);
              it_1.rfc(tmp0_1.jkm(), toMatrix4(mat_0));
              it_1.qfc(tmp0_1.kkm(), new Vector4F(paint.vd7_1, paint.wd7_1, paint.xd7_1, 1.0));
              it_1.qfc(tmp0_1.lkm(), new Vector4F(paint.yd7_1, paint.zd7_1, paint.ad8_1, 1.0));
              it_1.kfc(tmp0_1.ikm(), globalAlpha);
              if (true && this_2.z6x() >= 1) {
                var equals_1 = arrayequal(this_2.deo_1, index0_1, this_2.deo_1, index1_1, blockSize_1);
                if (equals_1) {
                  var _unary__edvuaz_4 = this_2.z6x();
                  this_2.efc(_unary__edvuaz_4 - 1 | 0);
                  break $l$block_1;
                }
              }
            }
            tmp = new PaintShader(this_2, gradientBitmap);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'paint=' + toString(paint);
            throw NotImplementedError.le('An operation is not implemented: ' + reason);
          }
        }
      }
    }
    return tmp;
  }
}
//endregion
var Companion_instance_14;
function Companion_getInstance_39() {
  if (Companion_instance_14 === VOID)
    new Companion();
  return Companion_instance_14;
}
function Korge$_init_$lambda_95dffl(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$_init_$slambda_ys8r4w() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    return Unit_instance;
  }, 1);
}
function Korge$_init_$lambda_95dffl_0(it) {
  return Stage.ehl(it);
}
function Korge$start$slambda(this$0, $entry) {
  return constructCallableReference(function *($this$withContext, $completion) {
    yield* KorgeRunner_instance.ohm(this$0.nhm(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $entry), $completion);
    return Unit_instance;
  }, 1);
}
var Companion_instance_15;
function Companion_getInstance_40() {
  if (Companion_instance_15 === VOID)
    new Companion_0();
  return Companion_instance_15;
}
function KorgeRunner$invoke$slambda$slambda$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow) {
  return constructCallableReference(function *($this$coroutineScope, $completion) {
    var tmp;
    if (!($config.ihl_1 == null)) {
      // Inline function 'korlibs.korge.scene.sceneContainer' call
      var this_0 = $views.pho_1;
      var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_36()));
      var name = 'sceneContainer';
      var size = Companion_getInstance_28().c9s_1;
      // Inline function 'korlibs.korge.scene.sceneContainer' call
      var views_0 = yield* views($completion);
      var width = size.jm();
      var height = size.km();
      var rwidth = width;
      var rheight = height;
      if (width === 0.0 && height === 0.0) {
        var tmp_0 = findFirstAscendant(this_0, KorgeRunner$invoke$slambda$slambda$slambda$lambda);
        var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
        var tmp1_elvis_lhs = base == null ? null : base.w9z();
        rwidth = tmp1_elvis_lhs == null ? views_0.pho_1.w9z() : tmp1_elvis_lhs;
        var tmp3_elvis_lhs = base == null ? null : base.x9z();
        rheight = tmp3_elvis_lhs == null ? views_0.pho_1.x9z() : tmp3_elvis_lhs;
      }
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = SceneContainer.mhu(views_0, defaultTransition, name, Size2D.y9p(rwidth, rheight));
      // Inline function 'kotlin.apply' call
      yield* addTo(this_1, this_0).nhu($config.ihl_1, [], VOID, VOID, $completion);
      tmp = Unit_instance;
    }
    yield* $entry($views.pho_1, $completion);
    var tmp_1;
    if ($config.qhl_1) {
      tmp_1 = yield* $gameWindow.xgk($completion);
    }
    return Unit_instance;
  }, 1);
}
function KorgeRunner$invoke$slambda$slambda($config, $views, $entry, $gameWindow) {
  return constructCallableReference(function *($completion) {
    yield* coroutineScope(KorgeRunner$invoke$slambda$slambda$slambda($config, $views, $entry, $gameWindow), $completion);
    return Unit_instance;
  }, 0);
}
function KorgeRunner$invoke$slambda($realGameWindow, $windowSize, $config, $iconPath, $imageFormats, $entry) {
  return constructCallableReference(function *($this$loop, $completion) {
    var gameWindow = $this$loop;
    var tmp;
    if (Companion_getInstance_38().db1()) {
      println('Korui[0]');
      tmp = Unit_instance;
    }
    var tmp2 = 'configureGameWindow';
    $l$block: {
      // Inline function 'korlibs.render.GameWindow.registerTime' call
      var start = PerformanceCounter_getInstance().ke5();
      try {
        var tmp0_elvis_lhs = $config.yhl_1;
        var tmp_0;
        var tmp_1 = tmp0_elvis_lhs;
        if ((tmp_1 == null ? null : new RGBA(tmp_1)) == null) {
          tmp_0 = Colors_getInstance().ac3_1;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        configure($realGameWindow, $windowSize, $config.xhl_1, null, $config.phl_1, tmp_0);
        break $l$block;
      }finally {
        var end = PerformanceCounter_getInstance().ke5();
        // Inline function 'korlibs.time.microseconds' call
        var this_0 = end - start;
        var tmp$ret$2 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
        gameWindow.jgk(tmp2, tmp$ret$2);
      }
    }
    $l$block_0: {
      // Inline function 'korlibs.render.GameWindow.registerTime' call
      var start_0 = PerformanceCounter_getInstance().ke5();
      try {
        try {
          if (!($iconPath == null)) {
            $this$loop.lgk(yield* readBitmap(get_resourcesVfs().wi($iconPath), $imageFormats, $completion));
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            // Inline function 'korlibs.logger.Logger.error' call
            var tmp0 = Companion_getInstance_39().nhi_1;
            // Inline function 'korlibs.logger.Logger.log' call
            var level = Level_ERROR_getInstance();
            if (tmp0.obj(level)) {
              var tmp$ret$7 = "Couldn't get the application icon";
              tmp0.pbj(level, tmp$ret$7);
            }
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        break $l$block_0;
      }finally {
        var end_0 = PerformanceCounter_getInstance().ke5();
        // Inline function 'korlibs.time.microseconds' call
        var this_1 = end_0 - start_0;
        var tmp$ret$8 = toDuration(this_1, DurationUnit_MICROSECONDS_getInstance());
        gameWindow.jgk('setIcon', tmp$ret$8);
      }
    }
    $this$loop.qgk($this$loop.fgc());
    var tmp_2;
    if (Companion_getInstance_38().db1()) {
      println('CanvasApplicationEx.IN[0]');
      tmp_2 = Unit_instance;
    }
    var input = new Input();
    var stats = new Stats();
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$9 = $completion.od();
    // Inline function 'kotlin.also' call
    var this_2 = Views.ohu(tmp$ret$9.ep(gameWindow.cgk()).ep(new InjectorContext($config.khl_1)).ep(SupervisorJob()).ep(CoroutineName.b1u('Views')), $config.fhm_1 ? AGPrint.rfb() : $this$loop.bgk(), $config.khl_1, input, $config.jhl_1, stats, gameWindow, $config.rhl_1, $config.shl_1, $config.thl_1, VOID, $config.ihm_1);
    yield* this_2.tbf($completion);
    if (Companion_getInstance_38().ib1()) {
      Dyn__set_impl_2ozvx8(Companion_instance_13.rbq(), 'views', this_2);
    }
    var views = this_2;
    $config.khl_1.qe4(getKClass(GameWindow), gameWindow);
    $config.khl_1.qe4(getKClass(Korge), $config);
    views.sho_1 = $this$loop.sgk();
    views.phu($config.ghm_1);
    views.qhu($config.hhm_1);
    views.jho_1 = numberToInt($config.vhl_1.j9i_1);
    views.kho_1 = numberToInt($config.vhl_1.k9i_1);
    views.nho_1 = $config.whl_1.whm_1;
    views.mho_1 = $config.whl_1.vhm_1;
    views.oho_1 = $config.whl_1.xhm_1;
    views.dhp_1 = $config.jhm_1;
    var tmp2_0 = 'prepareViews';
    $l$block_1: {
      // Inline function 'korlibs.render.GameWindow.registerTime' call
      var start_1 = PerformanceCounter_getInstance().ke5();
      try {
        KorgeReload_getInstance().hg0(gameWindow);
        yield* KorgeRunner_instance.rhu(views, gameWindow, true, $this$loop.pgk(), Companion_instance_1.d9w(), $config.chm_1, $config.lhl_1).m1q($completion);
        break $l$block_1;
      }finally {
        var end_1 = PerformanceCounter_getInstance().ke5();
        // Inline function 'korlibs.time.microseconds' call
        var this_3 = end_1 - start_1;
        var tmp$ret$14 = toDuration(this_3, DurationUnit_MICROSECONDS_getInstance());
        gameWindow.jgk(tmp2_0, tmp$ret$14);
      }
    }
    var tmp2_1 = 'completeViews';
    $l$block_2: {
      // Inline function 'korlibs.render.GameWindow.registerTime' call
      var start_2 = PerformanceCounter_getInstance().ke5();
      try {
        completeViews(views);
        break $l$block_2;
      }finally {
        var end_2 = PerformanceCounter_getInstance().ke5();
        // Inline function 'korlibs.time.microseconds' call
        var this_4 = end_2 - start_2;
        var tmp$ret$17 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
        gameWindow.jgk(tmp2_1, tmp$ret$17);
      }
    }
    launchImmediately(views, KorgeRunner$invoke$slambda$slambda($config, views, $entry, gameWindow));
    var tmp_3;
    if ($config.qhl_1) {
      yield* gameWindow.xgk($completion);
      gameWindow.vgk();
      tmp_3 = Unit_instance;
    }
    return Unit_instance;
  }, 1);
}
function KorgeRunner$prepareViewsBase$lambda($this$mapSingleton) {
  return new ResourcesRoot();
}
function KorgeRunner$prepareViewsBase$lambda_0($this$mapPrototype) {
  return new EmptyScene();
}
function prepareViewsBase$getRealXY($views, x, y, scaleCoords) {
  return $views.fgb(Vector2D.t9g(x, y));
}
function prepareViewsBase$mouseDown(input, $views, downPos, downTime, type, p, button) {
  input.rg5(button, true);
  input.qg5(p, false);
  input.qg5(p, true);
  $views.shu();
  downPos._v = input.pg5();
  downTime._v = new DateTime(Companion_getInstance_5().x9v());
  input.bg5_1 = true;
}
function prepareViewsBase$mouseUp(input, $views, upPos, type, p, button) {
  input.rg5(button, false);
  input.qg5(p, false);
  $views.shu();
  upPos._v = $views.ghn_1.pg5();
}
function prepareViewsBase$mouseMove($views, moveMouseOutsideInNextFrame, moveTime, type, p, inside) {
  $views.ghn_1.qg5(p, false);
  $views.ghn_1.bg5_1 = inside;
  if (!inside) {
    moveMouseOutsideInNextFrame._v = true;
  }
  $views.shu();
  moveTime._v = new DateTime(Companion_getInstance_5().x9v());
}
function prepareViewsBase$mouseDrag($views, moveTime, type, p) {
  $views.ghn_1.qg5(p, false);
  $views.shu();
  moveTime._v = new DateTime(Companion_getInstance_5().x9v());
}
function prepareViewsBase$dispatchSimulatedTouchEvent(mouseTouchEvent, $views, p, button, type, status) {
  mouseTouchEvent.eeb_1 = 0;
  mouseTouchEvent.heb_1 = true;
  mouseTouchEvent.feb_1 = Companion_getInstance_5().x9v();
  mouseTouchEvent.geb_1 = false;
  mouseTouchEvent.peb(type);
  mouseTouchEvent.ueb(button.ref_1, p, status, VOID, Kind_MOUSE_getInstance(), button);
  mouseTouchEvent.qeb();
  $views.we7(mouseTouchEvent);
}
function KorgeRunner$prepareViewsBase$lambda_1($views, $input, $downPos, $downTime, $mouseTouchEvent, $upPos, $moveTime, $moveMouseOutsideInNextFrame) {
  return (e) => {
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'eventDispatcher.addEventListener<MouseEvent>:' + e.toString();
      tmp0.pbj(level, tmp$ret$2);
    }
    var p = prepareViewsBase$getRealXY($views, e.ue9_1, e.ve9_1, e.fea_1);
    var tmp;
    switch (e.se9_1.w1_1) {
      case 3:
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'mouseDown', p, e.we9_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.we9_1, Type_START_getInstance(), Status_ADD_getInstance());
        tmp = Unit_instance;
        break;
      case 2:
        prepareViewsBase$mouseUp($input, $views, $upPos, 'mouseUp', p, e.we9_1);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.we9_1, Type_END_getInstance(), Status_REMOVE_getInstance());
        tmp = Unit_instance;
        break;
      case 1:
        prepareViewsBase$mouseDrag($views, $moveTime, 'onMouseDrag', p);
        prepareViewsBase$dispatchSimulatedTouchEvent($mouseTouchEvent, $views, p, e.we9_1, Type_MOVE_getInstance(), Status_KEEP_getInstance());
        tmp = Unit_instance;
        break;
      case 0:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseMove', p, true);
        tmp = Unit_instance;
        break;
      case 4:
        tmp = Unit_instance;
        break;
      case 5:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseEnter', p, true);
        tmp = Unit_instance;
        break;
      case 6:
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'mouseExit', p, false);
        tmp = Unit_instance;
        break;
      case 7:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_2($views) {
  return (e) => {
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'eventDispatcher.addEventListener<KeyEvent>:' + e.toString();
      tmp0.pbj(level, tmp$ret$2);
    }
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_3($views) {
  return (e) => {
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'eventDispatcher.addEventListener<GestureEvent>:' + e.toString();
      tmp0.pbj(level, tmp$ret$2);
    }
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_4($views) {
  return (e) => {
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_5($views) {
  return (e) => {
    $views.we7(e);
    get_nativeSoundProvider().eaa(false);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_6($views) {
  return (e) => {
    $views.we7(e);
    get_nativeSoundProvider().eaa(true);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_7($views) {
  return (e) => {
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda$slambda($views) {
  return constructCallableReference(function *($completion) {
    $views.f7();
    return Unit_instance;
  }, 0);
}
function KorgeRunner$prepareViewsBase$lambda_8($views) {
  return (e) => {
    try {
      $views.we7(e);
    }finally {
      launchImmediately($views, KorgeRunner$prepareViewsBase$lambda$slambda($views));
    }
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_9($input, $views, $touchMouseEvent, $moveMouseOutsideInNextFrame, $downPos, $downTime, $upPos, $moveTime) {
  return (e) => {
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'eventDispatcher.addEventListener<TouchEvent>:' + e.toString();
      tmp0.pbj(level, tmp$ret$2);
    }
    $input.og5(e);
    var ee = $input.tg4_1;
    var _iterator__ex2g4s = ee.meb().p1();
    while (_iterator__ex2g4s.q1()) {
      var t = _iterator__ex2g4s.r1();
      t.rea_1 = prepareViewsBase$getRealXY($views, t.wea(), t.xea(), e.geb_1);
    }
    $views.we7(ee);
    var tmp;
    if (ee.neb() === 1) {
      var start = ee.xeb();
      var end = ee.yeb();
      var t_0 = first(ee.meb());
      var p = t_0.rea_1;
      var x = t_0.wea();
      var y = t_0.xea();
      var button = MouseButton_LEFT_getInstance();
      if (start) {
        prepareViewsBase$mouseDown($input, $views, $downPos, $downTime, 'onTouchStart', p, button);
      } else if (end) {
        prepareViewsBase$mouseUp($input, $views, $upPos, 'onTouchEnd', p, button);
      } else {
        prepareViewsBase$mouseMove($views, $moveMouseOutsideInNextFrame, $moveTime, 'onTouchMove', p, true);
      }
      // Inline function 'kotlin.also' call
      var this_0 = $touchMouseEvent;
      this_0.te9_1 = 0;
      this_0.we9_1 = button;
      this_0.xe9_1 = end ? 0 : 1 << button.ref_1;
      this_0.ue9_1 = numberToInt(x);
      this_0.ve9_1 = numberToInt(y);
      this_0.fea_1 = false;
      this_0.gea_1 = true;
      this_0.se9_1 = start ? Type_DOWN_getInstance() : end ? Type_UP_getInstance() : Type_DRAG_getInstance();
      $views.we7(this_0);
      var tmp_0;
      if (end) {
        $moveMouseOutsideInNextFrame._v = true;
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function prepareViewsBase$gamepadUpdated(input, e) {
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = e.fed_1;
  var n = 0;
  while (n < this_0.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var gamepad = this_0[_unary__edvuaz];
    input.lg5_1[gamepad.ged_1].ued(gamepad);
  }
  input.sg5();
}
function KorgeRunner$prepareViewsBase$lambda_10($views) {
  return (e) => {
    // Inline function 'korlibs.logger.Logger.trace' call
    var tmp0 = Companion_getInstance_39().nhi_1;
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_TRACE_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'eventDispatcher.addEventListener<GamePadConnectionEvent>:' + e.toString();
      tmp0.pbj(level, tmp$ret$2);
    }
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_11($views, $input) {
  return (e) => {
    prepareViewsBase$gamepadUpdated($input, e);
    $views.we7(e);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_12($views, $ag) {
  return (e) => {
    $views.thu($ag.zeg().seg_1, $ag.zeg().teg_1);
    return Unit_instance;
  };
}
function KorgeRunner$prepareViewsBase$lambda_13($views) {
  return (it) => {
    $views.we7(it);
    return Unit_instance;
  };
}
function prepareViewsBase$renderBlock($views, $fixedSizeStep, moveMouseOutsideInNextFrame, event) {
  try {
    $views.vhu($fixedSizeStep, $views.uhu(), event.pec_1, event.qec_1);
    $views.ghn_1.ag5_1 = false;
    if (moveMouseOutsideInNextFrame._v) {
      moveMouseOutsideInNextFrame._v = false;
      $views.ghn_1.ag5_1 = true;
      $views.ghn_1.bg5_1 = false;
      $views.shu();
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var tmp0 = Companion_getInstance_39().nhi_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_ERROR_getInstance();
      if (tmp0.obj(level)) {
        var tmp$ret$2 = 'views.gameWindow.onRenderEvent:';
        tmp0.pbj(level, tmp$ret$2);
      }
      printStackTrace(e);
      if ($views.rhn_1)
        throw e;
    } else {
      throw $p;
    }
  }
}
function KorgeRunner$prepareViewsBase$lambda_14($views, $renderShown, $firstRenderDeferred, $fixedSizeStep, $moveMouseOutsideInNextFrame) {
  return (event) => {
    var tmp;
    if (!event.qec_1) {
      prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
      tmp = Unit_instance;
    } else {
      // Inline function 'korlibs.korge.render.RenderContext.doRender' call
      var this_0 = $views.cho_1;
      var frameBuffer = this_0.zeg();
      this_0.qg1_1.ra8();
      this_0.jg1_1.ceh();
      try {
        // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
        this_0.tgc(frameBuffer);
        try {
          if (!$renderShown._v) {
            $renderShown._v = true;
            $firstRenderDeferred.l1t(Unit_instance);
          }
          prepareViewsBase$renderBlock($views, $fixedSizeStep, $moveMouseOutsideInNextFrame, event);
        }finally {
          this_0.ugc();
        }
      }finally {
        this_0.jg1_1.qeb();
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var KorgeRunner_instance;
function KorgeRunner_getInstance() {
  return KorgeRunner_instance;
}
function *Korge_0(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowWidth, windowHeight, windowSize, virtualWidth, virtualHeight, virtualSize, scaleMode, scaleAnchor, clipBorders, displayMode, title, bgcolor, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, entry, $completion) {
  var tmp;
  if (args === VOID) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [];
  } else {
    tmp = args;
  }
  args = tmp;
  imageFormats = imageFormats === VOID ? get_RegisteredImageFormats() : imageFormats;
  gameWindow = gameWindow === VOID ? null : gameWindow;
  mainSceneClass = mainSceneClass === VOID ? null : mainSceneClass;
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  injector = injector === VOID ? new Injector() : injector;
  var tmp_0;
  if (configInjector === VOID) {
    tmp_0 = Korge$lambda;
  } else {
    tmp_0 = configInjector;
  }
  configInjector = tmp_0;
  debug = debug === VOID ? false : debug;
  trace = trace === VOID ? false : trace;
  context = context === VOID ? null : context;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  blocking = blocking === VOID ? true : blocking;
  gameId = gameId === VOID ? Companion_getInstance_39().ohi_1 : gameId;
  settingsFolder = settingsFolder === VOID ? null : settingsFolder;
  batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_6().og8_1 : batchMaxQuads;
  windowWidth = windowWidth === VOID ? numberToInt(DefaultViewport_getInstance().zg5_1.j9i_1) : windowWidth;
  windowHeight = windowHeight === VOID ? numberToInt(DefaultViewport_getInstance().zg5_1.k9i_1) : windowHeight;
  windowSize = windowSize === VOID ? Size2D.l9i(windowWidth, windowHeight) : windowSize;
  virtualWidth = virtualWidth === VOID ? numberToInt(windowSize.j9i_1) : virtualWidth;
  virtualHeight = virtualHeight === VOID ? numberToInt(windowSize.k9i_1) : virtualHeight;
  virtualSize = virtualSize === VOID ? Size2D.l9i(virtualWidth, virtualHeight) : virtualSize;
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().v9r_1 : scaleMode;
  scaleAnchor = scaleAnchor === VOID ? Companion_getInstance_27().o9g() : scaleAnchor;
  clipBorders = clipBorders === VOID ? true : clipBorders;
  displayMode = displayMode === VOID ? new KorgeDisplayMode(scaleMode, scaleAnchor, clipBorders) : displayMode;
  title = title === VOID ? 'Game' : title;
  bgcolor = bgcolor === VOID ? Colors_getInstance().ac3_1 : bgcolor;
  backgroundColor = backgroundColor === VOID ? bgcolor : backgroundColor;
  quality = quality === VOID ? Quality_PERFORMANCE_getInstance() : quality;
  icon = icon === VOID ? null : icon;
  multithreaded = multithreaded === VOID ? null : multithreaded;
  forceRenderEveryFrame = forceRenderEveryFrame === VOID ? true : forceRenderEveryFrame;
  var tmp_1;
  if (main === VOID) {
    tmp_1 = Korge$slambda();
  } else {
    tmp_1 = main;
  }
  main = tmp_1;
  debugAg = debugAg === VOID ? false : debugAg;
  debugFontExtraScale = debugFontExtraScale === VOID ? 1.0 : debugFontExtraScale;
  debugFontColor = debugFontColor === VOID ? Colors_getInstance().zc2_1 : debugFontColor;
  var tmp_2;
  if (stageBuilder === VOID) {
    tmp_2 = Korge$lambda_0;
  } else {
    tmp_2 = stageBuilder;
  }
  stageBuilder = tmp_2;
  targetFps = targetFps === VOID ? 0.0 : targetFps;
  preferSyncIo = preferSyncIo === VOID ? null : preferSyncIo;
  debugCoroutines = debugCoroutines === VOID ? null : debugCoroutines;
  var tmp_3;
  if (entry === VOID) {
    tmp_3 = Korge$slambda_0();
  } else {
    tmp_3 = entry;
  }
  entry = tmp_3;
  return yield* (new Korge(args, imageFormats, gameWindow, mainSceneClass, timeProvider, injector, configInjector, debug, trace, context, fullscreen, blocking, gameId, settingsFolder, batchMaxQuads, windowSize, virtualSize, displayMode, title, backgroundColor, quality, icon, multithreaded, forceRenderEveryFrame, VOID, main, debugAg, debugFontExtraScale, debugFontColor, stageBuilder, targetFps, preferSyncIo, debugCoroutines, Unit_instance)).thm(entry, $completion);
}
function Korge$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function Korge$slambda() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    return Unit_instance;
  }, 1);
}
function Korge$lambda_0(it) {
  return Stage.ehl(it);
}
function Korge$slambda_0() {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    return Unit_instance;
  }, 1);
}
function get_viewStageComponent(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp0 = viewStageComponent$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('viewStageComponent', 1, tmp, _get_viewStageComponent_$ref_39faom(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewStageComponent$delegate;
function set_viewsToTrack(_this__u8e3s4, _set____db54di) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp0 = viewsToTrack$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_viewsToTrack_$ref_caohu0();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('viewsToTrack', 1, tmp, tmp_0, _set_viewsToTrack_$ref_tnbb2c());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_viewsToTrack(_this__u8e3s4) {
  _init_properties_StageComponent_kt__9w4k8v();
  var tmp0 = viewsToTrack$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_viewsToTrack_$ref_caohu0();
  var tmp4 = getPropertyCallableRef('viewsToTrack', 1, tmp, tmp_0, _set_viewsToTrack_$ref_tnbb2c());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var viewsToTrack$delegate;
function onNewAttachDetach(_this__u8e3s4, onAttach, onDetach) {
  var tmp;
  if (onAttach === VOID) {
    tmp = onNewAttachDetach$lambda;
  } else {
    tmp = onAttach;
  }
  onAttach = tmp;
  var tmp_0;
  if (onDetach === VOID) {
    tmp_0 = onNewAttachDetach$lambda_0;
  } else {
    tmp_0 = onDetach;
  }
  onDetach = tmp_0;
  _init_properties_StageComponent_kt__9w4k8v();
  var view = _this__u8e3s4;
  var closeable = new CancellableGroup();
  var viewStageComponent = get_viewStageComponent(_this__u8e3s4);
  deferWithViews(view, VOID, VOID, onNewAttachDetach$lambda_1(view));
  closeable.uay(viewStageComponent.bhv_1.v9y(onNewAttachDetach$lambda_2(onAttach, view)));
  closeable.uay(viewStageComponent.chv_1.v9y(onNewAttachDetach$lambda_3(onDetach, view)));
  return closeable;
}
function registerStageComponent(_this__u8e3s4, view) {
  _init_properties_StageComponent_kt__9w4k8v();
  var firstRun = get_viewsToTrack(_this__u8e3s4) == null;
  if (firstRun) {
    // Inline function 'kotlin.collections.linkedSetOf' call
    var tmp$ret$0 = LinkedHashSet.v2();
    set_viewsToTrack(_this__u8e3s4, tmp$ret$0);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  ensureNotNull(get_viewsToTrack(_this__u8e3s4)).d2(view);
  if (!firstRun)
    return Unit_instance;
  var componentsInStagePrev = FastArrayList.f9v();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStageCur = LinkedHashSet.v2();
  // Inline function 'kotlin.collections.linkedSetOf' call
  var componentsInStage = LinkedHashSet.v2();
  _this__u8e3s4.bhp_1.w9y(registerStageComponent$lambda(componentsInStagePrev, componentsInStageCur, _this__u8e3s4, componentsInStage));
}
function viewStageComponent$delegate$lambda($this$PropertyThis) {
  _init_properties_StageComponent_kt__9w4k8v();
  return new ViewStageComponent($this$PropertyThis);
}
function _get_viewStageComponent_$ref_39faom() {
  return constructCallableReference((p0) => get_viewStageComponent(p0), 1, 0, 369);
}
function viewsToTrack$delegate$lambda() {
  _init_properties_StageComponent_kt__9w4k8v();
  return null;
}
function _get_viewsToTrack_$ref_caohu0() {
  return constructCallableReference((p0) => get_viewsToTrack(p0), 1, 0, 370);
}
function _set_viewsToTrack_$ref_tnbb2c() {
  return constructCallableReference((p0, p1) => {
    set_viewsToTrack(p0, p1);
    return Unit_instance;
  }, 2, 0, 371);
}
function onNewAttachDetach$lambda(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_0(_this__u8e3s4, it) {
  _init_properties_StageComponent_kt__9w4k8v();
  return Unit_instance;
}
function onNewAttachDetach$lambda_1($view) {
  return (it) => {
    registerStageComponent(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_2($onAttach, $view) {
  return (it) => {
    $onAttach(it, $view);
    return Unit_instance;
  };
}
function onNewAttachDetach$lambda_3($onDetach, $view) {
  return (it) => {
    $onDetach(it, $view);
    return Unit_instance;
  };
}
function registerStageComponent$lambda($componentsInStagePrev, $componentsInStageCur, $this_registerStageComponent, $componentsInStage) {
  return (it) => {
    $componentsInStagePrev.a5();
    var tmp0 = $componentsInStagePrev;
    // Inline function 'kotlin.collections.plusAssign' call
    var elements = $componentsInStageCur;
    addAll(tmp0, elements);
    $componentsInStageCur.a5();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = ensureNotNull(get_viewsToTrack($this_registerStageComponent)).p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      if (hasExtra(element, '__viewStageComponent') && !(element.dhv() == null)) {
        var it_0 = get_viewStageComponent(element);
        // Inline function 'kotlin.collections.plusAssign' call
        $componentsInStageCur.d2(it_0);
        if (!$componentsInStage.w2(it_0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          $componentsInStage.d2(it_0);
          it_0.bhv_1.x9y($this_registerStageComponent.qhn_1);
        }
      }
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = $componentsInStagePrev.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var it_1 = array[_unary__edvuaz];
      if (!$componentsInStageCur.w2(it_1)) {
        it_1.chv_1.x9y($this_registerStageComponent.qhn_1);
        ensureNotNull(get_viewsToTrack($this_registerStageComponent)).z4(it_1.ahv_1);
      }
    }
    return Unit_instance;
  };
}
var properties_initialized_StageComponent_kt_b9koe7;
function _init_properties_StageComponent_kt__9w4k8v() {
  if (!properties_initialized_StageComponent_kt_b9koe7) {
    properties_initialized_StageComponent_kt_b9koe7 = true;
    viewStageComponent$delegate = new PropertyThis('__viewStageComponent', viewStageComponent$delegate$lambda);
    viewsToTrack$delegate = new Property(VOID, viewsToTrack$delegate$lambda);
  }
}
function get_keys(_this__u8e3s4) {
  _init_properties_KeysEvents_kt__ekyd0z();
  var tmp0 = keys$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('keys', 1, tmp, _get_keys_$ref_5wupmu(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var keys$delegate;
function KeysEvents$justDown$lambda($keys, $callback, this$0, $ke) {
  return ($this$addUpdaterWithViews, views, dt) => {
    var vkeys = views.x4();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $keys;
    var n = 0;
    while (n < this_0.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var key = this_0.u2(_unary__edvuaz);
      if (vkeys.lg4(key)) {
        $callback(this$0.khv($ke, key, vkeys, dt.ik_1));
      }
    }
    return Unit_instance;
  };
}
function KeysEvents$down$slambda($callback) {
  return constructCallableReference(function *(it, $completion) {
    yield* $callback(it, $completion);
    return Unit_instance;
  }, 1);
}
function KeysEvents$down$slambda_0($key, $callback) {
  return constructCallableReference(function *(it, $completion) {
    if (it.ae9_1.equals($key))
      yield* $callback(it, $completion);
    return Unit_instance;
  }, 1);
}
function KeysEvents$up$slambda($key, $callback) {
  return constructCallableReference(function *(e, $completion) {
    if (e.ae9_1.equals($key))
      yield* $callback(e, $completion);
    return Unit_instance;
  }, 1);
}
function KeysEvents$typed$slambda($callback) {
  return constructCallableReference(function *(it, $completion) {
    yield* $callback(it, $completion);
    return Unit_instance;
  }, 1);
}
function KeysEvents$lambda$slambda(this$0, $event) {
  return constructCallableReference(function *($completion) {
    yield* this$0.ihv_1.j9z($event, $completion);
    return Unit_instance;
  }, 0);
}
function KeysEvents$lambda(this$0) {
  return (event) => {
    var tmp = this$0;
    var tmp_0 = event.de8_1;
    tmp.fhv_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.lhv().dhn_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_0(this$0, $event) {
  return constructCallableReference(function *($completion) {
    yield* this$0.ghv_1.j9z($event, $completion);
    return Unit_instance;
  }, 0);
}
function KeysEvents$lambda_0(this$0) {
  return (event) => {
    var tmp = this$0;
    var tmp_0 = event.de8_1;
    tmp.fhv_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.lhv().dhn_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_0(this$0, event));
    return Unit_instance;
  };
}
function KeysEvents$lambda$slambda_1(this$0, $event) {
  return constructCallableReference(function *($completion) {
    yield* this$0.hhv_1.j9z($event, $completion);
    return Unit_instance;
  }, 0);
}
function KeysEvents$lambda_1(this$0) {
  return (event) => {
    var tmp = this$0;
    var tmp_0 = event.de8_1;
    tmp.fhv_1 = tmp_0 instanceof Views ? tmp_0 : THROW_CCE();
    var tmp_1 = this$0.lhv().dhn_1;
    launchImmediately_0(tmp_1, KeysEvents$lambda$slambda_1(this$0, event));
    return Unit_instance;
  };
}
function keys$delegate$lambda($this$PropertyThis) {
  _init_properties_KeysEvents_kt__ekyd0z();
  return new KeysEvents($this$PropertyThis);
}
function _get_keys_$ref_5wupmu() {
  return constructCallableReference((p0) => get_keys(p0), 1, 0, 372);
}
var properties_initialized_KeysEvents_kt_1mffin;
function _init_properties_KeysEvents_kt__ekyd0z() {
  if (!properties_initialized_KeysEvents_kt_1mffin) {
    properties_initialized_KeysEvents_kt_1mffin = true;
    keys$delegate = new PropertyThis(VOID, keys$delegate$lambda);
  }
}
function onMouseDrag(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  return onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback).pm_1;
}
function onMouseDragInternal(_this__u8e3s4, timeProvider, info, callback) {
  timeProvider = timeProvider === VOID ? Companion_instance_0 : timeProvider;
  info = info === VOID ? new MouseDragInfo(_this__u8e3s4) : info;
  var dragging = {_v: false};
  var sx = {_v: 0.0};
  var sy = {_v: 0.0};
  var cx = {_v: 0.0};
  var cy = {_v: 0.0};
  var view = _this__u8e3s4;
  var mousePos = {_v: Vector2D.y9j()};
  var onDownCloseable = null;
  var onUpAnywhereCloseable = null;
  var onMoveAnywhereCloseable = null;
  // Inline function 'korlibs.korge.input.mouse' call
  // Inline function 'kotlin.run' call
  var $this$mouse = get_mouse(_this__u8e3s4);
  // Inline function 'korlibs.korge.input.MouseEvents.onDownCloseable' call
  var handler = onMouseDragInternal$slambda(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  var tmp = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_0 = getPropertyCallableRef('down', 1, tmp, MouseEvents$_get_down_$ref_qneabi(), null).get($this$mouse);
  onDownCloseable = tmp_0.v9y(onMouseDragInternal$lambda($this$mouse, handler));
  // Inline function 'korlibs.korge.input.MouseEvents.onUpAnywhereCloseable' call
  var handler_0 = onMouseDragInternal$slambda_0(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  var tmp_1 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_2 = getPropertyCallableRef('upAnywhere', 1, tmp_1, MouseEvents$_get_upAnywhere_$ref_s41vu2(), null).get($this$mouse);
  onUpAnywhereCloseable = tmp_2.v9y(onMouseDragInternal$lambda_0($this$mouse, handler_0));
  // Inline function 'korlibs.korge.input.MouseEvents.onMoveAnywhereCloseable' call
  var handler_1 = onMouseDragInternal$slambda_1(dragging, info, mousePos, sx, sy, cx, cy, callback, timeProvider, view);
  var tmp_3 = KProperty1;
  // Inline function 'korlibs.korge.input.MouseEvents._mouseEventCloseable' call
  var tmp_4 = getPropertyCallableRef('moveAnywhere', 1, tmp_3, MouseEvents$_get_moveAnywhere_$ref_si2le4(), null).get($this$mouse);
  onMoveAnywhereCloseable = tmp_4.v9y(onMouseDragInternal$lambda_1($this$mouse, handler_1));
  var tmp_5;
  if (onDownCloseable == null) {
    throwUninitializedPropertyAccessException('onDownCloseable');
  } else {
    tmp_5 = onDownCloseable;
  }
  var tmp_6 = tmp_5;
  var tmp_7;
  if (onUpAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onUpAnywhereCloseable');
  } else {
    tmp_7 = onUpAnywhereCloseable;
  }
  var tmp_8 = tmp_7;
  var tmp_9;
  if (onMoveAnywhereCloseable == null) {
    throwUninitializedPropertyAccessException('onMoveAnywhereCloseable');
  } else {
    tmp_9 = onMoveAnywhereCloseable;
  }
  return to(_this__u8e3s4, new OnMouseDragCloseable(tmp_6, tmp_8, tmp_9));
}
var MouseDragState_START_instance;
var MouseDragState_DRAG_instance;
var MouseDragState_END_instance;
var MouseDragState_entriesInitialized;
function MouseDragState_initEntries() {
  if (MouseDragState_entriesInitialized)
    return Unit_instance;
  MouseDragState_entriesInitialized = true;
  MouseDragState_START_instance = new MouseDragState('START', 0);
  MouseDragState_DRAG_instance = new MouseDragState('DRAG', 1);
  MouseDragState_END_instance = new MouseDragState('END', 2);
}
function onMouseDragInternal$views(view) {
  return ensureNotNull(view.dhv()).phw();
}
function onMouseDragInternal$updateMouse(mousePos, view) {
  var views = onMouseDragInternal$views(view);
  mousePos._v = views.qhw();
}
function onMouseDragInternal$handle(dragging, $info, mousePos, sx, sy, cx, cy, $callback, $timeProvider, view, it, state) {
  if (!state.equals(MouseDragState_START_getInstance()) && !dragging._v)
    return Unit_instance;
  onMouseDragInternal$updateMouse(mousePos, view);
  $info.ehw_1 = it;
  var px = mousePos._v.r9g_1;
  var py = mousePos._v.s9g_1;
  switch (state.w1_1) {
    case 0:
      dragging._v = true;
      sx._v = px;
      sy._v = py;
      $info.ra8();
      break;
    case 2:
      dragging._v = false;
      break;
    default:
      break;
  }
  cx._v = mousePos._v.r9g_1;
  cy._v = mousePos._v.s9g_1;
  var dx = cx._v - sx._v;
  var dy = cy._v - sy._v;
  $callback(onMouseDragInternal$views(view), $info.jhw(dx, dy, state.xeb(), state.yeb(), $timeProvider.x9v(), sx._v, sy._v, cx._v, cy._v));
}
function onMouseDragInternal$slambda($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  return constructCallableReference(function *(it, $completion) {
    onMouseDragInternal$handle($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view, it, MouseDragState_START_getInstance());
    return Unit_instance;
  }, 1);
}
function onMouseDragInternal$lambda$slambda($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function onMouseDragInternal$lambda($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_0($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  return constructCallableReference(function *(it, $completion) {
    onMouseDragInternal$handle($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view, it, MouseDragState_END_getInstance());
    return Unit_instance;
  }, 1);
}
function onMouseDragInternal$lambda$slambda_0($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function onMouseDragInternal$lambda_0($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function onMouseDragInternal$slambda_1($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view) {
  return constructCallableReference(function *(it, $completion) {
    onMouseDragInternal$handle($dragging, $info, $mousePos, $sx, $sy, $cx, $cy, $callback, $timeProvider, $view, it, MouseDragState_DRAG_getInstance());
    return Unit_instance;
  }, 1);
}
function onMouseDragInternal$lambda$slambda_1($handler, $it) {
  return constructCallableReference(function *($completion) {
    yield* $handler($it, $completion);
    return Unit_instance;
  }, 0);
}
function onMouseDragInternal$lambda_1($this, $handler) {
  return (it) => {
    var tmp = $this.ghy();
    launchImmediately_0(tmp, onMouseDragInternal$lambda$slambda_1($handler, it));
    return Unit_instance;
  };
}
function MouseDragState_START_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_START_instance;
}
function MouseDragState_DRAG_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_DRAG_instance;
}
function MouseDragState_END_getInstance() {
  MouseDragState_initEntries();
  return MouseDragState_END_instance;
}
function set_mouseHitSearch(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitSearch$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitSearch_$ref_38xpks();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('mouseHitSearch', 1, tmp, tmp_0, _set_mouseHitSearch_$ref_uoxljk());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitSearch(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitSearch$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitSearch_$ref_38xpks();
  var tmp4 = getPropertyCallableRef('mouseHitSearch', 1, tmp, tmp_0, _set_mouseHitSearch_$ref_uoxljk());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitSearch$delegate;
function set_mouseHitResult(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitResult$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitResult_$ref_37njf5();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('mouseHitResult', 1, tmp, tmp_0, _set_mouseHitResult_$ref_uq7rp7());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResult(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitResult$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitResult_$ref_37njf5();
  var tmp4 = getPropertyCallableRef('mouseHitResult', 1, tmp, tmp_0, _set_mouseHitResult_$ref_uq7rp7());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResult$delegate;
function set_mouseHitResultUsed(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitResultUsed$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitResultUsed_$ref_rdjbxu();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('mouseHitResultUsed', 1, tmp, tmp_0, _set_mouseHitResultUsed_$ref_54fvi6());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseHitResultUsed(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseHitResultUsed$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseHitResultUsed_$ref_rdjbxu();
  var tmp4 = getPropertyCallableRef('mouseHitResultUsed', 1, tmp, tmp_0, _set_mouseHitResultUsed_$ref_54fvi6());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseHitResultUsed$delegate;
function set_mouseDebugHandlerOnce(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseDebugHandlerOnce$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseDebugHandlerOnce_$ref_8iyjnn();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('mouseDebugHandlerOnce', 1, tmp, tmp_0, _set_mouseDebugHandlerOnce_$ref_art2lz());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugHandlerOnce(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseDebugHandlerOnce$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseDebugHandlerOnce_$ref_8iyjnn();
  var tmp4 = getPropertyCallableRef('mouseDebugHandlerOnce', 1, tmp, tmp_0, _set_mouseDebugHandlerOnce_$ref_art2lz());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugHandlerOnce$delegate;
function set_mouseDebugLastFrameClicked(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseDebugLastFrameClicked$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseDebugLastFrameClicked_$ref_bgh5ms();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('mouseDebugLastFrameClicked', 1, tmp, tmp_0, _set_mouseDebugLastFrameClicked_$ref_o6cwjc());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_mouseDebugLastFrameClicked(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouseDebugLastFrameClicked$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_mouseDebugLastFrameClicked_$ref_bgh5ms();
  var tmp4 = getPropertyCallableRef('mouseDebugLastFrameClicked', 1, tmp, tmp_0, _set_mouseDebugLastFrameClicked_$ref_o6cwjc());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouseDebugLastFrameClicked$delegate;
function get_mouse(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = mouse$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('mouse', 1, tmp, _get_mouse_$ref_5i5flx(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var mouse$delegate;
function set_cursor(_this__u8e3s4, _set____db54di) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = cursor$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_cursor_$ref_dbww6c();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('cursor', 1, tmp, tmp_0, _set_cursor_$ref_se5hbk());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_cursor(_this__u8e3s4) {
  _init_properties_MouseEvents_kt__io5soc();
  var tmp0 = cursor$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_cursor_$ref_dbww6c();
  var tmp4 = getPropertyCallableRef('cursor', 1, tmp, tmp_0, _set_cursor_$ref_se5hbk());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var cursor$delegate;
function mouseHitTest($this, views) {
  if (!get_mouseHitSearch(views.ghn_1)) {
    set_mouseHitSearch(views.ghn_1, true);
    set_mouseHitResult(views.ghn_1, views.pho_1.hhy(views.qhw()));
    var view = get_mouseHitResult(views.ghn_1);
    $l$loop: while (!(view == null) && get_cursor(view) == null) {
      view = view.x1m();
    }
    var tmp0_safe_receiver = view;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_cursor(tmp0_safe_receiver);
    var newCursor = tmp1_elvis_lhs == null ? Cursor_DEFAULT_getInstance() : tmp1_elvis_lhs;
    if (!equals(views.jhn_1.agk(), newCursor)) {
      views.jhn_1.zgj(newCursor);
    }
  }
  return get_mouseHitResult(views.ghn_1);
}
function MouseEvents$Companion$installDebugExtensionOnce$lambda($views) {
  return (_this__u8e3s4, ctx) => {
    var scale = ctx.ggc();
    // Inline function 'kotlin.math.max' call
    var a = 1 * scale;
    var space = Math.max(a, 2.0);
    var matrix = $views.vga();
    var yy = 60 * scale;
    var lineHeight = 8 * scale;
    var mouseHit = mouseHitTest(Companion_instance_16, $views);
    var tmp;
    if (!(mouseHit == null)) {
      var bounds = mouseHit.ihy();
      if (get_mouseDebugLastFrameClicked(_this__u8e3s4)) {
        $views.jhy(mouseHit);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = _this__u8e3s4.cho_1.hg2_1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var this_1 = this_0.qg2_1;
      if (!(this_1.lg2_1 === this_0)) {
        this_1.lg2_1 = this_0;
        this_1.vg3();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$5 = get_Bitmaps_white();
      var tmp0_tex = ctx.wg3(tmp$ret$5);
      var tmp1_x = bounds.o9h_1;
      var tmp2_y = bounds.p9h_1;
      var tmp3_width = bounds.q9h_1;
      var tmp4_height = bounds.r9h_1;
      var tmp5_colorMul = RGBA__withAd_impl_cralao(Colors_getInstance().bc3_1, 0.3);
      var tmp6_m = mouseHit.khy();
      this_0.xg3(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp6_m, VOID, tmp5_colorMul);
      var tmp7_$receiver = _this__u8e3s4.cho_1;
      var tmp8_font = _this__u8e3s4.lhy();
      var tmp9_str = toString_0(mouseHit) + ' : ' + $views.qhw().r9g_1 + ',' + $views.qhw().s9g_1;
      var tmp10_y = numberToInt(yy);
      var tmp11_colMul = ctx.gg2_1;
      var tmp12_blendMode = Companion_getInstance_13().yg0_1;
      var tmp13_m = get_immutable(matrix);
      drawText(tmp7_$receiver, tmp8_font, lineHeight, tmp9_str, 0, tmp10_y, tmp13_m, tmp11_colMul, tmp12_blendMode, false);
      yy = yy + lineHeight;
      yy = yy + space;
      tmp = Unit_instance;
    }
    var mouseHitResultUsed = get_mouseHitResultUsed(_this__u8e3s4.ghn_1);
    var tmp_0;
    if (!(mouseHitResultUsed == null)) {
      var bounds_0 = mouseHitResultUsed.ihy();
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_2 = _this__u8e3s4.cho_1.hg2_1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var this_3 = this_2.qg2_1;
      if (!(this_3.lg2_1 === this_2)) {
        this_3.lg2_1 = this_2;
        this_3.vg3();
      }
      // Inline function 'korlibs.image.bitmap.Bitmaps.white' call
      var tmp$ret$10 = get_Bitmaps_white();
      var tmp0_tex_0 = ctx.wg3(tmp$ret$10);
      var tmp1_x_0 = bounds_0.o9h_1;
      var tmp2_y_0 = bounds_0.p9h_1;
      var tmp3_width_0 = bounds_0.q9h_1;
      var tmp4_height_0 = bounds_0.r9h_1;
      var tmp5_colorMul_0 = Companion_getInstance_1().ich(0, 0, 255, 63);
      var tmp6_m_0 = mouseHitResultUsed.khy();
      this_2.xg3(tmp0_tex_0, tmp1_x_0, tmp2_y_0, tmp3_width_0, tmp4_height_0, tmp6_m_0, VOID, tmp5_colorMul_0);
      var vview = mouseHitResultUsed;
      while (!(vview == null)) {
        var tmp7_$receiver_0 = _this__u8e3s4.cho_1;
        var tmp8_font_0 = _this__u8e3s4.lhy();
        var tmp9_str_0 = vview.toString();
        var tmp10_y_0 = numberToInt(yy);
        var tmp11_colMul_0 = ctx.gg2_1;
        var tmp12_blendMode_0 = Companion_getInstance_13().yg0_1;
        var tmp13_m_0 = get_immutable(matrix);
        drawText(tmp7_$receiver_0, tmp8_font_0, lineHeight, tmp9_str_0, 0, tmp10_y_0, tmp13_m_0, tmp11_colMul_0, tmp12_blendMode_0, false);
        vview = vview.x1m();
        yy = yy + lineHeight;
        yy = yy + space;
      }
      tmp_0 = Unit_instance;
    }
    set_mouseDebugLastFrameClicked(_this__u8e3s4, false);
    return Unit_instance;
  };
}
function MouseEvents$MouseEventsUpdate$lambda(this$0) {
  return ($this$addUpdaterWithViews, views, dt) => {
    this$0.mhy(views, dt.ik_1);
    return Unit_instance;
  };
}
var Companion_instance_16;
function Companion_getInstance_41() {
  return Companion_instance_16;
}
function temporalLastEvent($this, lastEventNew, block) {
  var old = $this.bhy_1;
  var tmp = $this;
  tmp.bhy_1 = lastEventNew == null ? $this.bhy_1 : lastEventNew;
  try {
    return block();
  }finally {
    $this.bhy_1 = old;
  }
}
function MouseEvents$closeable$lambda(this$0) {
  return (event) => {
    var tmp;
    if (!this$0.shw_1.rhy()) {
      return Unit_instance;
    }
    var tmp_0 = this$0;
    var tmp_1 = event.de8_1;
    tmp_0.thw_1 = tmp_1 instanceof Views ? tmp_1 : THROW_CCE();
    this$0.ahy_1 = event;
    this$0.bhy_1.kea(event);
    this$0.chy_1 = event.gea_1;
    this$0.zhx_1 = true;
    var tmp_2;
    switch (event.se9_1.w1_1) {
      case 2:
        this$0.dhy_1.kea(event);
        this$0.uhx_1 = this$0.phw().ghn_1.pg5();
        this$0.rhx_1 = PerformanceCounter_getInstance().le5();
        var elapsedTime = Duration__minus_impl_q5cfm7(this$0.rhx_1, this$0.shx_1);
        var tmp_3;
        if (this$0.uhx_1.g9t(this$0.thx_1) < this$0.phw().ghn_1.wg4_1 && Duration__compareTo_impl_pchp0f(elapsedTime, this$0.phw().ghn_1.vg4_1) < 0) {
          var _unary__edvuaz = this$0.yhx_1;
          this$0.yhx_1 = _unary__edvuaz + 1 | 0;
          var tmp_4;
          if (this$0.shy()) {
            this$0.vhw_1.x9y(this$0);
            var tmp_5;
            if (this$0.vhw_1.b9z() > 0) {
              event.je8(this$0.shw_1);
              tmp_5 = Unit_instance;
            }
            tmp_4 = tmp_5;
          }
          tmp_3 = tmp_4;
        }

        tmp_2 = tmp_3;
        break;
      case 3:
        if (!event.dea_1) {
          set_mouseDebugLastFrameClicked(this$0.phw(), true);
        }

        this$0.shx_1 = PerformanceCounter_getInstance().le5();
        this$0.thx_1 = this$0.phw().ghn_1.pg5();
        var tmp_6;
        if (this$0.uhw_1.c9z()) {
          var tmp_7;
          if (this$0.shy()) {
            this$0.uhw_1.x9y(this$0);
            tmp_7 = Unit_instance;
          }
          tmp_6 = tmp_7;
        }

        tmp_2 = tmp_6;
        break;
      case 7:
        if (this$0.shy()) {
          this$0.khx_1.x9y(this$0);
        } else {
          this$0.mhx_1.x9y(this$0);
        }

        this$0.lhx_1.x9y(this$0);
        tmp_2 = Unit_instance;
        break;
      default:
        tmp_2 = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
function MouseEvents$update$lambda($over, this$0) {
  return () => {
    var tmp;
    if ($over) {
      this$0.bhx_1.x9y(this$0);
      tmp = Unit_instance;
    } else {
      this$0.chx_1.x9y(this$0);
      this$0.ehx_1.x9y(this$0);
      tmp = Unit_instance;
    }
    this$0.fhx_1.x9y(this$0);
    return Unit_instance;
  };
}
function doubleClick(_this__u8e3s4, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  return multiClick(_this__u8e3s4, 2, callback);
}
function multiClick(_this__u8e3s4, count, callback) {
  _init_properties_MouseEvents_kt__io5soc();
  var clickCount = {_v: 0};
  var lastClickTime = {_v: new DateTime(Companion_getInstance_5().t9v_1)};
  return _this__u8e3s4.vhw_1.w9y(multiClick$lambda(lastClickTime, clickCount, count, callback));
}
function mouseHitSearch$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function _get_mouseHitSearch_$ref_38xpks() {
  return constructCallableReference((p0) => get_mouseHitSearch(p0), 1, 0, 373);
}
function _set_mouseHitSearch_$ref_uoxljk() {
  return constructCallableReference((p0, p1) => {
    set_mouseHitSearch(p0, p1);
    return Unit_instance;
  }, 2, 0, 374);
}
function mouseHitResult$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function _get_mouseHitResult_$ref_37njf5() {
  return constructCallableReference((p0) => get_mouseHitResult(p0), 1, 0, 375);
}
function _set_mouseHitResult_$ref_uq7rp7() {
  return constructCallableReference((p0, p1) => {
    set_mouseHitResult(p0, p1);
    return Unit_instance;
  }, 2, 0, 376);
}
function mouseHitResultUsed$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function _get_mouseHitResultUsed_$ref_rdjbxu() {
  return constructCallableReference((p0) => get_mouseHitResultUsed(p0), 1, 0, 377);
}
function _set_mouseHitResultUsed_$ref_54fvi6() {
  return constructCallableReference((p0, p1) => {
    set_mouseHitResultUsed(p0, p1);
    return Unit_instance;
  }, 2, 0, 378);
}
function mouseDebugHandlerOnce$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return new Once();
}
function _get_mouseDebugHandlerOnce_$ref_8iyjnn() {
  return constructCallableReference((p0) => get_mouseDebugHandlerOnce(p0), 1, 0, 379);
}
function _set_mouseDebugHandlerOnce_$ref_art2lz() {
  return constructCallableReference((p0, p1) => {
    set_mouseDebugHandlerOnce(p0, p1);
    return Unit_instance;
  }, 2, 0, 380);
}
function mouseDebugLastFrameClicked$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return false;
}
function _get_mouseDebugLastFrameClicked_$ref_bgh5ms() {
  return constructCallableReference((p0) => get_mouseDebugLastFrameClicked(p0), 1, 0, 381);
}
function _set_mouseDebugLastFrameClicked_$ref_o6cwjc() {
  return constructCallableReference((p0, p1) => {
    set_mouseDebugLastFrameClicked(p0, p1);
    return Unit_instance;
  }, 2, 0, 382);
}
function mouse$delegate$lambda($this$PropertyThis) {
  _init_properties_MouseEvents_kt__io5soc();
  return new MouseEvents($this$PropertyThis);
}
function _get_mouse_$ref_5i5flx() {
  return constructCallableReference((p0) => get_mouse(p0), 1, 0, 383);
}
function cursor$delegate$lambda() {
  _init_properties_MouseEvents_kt__io5soc();
  return null;
}
function _get_cursor_$ref_dbww6c() {
  return constructCallableReference((p0) => get_cursor(p0), 1, 0, 384);
}
function _set_cursor_$ref_se5hbk() {
  return constructCallableReference((p0, p1) => {
    set_cursor(p0, p1);
    return Unit_instance;
  }, 2, 0, 385);
}
function multiClick$lambda($lastClickTime, $clickCount, $count, $callback) {
  return (it) => {
    var currentClickTime = Companion_getInstance_5().x9v();
    var tmp;
    var tmp_0 = DateTime__minus_impl_10njw8(currentClickTime, $lastClickTime._v.a9w_1);
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0 = toDuration(0.3, DurationUnit_SECONDS_getInstance());
    if (Duration__compareTo_impl_pchp0f(tmp_0, tmp$ret$0) > 0) {
      $clickCount._v = 0;
      tmp = Unit_instance;
    }
    $lastClickTime._v = new DateTime(currentClickTime);
    var _unary__edvuaz = $clickCount._v;
    $clickCount._v = _unary__edvuaz + 1 | 0;
    it.yhx_1 = $clickCount._v;
    var tmp_1;
    if ($clickCount._v === $count) {
      tmp_1 = $callback(it);
    }
    return Unit_instance;
  };
}
var properties_initialized_MouseEvents_kt_t0zz8y;
function _init_properties_MouseEvents_kt__io5soc() {
  if (!properties_initialized_MouseEvents_kt_t0zz8y) {
    properties_initialized_MouseEvents_kt_t0zz8y = true;
    mouseHitSearch$delegate = new Property(VOID, mouseHitSearch$delegate$lambda);
    mouseHitResult$delegate = new Property(VOID, mouseHitResult$delegate$lambda);
    mouseHitResultUsed$delegate = new Property(VOID, mouseHitResultUsed$delegate$lambda);
    mouseDebugHandlerOnce$delegate = new Property(VOID, mouseDebugHandlerOnce$delegate$lambda);
    mouseDebugLastFrameClicked$delegate = new Property(VOID, mouseDebugLastFrameClicked$delegate$lambda);
    mouse$delegate = new PropertyThis(VOID, mouse$delegate$lambda);
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = cursor$delegate$lambda;
    cursor$delegate = new Property(null, default_0);
  }
}
function MouseEvents$_get_down_$ref_qneabi() {
  return constructCallableReference((p0) => p0.yhw_1, 1, 0, 386);
}
function MouseEvents$_get_upAnywhere_$ref_s41vu2() {
  return constructCallableReference((p0) => p0.fhx_1, 1, 0, 387);
}
function MouseEvents$_get_moveAnywhere_$ref_si2le4() {
  return constructCallableReference((p0) => p0.hhx_1, 1, 0, 388);
}
function set__debugAnnotateView(_this__u8e3s4, _set____db54di) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp0 = _debugAnnotateView$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__debugAnnotateView_$ref_84j0k5();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('_debugAnnotateView', 1, tmp, tmp_0, _set__debugAnnotateView_$ref_e4kfvj());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp0 = _debugAnnotateView$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__debugAnnotateView_$ref_84j0k5();
  var tmp4 = getPropertyCallableRef('_debugAnnotateView', 1, tmp, tmp_0, _set__debugAnnotateView_$ref_e4kfvj());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _debugAnnotateView$delegate;
function get_views(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  var tmp = _this__u8e3s4.kg1_1;
  return tmp instanceof Views ? tmp : null;
}
function get_debugAnnotateView(_this__u8e3s4) {
  _init_properties_RenderContextExt_kt__49d41k();
  return get__debugAnnotateView(_this__u8e3s4);
}
function _debugAnnotateView$delegate$lambda() {
  _init_properties_RenderContextExt_kt__49d41k();
  return null;
}
function _get__debugAnnotateView_$ref_84j0k5() {
  return constructCallableReference((p0) => get__debugAnnotateView(p0), 1, 0, 389);
}
function _set__debugAnnotateView_$ref_e4kfvj() {
  return constructCallableReference((p0, p1) => {
    set__debugAnnotateView(p0, p1);
    return Unit_instance;
  }, 2, 0, 390);
}
var properties_initialized_RenderContextExt_kt_9hx4ly;
function _init_properties_RenderContextExt_kt__49d41k() {
  if (!properties_initialized_RenderContextExt_kt_9hx4ly) {
    properties_initialized_RenderContextExt_kt_9hx4ly = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _debugAnnotateView$delegate$lambda;
    _debugAnnotateView$delegate = new Property(null, default_0);
  }
}
function Scene$coroutineContext$delegate$lambda(this$0) {
  return () => this$0.phw().dhn_1.ep(new InjectorContext(this$0.shz())).ep(SupervisorJob(this$0.phw().dhn_1.ae(Key_instance))).ep(CoroutineName.b1u('Scene:' + toString(this$0)));
}
function Scene$_get_coroutineContext_$ref_9kwv17() {
  return constructCallableReference((p0) => p0.d1m(), 1, 0, 391);
}
function Scene$sceneView$delegate$lambda(this$0) {
  return () => {
    // Inline function 'kotlin.apply' call
    var this_0 = this$0.uhz(this$0.thz().s2());
    this$0.nhz_1.di2(this_0);
    return this_0;
  };
}
function Scene$_get_sceneView_$ref_gy0cev() {
  return constructCallableReference((p0) => p0.ei2(), 1, 0, 392);
}
function Scene$resources$delegate$lambda(this$0) {
  return () => {
    // Inline function 'korlibs.inject.Injector.getSync' call
    return this$0.shz().ze4(getKClass(Resources));
  };
}
function *_changeTo($this, clazz, injects, time, transition, $completion) {
  var tmp;
  if (time === VOID) {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = time;
  }
  time = tmp;
  transition = transition === VOID ? $this.hhu_1 : transition;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects_0 = injects.slice();
  var sceneInjector = $this.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), $this).qe4(getKClass(Resources), new Resources($this.d1m(), $this.ghu_1.whu().wbw_1, $this.ghu_1.whu()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_0 = getKClassFromExpression(inject);
    sceneInjector.qe4(isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE(), inject);
  }
  var newScene = sceneInjector.ze4(clazz);
  // Inline function 'korlibs.logger.Logger.info' call
  var tmp0 = Companion_getInstance_42().mi5_1;
  // Inline function 'korlibs.logger.Logger.log' call
  var level = Level_INFO_getInstance();
  if (tmp0.obj(level)) {
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    tmp0.pbj(level, tmp$ret$8);
  }
  if (false) {
    newScene.be5(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    $this.ghu_1.fhn_1.ue4(tmp_2, SceneContainer$_changeTo$lambda(sceneInjector, clazz));
  }
  return yield* $this.oi5(newScene, time, transition, $completion);
}
var Companion_instance_17;
function Companion_getInstance_42() {
  if (Companion_instance_17 === VOID)
    new Companion_2();
  return Companion_instance_17;
}
function SceneContainer$lambda$lambda(this$0) {
  return (it) => {
    var tmp;
    if (it instanceof SceneContainer) {
      tmp = !equals(it, this$0);
    } else {
      tmp = false;
    }
    return tmp;
  };
}
function SceneContainer$lambda$slambda$lambda($sceneInjector, $sceneClass, $event, $scene) {
  return ($this$mapPrototype) => {
    // Inline function 'kotlin.also' call
    var this_0 = $sceneInjector.ze4($sceneClass);
    try {
      $event.kg0($scene, this_0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    return this_0;
  };
}
function SceneContainer$lambda$slambda(this$0, $event) {
  return constructCallableReference(function *($completion) {
    var scene = this$0.jhu_1;
    var tmp;
    if (!(scene == null)) {
      println('[ReloadEvent] Reloading ' + toString_0(this$0.jhu_1) + ' . doFullReload=' + $event.xi5());
      var tmp_0;
      if ($event.xi5()) {
        tmp_0 = $event.yi5(getKClassFromExpression(scene), scene.shz());
      } else {
        tmp_0 = getKClassFromExpression(scene);
      }
      var tmp_1 = tmp_0;
      var sceneClass = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
      var tmp0 = this$0;
      // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
      var injects = [];
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var time = toDuration(0, DurationUnit_SECONDS_getInstance());
      var transition = tmp0.hhu_1;
      var sceneInjector = tmp0.ghu_1.fhn_1.se4().qe4(getKClass(SceneContainer), tmp0).qe4(getKClass(Resources), new Resources(tmp0.d1m(), tmp0.ghu_1.whu().wbw_1, tmp0.ghu_1.whu()));
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < injects.length) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var inject = injects[_unary__edvuaz];
        var tmp_2 = getKClassFromExpression(inject);
        sceneInjector.qe4(isInterface(tmp_2, KClass) ? tmp_2 : THROW_CCE(), inject);
      }
      // Inline function 'kotlin.also' call
      var this_0 = sceneInjector.ze4(sceneClass);
      try {
        $event.kg0(scene, this_0);
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var newScene = this_0;
      // Inline function 'korlibs.logger.Logger.info' call
      var tmp0_0 = Companion_getInstance_42().mi5_1;
      // Inline function 'korlibs.logger.Logger.log' call
      var level = Level_INFO_getInstance();
      if (tmp0_0.obj(level)) {
        var tmp$ret$10 = 'Changing scene to... ' + toString(sceneClass) + ' ... ' + toString(newScene);
        tmp0_0.pbj(level, tmp$ret$10);
      }
      if (false) {
        newScene.be5(sceneInjector);
        var tmp_3 = getKClassFromExpression(newScene);
        var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
        tmp0.ghu_1.fhn_1.ue4(tmp_4, SceneContainer$lambda$slambda$lambda(sceneInjector, sceneClass, $event, scene));
      }
      var scene_0 = yield* tmp0.oi5(newScene, time, transition, $completion);
      scene_0.phw().jhy(scene_0.ei2());
      tmp = Unit_instance;
    }
    return Unit_instance;
  }, 0);
}
function SceneContainer$lambda(this$0) {
  return (event) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    var hasChildScenes = !descendantsWith(this$0, VOID, SceneContainer$lambda$lambda(this$0)).n1();
    var tmp;
    if (hasChildScenes) {
      println('[ReloadEvent] Scene ' + toString_0(this$0.jhu_1) + ' not reloaded because has child scenes...');
      return Unit_instance;
    }
    launchImmediately(this$0, SceneContainer$lambda$slambda(this$0, event));
    return Unit_instance;
  };
}
function SceneContainer$_changeTo$lambda($sceneInjector, $clazz) {
  return ($this$mapPrototype) => $sceneInjector.ze4($clazz);
}
function SceneContainer$_changeTo$slambda($newScene) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = $newScene.ei2();
    // Inline function 'kotlin.apply' call
    yield* $newScene.ti4(this_0, $completion);
    return this_0;
  }, 0);
}
function SceneContainer$_changeTo$slambda_0($newScene) {
  return constructCallableReference(function *($completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = $newScene.ei2();
    // Inline function 'kotlin.apply' call
    yield* $newScene.ui4(this_0, $completion);
    return Unit_instance;
  }, 0);
}
function SceneContainer$_changeTo$slambda_1($oldScene) {
  return constructCallableReference(function *($completion) {
    yield* $oldScene.wi4($completion);
    return Unit_instance;
  }, 0);
}
function _interpolateRatio$ref() {
  return constructCallableReference((p0, p1, p2) => new Ratio(_interpolateRatio(p0.v9f_1, p1.v9f_1, p2.v9f_1)), 3, 0, 393, '_interpolateRatio');
}
function SceneContainer$_changeTo$slambda_2($oldScene) {
  return constructCallableReference(function *($completion) {
    yield* $oldScene.xi4($completion);
    $oldScene.yi4();
    return Unit_instance;
  }, 0);
}
function SceneContainer$_changeTo$slambda_3($oldScene) {
  return constructCallableReference(function *($completion) {
    yield* $oldScene.ai5($completion);
    return Unit_instance;
  }, 0);
}
function SceneContainer$_changeTo$slambda_4($newScene) {
  return constructCallableReference(function *($completion) {
    yield* $newScene.vi4($completion);
    return Unit_instance;
  }, 0);
}
function get_AlphaTransition() {
  _init_properties_Transition_kt__s6zoln();
  return AlphaTransition;
}
var AlphaTransition;
function Transition(name, render) {
  name = name === VOID ? 'Transition' : name;
  _init_properties_Transition_kt__s6zoln();
  return new Transition$1(render, name);
}
function withEasing(_this__u8e3s4, easing) {
  _init_properties_Transition_kt__s6zoln();
  return new withEasing$1(_this__u8e3s4, easing);
}
function _get_transitionProcess__5hlux5($this) {
  var tmp = $this.eib_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('transitionProcess');
  }
}
function AlphaTransition$lambda(ctx, prev, next, ratio) {
  _init_properties_Transition_kt__s6zoln();
  var prevAlpha = prev.vig();
  var nextAlpha = next.vig();
  try {
    prev.uig(1.0 - Ratio__toFloat_impl_1ftup5(ratio.v9f_1));
    next.uig(Ratio__toFloat_impl_1ftup5(ratio.v9f_1));
    prev.nib(ctx);
    next.nib(ctx);
  }finally {
    prev.uig(prevAlpha);
    next.uig(nextAlpha);
  }
  return Unit_instance;
}
var properties_initialized_Transition_kt_wb2qvd;
function _init_properties_Transition_kt__s6zoln() {
  if (!properties_initialized_Transition_kt_wb2qvd) {
    properties_initialized_Transition_kt_wb2qvd = true;
    AlphaTransition = Transition('AlphaTransition', AlphaTransition$lambda);
  }
}
function TransitionView$_get_ratio_$ref_1lub6z(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new Ratio(tmp0.cib_1);
  }, 0, 0, 394, VOID, [p0]);
}
function TransitionView$_set_ratio_$ref_rp057l(p0) {
  return constructCallableReference((p0_0) => {
    p0.cib_1 = p0_0.v9f_1;
    return Unit_instance;
  }, 1, 0, 395, VOID, [p0]);
}
function get_styles(_this__u8e3s4) {
  _init_properties_ViewStyles_kt__hdc4op();
  var tmp0 = styles$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('styles', 1, tmp, _get_styles_$ref_lsbiug(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var styles$delegate;
var textFont$delegate;
var textSize$delegate;
var textColor$delegate;
var buttonBackColor$delegate;
var textAlignment$delegate;
function styles$delegate$lambda($this$PropertyThis) {
  _init_properties_ViewStyles_kt__hdc4op();
  return new ViewStyles($this$PropertyThis);
}
function _get_styles_$ref_lsbiug() {
  return constructCallableReference((p0) => get_styles(p0), 1, 0, 396);
}
var properties_initialized_ViewStyles_kt_405jyh;
function _init_properties_ViewStyles_kt__hdc4op() {
  if (!properties_initialized_ViewStyles_kt_405jyh) {
    properties_initialized_ViewStyles_kt_405jyh = true;
    styles$delegate = new PropertyThis(VOID, styles$delegate$lambda);
    textFont$delegate = new ViewStyle(get_DefaultTtfFontAsBitmap());
    textSize$delegate = new ViewStyle(16.0);
    textColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().zc2_1));
    buttonBackColor$delegate = new ViewStyle(new RGBA(Colors_getInstance().cc4_1));
    textAlignment$delegate = new ViewStyle(Companion_getInstance_2().ucr_1);
  }
}
function createProgram$lambda($median$delegate) {
  return $median$delegate.yq(null, getLocalDelegateReference('median', KProperty0, false));
}
function MsdfRender$createProgram$lambda($this$FUNC, a, b, c) {
  $this$FUNC.uez($this$FUNC.gf0($this$FUNC.ff0(a, b), $this$FUNC.ff0($this$FUNC.gf0(a, b), c)));
  return Unit_instance;
}
function MsdfRender$createProgram$lambda_0($$this$buildShader) {
  return ($this$IF_ELSE_BINARY_LOOKUP, n) => {
    $this$IF_ELSE_BINARY_LOOKUP.jey($this$IF_ELSE_BINARY_LOOKUP.mey(), $this$IF_ELSE_BINARY_LOOKUP.tey(Companion_getInstance_6().mg8_1[n], $this$IF_ELSE_BINARY_LOOKUP.sey($$this$buildShader.fey(), 'xy')));
    return Unit_instance;
  };
}
var MsdfRender_instance;
function MsdfRender_getInstance() {
  if (MsdfRender_instance === VOID)
    new MsdfRender();
  return MsdfRender_instance;
}
function setTextNoSnapshot($this, text, out) {
  out = out === VOID ? new TextSnapshot('', numberRangeToNumber(0, 0)) : out;
  if (!$this.gik_1($this.lij_1.dio(), text))
    return null;
  out.hij_1 = $this.lij_1.dio();
  out.iij_1 = $this.eio();
  $this.lij_1.fio(text);
  reclampSelection($this);
  $this.tij_1.x9y($this);
  return out;
}
function clampIndex($this, index) {
  return clamp(index, 0, $this.dio().length);
}
function reclampSelection($this) {
  $this.iio($this.gio(), $this.hio());
  $this.jio($this.gio());
}
function _get_gameWindow__b33wdz($this) {
  return ensureNotNull($this.lij_1.dhv()).phw().jhn_1;
}
function TextEditController$lambda($this$onNewAttachDetach, it) {
  get_uiFocusManager($this$onNewAttachDetach.pho_1);
  return Unit_instance;
}
function TextEditController$acceptTextChange$lambda(old, new_0) {
  return true;
}
function TextEditController$lambda_0(this$0) {
  return () => {
    var tmp;
    if (!get_focused(this$0)) {
      this$0.zij_1.ngk(false);
      tmp = Unit_instance;
    } else {
      var tmp_0;
      if (this$0.kio() === 0) {
        this$0.zij_1.ngk(!this$0.zij_1.yig());
        tmp_0 = Unit_instance;
      } else {
        this$0.zij_1.ngk(true);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  };
}
function TextEditController$slambda(this$0) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if (!get_focused(this$0)) {
      return Unit_instance;
    }
    var tmp_0;
    if (it.ge9_1 || it.ee9_1) {
      return Unit_instance;
    }
    // Inline function 'kotlin.code' call
    var this_0 = it.ce9_1;
    var code = Char__toInt_impl_vasixd(this_0);
    var tmp_1;
    switch (code) {
      case 8:
      case 127:
        tmp_1 = Unit_instance;
        break;
      case 9:
      case 10:
      case 13:
        var tmp_2;
        if (code === 10 || code === 13) {
          this$0.sij_1.x9y(this$0);
          tmp_2 = Unit_instance;
        }

        tmp_1 = tmp_2;
        break;
      case 27:
        this$0.rij_1.x9y(this$0);
        tmp_1 = Unit_instance;
        break;
      default:
        this$0.lio(it.je9());
        tmp_1 = Unit_instance;
        break;
    }
    return Unit_instance;
  }, 1);
}
function TextEditController$slambda_0(this$0) {
  return constructCallableReference(function *(it, $completion) {
    var tmp;
    if (!get_focused(this$0)) {
      return Unit_instance;
    }
    var tmp_0;
    switch (it.ae9_1.w1_1) {
      case 25:
      case 44:
      case 48:
      case 23:
      case 46:
        var tmp_1;
        if (this$0.rio(it)) {
          switch (it.ae9_1.w1_1) {
            case 48:
              if (it.de9_1) {
                this$0.nio();
              } else {
                this$0.mio();
              }

              break;
            case 25:
            case 46:
              var tmp_2;
              // Inline function 'kotlin.text.isNotEmpty' call

              var this_0 = this$0.oio();
              if (charSequenceLength(this_0) > 0) {
                tmp_2 = new TextClipboardData(this$0.oio());
              } else {
                tmp_2 = null;
              }

              var oldText = tmp_2;
              if (it.ae9_1.equals(Key_X_getInstance())) {
                var selection = this$0.eio();
                this$0.fio(withoutRange(this$0.dio(), this$0.eio()));
                this$0.pio(false, selection.n3_1);
              }

              if (oldText == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                yield* _get_gameWindow__b33wdz(this$0).mgl(oldText, $completion);
              }

              break;
            case 44:
              var tmp_3 = yield* _get_gameWindow__b33wdz(this$0).ngl($completion);
              var tmp3_safe_receiver = (tmp_3 == null ? true : tmp_3 instanceof TextClipboardData) ? tmp_3 : null;
              var rtext = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.dgm_1;
              if (!(rtext == null)) {
                this$0.lio(rtext);
              }

              break;
            case 23:
              this$0.qio();
              break;
            default:
              break;
          }
          tmp_1 = Unit_instance;
        }

        tmp_0 = tmp_1;
        break;
      case 59:
      case 61:
        var range = this$0.eio();
        var tmp_4;
        if (get_length(range) > 0) {
          this$0.fio(withoutRange(this$0.dio(), range));
          this$0.tio(range.n3_1);
          tmp_4 = Unit_instance;
        } else {
          var tmp_5;
          if (it.ae9_1.equals(Key_BACKSPACE_getInstance())) {
            var tmp_6;
            if (this$0.sio() > 0) {
              var oldCursorIndex = this$0.sio();
              this$0.fio(withoutIndex(this$0.dio(), this$0.sio() - 1 | 0));
              this$0.tio(oldCursorIndex - 1 | 0);
              tmp_6 = Unit_instance;
            }
            tmp_5 = tmp_6;
          } else {
            var tmp_7;
            if (this$0.sio() < this$0.dio().length) {
              this$0.fio(withoutIndex(this$0.dio(), this$0.sio()));
              tmp_7 = Unit_instance;
            }
            tmp_5 = tmp_7;
          }
          tmp_4 = tmp_5;
        }

        tmp_0 = tmp_4;
        break;
      case 63:
        var tmp_8;
        if (this$0.wio(it)) {
          this$0.pio(it.de9_1, 0);
          tmp_8 = Unit_instance;
        } else {
          this$0.pio(it.de9_1, this$0.vio(this$0.gio(), this$0.uio(it)));
          tmp_8 = Unit_instance;
        }

        tmp_0 = tmp_8;
        break;
      case 62:
        var tmp_9;
        if (this$0.wio(it)) {
          this$0.pio(it.de9_1, this$0.dio().length);
          tmp_9 = Unit_instance;
        } else {
          this$0.pio(it.de9_1, this$0.xio(this$0.gio(), this$0.uio(it)));
          tmp_9 = Unit_instance;
        }

        tmp_0 = tmp_9;
        break;
      case 74:
        this$0.pio(it.de9_1, 0);
        tmp_0 = Unit_instance;
        break;
      case 75:
        this$0.pio(it.de9_1, this$0.dio().length);
        tmp_0 = Unit_instance;
        break;
      default:
        tmp_0 = Unit_instance;
        break;
    }
    return Unit_instance;
  }, 1);
}
function TextEditController$lambda_1(this$0) {
  return (it) => {
    this$0.wij_1.x9y(this$0);
    var tmp0_safe_receiver = this$0.oij_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jir_1 = true;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_2(this$0) {
  return (it) => {
    this$0.xij_1.x9y(this$0);
    var tmp0_safe_receiver = this$0.oij_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.jir_1 = false;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_3(this$0, $dragging) {
  return (it) => {
    this$0.tio(this$0.lir(it.uhy()));
    $dragging._v = false;
    set_focused(this$0, true);
    return Unit_instance;
  };
}
function TextEditController$lambda_4(this$0, $dragging) {
  return (it) => {
    this$0.tio(this$0.lir(it.uhy()));
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_5($dragging, this$0) {
  return (it) => {
    $dragging._v = false;
    var tmp;
    if (get_focused(this$0)) {
      set_focused(this$0, false);
      blur(this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_6(this$0, $dragging) {
  return (it) => {
    var tmp;
    if (get_focused(this$0) && it.ahz()) {
      $dragging._v = true;
      this$0.mir(this$0.lir(it.uhy()));
      it.why();
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TextEditController$lambda_7($dragging, this$0) {
  return (it) => {
    var tmp;
    if (!$dragging._v && get_focused(this$0)) {
      blur(this$0);
      tmp = Unit_instance;
    }
    $dragging._v = false;
    return Unit_instance;
  };
}
function TextEditController$lambda_8(this$0) {
  return (it) => {
    var index = this$0.lir(it.uhy());
    this$0.iio(this$0.vio(index, true), this$0.xio(index, true));
    return Unit_instance;
  };
}
function TextEditController$_get_text_$ref_8pfnni(p0) {
  return constructCallableReference(() => p0.dio(), 0, 0, 397, VOID, [p0]);
}
function TextEditController$_set_text_$ref_libz4a(p0) {
  return constructCallableReference((p0_0) => {
    p0.fio(p0_0);
    return Unit_instance;
  }, 1, 0, 398, VOID, [p0]);
}
function TextEditController$_get_textSize_$ref_hra1rx(p0) {
  return constructCallableReference(() => p0.giu(), 0, 0, 399, VOID, [p0]);
}
function TextEditController$_set_textSize_$ref_27jb7t(p0) {
  return constructCallableReference((p0_0) => {
    p0.fiu(p0_0);
    return Unit_instance;
  }, 1, 0, 400, VOID, [p0]);
}
function TextEditController$_get_font_$ref_edfa4(p0) {
  return constructCallableReference(() => p0.ccw(), 0, 0, 401, VOID, [p0]);
}
function TextEditController$_set_font_$ref_d79qqw(p0) {
  return constructCallableReference((p0_0) => {
    p0.diu(p0_0);
    return Unit_instance;
  }, 1, 0, 402, VOID, [p0]);
}
function TextEditController$_get_onReturnPressed_$ref_s5777o(p0) {
  return constructCallableReference(() => p0.sij_1, 0, 0, 403, VOID, [p0]);
}
function TextEditController$_get_onEscPressed_$ref_j0dpnl(p0) {
  return constructCallableReference(() => p0.rij_1, 0, 0, 404, VOID, [p0]);
}
function TextEditController$_get_onFocusLost_$ref_i4znle(p0) {
  return constructCallableReference(() => p0.vij_1, 0, 0, 405, VOID, [p0]);
}
function TextEditController$_get_selectionRange_$ref_24yo2u(p0) {
  return constructCallableReference(() => p0.eio(), 0, 0, 406, VOID, [p0]);
}
function TextEditController$_set_selectionRange_$ref_vswn1i(p0) {
  return constructCallableReference((p0_0) => {
    p0.hiu(p0_0);
    return Unit_instance;
  }, 1, 0, 407, VOID, [p0]);
}
function TextEditController$_get_selectionStart_$ref_1v2ufp(p0) {
  return constructCallableReference(() => p0.gio(), 0, 0, 408, VOID, [p0]);
}
function TextEditController$_set_selectionStart_$ref_z85wf3(p0) {
  return constructCallableReference((p0_0) => {
    p0.jio(p0_0);
    return Unit_instance;
  }, 1, 0, 409, VOID, [p0]);
}
function TextEditController$_get_selectionEnd_$ref_67w5ks(p0) {
  return constructCallableReference(() => p0.hio(), 0, 0, 410, VOID, [p0]);
}
function TextEditController$_set_selectionEnd_$ref_mv83i0(p0) {
  return constructCallableReference((p0_0) => {
    p0.mir(p0_0);
    return Unit_instance;
  }, 1, 0, 411, VOID, [p0]);
}
function TextEditController$_get_selectionLength_$ref_fphy6b(p0) {
  return constructCallableReference(() => p0.kio(), 0, 0, 412, VOID, [p0]);
}
function get_timers(_this__u8e3s4) {
  _init_properties_TimerComponents_kt__j84oeh();
  var tmp0 = timers$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('timers', 1, tmp, _get_timers_$ref_n5mfmc(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var timers$delegate;
function ensureUpdater($this) {
  if (!($this.zit_1 == null))
    return Unit_instance;
  var tmp = $this;
  tmp.zit_1 = addFastUpdater_0($this.vit_1, TimerComponents$ensureUpdater$lambda($this));
}
function addTimer($this, autoRemove, callback) {
  if ($this.yit_1.o9j()) {
    var index = $this.yit_1.g5($this.yit_1.s2() - 1 | 0);
    $this.wit_1.e5(index, callback);
    // Inline function 'korlibs.math.toInt' call
    var tmp$ret$0 = autoRemove ? 1 : 0;
    $this.xit_1.s7x(index, tmp$ret$0);
    ensureUpdater($this);
    return _TimerRef___init__impl__cysrar(index);
  }
  // Inline function 'kotlin.collections.plusAssign' call
  $this.wit_1.d2(callback);
  // Inline function 'korlibs.math.toInt' call
  var tmp$ret$2 = autoRemove ? 1 : 0;
  $this.xit_1.ga2(tmp$ret$2);
  ensureUpdater($this);
  return _TimerRef___init__impl__cysrar($this.wit_1.s2() - 1 | 0);
}
function removeTimer($this, ref) {
  $this.wit_1.e5(_TimerRef___get_index__impl__pnrx4q(ref), null);
  $this.xit_1.s7x(_TimerRef___get_index__impl__pnrx4q(ref), 0);
  $this.yit_1.ga2(_TimerRef___get_index__impl__pnrx4q(ref));
}
function _interval($this, time, repeat, callback) {
  var tmp;
  if (callback === VOID) {
    tmp = TimerComponents$_interval$lambda;
  } else {
    tmp = callback;
  }
  callback = tmp;
  var elapsed = {_v: new FastDuration(get_fastMilliseconds(0))};
  var ref = {_v: new TimerRef(_TimerRef___init__impl__cysrar(-1))};
  ref._v = new TimerRef(addTimer($this, false, TimerComponents$_interval$lambda_0(elapsed, time, repeat, $this, ref, callback)));
  return Closeable(TimerComponents$_interval$lambda_1($this, ref));
}
function TimerComponents$ensureUpdater$lambda(this$0) {
  return ($this$addFastUpdater, dt) => {
    // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
    var this_0 = this$0.wit_1;
    var n = 0;
    while (n < this_0.s2()) {
      var tmp0 = n;
      var tmp0_safe_receiver = this_0.u2(n);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(dt);
      if (!(this$0.xit_1.u2(tmp0) === 0)) {
        removeTimer(this$0, _TimerRef___init__impl__cysrar(tmp0));
      }
      n = n + 1 | 0;
    }
    var tmp;
    if (this$0.wit_1.n1()) {
      var tmp0_safe_receiver_0 = this$0.zit_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.f7();
      }
      this$0.zit_1 = null;
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda() {
  return Unit_instance;
}
function TimerComponents$_interval$lambda_0($elapsed, $time, $repeat, this$0, $ref, $callback) {
  return (dt) => {
    $elapsed._v = new FastDuration(FastDuration__plus_impl_q1enab($elapsed._v.f9w_1, dt.f9w_1));
    $l$loop: while (FastDuration__compareTo_impl_4fhnj7($elapsed._v.f9w_1, $time) >= 0) {
      if (!$repeat) {
        removeTimer(this$0, $ref._v.tiu_1);
      }
      $elapsed._v = new FastDuration(FastDuration__minus_impl_evs237($elapsed._v.f9w_1, $time));
      $callback();
      if (!$repeat)
        break $l$loop;
    }
    return Unit_instance;
  };
}
function TimerComponents$_interval$lambda_1(this$0, $ref) {
  return () => {
    removeTimer(this$0, $ref._v.tiu_1);
    return Unit_instance;
  };
}
function _TimerRef___init__impl__cysrar(index) {
  return index;
}
function _TimerRef___get_index__impl__pnrx4q($this) {
  return $this;
}
function TimerRef__toString_impl_8hh2j7($this) {
  return 'TimerRef(index=' + $this + ')';
}
function TimerRef__hashCode_impl_d9ou9o($this) {
  return $this;
}
function TimerRef__equals_impl_2fvpr4($this, other) {
  if (!(other instanceof TimerRef))
    return false;
  if (!($this === (other instanceof TimerRef ? other.tiu_1 : THROW_CCE())))
    return false;
  return true;
}
function timers$delegate$lambda($this$PropertyThis) {
  _init_properties_TimerComponents_kt__j84oeh();
  return new TimerComponents($this$PropertyThis);
}
function _get_timers_$ref_n5mfmc() {
  return constructCallableReference((p0) => get_timers(p0), 1, 0, 413);
}
var properties_initialized_TimerComponents_kt_v7ywzv;
function _init_properties_TimerComponents_kt__j84oeh() {
  if (!properties_initialized_TimerComponents_kt_v7ywzv) {
    properties_initialized_TimerComponents_kt_v7ywzv = true;
    timers$delegate = new PropertyThis('__ViewTimerComponents', timers$delegate$lambda);
  }
}
function get_DEFAULT_EASING() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_EASING;
}
var DEFAULT_EASING;
function get_DEFAULT_TIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_TIME;
}
var DEFAULT_TIME;
function get_DEFAULT_FTIME() {
  _init_properties_tween_kt__1g7sex();
  return DEFAULT_FTIME;
}
var DEFAULT_FTIME;
function *tween(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_TIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  var tmp;
  if (waitTime === VOID) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance_0();
    tmp = get_DURATION_NIL();
  } else {
    tmp = waitTime;
  }
  waitTime = tmp;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp_0;
  if (callback === VOID) {
    tmp_0 = tween$lambda;
  } else {
    tmp_0 = callback;
  }
  callback = tmp_0;
  return yield* tween_0(_this__u8e3s4, vs.slice(), get_fast(time), easing, get_fast(waitTime), timeout, autoInvalidate, callback, $completion);
}
function *tween_0(_this__u8e3s4, vs, time, easing, waitTime, timeout, autoInvalidate, callback, $completion) {
  time = time === VOID ? get_DEFAULT_FTIME() : time;
  easing = easing === VOID ? get_DEFAULT_EASING() : easing;
  waitTime = waitTime === VOID ? Companion_instance_1.d9w() : waitTime;
  timeout = timeout === VOID ? false : timeout;
  autoInvalidate = autoInvalidate === VOID ? true : autoInvalidate;
  var tmp;
  if (callback === VOID) {
    tmp = tween$lambda_0;
  } else {
    tmp = callback;
  }
  callback = tmp;
  if (!(_this__u8e3s4 == null)) {
    var tc = {_v: null};
    try {
      var tmp_0;
      if (timeout) {
        // Inline function 'korlibs.time.FastDuration.times' call
        var tmp$ret$0 = FastDuration__times_impl_h6amcp(time, numberToDouble(2));
        tmp_0 = FastDuration__plus_impl_q1enab(tmp$ret$0, get_fastMilliseconds(300));
      } else {
        tmp_0 = Companion_instance_1.d9w();
      }
      var tmp_1 = tmp_0;
      yield* withTimeoutNullable(tmp_1, tween$slambda(_this__u8e3s4, tc, vs, time, easing, callback, waitTime, autoInvalidate), $completion);
    } catch ($p) {
      if ($p instanceof TimeoutCancellationException) {
        var e = $p;
        var tmp0_safe_receiver = tc._v;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.jiv(time);
        }
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function _update($this, dt) {
  if ($this.civ_1) {
    $this.viu_1.hie();
  }
  if ($this.fiv_1) {
    return $this.oiv();
  }
  $this.div_1 = FastDuration__plus_impl_q1enab($this.div_1, dt);
  var ratio = clamp_0(FastDuration__div_impl_rlslck($this.div_1, $this.eiv_1), 0.0, 1.0);
  $this.jiv($this.div_1);
  $this.ziu_1($this.yiu_1.o9f(ratio));
  var tmp;
  var tmp_0 = $this.piv();
  // Inline function 'korlibs.time.NIL' call
  Companion_getInstance_0();
  var tmp$ret$0 = get_DURATION_NIL();
  if (!equals(tmp_0, tmp$ret$0)) {
    tmp = FastDuration__compareTo_impl_4fhnj7_0($this.div_1, $this.piv()) >= 0;
  } else {
    tmp = false;
  }
  if (tmp) {
    $this.qiv();
  }
  if (ratio >= 1.0) {
    return $this.oiv();
  }
}
function TweenComponent$updater$lambda(this$0) {
  return (it) => {
    _update(this$0, it.tgm_1);
    return Unit_instance;
  };
}
function TweenComponent$lambda(this$0) {
  return (it) => {
    this$0.fiv_1 = true;
    return Unit_instance;
  };
}
function *withTimeoutNullable(time, block, $completion) {
  var tmp;
  var tmp_0;
  var tmp_1 = time;
  if ((tmp_1 == null ? null : new FastDuration(tmp_1)) == null) {
    tmp_0 = true;
  } else {
    var tmp_2 = time;
    tmp_0 = equals(tmp_2 == null ? null : new FastDuration(tmp_2), new FastDuration(Companion_instance_1.d9w()));
  }
  if (tmp_0) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.od();
    tmp = yield* block(CoroutineScope(tmp$ret$0), $completion);
  } else {
    tmp = yield* withTimeout(toLongRound(_FastDuration___get_fastMilliseconds__impl__pe68va(time)), block, $completion);
  }
  return tmp;
}
function tween$lambda(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$lambda_0(it) {
  _init_properties_tween_kt__1g7sex();
  return Unit_instance;
}
function tween$slambda($this_tween, $tc, $vs, $time, $easing, $callback, $waitTime, $autoInvalidate) {
  return constructCallableReference(function *($this$withTimeoutNullable, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    (yield () => {
      var uCont = $completion;
      var cancellable = new CancellableContinuationImpl(intercepted(uCont), 1);
      cancellable.u1p();
      var view = $this_tween;
      $tc._v = new TweenComponent(view, toList($vs), $time, $easing, $callback, cancellable, $waitTime, $autoInvalidate);
      return cancellable.v1p();
    });
    return Unit_instance;
  }, 1);
}
var properties_initialized_tween_kt_p0n8nv;
function _init_properties_tween_kt__1g7sex() {
  if (!properties_initialized_tween_kt_p0n8nv) {
    properties_initialized_tween_kt_p0n8nv = true;
    DEFAULT_EASING = get_EASE_IN_OUT_QUAD(Companion_getInstance_36());
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_TIME = toDuration(1, DurationUnit_SECONDS_getInstance());
    DEFAULT_FTIME = get_fastSeconds(1);
  }
}
function set__focusable(_this__u8e3s4, _set____db54di) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0 = _focusable$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__focusable_$ref_igtxrb();
  // Inline function 'korlibs.datastructure.Property.setValue' call
  var property = getPropertyCallableRef('_focusable', 1, tmp, tmp_0, _set__focusable_$ref_729ia5());
  var tmp0_elvis_lhs = tmp0.q9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get__focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0 = _focusable$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get__focusable_$ref_igtxrb();
  var tmp4 = getPropertyCallableRef('_focusable', 1, tmp, tmp_0, _set__focusable_$ref_729ia5());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var tmp_1 = _this__u8e3s4.p9u();
    var tmp0_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMutableMap) : false) ? tmp_1 : null;
    var tmp_2;
    if (tmp0_safe_receiver == null) {
      tmp_2 = null;
    } else {
      var tmp0_elvis_lhs = tmp0.q9u_1;
      tmp_2 = tmp0_safe_receiver.w4(tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_2;
    if (res == null) {
      var r = tmp0.r9u_1();
      var tmp_3;
      if (!(r == null)) {
        tmp_3 = true;
      } else {
        var tmp1_elvis_lhs = tmp0.q9u_1;
        tmp_3 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? tmp4.callableName : tmp1_elvis_lhs);
      }
      if (tmp_3) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = tmp0.q9u_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var _focusable$delegate;
function get_uiFocusManager(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0 = uiFocusManager$delegate;
  var tmp = KProperty1;
  var tmp4 = getPropertyCallableRef('uiFocusManager', 1, tmp, _get_uiFocusManager_$ref_noeab5(), null);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var uiFocusManager$delegate;
function set_focused(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.ciu(Scope_instance).dhv();
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_uiFocusManager(tmp0_safe_receiver);
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.riv(value ? _this__u8e3s4 : null);
  }
}
function get_focused(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_safe_receiver = _this__u8e3s4.ciu(Scope_instance).dhv();
  return equals(tmp0_safe_receiver == null ? null : get_uiFocusedView(tmp0_safe_receiver), _this__u8e3s4);
}
function focus(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, true);
}
function blur(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  set_focused(_this__u8e3s4, false);
}
var Scope_instance;
function Scope_getInstance() {
  return Scope_instance;
}
function _get_rfocusView__qys03k($this, $receiver) {
  // Inline function 'kotlin.run' call
  return $receiver.ciu(Scope_instance);
}
function UIFocusManager$changeFocusIndex$lambda(it) {
  return !(get_focusable(it) == null);
}
function UIFocusManager$changeFocusIndex$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.miu();
  var tmp$ret$2 = b.miu();
  return compareValues(tmp, tmp$ret$2);
}
function UIFocusManager$lambda(this$0) {
  return (it) => {
    var tmp;
    if (it.ae9_1.equals(Key_TAB_getInstance())) {
      this$0.tiv(it.de9_1 ? -1 : 1);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function get_uiFocusedView(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  return get_uiFocusManager(_this__u8e3s4).riu_1;
}
function set_focusable(_this__u8e3s4, value) {
  _init_properties_UIFocusManager_kt__odyms7();
  set__focusable(_this__u8e3s4, value);
}
function get_focusable(_this__u8e3s4) {
  _init_properties_UIFocusManager_kt__odyms7();
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, UIFocusable) ? _this__u8e3s4 : null;
  return tmp0_elvis_lhs == null ? get__focusable(_this__u8e3s4) : tmp0_elvis_lhs;
}
function _focusable$delegate$lambda() {
  _init_properties_UIFocusManager_kt__odyms7();
  return null;
}
function _get__focusable_$ref_igtxrb() {
  return constructCallableReference((p0) => get__focusable(p0), 1, 0, 414);
}
function _set__focusable_$ref_729ia5() {
  return constructCallableReference((p0, p1) => {
    set__focusable(p0, p1);
    return Unit_instance;
  }, 2, 0, 415);
}
function uiFocusManager$delegate$lambda($this$PropertyThis) {
  _init_properties_UIFocusManager_kt__odyms7();
  return new UIFocusManager($this$PropertyThis);
}
function _get_uiFocusManager_$ref_noeab5() {
  return constructCallableReference((p0) => get_uiFocusManager(p0), 1, 0, 416);
}
var properties_initialized_UIFocusManager_kt_a5rjit;
function _init_properties_UIFocusManager_kt__odyms7() {
  if (!properties_initialized_UIFocusManager_kt_a5rjit) {
    properties_initialized_UIFocusManager_kt_a5rjit = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = _focusable$delegate$lambda;
    _focusable$delegate = new Property(null, default_0);
    uiFocusManager$delegate = new PropertyThis(VOID, uiFocusManager$delegate$lambda);
  }
}
function UIScrollable$MyScrollbarInfo$_get_containerPos_$ref_5zlxmc() {
  return constructCallableReference((p0) => p0.liw(), 1, 0, 417);
}
function UIScrollable$MyScrollbarInfo$_set_containerPos_$ref_z2q6p4() {
  return constructCallableReference((p0, p1) => {
    p0.miw(p1);
    return Unit_instance;
  }, 2, 0, 418);
}
function set_uiTextInputBackgroundRender(_this__u8e3s4, _set____db54di) {
  _init_properties_UITextInput_kt__kefnmf();
  uiTextInputBackgroundRender$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_uiTextInputBackgroundRender_$ref_l0m18t();
  // Inline function 'korlibs.korge.style.ViewStyle.setValue' call
  var property = getPropertyCallableRef('uiTextInputBackgroundRender', 1, tmp, tmp_0, _set_uiTextInputBackgroundRender_$ref_avq4kn());
  if (_this__u8e3s4.uii_1 == null)
    _this__u8e3s4.uii_1 = linkedHashMapOf([]);
  var tmp0 = ensureNotNull(_this__u8e3s4.uii_1);
  // Inline function 'kotlin.collections.set' call
  var key = property.callableName;
  tmp0.b5(key, _set____db54di);
  _this__u8e3s4.zii();
  return Unit_instance;
}
function get_uiTextInputBackgroundRender(_this__u8e3s4) {
  _init_properties_UITextInput_kt__kefnmf();
  var tmp0 = uiTextInputBackgroundRender$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_uiTextInputBackgroundRender_$ref_l0m18t();
  // Inline function 'korlibs.korge.style.ViewStyle.getValue' call
  var property = getPropertyCallableRef('uiTextInputBackgroundRender', 1, tmp, tmp_0, _set_uiTextInputBackgroundRender_$ref_avq4kn());
  var tmp0_elvis_lhs = _this__u8e3s4.wii(property, tmp0.aij_1);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = "Can't cast " + toString(property) + ' to T';
    throw IllegalStateException.o(toString(message));
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  return tmp_1;
}
var uiTextInputBackgroundRender$delegate;
function UITextInput$bg$lambda($this$renderableView) {
  // Inline function 'kotlin.apply' call
  get_uiTextInputBackgroundRender(get_styles($this$renderableView)).xiz($this$renderableView);
  return Unit_instance;
}
function UITextInput$_get_text_$ref_iy7m14() {
  return constructCallableReference((p0) => p0.dio(), 1, 0, 419);
}
function UITextInput$_set_text_$ref_vr3xhw() {
  return constructCallableReference((p0, p1) => {
    p0.fio(p1);
    return Unit_instance;
  }, 2, 0, 420);
}
function UITextInput$_get_onReturnPressed_$ref_y9lky6() {
  return constructCallableReference((p0) => p0.jj3(), 1, 0, 421);
}
function uiTextInputBackgroundRender$delegate$lambda($this$ViewRenderer) {
  _init_properties_UITextInput_kt__kefnmf();
  $this$ViewRenderer.lj8().kgd(new Rectangle(0.0, 0.0, $this$ViewRenderer.w9z(), $this$ViewRenderer.x9z()), Colors_getInstance().zc2_1);
  return Unit_instance;
}
function _get_uiTextInputBackgroundRender_$ref_l0m18t() {
  return constructCallableReference((p0) => get_uiTextInputBackgroundRender(p0), 1, 0, 422);
}
function _set_uiTextInputBackgroundRender_$ref_avq4kn() {
  return constructCallableReference((p0, p1) => {
    set_uiTextInputBackgroundRender(p0, p1);
    return Unit_instance;
  }, 2, 0, 423);
}
var properties_initialized_UITextInput_kt_7ksi6x;
function _init_properties_UITextInput_kt__kefnmf() {
  if (!properties_initialized_UITextInput_kt_7ksi6x) {
    properties_initialized_UITextInput_kt_7ksi6x = true;
    var tmp = uiTextInputBackgroundRender$delegate$lambda;
    uiTextInputBackgroundRender$delegate = new ViewStyle(new sam$korlibs_korge_view_ViewRenderer$0_0(tmp));
  }
}
function registerUISupportOnce($this) {
  if ($this.si8_1)
    return Unit_instance;
  var tmp0_elvis_lhs = $this.dhv();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var stage = tmp;
  $this.si8_1 = true;
  if (equals(getExtra(stage, 'uiSupport'), true))
    return Unit_instance;
  setExtra(stage, 'uiSupport', true);
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  get_keys(stage);
}
var Companion_instance_18;
function Companion_getInstance_43() {
  if (Companion_instance_18 === VOID)
    new Companion_3();
  return Companion_instance_18;
}
function anchor(_this__u8e3s4, anchor) {
  _this__u8e3s4.ijb(anchor);
  return _this__u8e3s4;
}
function clearBitmaps($this, onParentChanged) {
  onParentChanged = onParentChanged === VOID ? false : onParentChanged;
  if ($this.wjd_1.n1())
    return Unit_instance;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.wjd_1;
  var n = 0;
  while (n < this_0.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = this_0.u2(_unary__edvuaz);
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$2 = get_Bitmaps_transparent();
    if (!equals(it, get_bmp(tmp$ret$2))) {
      var tmp0_safe_receiver = $this.bje_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cg2_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.ag8(it, 'BaseGraphics');
      }
    }
  }
  $this.wjd_1.a5();
}
function _get_bitmapWidth__ndy7bu($this) {
  return $this.gde().w9z();
}
function _get_bitmapHeight__5t1vx1($this) {
  return $this.gde().x9z();
}
function _getLocalBoundsInternal($this, strokes) {
  strokes = strokes === VOID ? $this.fje_1 : strokes;
  var bounds = boundsUnsafe($this, strokes);
  return new Rectangle(bounds.o9h_1 - $this.fif(), bounds.p9h_1 - $this.gif(), bounds.q9h_1, bounds.r9h_1);
}
function boundsUnsafe($this, strokes) {
  if ($this.aje_1) {
    $this.aje_1 = false;
    $this.hje_1 = $this.qjg(false);
    $this.gje_1 = $this.qjg(true);
  }
  return strokes ? $this.gje_1 : $this.hje_1;
}
function updateGraphics($this) {
  var halfStroke = $this.xjm_1 / 2;
  var radius = $this.vjp();
  $this.wjp(toShape2D(new Circle(Vector2D.t9g(radius, radius), radius)));
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  var $this$updatePath = $this.yjm_1;
  $this$updatePath.a5();
  $this$updatePath.oab(Vector2D.t9g(radius, radius), radius);
  $this$updatePath.rah_1 = true;
  $this.ujm_1 = $this.yjm_1;
  $this.xjp();
}
function Circle$radius$delegate$lambda(this$0) {
  return (it) => {
    updateGraphics(this$0);
    return Unit_instance;
  };
}
function Circle$_get_radius_$ref_oq96jg() {
  return constructCallableReference((p0) => p0.vjp(), 1, 0, 424);
}
function Circle$_set_radius_$ref_v8maag() {
  return constructCallableReference((p0, p1) => {
    p0.yjp(p1);
    return Unit_instance;
  }, 2, 0, 425);
}
function Circle$_get_colorMul_$ref_517rfx(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.mci());
  }, 0, 0, 426, VOID, [p0]);
}
function Circle$_set_colorMul_$ref_aiiz47(p0) {
  return constructCallableReference((p0_0) => {
    p0.kci(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 427, VOID, [p0]);
}
function Circle$_get_color_$ref_y7a19z() {
  return constructCallableReference((p0) => new RGBA(p0.qd9()), 1, 0, 428);
}
function Circle$_set_color_$ref_7izkal() {
  return constructCallableReference((p0, p1) => {
    p0.zjp(p1.sci_1);
    return Unit_instance;
  }, 2, 0, 429);
}
var ZIndexComparator_instance;
function ZIndexComparator_getInstance() {
  return ZIndexComparator_instance;
}
function Container$renderChildrenInternal$lambda(it) {
  var tmp;
  if (it instanceof FixedSizeContainer) {
    tmp = it.mds();
  } else {
    tmp = false;
  }
  return tmp;
}
function addTo(_this__u8e3s4, parent) {
  parent.di2(_this__u8e3s4);
  return _this__u8e3s4;
}
function dummyView(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = DummyView.njy();
  _this__u8e3s4.uie(this_0);
  return this_0;
}
var Companion_instance_19;
function Companion_getInstance_44() {
  return Companion_instance_19;
}
function installFpsDebugOverlay(_this__u8e3s4) {
  var longWindow = new TimeSlidingWindow(240);
  var shortWindow = new TimeSlidingWindow(10);
  var previousTime = {_v: new FastDuration(PerformanceCounter_getInstance().me5())};
  var frames = {_v: 0};
  var batchCount = {_v: 0};
  var vertexCount = {_v: 0};
  var instanceCount = {_v: 0};
  var tmp = _this__u8e3s4.phw().bhp_1;
  tmp.w9y(installFpsDebugOverlay$lambda(batchCount, vertexCount, instanceCount));
  var tmp_0 = get_debugLineRenderContext(_this__u8e3s4.phw().cho_1).lgb_1;
  tmp_0.w9y(installFpsDebugOverlay$lambda_0(batchCount, vertexCount));
  var tmp_1 = _this__u8e3s4.phw().cho_1.hg2_1.pg3_1;
  tmp_1.w9y(installFpsDebugOverlay$lambda_1(batchCount, vertexCount));
  var tmp_2 = _this__u8e3s4.phw().cho_1.hg2_1.qg3_1;
  tmp_2.w9y(installFpsDebugOverlay$lambda_2(instanceCount));
  var tmp_3 = _this__u8e3s4.phw();
  tmp_3.pjy(installFpsDebugOverlay$lambda_3(previousTime, frames, longWindow, shortWindow, batchCount, vertexCount, instanceCount));
}
function installFpsDebugOverlay$lambda($batchCount, $vertexCount, $instanceCount) {
  return (it) => {
    $batchCount._v = 0;
    $vertexCount._v = 0;
    $instanceCount._v = 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_0($batchCount, $vertexCount) {
  return (it) => {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.tgb_1 | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_1($batchCount, $vertexCount) {
  return (it) => {
    var _unary__edvuaz = $batchCount._v;
    $batchCount._v = _unary__edvuaz + 1 | 0;
    $vertexCount._v = $vertexCount._v + it.hg9() | 0;
    return Unit_instance;
  };
}
function installFpsDebugOverlay$lambda_2($instanceCount) {
  return (it) => {
    $instanceCount._v = $instanceCount._v + it | 0;
    return Unit_instance;
  };
}
function invoke$drawTextWithShadow($this_addDebugRenderer, $ctx, fontSize, matrix, text, x, y) {
  var tmp0_font = $this_addDebugRenderer.lhy();
  var tmp1_colMul = $ctx.gg2_1;
  var tmp2_blendMode = Companion_getInstance_13().yg0_1;
  drawText($ctx, tmp0_font, fontSize, text, x, y, matrix, tmp1_colMul, tmp2_blendMode, false);
}
function LineRenderBatcher$_get_currentMatrix_$ref_6vk8sh(p0) {
  return constructCallableReference(() => p0.wgb_1, 0, 0, 430, VOID, [p0]);
}
function LineRenderBatcher$_set_currentMatrix_$ref_eu8nhv(p0) {
  return constructCallableReference((p0_0) => {
    p0.wgb_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 431, VOID, [p0]);
}
function installFpsDebugOverlay$lambda_3($previousTime, $frames, $longWindow, $shortWindow, $batchCount, $vertexCount, $instanceCount) {
  return ($this$addDebugRenderer, ctx) => {
    var scale = ctx.ggc();
    var fontSize = 8.0 * scale;
    var currentTime = PerformanceCounter_getInstance().me5();
    var elapsedTime = FastDuration__minus_impl_evs237(currentTime, $previousTime._v.f9w_1);
    var tmp;
    if ($frames._v > 3) {
      var tmp_0;
      if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, get_fastMilliseconds(4)) > 0) {
        $longWindow.wjy(elapsedTime);
        $shortWindow.wjy(elapsedTime);
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    var _unary__edvuaz = $frames._v;
    $frames._v = _unary__edvuaz + 1 | 0;
    $previousTime._v = new FastDuration(currentTime);
    var matrix = $this$addDebugRenderer.qhn_1.vga();
    invoke$drawTextWithShadow($this$addDebugRenderer, ctx, fontSize, matrix, 'FPS: ' + ('' + roundDecimalPlaces($shortWindow.ujy(), 1)) + (', batchCount=' + $batchCount._v + ', vertexCount=' + $vertexCount._v + ', instanceCount=' + $instanceCount._v) + (', (' + Companion_getInstance_38().bb1() + ')'), 0, 0);
    var graphLeft = 1.0;
    var graphTop = fontSize * 2;
    var overlayLines = 60;
    var overlayWidth = 120.0 * scale;
    var overlayHeight = 30 * scale;
    var overlayHeightGap = 5.0;
    // Inline function 'korlibs.korge.render.useLineBatcher' call
    var this_0 = $this$addDebugRenderer.cho_1;
    // Inline function 'korlibs.korge.render.LineRenderBatcher.use' call
    var this_1 = get_debugLineRenderContext(this_0);
    // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
    var this_2 = this_1.kgb_1;
    if (!(this_2.lg2_1 === this_1)) {
      this_2.lg2_1 = this_1;
      this_2.vg3();
    }
    // Inline function 'korlibs.korge.render.LineRenderBatcher.drawWithGlobalMatrix' call
    var this_3 = get_debugLineRenderContext(this_0);
    var tmp_1 = KMutableProperty0;
    var tmp_2 = LineRenderBatcher$_get_currentMatrix_$ref_6vk8sh(this_3);
    var tmp0 = getPropertyCallableRef('currentMatrix', 0, tmp_1, tmp_2, LineRenderBatcher$_set_currentMatrix_$ref_eu8nhv(this_3));
    $l$block_0: {
      // Inline function 'korlibs.datastructure.keep' call
      var temp = tmp0.get();
      try {
        if (!(matrix == null))
          this_3.wgb_1 = matrix;
        var tmp2 = Companion_getInstance_13().yg0_1;
        $l$block: {
          // Inline function 'korlibs.korge.render.LineRenderBatcher.blending' call
          var doUpdate = !(this_1.vgb_1 === tmp2);
          var old = this_1.vgb_1;
          try {
            if (doUpdate) {
              this_1.kgb_1.vg3();
              this_1.vgb_1 = tmp2;
            }
            // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
            var color = Colors_getInstance().pc8_1;
            var oldColor = this_1.ngb_1;
            this_1.ngb_1 = color;
            try {
              this_1.bgc(graphLeft, graphTop, graphLeft, graphTop + overlayHeight);
              this_1.bgc(graphLeft, graphTop + overlayHeight, graphLeft + overlayWidth, graphTop + overlayHeight);
            }finally {
              this_1.ngb_1 = oldColor;
            }
            var inductionVariable = 0;
            if (inductionVariable <= 0)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var color_0 = index === 0 ? Colors_getInstance().zc2_1 : Colors_getInstance().ac3_1;
                // Inline function 'korlibs.korge.render.LineRenderBatcher.color' call
                var oldColor_0 = this_1.ngb_1;
                this_1.ngb_1 = color_0;
                try {
                  var ratio = $longWindow.s2() / $longWindow.qjy_1;
                  var totalOverlayLines = coerceAtLeast(numberToInt(overlayLines * ratio), 1);
                  if ($longWindow.s2() > 0) {
                    var previousX = 0.0;
                    var previousY = 0.0;
                    var minFps = 0.0;
                    var maxFps = 150.0;
                    var inductionVariable_0 = 0;
                    if (inductionVariable_0 < totalOverlayLines)
                      do {
                        var n = inductionVariable_0;
                        inductionVariable_0 = inductionVariable_0 + 1 | 0;
                        // Inline function 'kotlin.run' call
                        var p0 = convertRange(n, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.s2(), 1));
                        var p1 = convertRange(n + 1 | 0, 0, totalOverlayLines, 0, coerceAtLeast($longWindow.s2(), 1));
                        var plen = 0;
                        var timeSum = get_fastMilliseconds(0);
                        var inductionVariable_1 = p0;
                        var last = coerceAtMost(p1, $longWindow.s2());
                        if (inductionVariable_1 < last)
                          do {
                            var m = inductionVariable_1;
                            inductionVariable_1 = inductionVariable_1 + 1 | 0;
                            timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.vjy(m));
                            plen = plen + 1 | 0;
                          }
                           while (inductionVariable_1 < last);
                        if (plen === 0) {
                          timeSum = FastDuration__plus_impl_q1enab(timeSum, $longWindow.vjy(p0));
                          plen = plen + 1 | 0;
                        }
                        var time = FastDuration__div_impl_rlslck_0(timeSum, plen);
                        var fps = _Frequency___get_hertz__impl__9m7k6x(toFrequency(time));
                        var fps_0 = fps;
                        var scaledFreq = convertRange_0(fps_0, minFps, maxFps, overlayHeightGap, overlayHeight);
                        var y = graphTop + overlayHeight - scaledFreq;
                        var x = graphLeft + n * overlayWidth / overlayLines;
                        if (n > 0) {
                          this_1.bgc(previousX, previousY + index, x, y + index);
                        }
                        previousY = y;
                        previousX = x;
                      }
                       while (inductionVariable_0 < totalOverlayLines);
                  }
                }finally {
                  this_1.ngb_1 = oldColor_0;
                }
              }
               while (inductionVariable <= 0);
            break $l$block;
          }finally {
            if (doUpdate) {
              this_1.kgb_1.vg3();
            }
            this_1.vgb_1 = old;
          }
        }
        break $l$block_0;
      }finally {
        tmp0.set(temp);
      }
    }
    return Unit_instance;
  };
}
var GraphicsRenderer_SYSTEM_instance;
var GraphicsRenderer_CPU_instance;
var GraphicsRenderer_GPU_instance;
var GraphicsRenderer_entriesInitialized;
function GraphicsRenderer_initEntries() {
  if (GraphicsRenderer_entriesInitialized)
    return Unit_instance;
  GraphicsRenderer_entriesInitialized = true;
  GraphicsRenderer_SYSTEM_instance = new GraphicsRenderer('SYSTEM', 0);
  GraphicsRenderer_CPU_instance = new GraphicsRenderer('CPU', 1);
  GraphicsRenderer_GPU_instance = new GraphicsRenderer('GPU', 2);
}
function _get_anchorable__ebfoik($this) {
  var tmp0_elvis_lhs = $this.fk1_1;
  return ensureNotNull(tmp0_elvis_lhs == null ? $this.gk1_1 : tmp0_elvis_lhs);
}
function ensure($this) {
  if ($this.mk1_1.w1_1 === 2) {
    if (!($this.fk1_1 == null)) {
      var tmp1_safe_receiver = $this.fk1_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.uih();
      }
      $this.fk1_1 = null;
    }
    if ($this.gk1_1 == null) {
      var tmp = $this;
      // Inline function 'korlibs.korge.view.vector.gpuGraphics' call
      // Inline function 'korlibs.korge.view.vector.gpuShapeView' call
      // Inline function 'kotlin.also' call
      var this_0 = GpuShapeView.mk4(EmptyShape_instance, true);
      // Inline function 'korlibs.korge.view.vector.GpuShapeView.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      var tmp$ret$5 = (new ShapeBuilder(null, null)).rcq();
      this_0.nk4(tmp$ret$5);
      // Inline function 'kotlin.also' call
      var this_1 = addTo(this_0, $this);
      this_1.ok4($this.hk1_1);
      this_1.nk3_1 = $this.kk1_1;
      this_1.pk3_1 = $this.jk1_1;
      this_1.nk4($this.lk1_1);
      tmp.gk1_1 = this_1;
    }
  } else {
    if (!($this.gk1_1 == null)) {
      var tmp2_safe_receiver = $this.gk1_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.uih();
      }
      $this.gk1_1 = null;
    }
    if ($this.fk1_1 == null) {
      var tmp_0 = $this;
      // Inline function 'korlibs.korge.view.cpuGraphics' call
      // Inline function 'kotlin.also' call
      var this_2 = addTo(CpuGraphics.ijw(false), $this);
      // Inline function 'korlibs.korge.view.CpuGraphics.updateShape' call
      // Inline function 'korlibs.image.vector.buildShape' call
      // Inline function 'kotlin.apply' call
      var tmp$ret$16 = (new ShapeBuilder(null, null)).rcq();
      this_2.jjw(tmp$ret$16);
      if (false) {
        this_2.cjh();
      }
      this_2.aje_1 = true;
      this_2.gih();
      this_2.cjh();
      // Inline function 'kotlin.also' call
      this_2.cjw_1 = $this.hk1_1;
      this_2.sjd_1 = $this.kk1_1;
      this_2.hjj_1 = $this.jk1_1;
      this_2.jjw($this.lk1_1);
      tmp_0.fk1_1 = this_2;
    }
    var tmp3_safe_receiver = $this.fk1_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.ajh($this.mk1_1.equals(GraphicsRenderer_SYSTEM_getInstance()));
    }
  }
}
function GraphicsRenderer_SYSTEM_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_SYSTEM_instance;
}
function GraphicsRenderer_GPU_getInstance() {
  GraphicsRenderer_initEntries();
  return GraphicsRenderer_GPU_instance;
}
function Graphics$_get_anchor_$ref_omu6ke(p0) {
  return constructCallableReference(() => p0.jjb(), 0, 0, 432, VOID, [p0]);
}
function Graphics$_set_anchor_$ref_vc1a9i(p0) {
  return constructCallableReference((p0_0) => {
    p0.ijb(p0_0);
    return Unit_instance;
  }, 1, 0, 433, VOID, [p0]);
}
function Graphics$_get_antialiased_$ref_lyxmqu(p0) {
  return constructCallableReference(() => p0.hk1_1, 0, 0, 434, VOID, [p0]);
}
function Graphics$_set_antialiased_$ref_w2nu9e(p0) {
  return constructCallableReference((p0_0) => {
    p0.ok4(p0_0);
    return Unit_instance;
  }, 1, 0, 435, VOID, [p0]);
}
function Graphics$_get_autoScaling_$ref_ph0c29(p0) {
  return constructCallableReference(() => p0.kk1_1, 0, 0, 436, VOID, [p0]);
}
function Graphics$_set_autoScaling_$ref_zgdieb(p0) {
  return constructCallableReference((p0_0) => {
    p0.tk4(p0_0);
    return Unit_instance;
  }, 1, 0, 437, VOID, [p0]);
}
function Graphics$_get_renderer_$ref_f00p9s(p0) {
  return constructCallableReference(() => p0.mk1_1, 0, 0, 438, VOID, [p0]);
}
function Graphics$_set_renderer_$ref_jq1ac(p0) {
  return constructCallableReference((p0_0) => {
    p0.uk4(p0_0);
    return Unit_instance;
  }, 1, 0, 439, VOID, [p0]);
}
function Graphics$_get_smoothing_$ref_6lbr1p(p0) {
  return constructCallableReference(() => p0.jk1_1, 0, 0, 440, VOID, [p0]);
}
function Graphics$_set_smoothing_$ref_8mfrgn(p0) {
  return constructCallableReference((p0_0) => {
    p0.sk4(p0_0);
    return Unit_instance;
  }, 1, 0, 441, VOID, [p0]);
}
function Graphics$_get_boundsIncludeStrokes_$ref_pp8zhx(p0) {
  return constructCallableReference(() => p0.rk4(), 0, 0, 442, VOID, [p0]);
}
function Graphics$_set_boundsIncludeStrokes_$ref_u7m755(p0) {
  return constructCallableReference((p0_0) => {
    p0.pjj(p0_0);
    return Unit_instance;
  }, 1, 0, 443, VOID, [p0]);
}
function Image$_get_sourceFile_$ref_qb7578(p0) {
  return constructCallableReference(() => p0.gk7(), 0, 0, 444, VOID, [p0]);
}
function Image$_set_sourceFile_$ref_j6tgqg(p0) {
  return constructCallableReference((p0_0) => {
    p0.hk7(p0_0);
    return Unit_instance;
  }, 1, 0, 445, VOID, [p0]);
}
function trySetSourceActually($this) {
  var source = $this.pjg_1.q9v();
  if (!(source == null)) {
    $this.ojg_1 = true;
    $this.tjj(source);
  }
}
function RenderableView$_get_viewRenderer_$ref_kgwm7(p0) {
  return constructCallableReference(() => p0.hir_1, 0, 0, 446, VOID, [p0]);
}
function RenderableView$_set_viewRenderer_$ref_tnl5oz(p0) {
  return constructCallableReference((p0_0) => {
    p0.hir_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 447, VOID, [p0]);
}
function updateGraphics_0($this) {
  // Inline function 'korlibs.korge.view.ShapeView.updatePath' call
  var $this$updatePath = $this.yjm_1;
  $this$updatePath.a5();
  $this$updatePath.aat(new RoundRectangle(new Rectangle(0.0, 0.0, $this.w9z(), $this.x9z()), $this.vjp()));
  $this$updatePath.rah_1 = true;
  $this.ujm_1 = $this.yjm_1;
  $this.xjp();
}
function RoundRect$unscaledSize$delegate$lambda(this$0) {
  return (it) => {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function RoundRect$_get_unscaledSize_$ref_h95i3c() {
  return constructCallableReference((p0) => p0.mib(), 1, 0, 448);
}
function RoundRect$_set_unscaledSize_$ref_btyqzg() {
  return constructCallableReference((p0, p1) => {
    p0.lib(p1);
    return Unit_instance;
  }, 2, 0, 449);
}
function RoundRect$radius$delegate$lambda(this$0) {
  return (it) => {
    updateGraphics_0(this$0);
    return Unit_instance;
  };
}
function RoundRect$_get_radius_$ref_f18u7a() {
  return constructCallableReference((p0) => p0.vjp(), 1, 0, 450);
}
function RoundRect$_set_radius_$ref_zqxy() {
  return constructCallableReference((p0, p1) => {
    p0.qka(p1);
    return Unit_instance;
  }, 2, 0, 451);
}
function RoundRect$_get_colorMul_$ref_6jrgtn(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.mci());
  }, 0, 0, 452, VOID, [p0]);
}
function RoundRect$_set_colorMul_$ref_8zz9qh(p0) {
  return constructCallableReference((p0_0) => {
    p0.kci(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 453, VOID, [p0]);
}
var CoordsType_D_0_1_instance;
var CoordsType_D_M1_1_instance;
var CoordsType_D_W_H_instance;
var CoordsType_entriesInitialized;
function CoordsType_initEntries() {
  if (CoordsType_entriesInitialized)
    return Unit_instance;
  CoordsType_entriesInitialized = true;
  CoordsType_D_0_1_instance = new CoordsType('D_0_1', 0);
  CoordsType_D_M1_1_instance = new CoordsType('D_M1_1', 1);
  CoordsType_D_W_H_instance = new CoordsType('D_W_H', 2);
}
var Companion_instance_20;
function Companion_getInstance_45() {
  return Companion_instance_20;
}
function CoordsType_D_0_1_getInstance() {
  CoordsType_initEntries();
  return CoordsType_D_0_1_instance;
}
function ShapeView$_get_anchor_$ref_rn1mgt() {
  return constructCallableReference((p0) => p0.jjb(), 1, 0, 454);
}
function ShapeView$_set_anchor_$ref_ckt1bl() {
  return constructCallableReference((p0, p1) => {
    p0.ijb(p1);
    return Unit_instance;
  }, 2, 0, 455);
}
var Companion_instance_21;
function Companion_getInstance_46() {
  return Companion_instance_21;
}
function Stage$_get_clip_$ref_cmaivk() {
  return constructCallableReference((p0) => p0.mds(), 1, 0, 456);
}
function Stage$_set_clip_$ref_6lsl8() {
  return constructCallableReference((p0, p1) => {
    p0.nkf(p1);
    return Unit_instance;
  }, 2, 0, 457);
}
function Stage$_get_unscaledSize_$ref_rdy7l8() {
  return constructCallableReference((p0) => p0.mib(), 1, 0, 458);
}
function Stage$_set_unscaledSize_$ref_1p61hk() {
  return constructCallableReference((p0, p1) => {
    p0.lib(p1);
    return Unit_instance;
  }, 2, 0, 459);
}
var Companion_instance_22;
function Companion_getInstance_47() {
  return Companion_instance_22;
}
function updateLineCount($this) {
  var tmp = $this;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = $this.dio();
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (element === _Char___init__impl__6a9atx(10)) {
      count = count + 1 | 0;
    }
  }
  tmp.uim_1 = count + 1 | 0;
}
function setContainerPosition($this, pos, baseline) {
  var x = pos.jm();
  var y = pos.km();
  if ($this.min_1) {
    setRealContainerPosition($this, x, y);
  } else {
    setRealContainerPosition($this, x + HorizontalAlign__getOffsetX_impl_urzzxf($this.ein_1.ict_1, $this.lin_1.q9h_1), y - VerticalAlign__getOffsetY_impl_iso0y6($this.ein_1.jct_1, $this.lin_1.r9h_1, baseline));
  }
}
function setRealContainerPosition($this, x, y) {
  position($this.fin_1, x, y);
}
function Text$_get_textSize_$ref_mcnl5v(p0) {
  return constructCallableReference(() => p0.zim_1, 0, 0, 460, VOID, [p0]);
}
function Text$_set_textSize_$ref_6swulr(p0) {
  return constructCallableReference((p0_0) => {
    p0.fiu(p0_0);
    return Unit_instance;
  }, 1, 0, 461, VOID, [p0]);
}
function Text$_get_fontSize_$ref_hdbrpb() {
  return constructCallableReference((p0) => p0.eck(), 1, 0, 462);
}
function Text$_set_fontSize_$ref_wx2i9f() {
  return constructCallableReference((p0, p1) => {
    p0.okf(p1);
    return Unit_instance;
  }, 2, 0, 463);
}
function Text$_renderInternal$slambda(this$0, $ctx, $fontSource) {
  return constructCallableReference(function *($completion) {
    yield* this$0.pkf(ensureNotNull(get_views($ctx)).aho_1, $fontSource, $completion);
    return Unit_instance;
  }, 0);
}
function Text$_get_fontSource_$ref_bq5hbb(p0) {
  return constructCallableReference(() => p0.kin_1, 0, 0, 464, VOID, [p0]);
}
function Text$_set_fontSource_$ref_dsxyq5(p0) {
  return constructCallableReference((p0_0) => {
    p0.qkf(p0_0);
    return Unit_instance;
  }, 1, 0, 465, VOID, [p0]);
}
function get_agProgram(_this__u8e3s4) {
  switch (_this__u8e3s4.gck()) {
    case 'msdf':
      return MsdfRender_getInstance().bij_1;
    case 'psdf':
      return MsdfRender_getInstance().eij_1;
    case 'sdf':
      return MsdfRender_getInstance().eij_1;
    default:
      return null;
  }
}
function Text$_get_color_$ref_w55kt6(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.qd9());
  }, 0, 0, 466, VOID, [p0]);
}
function Text$_set_color_$ref_9l40re(p0) {
  return constructCallableReference((p0_0) => {
    p0.zjp(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 467, VOID, [p0]);
}
function setText(_this__u8e3s4, text) {
  foreachDescendant(_this__u8e3s4, setText$lambda(text));
}
function setText$lambda($text) {
  return (it) => {
    var tmp;
    if (isInterface(it, IText)) {
      it.fio($text);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var Companion_instance_23;
function Companion_getInstance_48() {
  return Companion_instance_23;
}
function updateRenderColorTransform($this) {
  $this.yhq_1 = $this.dhr_1;
  $this.fhr_1 = true;
  var parent = $this.x1m();
  if (!((parent == null ? null : get_filter(parent)) == null)) {
    $this.xhq_1.nci($this.whq_1);
  } else {
    var tmp;
    if (!(parent == null)) {
      tmp = !isInterface($this, ColorReference);
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.xhq_1.oci($this.whq_1, parent.bih());
    } else {
      $this.xhq_1.nci($this.whq_1);
    }
  }
}
function updateRenderColorTransformIfRequired($this) {
  if ($this.yhq_1 === $this.dhr_1)
    return Unit_instance;
  updateRenderColorTransform($this);
}
function updateRenderBlendMode($this) {
  $this.ahr_1 = $this.chr_1;
  $this.ehr_1 = true;
  var tmp = $this;
  var tmp_0;
  if ($this.chq_1.equals(Companion_getInstance_13().pg0_1)) {
    var tmp1_safe_receiver = $this.x1m();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.cih();
    tmp_0 = tmp2_elvis_lhs == null ? Companion_getInstance_13().og0_1 : tmp2_elvis_lhs;
  } else {
    tmp_0 = $this.chq_1;
  }
  tmp.zhq_1 = tmp_0;
}
function updateRenderBlendModeIfRequired($this) {
  if ($this.ahr_1 === $this.chr_1)
    return Unit_instance;
  updateRenderBlendMode($this);
}
function View$bviewAll$delegate$lambda(this$0) {
  return () => listOf(this$0);
}
function View$_get_bviewAll_$ref_htso7z() {
  return constructCallableReference((p0) => p0.eif(), 1, 0, 468);
}
function View$_get_scale_$ref_5ah2s7(p0) {
  return constructCallableReference(() => p0.vif(), 0, 0, 469, VOID, [p0]);
}
function View$_set_scale_$ref_o0ddmd(p0) {
  return constructCallableReference((p0_0) => {
    p0.uif(p0_0);
    return Unit_instance;
  }, 1, 0, 470, VOID, [p0]);
}
function View$addRenderPhase$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.vkf();
  var tmp$ret$2 = b.vkf();
  return compareValues(tmp, tmp$ret$2);
}
function xy(_this__u8e3s4, x, y) {
  _this__u8e3s4.qif(x, y);
  return _this__u8e3s4;
}
function position(_this__u8e3s4, x, y) {
  return xy_0(_this__u8e3s4, Vector2D.t9g(x, y));
}
function addFastUpdater(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_instance_1.c9w() : firstTime;
  if (first)
    updatable(_this__u8e3s4, new FastDuration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.le7(tmp, addFastUpdater$lambda(updatable, _this__u8e3s4));
}
function addFastUpdater_0(_this__u8e3s4, updatable) {
  return addFastUpdater(_this__u8e3s4, true, VOID, updatable);
}
function addUpdaterWithViews(_this__u8e3s4, updatable) {
  var tmp = Companion_instance_24;
  return _this__u8e3s4.le7(tmp, addUpdaterWithViews$lambda(updatable, _this__u8e3s4));
}
function hasAncestor(_this__u8e3s4, ancestor) {
  var tmp;
  if (equals(_this__u8e3s4, ancestor)) {
    tmp = true;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.x1m();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hasAncestor(tmp0_safe_receiver, ancestor);
    tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  return tmp;
}
function scale(_this__u8e3s4, sx, sy) {
  sy = sy === VOID ? sx : sy;
  _this__u8e3s4.aig(Scale.e9p(sx, sy));
  return _this__u8e3s4;
}
function size(_this__u8e3s4, width, height) {
  return size_0(_this__u8e3s4, Size2D.y9p(width, height));
}
function descendantsWith(_this__u8e3s4, out, check) {
  var tmp;
  if (out === VOID) {
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp = ArrayList.p2();
  } else {
    tmp = out;
  }
  out = tmp;
  if (!(_this__u8e3s4 == null)) {
    if (check(_this__u8e3s4)) {
      // Inline function 'kotlin.collections.plusAssign' call
      out.d2(_this__u8e3s4);
    }
    if (_this__u8e3s4.qhp_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.kie();
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.s2()) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.u2(_unary__edvuaz);
          descendantsWith(child, out, check);
        }
        tmp_0 = Unit_instance;
      }
    }
  }
  return out;
}
function scrollParentsToMakeVisible(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.firstAncestorOfType' call
  var tmp = firstAncestor(_this__u8e3s4, false, scrollParentsToMakeVisible$lambda);
  var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof UIScrollable) ? tmp : THROW_CCE();
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.viz(_this__u8e3s4);
  }
}
function findFirstAscendant(_this__u8e3s4, cond) {
  var current = _this__u8e3s4;
  while (!(current == null)) {
    if (cond(current))
      return current;
    current = current.x1m();
  }
  return null;
}
function get_ancestorCount(_this__u8e3s4) {
  var count = 0;
  var parent = _this__u8e3s4 == null ? null : _this__u8e3s4.x1m();
  while (!(parent == null)) {
    count = count + 1 | 0;
    parent = parent.x1m();
  }
  return count;
}
function xy_0(_this__u8e3s4, p) {
  _this__u8e3s4.fcw(p);
  return _this__u8e3s4;
}
function addUpdater(_this__u8e3s4, updatable) {
  return addUpdater_0(_this__u8e3s4, true, VOID, updatable);
}
function size_0(_this__u8e3s4, size) {
  _this__u8e3s4.hig(size);
  return _this__u8e3s4;
}
function addUpdater_0(_this__u8e3s4, first, firstTime, updatable) {
  first = first === VOID ? true : first;
  firstTime = firstTime === VOID ? Companion_getInstance_0().jk_1 : firstTime;
  if (first)
    updatable(_this__u8e3s4, new Duration(firstTime));
  var tmp = Companion_instance_9;
  return _this__u8e3s4.le7(tmp, addUpdater$lambda(updatable, _this__u8e3s4));
}
function firstAncestor(_this__u8e3s4, includeThis, condition) {
  includeThis = includeThis === VOID ? true : includeThis;
  if (_this__u8e3s4 == null)
    return null;
  if (includeThis && condition(_this__u8e3s4))
    return _this__u8e3s4;
  var tmp0_safe_receiver = _this__u8e3s4.x1m();
  return tmp0_safe_receiver == null ? null : firstAncestor(tmp0_safe_receiver, true, condition);
}
function position_0(_this__u8e3s4, p) {
  return xy_0(_this__u8e3s4, p);
}
function rotation(_this__u8e3s4, rot) {
  _this__u8e3s4.eig(rot);
  return _this__u8e3s4;
}
function bounds(_this__u8e3s4, rect) {
  return bounds_0(_this__u8e3s4, rect.v9h(), rect.x9h(), rect.w9h(), rect.y9h());
}
function foreachDescendant(_this__u8e3s4, handler) {
  if (!(_this__u8e3s4 == null)) {
    handler(_this__u8e3s4);
    if (_this__u8e3s4.qhp_1) {
      // Inline function 'korlibs.korge.view.View.forEachChild' call
      var tmp0_safe_receiver = _this__u8e3s4.kie();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp0_safe_receiver.s2()) {
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var child = tmp0_safe_receiver.u2(_unary__edvuaz);
          foreachDescendant(child, handler);
        }
        tmp = Unit_instance;
      }
    }
  }
}
function bounds_0(_this__u8e3s4, left, top, right, bottom) {
  return size(xy(_this__u8e3s4, left, top), right - left, bottom - top);
}
function deferWithViews(_this__u8e3s4, views, tryImmediate, block) {
  views = views === VOID ? null : views;
  tryImmediate = tryImmediate === VOID ? true : tryImmediate;
  if (tryImmediate) {
    var tmp;
    if (views == null) {
      var tmp1_safe_receiver = _this__u8e3s4.dhv();
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.phw();
    } else {
      tmp = views;
    }
    var tmp2_safe_receiver = tmp;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      block(tmp2_safe_receiver);
      return _this__u8e3s4;
    }
  }
  onNextFrame(_this__u8e3s4, deferWithViews$lambda(block));
  return _this__u8e3s4;
}
function onNextFrame(_this__u8e3s4, block) {
  var closeable = {_v: null};
  closeable._v = addUpdaterWithViews(_this__u8e3s4, onNextFrame$lambda(block, closeable));
  return closeable._v;
}
function addFastUpdater$lambda($updatable, $this_addFastUpdater) {
  return (it) => {
    $updatable($this_addFastUpdater, new FastDuration(FastDuration__times_impl_h6amcp(it.tgm_1, $this_addFastUpdater.pif())));
    return Unit_instance;
  };
}
function addUpdaterWithViews$lambda($updatable, $this_addUpdaterWithViews) {
  return (it) => {
    $updatable($this_addUpdaterWithViews, it.bkg_1, new Duration(Duration__times_impl_sfuzvp(it.dkg(), $this_addUpdaterWithViews.pif())));
    return Unit_instance;
  };
}
function scrollParentsToMakeVisible$lambda(it) {
  return it instanceof UIScrollable;
}
function addUpdater$lambda($updatable, $this_addUpdater) {
  return (it) => {
    $updatable($this_addUpdater, new Duration(Duration__times_impl_sfuzvp(it.ugm(), $this_addUpdater.pif())));
    return Unit_instance;
  };
}
function deferWithViews$lambda($block) {
  return ($this$onNextFrame, it) => {
    $block(it);
    return Unit_instance;
  };
}
function onNextFrame$lambda($block, $closeable) {
  return ($this$addUpdaterWithViews, views, _unused_var__etf5q3) => {
    $block($this$addUpdaterWithViews, views);
    var tmp0_safe_receiver = $closeable._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f7();
    }
    return Unit_instance;
  };
}
function ViewFileRef$Mixin$lazyLoadRenderInternalActually$slambda($view, $ctx, this$0) {
  return constructCallableReference(function *($completion) {
    yield* $view.pk7(ensureNotNull(get_views($ctx)), VOID, this$0.sk7_1, $completion);
    return Unit_instance;
  }, 0);
}
function get_logger() {
  _init_properties_ViewRenderToBitmap_kt__12ybtn();
  return logger;
}
var logger;
function *renderToBitmap(_this__u8e3s4, views, region, scale, outPoint, includeBackground, $completion) {
  var tmp;
  if (views === VOID) {
    var tmp0_safe_receiver = _this__u8e3s4.dhv();
    tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.phw();
  } else {
    tmp = views;
  }
  views = tmp;
  region = region === VOID ? null : region;
  scale = scale === VOID ? 1.0 : scale;
  outPoint = outPoint === VOID ? null : outPoint;
  includeBackground = includeBackground === VOID ? false : includeBackground;
  if (views == null) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var tmp0 = get_logger();
    // Inline function 'korlibs.logger.Logger.log' call
    var level = Level_WARN_getInstance();
    if (tmp0.obj(level)) {
      var tmp$ret$2 = 'View.renderToBitmap Views not specified';
      tmp0.pbj(level, tmp$ret$2);
    }
    return Companion_getInstance_4().yc9(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().ec3_1));
  }
  var done = CompletableDeferred();
  views.pho_1.hie();
  views.bhp_1.p9y(renderToBitmap$lambda(done, _this__u8e3s4, region, scale, outPoint, includeBackground, views));
  return yield* done.m1q($completion);
}
function unsafeRenderToBitmapSync(_this__u8e3s4, ctx, region, scale, outPoint, useTexture, bgcolor) {
  region = region === VOID ? null : region;
  scale = scale === VOID ? 1.0 : scale;
  outPoint = outPoint === VOID ? null : outPoint;
  useTexture = useTexture === VOID ? true : useTexture;
  bgcolor = bgcolor === VOID ? Colors_getInstance().ec3_1 : bgcolor;
  _init_properties_ViewRenderToBitmap_kt__12ybtn();
  var view = _this__u8e3s4;
  var bounds = _this__u8e3s4.ihy(VOID, true);
  var tmp1_elvis_lhs = region == null ? null : region.q9h_1;
  var tmp = numberToInt(tmp1_elvis_lhs == null ? bounds.q9h_1 : tmp1_elvis_lhs);
  var tmp3_elvis_lhs = region == null ? null : region.r9h_1;
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.lc1(tmp, numberToInt(tmp3_elvis_lhs == null ? bounds.r9h_1 : tmp3_elvis_lhs), VOID, true);
  // Inline function 'korlibs.korge.render.RenderContext.renderToBitmap' call
  if (useTexture) {
    var tmp2 = this_0.sc1_1;
    // Inline function 'korlibs.korge.render.RenderContext.renderToTextureInternal' call
    var height = this_0.tc1_1;
    ctx.vg3();
    // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
    var rb = ctx.rgc(tmp2, height, false, true, 1);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
      ctx.tgc(rb);
      try {
        ctx.mgc(Colors_getInstance().ec3_1);
        if (!(bgcolor === Colors_getInstance().ec3_1)) {
          ctx.mgc(bgcolor);
        }
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
        var this_1 = ctx.hg2_1;
        // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
        var this_2 = this_1.qg2_1;
        if (!(this_2.lg2_1 === this_1)) {
          this_2.lg2_1 = this_1;
          this_2.vg3();
        }
        var matrix = get_mutable(view.aih().g9m());
        if (!(region == null)) {
          matrix.rau(scale);
          matrix.tau(-region.o9h_1, -region.p9h_1);
        }
        matrix.sau(-bounds.o9h_1, -bounds.p9h_1);
        if (outPoint == null)
          null;
        else {
          outPoint.pa9(Vector2D.t9g(bounds.o9h_1, bounds.p9h_1));
        }
        // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
        var matrix_0 = matrix.x9p();
        // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
        var this_3 = this_1.qg2_1;
        this_3.vg3();
        var temp4 = this_3.wg1_1;
        var temp2d = this_3.xg1_1;
        this_3.xg1_1 = matrix_0;
        this_3.wg1_1 = toMatrix4(matrix_0);
        var tmp0 = this_3.ieo(ProjViewUB_getInstance());
        $l$block: {
          // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
          var _unary__edvuaz = tmp0.z6x();
          tmp0.efc(_unary__edvuaz + 1 | 0);
          tmp0.ffc(tmp0.z6x() + 1 | 0);
          var blockSize = tmp0.beo_1;
          var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
          var index1 = imul(tmp0.z6x(), blockSize);
          var texBlockSize = tmp0.yen_1.wev().s2();
          var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
          var texIndex1 = imul(tmp0.z6x(), texBlockSize);
          if (tmp0.z6x() > 0) {
            arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
          } else {
            arrayfill(tmp0.deo_1, 0, 0, blockSize);
          }
          var tmp0_0 = tmp0.yen_1;
          tmp0.eeo_1.rfc(tmp0_0.kev(), this_3.wg1_1);
          if (true && tmp0.z6x() >= 1) {
            var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
            if (equals) {
              var _unary__edvuaz_0 = tmp0.z6x();
              tmp0.efc(_unary__edvuaz_0 - 1 | 0);
              break $l$block;
            }
          }
        }
        try {
          view.nib(ctx);
        }finally {
          this_3.vg3();
          this_3.wg1_1 = temp4;
          this_3.xg1_1 = temp2d;
          this_3.ieo(ProjViewUB_getInstance()).gfc();
        }
        readColor(ctx.jg1_1, ctx.mg2_1, this_0);
      }finally {
        ctx.ugc();
      }
      rb.jek();
      rb.seg_1;
      rb.teg_1;
    }finally {
      ctx.sgc(rb);
    }
  } else {
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    var rb_0 = ctx.zeg();
    ctx.tgc(rb_0);
    try {
      ctx.iga();
      ctx.mgc(Colors_getInstance().ec3_1);
      ctx.vg3();
      if (!(bgcolor === Colors_getInstance().ec3_1)) {
        ctx.mgc(bgcolor);
      }
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_4 = ctx.hg2_1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var this_5 = this_4.qg2_1;
      if (!(this_5.lg2_1 === this_4)) {
        this_5.lg2_1 = this_4;
        this_5.vg3();
      }
      var matrix_1 = get_mutable(view.aih().g9m());
      if (!(region == null)) {
        matrix_1.rau(scale);
        matrix_1.tau(-region.o9h_1, -region.p9h_1);
      }
      matrix_1.sau(-bounds.o9h_1, -bounds.p9h_1);
      if (outPoint == null)
        null;
      else {
        outPoint.pa9(Vector2D.t9g(bounds.o9h_1, bounds.p9h_1));
      }
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
      var matrix_2 = matrix_1.x9p();
      // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
      var this_6 = this_4.qg2_1;
      this_6.vg3();
      var temp4_0 = this_6.wg1_1;
      var temp2d_0 = this_6.xg1_1;
      this_6.xg1_1 = matrix_2;
      this_6.wg1_1 = toMatrix4(matrix_2);
      var tmp0_1 = this_6.ieo(ProjViewUB_getInstance());
      $l$block_0: {
        // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
        var _unary__edvuaz_1 = tmp0_1.z6x();
        tmp0_1.efc(_unary__edvuaz_1 + 1 | 0);
        tmp0_1.ffc(tmp0_1.z6x() + 1 | 0);
        var blockSize_0 = tmp0_1.beo_1;
        var index0_0 = imul(tmp0_1.z6x() - 1 | 0, blockSize_0);
        var index1_0 = imul(tmp0_1.z6x(), blockSize_0);
        var texBlockSize_0 = tmp0_1.yen_1.wev().s2();
        var texIndex0_0 = imul(tmp0_1.z6x() - 1 | 0, texBlockSize_0);
        var texIndex1_0 = imul(tmp0_1.z6x(), texBlockSize_0);
        if (tmp0_1.z6x() > 0) {
          arraycopy(tmp0_1.deo_1, index0_0, tmp0_1.deo_1, index1_0, blockSize_0);
        } else {
          arrayfill(tmp0_1.deo_1, 0, 0, blockSize_0);
        }
        var tmp0_2 = tmp0_1.yen_1;
        tmp0_1.eeo_1.rfc(tmp0_2.kev(), this_6.wg1_1);
        if (true && tmp0_1.z6x() >= 1) {
          var equals_0 = arrayequal(tmp0_1.deo_1, index0_0, tmp0_1.deo_1, index1_0, blockSize_0);
          if (equals_0) {
            var _unary__edvuaz_2 = tmp0_1.z6x();
            tmp0_1.efc(_unary__edvuaz_2 - 1 | 0);
            break $l$block_0;
          }
        }
      }
      try {
        view.nib(ctx);
      }finally {
        this_6.vg3();
        this_6.wg1_1 = temp4_0;
        this_6.xg1_1 = temp2d_0;
        this_6.ieo(ProjViewUB_getInstance()).gfc();
      }
      ctx.vg3();
      readColor(ctx.jg1_1, ctx.zeg(), this_0);
    }finally {
      ctx.ugc();
    }
  }
  return this_0;
}
function renderToBitmap$lambda($done, $this_renderToBitmap, $region, $scale, $outPoint, $includeBackground, $views) {
  return (ctx) => {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.also' call
      var this_0 = unsafeRenderToBitmapSync($this_renderToBitmap, ctx, $region, $scale, $outPoint, VOID, $includeBackground ? $views.eho_1 : Colors_getInstance().ec3_1);
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(this_0);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp$ret$0 = tmp;
    completeWith($done, tmp$ret$0);
    return Unit_instance;
  };
}
var properties_initialized_ViewRenderToBitmap_kt_yjoejd;
function _init_properties_ViewRenderToBitmap_kt__12ybtn() {
  if (!properties_initialized_ViewRenderToBitmap_kt_yjoejd) {
    properties_initialized_ViewRenderToBitmap_kt_yjoejd = true;
    logger = Companion_getInstance().pb5('RenderToBitmap');
  }
}
function Views$_init_$lambda_jivasj(it) {
  return Stage.ehl(it);
}
function GameWindow$_get_quality_$ref_imgvhb(p0) {
  return constructCallableReference(() => p0.fgc(), 0, 0, 471, VOID, [p0]);
}
function GameWindow$_set_quality_$ref_bnxaul(p0) {
  return constructCallableReference((p0_0) => {
    p0.qgk(p0_0);
    return Unit_instance;
  }, 1, 0, 472, VOID, [p0]);
}
function GameWindow$_get_continuousRenderMode_$ref_vajq30(p0) {
  return constructCallableReference(() => p0.egj(), 0, 0, 195, VOID, [p0]);
}
function GameWindow$_set_continuousRenderMode_$ref_z8748w(p0) {
  return constructCallableReference((p0_0) => {
    p0.fgj(p0_0);
    return Unit_instance;
  }, 1, 0, 196, VOID, [p0]);
}
function Views$_get_forceRenderEveryFrame_$ref_9piv07() {
  return constructCallableReference((p0) => p0.uhu(), 1, 0, 473);
}
function Views$_set_forceRenderEveryFrame_$ref_byddyj() {
  return constructCallableReference((p0, p1) => {
    p0.xhu(p1);
    return Unit_instance;
  }, 2, 0, 474);
}
function Views$realSettingsFolder$delegate$lambda(this$0) {
  return () => !(this$0.lhn_1 == null) ? ensureNotNull(this$0.lhn_1) : StandardPaths_instance.abs(this$0.fkg());
}
function Views$close$slambda(this$0) {
  return constructCallableReference(function *($completion) {
    yield* this$0.gkg($completion);
    return Unit_instance;
  }, 0);
}
function RenderContext$_get_debugExtraFontScale_$ref_b93nih(p0) {
  return constructCallableReference(() => p0.fg2_1, 0, 0, 475, VOID, [p0]);
}
function RenderContext$_set_debugExtraFontScale_$ref_981qqz(p0) {
  return constructCallableReference((p0_0) => {
    p0.fg2_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 476, VOID, [p0]);
}
function Views$_get_debugFontExtraScale_$ref_i9zsk2() {
  return constructCallableReference((p0) => p0.hkg(), 1, 0, 477);
}
function Views$_set_debugFontExtraScale_$ref_275lpe() {
  return constructCallableReference((p0, p1) => {
    p0.phu(p1);
    return Unit_instance;
  }, 2, 0, 478);
}
function RenderContext$_get_debugExtraFontColor_$ref_lqxcua(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.gg2_1);
  }, 0, 0, 479, VOID, [p0]);
}
function RenderContext$_set_debugExtraFontColor_$ref_19ryku(p0) {
  return constructCallableReference((p0_0) => {
    p0.gg2_1 = p0_0.sci_1;
    return Unit_instance;
  }, 1, 0, 480, VOID, [p0]);
}
function Views$_get_debugFontColor_$ref_r1314f() {
  return constructCallableReference((p0) => new RGBA(p0.ikg()), 1, 0, 481);
}
function Views$_set_debugFontColor_$ref_a25pqd() {
  return constructCallableReference((p0, p1) => {
    p0.qhu(p1.sci_1);
    return Unit_instance;
  }, 2, 0, 482);
}
function Views$tempViewsPool$lambda(it) {
  return FastArrayList.f9v();
}
function Views$lambda(this$0) {
  return (it) => {
    this$0.cho_1.zg7();
    return Unit_instance;
  };
}
function Views$lambda_0(this$0) {
  return (it) => {
    this$0.cho_1.pgc();
    return Unit_instance;
  };
}
function Views$_get_virtualSize_$ref_agbw1q(p0) {
  return constructCallableReference(() => p0.yho_1, 0, 0, 483, VOID, [p0]);
}
function Views$_set_virtualSize_$ref_cloj6(p0) {
  return constructCallableReference((p0_0) => {
    p0.yho_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 484, VOID, [p0]);
}
function Views$_get_targetSize_$ref_pp11ni(p0) {
  return constructCallableReference(() => p0.ahp_1, 0, 0, 485, VOID, [p0]);
}
function Views$_set_targetSize_$ref_5xlm2(p0) {
  return constructCallableReference((p0_0) => {
    p0.ahp_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 486, VOID, [p0]);
}
function GameWindow$_get_updatedSinceFrame_$ref_kl09hs(p0) {
  return constructCallableReference(() => p0.kgi_1, 0, 0, 487, VOID, [p0]);
}
function GameWindow$_set_updatedSinceFrame_$ref_qqmlxg(p0) {
  return constructCallableReference((p0_0) => {
    p0.kgi_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 488, VOID, [p0]);
}
function Views$_get_updatedSinceFrame_$ref_ww8j3w() {
  return constructCallableReference((p0) => p0.jkg(), 1, 0, 489);
}
function Views$_set_updatedSinceFrame_$ref_vz96fk() {
  return constructCallableReference((p0, p1) => {
    p0.kkg(p1);
    return Unit_instance;
  }, 2, 0, 490);
}
var Companion_instance_24;
function Companion_getInstance_49() {
  return Companion_instance_24;
}
var Companion_instance_25;
function Companion_getInstance_50() {
  return Companion_instance_25;
}
function updateSingleViewWithViewsAll(_this__u8e3s4, views, delta) {
  // Inline function 'kotlin.also' call
  var this_0 = views.uhn_1;
  this_0.tgm_1 = delta;
  _this__u8e3s4.we7(this_0);
  // Inline function 'kotlin.also' call
  var this_1 = views.vhn_1;
  this_1.ckg_1 = delta;
  _this__u8e3s4.we7(this_1);
}
function setBoundsInfo(_this__u8e3s4, reqVirtualSize, actualSize, scaleMode, anchor, virtualSize, targetSize) {
  scaleMode = scaleMode === VOID ? Companion_getInstance_26().y9r() : scaleMode;
  anchor = anchor === VOID ? Companion_getInstance_27().o9g() : anchor;
  virtualSize = virtualSize === VOID ? Ref_0() : virtualSize;
  targetSize = targetSize === VOID ? Ref_0() : targetSize;
  var reqVirtualSize_0 = toInt(reqVirtualSize);
  var actualSize_0 = toInt(actualSize);
  virtualSize.pa9(reqVirtualSize_0);
  targetSize.pa9(scaleMode.b9s(virtualSize.k3(), actualSize_0));
  var ratioX = targetSize.k3().o9s_1 / reqVirtualSize_0.o9s_1;
  var ratioY = targetSize.k3().p9s_1 / reqVirtualSize_0.p9s_1;
  var actualVirtualWidth = toIntRound(actualSize_0.o9s_1 / ratioX);
  var actualVirtualHeight = toIntRound(actualSize_0.p9s_1 / ratioY);
  _this__u8e3s4.yga(Companion_getInstance_33().v9k_1.w9l(ratioX, ratioY).e9m(toIntRound((actualVirtualWidth - reqVirtualSize_0.o9s_1 | 0) * anchor.l9g_1), toIntRound((actualVirtualHeight - reqVirtualSize_0.p9s_1 | 0) * anchor.m9g_1)));
  _this__u8e3s4.uga(_this__u8e3s4.zga().h9m());
  _this__u8e3s4.agb(_this__u8e3s4.zga().i9m());
  _this__u8e3s4.wga(_this__u8e3s4.vga().i9m());
  var tl = _this__u8e3s4.fgb(Vector2D.a9k(0, 0));
  var br = _this__u8e3s4.fgb(Vector2D.t9g(actualSize_0.o9s_1, actualSize_0.p9s_1));
  _this__u8e3s4.cgb(Companion_getInstance_31().u9p(tl.r9g_1, tl.s9g_1, br.r9g_1, br.s9g_1));
}
function *views($completion) {
  // Inline function 'korlibs.inject.Injector.get' call
  return (yield* injector($completion)).ze4(getKClass(Views));
}
function Views$_get_clipBorders_$ref_ey1djh(p0) {
  return constructCallableReference(() => p0.oho_1, 0, 0, 491, VOID, [p0]);
}
function Views$_set_clipBorders_$ref_p1rl21(p0) {
  return constructCallableReference((p0_0) => {
    p0.oho_1 = p0_0;
    return Unit_instance;
  }, 1, 0, 492, VOID, [p0]);
}
function Views$_get_virtualSizeDouble_$ref_h1wx65(p0) {
  return constructCallableReference(() => p0.qkg(), 0, 0, 493, VOID, [p0]);
}
function Views$_set_virtualSizeDouble_$ref_n7j9lt(p0) {
  return constructCallableReference((p0_0) => {
    p0.pkg(p0_0);
    return Unit_instance;
  }, 1, 0, 494, VOID, [p0]);
}
function DebugVertexView$UB$_get_u_Col_$ref_3asquz() {
  return constructCallableReference((p0) => p0.hkh(), 1, 0, 495);
}
function DebugVertexView$UB$_get_u_Matrix_$ref_ynv9qa() {
  return constructCallableReference((p0) => p0.ikh(), 1, 0, 496);
}
var UB_instance;
function UB_getInstance() {
  if (UB_instance === VOID)
    new UB();
  return UB_instance;
}
var Companion_instance_26;
function Companion_getInstance_51() {
  if (Companion_instance_26 === VOID)
    new Companion_11();
  return Companion_instance_26;
}
function updatedPoints($this) {
  var tmp = $this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = $this.oit_1.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp_0 = sum;
    sum = tmp_0 + element.s2() | 0;
  }
  var tmp$ret$0 = sum;
  tmp.qit_1 = new Float32Array(imul(tmp$ret$0, 2));
  var buffer = $this.qit_1;
  var n = 0;
  $this.rit_1.a5();
  $this.sit_1 = Companion_getInstance_32().e9i();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.oit_1;
  var n_0 = 0;
  while (n_0 < this_0.s2()) {
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    var points = this_0.u2(_unary__edvuaz);
    $this.rit_1.d2(new Batch(n / 2 | 0, points.s2()));
    if (points.r9j() >= 5) {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable = 0;
      var last = points.s2();
      if (inductionVariable < last)
        do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var x = points.p9j(n_1, 0);
          var y = points.p9j(n_1, 1);
          var dx = points.p9j(n_1, 2);
          var dy = points.p9j(n_1, 3);
          var scale = points.p9j(n_1, 4);
          var px = x + dx * scale;
          var py = y + dy * scale;
          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          buffer[_unary__edvuaz_0] = px;
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          buffer[_unary__edvuaz_1] = py;
          $this.sit_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.sit_1, Vector2D.t9g(px, py));
        }
         while (inductionVariable < last);
    } else {
      // Inline function 'korlibs.math.geom.fastForEachGeneric' call
      var inductionVariable_0 = 0;
      var last_0 = points.s2();
      if (inductionVariable_0 < last_0)
        do {
          var n_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var x_0 = points.p9j(n_2, 0);
          var y_0 = points.p9j(n_2, 1);
          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          buffer[_unary__edvuaz_2] = x_0;
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          buffer[_unary__edvuaz_3] = y_0;
          $this.sit_1 = BoundsBuilder__plus_impl_cz7f7x_0($this.sit_1, Vector2D.t9g(x_0, y_0));
        }
         while (inductionVariable_0 < last_0);
    }
  }
}
function DebugVertexView$_get_colorMul_$ref_xduhb5(p0) {
  return constructCallableReference(() => {
    var tmp0 = p0;
    return new RGBA(tmp0.mci());
  }, 0, 0, 497, VOID, [p0]);
}
function DebugVertexView$_set_colorMul_$ref_hu3qr1(p0) {
  return constructCallableReference((p0_0) => {
    p0.kci(p0_0.sci_1);
    return Unit_instance;
  }, 1, 0, 498, VOID, [p0]);
}
var renderToTextureResultPool$delegate;
var Companion_instance_27;
function Companion_getInstance_52() {
  if (Companion_instance_27 === VOID)
    new Companion_12();
  return Companion_instance_27;
}
function expandedBorderRectangle(_this__u8e3s4, inp) {
  _init_properties_Filter_kt__xu8pbc();
  return inp.t9q(getBorder(_this__u8e3s4, toIntCeil(inp.q9h_1), toIntCeil(inp.r9h_1)));
}
function getBorder(_this__u8e3s4, texWidth, texHeight) {
  _init_properties_Filter_kt__xu8pbc();
  return _this__u8e3s4.pkh(texWidth, texHeight);
}
function renderToTextureResultPool$delegate$lambda() {
  _init_properties_Filter_kt__xu8pbc();
  var tmp = renderToTextureResultPool$delegate$lambda$lambda;
  return Pool.ga8(tmp, VOID, renderToTextureResultPool$delegate$lambda$lambda_0);
}
function renderToTextureResultPool$delegate$lambda$lambda(it) {
  _init_properties_Filter_kt__xu8pbc();
  it.u1o();
  return Unit_instance;
}
function renderToTextureResultPool$delegate$lambda$lambda_0(it) {
  _init_properties_Filter_kt__xu8pbc();
  return new RenderToTextureResult();
}
var properties_initialized_Filter_kt_lkm0w6;
function _init_properties_Filter_kt__xu8pbc() {
  if (!properties_initialized_Filter_kt_lkm0w6) {
    properties_initialized_Filter_kt_lkm0w6 = true;
    renderToTextureResultPool$delegate = new Property(VOID, renderToTextureResultPool$delegate$lambda);
  }
}
var Companion_instance_28;
function Companion_getInstance_53() {
  if (Companion_instance_28 === VOID)
    new Companion_13();
  return Companion_instance_28;
}
function ShaderFilter$TexInfoUB$_get_u_TextureSize_$ref_p65vff() {
  return constructCallableReference((p0) => p0.lki(), 1, 0, 499);
}
function ShaderFilter$TexInfoUB$_get_u_MaxTexCoords_$ref_oxvt6w() {
  return constructCallableReference((p0) => p0.mki(), 1, 0, 500);
}
function ShaderFilter$TexInfoUB$_get_u_StdTexDerivates_$ref_k07hom() {
  return constructCallableReference((p0) => p0.nki(), 1, 0, 501);
}
function ShaderFilter$TexInfoUB$_get_u_filterScale_$ref_epvjxt() {
  return constructCallableReference((p0) => p0.oki(), 1, 0, 502);
}
var Companion_instance_29;
function Companion_getInstance_54() {
  if (Companion_instance_29 === VOID)
    new Companion_14();
  return Companion_instance_29;
}
function _get__program__9g4ap2($this) {
  var tmp0 = $this.rki_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_program', 1, tmp, ShaderFilter$BaseProgramProvider$_get__program_$ref_oxucjo(), null);
  return tmp0.k3();
}
function ShaderFilter$BaseProgramProvider$_program$delegate$lambda(this$0) {
  return () => this$0.ski(this$0.tki(), this$0.x7u());
}
function ShaderFilter$BaseProgramProvider$_get__program_$ref_oxucjo() {
  return constructCallableReference((p0) => _get__program__9g4ap2(p0), 1, 0, 503);
}
var TexInfoUB_instance;
function TexInfoUB_getInstance() {
  if (TexInfoUB_instance === VOID)
    new TexInfoUB();
  return TexInfoUB_instance;
}
var Companion_instance_30;
function Companion_getInstance_55() {
  if (Companion_instance_30 === VOID)
    new Companion_15();
  return Companion_instance_30;
}
function _restoreUniforms($this, ctx, filterScale) {
  // Inline function 'korlibs.memory.fastForEachOneBits' call
  var value = $this.gkj_1;
  var index = 0;
  while (!(value === 0)) {
    var shift = countTrailingZeroBits(value);
    index = index + shift | 0;
    if (index < 32) {
      var it = index;
      ctx.sg1_1.lem($this.fkj_1, it);
      $this.fkj_1.nem(it, null);
    }
    value = value >>> (shift + 1 | 0) | 0;
    index = index + 1 | 0;
  }
  $this.gkj_1 = 0;
}
function _updateUniforms($this, ctx, filterScale, texture, texWidth, texHeight) {
  $this.bkj_1 = Vector2D.d9m(texture.haj_1.w9z(), texture.haj_1.x9z());
  $this.dkj_1 = Vector2D.d9m(1.0 / texture.haj_1.w9z(), 1.0 / texture.haj_1.x9z());
  $this.ckj_1 = Vector2D.d9m(texWidth / texture.haj_1.w9z(), texHeight / texture.haj_1.x9z());
  var tmp0 = ctx.ieo(TexInfoUB_getInstance());
  $l$block: {
    // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
    var _unary__edvuaz = tmp0.z6x();
    tmp0.efc(_unary__edvuaz + 1 | 0);
    tmp0.ffc(tmp0.z6x() + 1 | 0);
    var blockSize = tmp0.beo_1;
    var index0 = imul(tmp0.z6x() - 1 | 0, blockSize);
    var index1 = imul(tmp0.z6x(), blockSize);
    var texBlockSize = tmp0.yen_1.wev().s2();
    var texIndex0 = imul(tmp0.z6x() - 1 | 0, texBlockSize);
    var texIndex1 = imul(tmp0.z6x(), texBlockSize);
    if (tmp0.z6x() > 0) {
      arraycopy(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
    } else {
      arrayfill(tmp0.deo_1, 0, 0, blockSize);
    }
    var tmp0_0 = tmp0.yen_1;
    var it = tmp0.eeo_1;
    it.jfc(tmp0_0.oki(), filterScale);
    it.lfc(tmp0_0.lki(), $this.bkj_1);
    it.lfc(tmp0_0.mki(), $this.ckj_1);
    it.lfc(tmp0_0.nki(), $this.dkj_1);
    if (true && tmp0.z6x() >= 1) {
      var equals = arrayequal(tmp0.deo_1, index0, tmp0.deo_1, index1, blockSize);
      if (equals) {
        var _unary__edvuaz_0 = tmp0.z6x();
        tmp0.efc(_unary__edvuaz_0 - 1 | 0);
        break $l$block;
      }
    }
  }
  $this.hkj(ctx, filterScale);
}
function get_backdropFilter(_this__u8e3s4) {
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.ihr_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0_safe_receiver.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof ViewRenderPhaseBackdropFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseBackdropFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.kkj_1;
}
function set_filterScale(_this__u8e3s4, _set____db54di) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp0 = filterScale$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_filterScale_$ref_8osghe();
  // Inline function 'korlibs.datastructure.PropertyThis.setValue' call
  var tmp4 = getPropertyCallableRef('filterScale', 1, tmp, tmp_0, _set_filterScale_$ref_isinzy());
  // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
  var value = tmp0.u9u_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = tmp0.s9u_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_filterScale(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var tmp0 = filterScale$delegate;
  var tmp = KMutableProperty1;
  var tmp_0 = _get_filterScale_$ref_8osghe();
  var tmp4 = getPropertyCallableRef('filterScale', 1, tmp, tmp_0, _set_filterScale_$ref_isinzy());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var tmp0_elvis_lhs = tmp0.s9u_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? tmp4.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = tmp0.t9u_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = tmp0.s9u_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? tmp4.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var filterScale$delegate;
function renderFiltered(_this__u8e3s4, ctx, filter, first) {
  first = first === VOID ? true : first;
  _init_properties_ViewFilter_kt__pd9xp9();
  var bounds = _this__u8e3s4.ihy(VOID, false);
  if (bounds.q9h_1 <= 0.0 || bounds.r9h_1 <= 0.0)
    return Unit_instance;
  var tmp = Companion_getInstance_52();
  var tmp0 = get_filterScale(_this__u8e3s4);
  // Inline function 'kotlin.math.min' call
  var b = filter.okh();
  var tmp$ret$0 = Math.min(tmp0, b);
  var tryFilterScale = tmp.nkh(tmp$ret$0);
  var texWidthNoBorder = coerceAtLeast(numberToInt(bounds.q9h_1 * tryFilterScale), 1);
  var texHeightNoBorder = coerceAtLeast(numberToInt(bounds.r9h_1 * tryFilterScale), 1);
  var realFilterScale = clamp_1(texWidthNoBorder / bounds.q9h_1, 0.03125, 1.0);
  var tmp_0;
  switch (false) {
    case true:
      tmp_0 = clamp(toIntCeil(1.0 / get_filterScale(_this__u8e3s4)), 1, 8);
      break;
    case false:
      tmp_0 = 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var edgeSize = tmp_0;
  var texWidth = texWidthNoBorder + imul(edgeSize, 2) | 0;
  var texHeight = texHeightNoBorder + imul(edgeSize, 2) | 0;
  var addx = -bounds.o9h_1 + edgeSize;
  var addy = -bounds.p9h_1 + edgeSize;
  // Inline function 'korlibs.korge.render.RenderContext.renderToTexture' call
  ctx.vg3();
  // Inline function 'korlibs.korge.render.RenderContext.tempAllocateFrameBuffer' call
  var rb = ctx.rgc(texWidth, texHeight, false, true, 1);
  try {
    // Inline function 'korlibs.korge.render.RenderContext.renderToFrameBuffer' call
    // Inline function 'korlibs.korge.render.RenderContext.setFrameBufferTemporally' call
    ctx.tgc(rb);
    try {
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
      var this_0 = ctx.hg2_1;
      // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
      var this_1 = this_0.qg2_1;
      if (!(this_1.lg2_1 === this_0)) {
        this_1.lg2_1 = this_0;
        this_1.vg3();
      }
      var tmp2 = AGScissor.beq(0, 0, rb.seg_1, rb.teg_1);
      $l$block_0: {
        // Inline function 'korlibs.korge.render.BatchBuilder2D.scissor' call
        var temp = this_0.og3_1;
        this_0.zg9();
        this_0.og3_1 = tmp2;
        try {
          if (true) {
            ctx.mgc(Colors_getInstance().ec3_1);
          }
          var mat = _this__u8e3s4.aih().a9m(addx, addy).v9l(realFilterScale);
          // Inline function 'korlibs.korge.render.BatchBuilder2D.setViewMatrixTemp' call
          // Inline function 'korlibs.korge.render.RenderContext.setViewMatrixTemp' call
          var this_2 = ctx.hg2_1.qg2_1;
          this_2.vg3();
          var temp4 = this_2.wg1_1;
          var temp2d = this_2.xg1_1;
          this_2.xg1_1 = mat;
          this_2.wg1_1 = toMatrix4(mat);
          var tmp0_0 = this_2.ieo(ProjViewUB_getInstance());
          $l$block: {
            // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
            var _unary__edvuaz = tmp0_0.z6x();
            tmp0_0.efc(_unary__edvuaz + 1 | 0);
            tmp0_0.ffc(tmp0_0.z6x() + 1 | 0);
            var blockSize = tmp0_0.beo_1;
            var index0 = imul(tmp0_0.z6x() - 1 | 0, blockSize);
            var index1 = imul(tmp0_0.z6x(), blockSize);
            var texBlockSize = tmp0_0.yen_1.wev().s2();
            var texIndex0 = imul(tmp0_0.z6x() - 1 | 0, texBlockSize);
            var texIndex1 = imul(tmp0_0.z6x(), texBlockSize);
            if (tmp0_0.z6x() > 0) {
              arraycopy(tmp0_0.deo_1, index0, tmp0_0.deo_1, index1, blockSize);
            } else {
              arrayfill(tmp0_0.deo_1, 0, 0, blockSize);
            }
            var tmp0_1 = tmp0_0.yen_1;
            tmp0_0.eeo_1.rfc(tmp0_1.kev(), this_2.wg1_1);
            if (true && tmp0_0.z6x() >= 1) {
              var equals = arrayequal(tmp0_0.deo_1, index0, tmp0_0.deo_1, index1, blockSize);
              if (equals) {
                var _unary__edvuaz_0 = tmp0_0.z6x();
                tmp0_0.efc(_unary__edvuaz_0 - 1 | 0);
                break $l$block;
              }
            }
          }
          try {
            if (first) {
              _this__u8e3s4.kih(ctx);
            } else {
              _this__u8e3s4.lih(ctx);
            }
          }finally {
            this_2.vg3();
            this_2.wg1_1 = temp4;
            this_2.xg1_1 = temp2d;
            this_2.ieo(ProjViewUB_getInstance()).gfc();
          }
          break $l$block_0;
        }finally {
          this_0.zg9();
          this_0.og3_1 = temp;
        }
      }
    }finally {
      ctx.ugc();
    }
    var texture = Texture_0(rb).yak(0, 0, texWidth, texHeight);
    var mat_0 = _this__u8e3s4.khy().e9m(-addx, -addy).x9l(1.0 / realFilterScale);
    filter.qkh(ctx, mat_0, texture, texWidth, texHeight, _this__u8e3s4.dih(), _this__u8e3s4.chq_1, realFilterScale);
    ctx.vg3();
  }finally {
    ctx.sgc(rb);
  }
}
function set_filter(_this__u8e3s4, value) {
  _init_properties_ViewFilter_kt__pd9xp9();
  var enabled = !(value == null);
  if (enabled) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'korlibs.korge.view.View.getOrCreateAndAddRenderPhase' call
      // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
      var tmp0_safe_receiver = _this__u8e3s4.ihr_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0_safe_receiver.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (element instanceof ViewRenderPhaseFilter) {
              tmp$ret$2 = element;
              break $l$block;
            }
          }
          tmp$ret$2 = null;
        }
        tmp = tmp$ret$2;
      }
      var tmp_0 = tmp;
      var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp$ret$0 = tmp0_safe_receiver_0;
        break $l$block_0;
      }
      // Inline function 'kotlin.also' call
      var this_0 = new ViewRenderPhaseFilter(value);
      _this__u8e3s4.jih(this_0);
      tmp$ret$0 = this_0;
    }
    tmp$ret$0.lkj_1 = value;
  } else {
    // Inline function 'korlibs.korge.view.View.removeRenderPhaseOfType' call
    var tmp0_safe_receiver_1 = _this__u8e3s4.ihr_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      removeAll(tmp0_safe_receiver_1, _set_filter_$lambda_rgmh04);
    }
  }
  _this__u8e3s4.lie();
}
function get_filter(_this__u8e3s4) {
  _init_properties_ViewFilter_kt__pd9xp9();
  // Inline function 'korlibs.korge.view.View.getRenderPhaseOfTypeOrNull' call
  var tmp0_safe_receiver = _this__u8e3s4.ihr_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0_safe_receiver.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (element instanceof ViewRenderPhaseFilter) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp = tmp$ret$1;
  }
  var tmp_0 = tmp;
  var tmp0_safe_receiver_0 = (tmp_0 == null ? true : tmp_0 instanceof ViewRenderPhaseFilter) ? tmp_0 : null;
  return tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.lkj_1;
}
var Companion_instance_31;
function Companion_getInstance_56() {
  return Companion_instance_31;
}
function filterScale$delegate$lambda($this$extraPropertyThis, it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return Companion_getInstance_52().nkh(it);
}
function filterScale$delegate$lambda_0($this$extraPropertyThis) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return 1.0;
}
function _get_filterScale_$ref_8osghe() {
  return constructCallableReference((p0) => get_filterScale(p0), 1, 0, 504);
}
function _set_filterScale_$ref_isinzy() {
  return constructCallableReference((p0, p1) => {
    set_filterScale(p0, p1);
    return Unit_instance;
  }, 2, 0, 505);
}
function _set_filter_$lambda_rgmh04(it) {
  _init_properties_ViewFilter_kt__pd9xp9();
  return it instanceof ViewRenderPhaseFilter;
}
var properties_initialized_ViewFilter_kt_mku9up;
function _init_properties_ViewFilter_kt__pd9xp9() {
  if (!properties_initialized_ViewFilter_kt_mku9up) {
    properties_initialized_ViewFilter_kt_mku9up = true;
    var tmp1 = filterScale$delegate$lambda;
    // Inline function 'korlibs.datastructure.extraPropertyThis' call
    var default_0 = filterScale$delegate$lambda_0;
    // Inline function 'korlibs.datastructure.PropertyThis.withTransform' call
    var this_0 = new PropertyThis(null, default_0);
    this_0.u9u_1 = tmp1;
    filterScale$delegate = this_0;
  }
}
function _get_shapeBounds__actvvf($this) {
  var valid = $this.qk3_1 ? $this.bk4_1 : $this.ak4_1;
  if (!valid) {
    if ($this.qk3_1)
      $this.bk4_1 = true;
    else
      $this.ak4_1 = true;
    var result = $this.yk3_1.zdr($this.qk3_1);
    if ($this.qk3_1)
      $this.ek4_1 = result;
    else
      $this.dk4_1 = result;
    return result;
  }
  return $this.qk3_1 ? $this.ek4_1 : $this.dk4_1;
}
function invalidateShape($this) {
  $this.ck4_1 = 0;
  $this.zk3_1 = false;
  $this.ak4_1 = false;
  $this.bk4_1 = false;
  $this.hie();
}
function requireShape($this) {
  if ($this.zk3_1)
    return Unit_instance;
  $this.zk3_1 = true;
  $this.rk3_1.a5();
  $this.rk3_1.xkj();
  $this.rk3_1.ykj(Companion_getInstance_15().mej_1);
  $this.fk4_1 = true;
  renderShape($this, $this.yk3_1);
  $this.rk3_1.v7e();
  $this.hk4_1 = $this.gk4_1;
}
function renderCommands($this, ctx, doRequireTexture) {
  var mat = doRequireTexture ? $this.khy().j9l(get_immutable(ctx.kg1_1.zga())) : $this.khy();
  $this.ik4_1 = mat.c9m(-$this.fif(), -$this.gif());
  requireShape($this);
  $this.rk3_1.zkj(ctx, $this.ik4_1, $this.zig(), $this.vk3_1, $this.dih(), doRequireTexture);
}
function renderShape($this, shape) {
  if (!equals(shape, EmptyShape_instance)) {
    if (shape instanceof CompoundShape) {
      var _iterator__ex2g4s = shape.ads_1.p1();
      while (_iterator__ex2g4s.q1()) {
        var v = _iterator__ex2g4s.r1();
        renderShape($this, v);
      }
    } else {
      if (shape instanceof TextShape) {
        renderShape($this, shape.cds());
      } else {
        if (shape instanceof FillShape) {
          $this.ck4_1 = $this.ck4_1 + 1 | 0;
          if ($this.ck4_1 > $this.jk4_1)
            return Unit_instance;
          renderFill($this, shape);
        } else {
          if (shape instanceof PolylineShape) {
            $this.ck4_1 = $this.ck4_1 + 1 | 0;
            if ($this.ck4_1 > $this.jk4_1)
              return Unit_instance;
            renderStroke($this, shape.sds_1, shape.pds_1, shape.rds_1, shape.uds_1, shape.tds_1);
          } else {
            // Inline function 'kotlin.TODO' call
            var reason = 'shape=' + toString(shape);
            throw NotImplementedError.le('An operation is not implemented: ' + reason);
          }
        }
      }
    }
  }
}
function renderStroke($this, stateTransform, strokePath, paint, globalAlpha, strokeInfo, forceClosed, stencilOpFunc, stencilRef) {
  forceClosed = forceClosed === VOID ? null : forceClosed;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_18().aej_1 : stencilOpFunc;
  stencilRef = stencilRef === VOID ? Companion_getInstance_19().yei_1 : stencilRef;
  var gpuShapeViewCommands = $this.rk3_1;
  var pointsList = toStrokePointsList(toCurvesList(strokePath), strokeInfo, StrokePointsMode_SCALABLE_POS_NORMAL_WIDTH_getInstance(), VOID, forceClosed);
  gpuShapeViewCommands.ykj(Companion_getInstance_15().mej_1);
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pointsList.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var points = pointsList.u2(_unary__edvuaz);
    var startIndex = gpuShapeViewCommands.akk();
    var vector = points.gac();
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var inductionVariable = 0;
    var last = vector.s2();
    if (inductionVariable < last)
      do {
        var n_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = vector.p9j(n_0, 0);
        var y = vector.p9j(n_0, 1);
        var dx = vector.p9j(n_0, 2);
        var dy = vector.p9j(n_0, 3);
        var len = vector.p9j(n_0, 4);
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = vector.p9j(n_0, 5);
        var maxLen = Math.abs(this_0);
        var px = x + dx * len;
        var py = y + dy * len;
        gpuShapeViewCommands.bkk(px, py, $this.xk3_1 ? len : 0.0, $this.xk3_1 ? maxLen : $this.lk4_1);
      }
       while (inductionVariable < last);
    var endIndex = gpuShapeViewCommands.ckk();
    var info = GpuShapeViewPrograms_getInstance().vkk(stateTransform, paint, globalAlpha, strokeInfo.pab_1);
    var tmp0_drawType = Companion_getInstance_14().ner_1;
    var tmp1_blendMode = Companion_getInstance_13().og0_1;
    gpuShapeViewCommands.wkk(tmp0_drawType, info, VOID, stencilOpFunc, stencilRef, tmp1_blendMode, VOID, startIndex, endIndex);
  }
}
function getPointsForPath($this, points, type) {
  if (points.s2() < 3)
    return null;
  var vertexStart = $this.rk3_1.akk();
  var bb = BoundsBuilder__plus_impl_cz7f7x_1(Companion_getInstance_32().e9i(), points);
  var xMid = (_BoundsBuilder___get_xmax__impl__gsz0km(bb) + _BoundsBuilder___get_xmin__impl__o2sib0(bb)) / 2;
  var yMid = (_BoundsBuilder___get_ymax__impl__oia4uz(bb) + _BoundsBuilder___get_ymin__impl__5n2e8j(bb)) / 2;
  var pMid = Vector2D.t9g(xMid, yMid);
  var isStrip = type === Companion_getInstance_14().ner_1;
  var antialiased = $this.xk3_1;
  var isStripAndAntialiased = antialiased && isStrip;
  if (!isStrip) {
    $this.rk3_1.bkk(xMid, yMid, 0.0, $this.lk4_1);
  }
  var inductionVariable = 0;
  var last = points.s2() + 1 | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = points.u2(n % points.s2() | 0);
      var x = p.jm();
      var y = p.km();
      var len = isStripAndAntialiased ? Companion_getInstance_29().z9s(p, pMid) : 0.0;
      var maxLen = isStripAndAntialiased ? len : $this.lk4_1;
      if (isStrip) {
        $this.rk3_1.bkk(xMid, yMid, 0.0, maxLen);
      }
      $this.rk3_1.bkk(x, y, len, maxLen);
    }
     while (inductionVariable < last);
  var vertexEnd = $this.rk3_1.ckk();
  return new PointsResult(toAGScissor(_BoundsBuilder___get_bounds__impl__s1l1gx(bb)), points.s2() + 2 | 0, vertexStart, vertexEnd);
}
function getPointsForPath_0($this, path, type) {
  return getPointsForPath($this, get_cachedPoints(path), type);
}
function getPointsForPathList($this, path, type) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = getPoints2List(path);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList.p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_safe_receiver = getPointsForPath($this, element, type);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.d2(tmp0_safe_receiver);
    }
  }
  return destination;
}
function renderFill($this, shape) {
  var tmp0_elvis_lhs = GpuShapeViewPrograms_getInstance().vkk(shape.gds_1, shape.fds_1, shape.hds_1, 1.0E7);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paintShader = tmp;
  var drawFill = !$this.kk4_1;
  var drawAntialiasingBorder = $this.kk4_1 ? true : $this.xk3_1;
  var shapeIsConvex = shape.nds();
  var isSimpleDraw = shapeIsConvex && shape.eds_1 == null && !$this.kk4_1;
  var pathDataList = getPointsForPathList($this, shape.dds_1, isSimpleDraw ? Companion_getInstance_14().ner_1 : Companion_getInstance_14().oer_1);
  // Inline function 'kotlin.run' call
  var bb = Companion_getInstance_32().e9i();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < pathDataList.s2()) {
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = pathDataList.u2(_unary__edvuaz);
    bb = plus(bb, it.xkk_1);
  }
  var pathBoundsNoExpanded = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  var pathBounds = toAGScissor(pathBoundsNoExpanded.t9q(MarginInt.t9k(2)));
  var clipDataStart = $this.rk3_1.akk();
  var tmp1_safe_receiver = shape.eds_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = getPointsForPath_0($this, tmp1_safe_receiver, Companion_getInstance_14().oer_1);
  }
  var clipData = tmp_0;
  var clipDataEnd = $this.rk3_1.ckk();
  var tmp3_elvis_lhs = clipData == null ? null : clipData.xkk_1;
  var clipBounds = tmp3_elvis_lhs == null ? Companion_getInstance_15().mej_1 : tmp3_elvis_lhs;
  if (!isSimpleDraw || $this.fk4_1) {
    $this.fk4_1 = true;
    $this.rk3_1.ykj(isSimpleDraw ? Companion_getInstance_15().mej_1 : !clipBounds.equals(Companion_getInstance_15().mej_1) ? Companion_getInstance_15().geq(pathBounds, clipBounds) : pathBounds);
  }
  if (isSimpleDraw) {
    $this.fk4_1 = false;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < pathDataList.s2()) {
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var pathData = pathDataList.u2(_unary__edvuaz_0);
      var tmp0_$this = $this.rk3_1;
      var tmp1_drawType = Companion_getInstance_14().ner_1;
      var tmp2_startIndex = pathData.zkk_1;
      var tmp3_endIndex = pathData.akl_1;
      var tmp4_colorMask = _AGColorMask___init__impl__j38ai8(true);
      var tmp5_blendMode = $this.cih();
      tmp0_$this.wkk(tmp1_drawType, paintShader, tmp4_colorMask, VOID, VOID, tmp5_blendMode, VOID, tmp2_startIndex, tmp3_endIndex);
    }
    return Unit_instance;
  }
  var winding = shape.dds_1.pah_1;
  var stencilReferenceValue = 1;
  var stencilCompare = Companion_getInstance_20().leq_1;
  if (drawFill) {
    switch (winding.w1_1) {
      case 0:
        stencilReferenceValue = 1;
        stencilCompare = Companion_getInstance_20().leq_1;
        var stencilOpFunc = AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), Companion_getInstance_20().keq_1), Companion_getInstance_21().weq_1);
        var stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().yei_1, 1);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_1 = 0;
        while (n_1 < pathDataList.s2()) {
          var _unary__edvuaz_1 = n_1;
          n_1 = _unary__edvuaz_1 + 1 | 0;
          var pathData_0 = pathDataList.u2(_unary__edvuaz_1);
          writeStencil($this, pathData_0.zkk_1, pathData_0.akl_1, stencilOpFunc, stencilRef, Companion_getInstance_22().oej_1);
        }

        break;
      case 1:
        stencilReferenceValue = 0;
        stencilCompare = Companion_getInstance_20().req_1;
        var stencilOpFunc_0 = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), Companion_getInstance_20().keq_1);
        var stencilRef_0 = AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().yei_1, 255);
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var n_2 = 0;
        while (n_2 < pathDataList.s2()) {
          var _unary__edvuaz_2 = n_2;
          n_2 = _unary__edvuaz_2 + 1 | 0;
          var pathData_1 = pathDataList.u2(_unary__edvuaz_2);
          writeStencil($this, pathData_1.zkk_1, pathData_1.akl_1, AGStencilOpFunc__withActionOnBothPass_impl_qbn6at(stencilOpFunc_0, Companion_getInstance_21().veq_1, Companion_getInstance_21().teq_1), stencilRef_0, Companion_getInstance_22().oej_1);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    if (!(clipData == null)) {
      if (winding.equals(Winding_NON_ZERO_getInstance())) {
        writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), Companion_getInstance_20().req_1), Companion_getInstance_21().weq_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(Companion_getInstance_19().yei_1, 0), 255), Companion_getInstance_22().pej_1);
      }
      writeStencil($this, clipDataStart, clipDataEnd, AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), Companion_getInstance_20().keq_1), Companion_getInstance_21().weq_1), AGStencilReference__withWriteMask$default_impl_b7j7b4(Companion_getInstance_19().yei_1, 2), Companion_getInstance_22().rej_1);
      stencilReferenceValue = 3;
    }
  }
  if (drawAntialiasingBorder && shape.eds_1 == null) {
    renderStroke($this, shape.gds_1, shape.dds_1, shape.fds_1, shape.hds_1, new StrokeInfo(1.6 / $this.gk4_1, VOID, LineScaleMode_NONE_getInstance(), LineCap_BUTT_getInstance(), LineCap_BUTT_getInstance(), LineJoin_MITER_getInstance(), 5.0), true, !drawFill ? Companion_getInstance_18().aej_1 : AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), AGCompareMode__inverted_impl_7xxk8m(stencilCompare)), AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().yei_1, stencilReferenceValue), 0));
  }
  if (drawFill) {
    writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare);
    $this.rk3_1.yf7(0);
  }
}
function writeStencil($this, pathDataStart, pathDataEnd, stencilOpFunc, stencilRef, cullFace) {
  var tmp0_$this = $this.rk3_1;
  var tmp1_drawType = Companion_getInstance_14().oer_1;
  var tmp2_paintShader = GpuShapeViewPrograms_getInstance().ukk_1;
  var tmp3_colorMask = _AGColorMask___init__impl__j38ai8_0(false, false, false, false);
  var tmp4_blendMode = Companion_getInstance_13().qg0_1;
  tmp0_$this.bkl(tmp1_drawType, tmp2_paintShader, tmp3_colorMask, stencilOpFunc, stencilRef, tmp4_blendMode, cullFace, pathDataStart, pathDataEnd);
}
function writeFill($this, paintShader, stencilReferenceValue, pathBounds, pathDataList, stencilCompare) {
  var vstart = $this.rk3_1.akk();
  var x0 = pathBounds.v9h();
  var y0 = pathBounds.x9h();
  var x1 = pathBounds.w9h();
  var y1 = pathBounds.y9h();
  $this.rk3_1.bkk(x0, y0, 0.0, $this.lk4_1);
  $this.rk3_1.bkk(x1, y0, 0.0, $this.lk4_1);
  $this.rk3_1.bkk(x1, y1, 0.0, $this.lk4_1);
  $this.rk3_1.bkk(x0, y1, 0.0, $this.lk4_1);
  var vend = $this.rk3_1.ckk();
  var tmp0_$this = $this.rk3_1;
  var tmp1_drawType = Companion_getInstance_14().oer_1;
  var tmp2_colorMask = _AGColorMask___init__impl__j38ai8(true);
  var tmp3_stencilOpFunc = AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(Companion_getInstance_18().aej_1, true), stencilCompare);
  var tmp4_stencilRef = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReferenceValue$default_impl_2trj0v(Companion_getInstance_19().yei_1, stencilReferenceValue), 0);
  var tmp5_blendMode = $this.cih();
  tmp0_$this.wkk(tmp1_drawType, paintShader, tmp2_colorMask, tmp3_stencilOpFunc, tmp4_stencilRef, tmp5_blendMode, VOID, vstart, vend);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_ProgramType_$ref_gtfuu8() {
  return constructCallableReference((p0) => p0.gkm(), 1, 0, 506);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_Color_$ref_m1fq11() {
  return constructCallableReference((p0) => p0.hkm(), 1, 0, 507);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_ColorMul_$ref_2t2a63() {
  return constructCallableReference((p0) => p0.fkm(), 1, 0, 508);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalAlpha_$ref_ww8199() {
  return constructCallableReference((p0) => p0.ikm(), 1, 0, 509);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_GlobalPixelScale_$ref_gal705() {
  return constructCallableReference((p0) => p0.ekm(), 1, 0, 510);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_Transform_$ref_nvbejy() {
  return constructCallableReference((p0) => p0.jkm(), 1, 0, 511);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp0_$ref_kf5l2s() {
  return constructCallableReference((p0) => p0.kkm(), 1, 0, 512);
}
function GpuShapeViewPrograms$ShapeViewUB$_get_u_Gradientp1_$ref_jy3yol() {
  return constructCallableReference((p0) => p0.lkm(), 1, 0, 513);
}
var ShapeViewUB_instance;
function ShapeViewUB_getInstance() {
  if (ShapeViewUB_instance === VOID)
    new ShapeViewUB();
  return ShapeViewUB_instance;
}
function GpuShapeViewPrograms$PROGRAM_COMBINED$lambda($$this$FragmentShaderDefault) {
  return ($this$IF_ELSE_LIST, it) => {
    var tmp;
    switch (it) {
      case 0:
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.mey(), GpuShapeViewPrograms_getInstance().hkm());
        tmp = Unit_instance;
        break;
      case 1:
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.mey(), $this$IF_ELSE_LIST.tey($$this$FragmentShaderDefault.iew(), $this$IF_ELSE_LIST.df0($this$IF_ELSE_LIST.lf0([$this$IF_ELSE_LIST.sey($this$IF_ELSE_LIST.ney(GpuShapeViewPrograms_getInstance().jkm(), $this$IF_ELSE_LIST.qey([$$this$FragmentShaderDefault.fey(), $this$IF_ELSE_LIST.pey(0.0), $this$IF_ELSE_LIST.pey(1.0)])), 'xy')]))));
        tmp = Unit_instance;
        break;
      case 2:
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.mey(), $this$IF_ELSE_LIST.tey($$this$FragmentShaderDefault.iew(), $this$IF_ELSE_LIST.sey($this$IF_ELSE_LIST.ney(GpuShapeViewPrograms_getInstance().jkm(), $this$IF_ELSE_LIST.qey([$this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.pey(0.0), $this$IF_ELSE_LIST.pey(1.0)])), 'xy')));
        tmp = Unit_instance;
        break;
      case 3:
        var rpoint = $this$IF_ELSE_LIST.wez(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.sey(rpoint, 'xy'), $this$IF_ELSE_LIST.sey($this$IF_ELSE_LIST.ney(GpuShapeViewPrograms_getInstance().jkm(), $this$IF_ELSE_LIST.qey([$this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.pey(0.0), $this$IF_ELSE_LIST.pey(1.0)])), 'xy'));
        var x = $this$IF_ELSE_LIST.pf0(rpoint);
        var y = $this$IF_ELSE_LIST.qf0(rpoint);
        var x0 = $this$IF_ELSE_LIST.pf0(GpuShapeViewPrograms_getInstance().kkm());
        var y0 = $this$IF_ELSE_LIST.qf0(GpuShapeViewPrograms_getInstance().kkm());
        var r0 = $this$IF_ELSE_LIST.rf0(GpuShapeViewPrograms_getInstance().kkm());
        var x1 = $this$IF_ELSE_LIST.pf0(GpuShapeViewPrograms_getInstance().lkm());
        var y1 = $this$IF_ELSE_LIST.qf0(GpuShapeViewPrograms_getInstance().lkm());
        var r1 = $this$IF_ELSE_LIST.rf0(GpuShapeViewPrograms_getInstance().lkm());
        var ratio = $this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.vey());
        var r0r1_2 = $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.vey());
        var r0pow2 = $this$IF_ELSE_LIST.rf0($$this$FragmentShaderDefault.vey());
        var r1pow2 = $this$IF_ELSE_LIST.sf0($$this$FragmentShaderDefault.vey());
        var y0_y1 = $this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.hf1());
        var x0_x1 = $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.hf1());
        var r0_r1 = $this$IF_ELSE_LIST.rf0($$this$FragmentShaderDefault.hf1());
        var radial_scale = $this$IF_ELSE_LIST.sf0($$this$FragmentShaderDefault.hf1());
        $this$IF_ELSE_LIST.jey(r0r1_2, $this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.pey(2.0), r0), r1));
        $this$IF_ELSE_LIST.jey(r0pow2, GpuShapeViewPrograms_getInstance().mkm(r0));
        $this$IF_ELSE_LIST.jey(r1pow2, GpuShapeViewPrograms_getInstance().mkm(r1));
        $this$IF_ELSE_LIST.jey(x0_x1, $this$IF_ELSE_LIST.uf0(x0, x1));
        $this$IF_ELSE_LIST.jey(y0_y1, $this$IF_ELSE_LIST.uf0(y0, y1));
        $this$IF_ELSE_LIST.jey(r0_r1, $this$IF_ELSE_LIST.uf0(r0, r1));
        $this$IF_ELSE_LIST.jey(radial_scale, $this$IF_ELSE_LIST.wey($this$IF_ELSE_LIST.pey(1.0), $this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.uf0(GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(r0, r1)), GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(x0, x1))), GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(y0, y1)))));
        $this$IF_ELSE_LIST.jey(ratio, $this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.pey(1.0), $this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.tf0(r1), r0_r1), $this$IF_ELSE_LIST.ney(x0_x1, $this$IF_ELSE_LIST.uf0(x1, x))), $this$IF_ELSE_LIST.ney(y0_y1, $this$IF_ELSE_LIST.uf0(y1, y))), $this$IF_ELSE_LIST.bf0($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.ney(r1pow2, $this$IF_ELSE_LIST.xf0(GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(x0, x)), GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(y0, y)))), $this$IF_ELSE_LIST.ney(r0r1_2, $this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.uf0(x0, x), $this$IF_ELSE_LIST.uf0(x1, x)), $this$IF_ELSE_LIST.ney($this$IF_ELSE_LIST.uf0(y0, y), $this$IF_ELSE_LIST.uf0(y1, y))))), $this$IF_ELSE_LIST.ney(r0pow2, $this$IF_ELSE_LIST.xf0(GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(x1, x)), GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0(y1, y))))), GpuShapeViewPrograms_getInstance().mkm($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.xf0($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.uf0($this$IF_ELSE_LIST.ney(x1, y0), $this$IF_ELSE_LIST.ney(x, y0)), $this$IF_ELSE_LIST.ney(x0, y1)), $this$IF_ELSE_LIST.ney(x, y1)), $this$IF_ELSE_LIST.ney(x0, y)), $this$IF_ELSE_LIST.ney(x1, y)))))), radial_scale)));
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.mey(), $this$IF_ELSE_LIST.tey($$this$FragmentShaderDefault.iew(), $this$IF_ELSE_LIST.lf0([ratio, $this$IF_ELSE_LIST.pey(0.0)])));
        tmp = Unit_instance;
        break;
      case 4:
        var rpoint_0 = $this$IF_ELSE_LIST.wez(VarType_Float2_getInstance());
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.sey(rpoint_0, 'xy'), $this$IF_ELSE_LIST.sey($this$IF_ELSE_LIST.ney(GpuShapeViewPrograms_getInstance().jkm(), $this$IF_ELSE_LIST.qey([$this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.fey()), $this$IF_ELSE_LIST.pey(0.0), $this$IF_ELSE_LIST.pey(1.0)])), 'xy'));
        var x_0 = $this$IF_ELSE_LIST.pf0(rpoint_0);
        var y_0 = $this$IF_ELSE_LIST.qf0(rpoint_0);
        var ratio_0 = $this$IF_ELSE_LIST.pf0($$this$FragmentShaderDefault.vey());
        var angle = $this$IF_ELSE_LIST.qf0($$this$FragmentShaderDefault.vey());
        var x0_0 = $this$IF_ELSE_LIST.pf0(GpuShapeViewPrograms_getInstance().kkm());
        var y0_0 = $this$IF_ELSE_LIST.qf0(GpuShapeViewPrograms_getInstance().kkm());
        var PI2 = $this$IF_ELSE_LIST.pey(3.141592653589793 * 2);
        $this$IF_ELSE_LIST.jey(angle, $this$IF_ELSE_LIST.yez($this$IF_ELSE_LIST.uf0(y_0, y0_0), $this$IF_ELSE_LIST.uf0(x_0, x0_0)));
        // Inline function 'korlibs.graphics.shader.Builder.IF' call

        var cond = $this$IF_ELSE_LIST.ef1(angle, $this$IF_ELSE_LIST.pey(0.0));
        var body = $this$IF_ELSE_LIST.yey();
        body.jey(angle, body.xf0(angle, PI2));
        var stmIf = new If(cond, body.aez());
        // Inline function 'kotlin.collections.plusAssign' call

        $this$IF_ELSE_LIST.iey_1.d2(stmIf);
        $this$IF_ELSE_LIST.jey(ratio_0, $this$IF_ELSE_LIST.wey(angle, PI2));
        $this$IF_ELSE_LIST.jey($this$IF_ELSE_LIST.mey(), $this$IF_ELSE_LIST.tey($$this$FragmentShaderDefault.iew(), $this$IF_ELSE_LIST.df0($this$IF_ELSE_LIST.lf0([ratio_0, $this$IF_ELSE_LIST.pey(0.0)]))));
        tmp = Unit_instance;
        break;
    }
    return Unit_instance;
  };
}
var GpuShapeViewPrograms_instance;
function GpuShapeViewPrograms_getInstance() {
  if (GpuShapeViewPrograms_instance === VOID)
    new GpuShapeViewPrograms();
  return GpuShapeViewPrograms_instance;
}
function beforeStartingKorge(config) {
}
function completeViews(views) {
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Korge, 'Korge', Korge, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(KorgeDisplayMode, 'KorgeDisplayMode');
initMetadataForObject(KorgeRunner, 'KorgeRunner', VOID, VOID, VOID, [1]);
initMetadataForClass(ViewStageComponent, 'ViewStageComponent');
initMetadataForClass(KeysEvents, 'KeysEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragInfo, 'MouseDragInfo');
initMetadataForClass(OnMouseDragCloseable, 'OnMouseDragCloseable', VOID, VOID, [AutoCloseable]);
initMetadataForClass(MouseDragState, 'MouseDragState');
initMetadataForCompanion(Companion_1);
initMetadataForClass(MouseEventsUpdate, 'MouseEventsUpdate');
initMetadataForClass(MouseEvents, 'MouseEvents', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SceneCancellationException, 'SceneCancellationException');
initMetadataForClass(Scene, 'Scene', VOID, VOID, [InjectorDependency], [1, 0]);
initMetadataForClass(EmptyScene, 'EmptyScene', EmptyScene, VOID, VOID, [1, 0]);
initMetadataForClass(VisitEntry, 'VisitEntry');
initMetadataForCompanion(Companion_2);
initMetadataForClass(BaseView, 'BaseView', BaseView.xjj);
initMetadataForClass(View, 'View');
initMetadataForClass(Container, 'Container', Container.fi2);
initMetadataForClass(CachedContainer, 'CachedContainer', CachedContainer.yjj);
initMetadataForClass(FixedSizeCachedContainer, 'FixedSizeCachedContainer', FixedSizeCachedContainer.hjb);
initMetadataForClass(UIView, 'UIView', UIView.ti8);
initMetadataForClass(SceneContainer, 'SceneContainer', VOID, VOID, VOID, [2, 4, 6, 3]);
initMetadataForInterface(TransitionProcess, 'TransitionProcess');
initMetadataForClass(TransitionView, 'TransitionView', TransitionView.fib);
protoOf(Transition$1).iii = start;
protoOf(Transition$1).jii = end;
initMetadataForClass(Transition$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1$create$1, VOID, VOID, VOID, [TransitionProcess]);
initMetadataForClass(withEasing$1);
initMetadataForClass(ViewStyles, 'ViewStyles');
initMetadataForClass(ViewStyle, 'ViewStyle');
initMetadataForInterface(StyleableView, 'StyleableView');
initMetadataForObject(MsdfRender, 'MsdfRender');
initMetadataForClass(TextSnapshot, 'TextSnapshot');
initMetadataForInterface(UIFocusable, 'UIFocusable');
initMetadataForClass(TextEditController, 'TextEditController', VOID, VOID, [AutoCloseable, UIFocusable, ISoftKeyboardConfig]);
initMetadataForClass(TimerComponents, 'TimerComponents', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(TimerRef, 'TimerRef');
initMetadataForClass(TweenComponent, 'TweenComponent');
initMetadataForObject(Scope, 'Scope');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(UIFocusManager, 'UIFocusManager');
initMetadataForClass(UIObservable, 'UIObservable');
initMetadataForClass(UIScrollable, 'UIScrollable');
initMetadataForInterface(ViewRenderer, 'ViewRenderer');
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForClass(UITextInput, 'UITextInput', UITextInput.kj3, VOID, [ISoftKeyboardConfig]);
initMetadataForClass(sam$korlibs_korge_view_ViewRenderer$0_0, 'sam$korlibs_korge_view_ViewRenderer$0', VOID, VOID, [ViewRenderer, FunctionAdapter]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(Anchorable, 'Anchorable');
initMetadataForClass(InternalViewAutoscaling, 'InternalViewAutoscaling', InternalViewAutoscaling);
initMetadataForClass(RectBase, 'RectBase', RectBase.ljw, VOID, [Anchorable]);
initMetadataForClass(BaseImage, 'BaseImage');
initMetadataForClass(BaseGraphics, 'BaseGraphics');
initMetadataForClass(CacheTexture, 'CacheTexture', VOID, VOID, [AutoCloseable]);
initMetadataForClass(ShapeView, 'ShapeView', ShapeView.bjq, VOID, [Anchorable]);
initMetadataForClass(Circle_0, 'Circle', Circle_0.ajq);
initMetadataForClass(FixedSizeContainer, 'FixedSizeContainer', FixedSizeContainer.pjs);
initMetadataForClass(ClipContainer, 'ClipContainer', ClipContainer.xj5);
initMetadataForObject(ZIndexComparator, 'ZIndexComparator', VOID, VOID, [Comparator]);
initMetadataForClass(ContainerCollection$iterator$1);
initMetadataForClass(ContainerCollection, 'ContainerCollection', VOID, VOID, [Collection, MutableIterable, KtList]);
initMetadataForClass(CpuGraphics, 'CpuGraphics', CpuGraphics.ijw);
initMetadataForClass(CustomContextRenderizableView, 'CustomContextRenderizableView');
initMetadataForClass(DummyView, 'DummyView', DummyView.njy);
initMetadataForCompanion(Companion_4);
initMetadataForClass(SContainer, 'SContainer', SContainer.si4);
initMetadataForClass(TimeSlidingWindow, 'TimeSlidingWindow');
initMetadataForClass(GraphicsRenderer, 'GraphicsRenderer');
initMetadataForClass(Graphics, 'Graphics', Graphics.pk4, VOID, [Anchorable]);
initMetadataForInterface(ViewFileRef, 'ViewFileRef', VOID, VOID, VOID, [4, 3]);
protoOf(Image).pk7 = forceLoadSourceFile$default;
initMetadataForClass(Image, 'Image', VOID, VOID, [ViewFileRef], [3, 4]);
initMetadataForClass(RenderableView, 'RenderableView');
initMetadataForClass(RoundRect, 'RoundRect');
initMetadataForClass(CoordsType, 'CoordsType');
initMetadataForCompanion(Companion_5);
initMetadataForClass(ShadedView, 'ShadedView');
initMetadataForCompanion(Companion_6);
initMetadataForClass(SolidRect, 'SolidRect');
initMetadataForClass(Stage, 'Stage', VOID, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_7);
initMetadataForInterface(IText, 'IText');
initMetadataForClass(Text, 'Text', VOID, VOID, [IText], [2]);
initMetadataForInterface(ColorReference, 'ColorReference');
initMetadataForCompanion(Companion_8);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(ViewRenderPhase, 'ViewRenderPhase');
protoOf(Mixin_0).pk7 = forceLoadSourceFile$default;
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0, VOID, [ViewFileRef], [4, 3]);
initMetadataForClass(Views, 'Views', VOID, VOID, [BoundsProvider, AutoCloseable, DeviceDimensionsProvider], [0]);
initMetadataForCompanion(Companion_9);
initMetadataForClass(ViewsUpdateEvent, 'ViewsUpdateEvent');
initMetadataForCompanion(Companion_10);
initMetadataForClass(ViewsResizedEvent, 'ViewsResizedEvent');
initMetadataForObject(UB, 'UB');
initMetadataForCompanion(Companion_11);
initMetadataForClass(Batch, 'Batch');
initMetadataForClass(DebugVertexView, 'DebugVertexView');
initMetadataForCompanion(Companion_12);
initMetadataForInterface(Filter, 'Filter');
initMetadataForClass(RenderToTextureResult, 'RenderToTextureResult', RenderToTextureResult, VOID, [DisposableHandle]);
protoOf(IdentityFilter).okh = get_recommendedFilterScale;
protoOf(IdentityFilter).pkh = computeBorder;
initMetadataForClass(IdentityFilter, 'IdentityFilter', VOID, VOID, [Filter]);
initMetadataForCompanion(Companion_13);
initMetadataForClass(BaseProgramProvider, 'BaseProgramProvider', BaseProgramProvider);
initMetadataForCompanion(Companion_14);
initMetadataForObject(TexInfoUB, 'TexInfoUB');
initMetadataForCompanion(Companion_15);
protoOf(ShaderFilter).okh = get_recommendedFilterScale;
initMetadataForClass(ShaderFilter, 'ShaderFilter', VOID, VOID, [Filter]);
initMetadataForClass(ViewRenderPhaseBackdropFilter, 'ViewRenderPhaseBackdropFilter', VOID, VOID, [ViewRenderPhase]);
initMetadataForCompanion(Companion_16);
protoOf(ViewRenderPhaseFilter).wkf = beforeRender;
protoOf(ViewRenderPhaseFilter).xkf = afterRender;
initMetadataForClass(ViewRenderPhaseFilter, 'ViewRenderPhaseFilter', ViewRenderPhaseFilter, VOID, [ViewRenderPhase]);
initMetadataForClass(PointsResult, 'PointsResult');
initMetadataForClass(GpuShapeView, 'GpuShapeView', GpuShapeView.mk4, VOID, [Anchorable]);
initMetadataForClass(ScissorCommand, 'ScissorCommand');
initMetadataForClass(ClearCommand, 'ClearCommand');
initMetadataForClass(ShapeCommand, 'ShapeCommand');
initMetadataForClass(GpuShapeViewCommands, 'GpuShapeViewCommands', GpuShapeViewCommands);
initMetadataForObject(ShapeViewUB, 'ShapeViewUB');
initMetadataForClass(PaintShader, 'PaintShader');
initMetadataForObject(GpuShapeViewPrograms, 'GpuShapeViewPrograms');
//endregion
//region block: init
KorgeRunner_instance = new KorgeRunner();
Companion_instance_16 = new Companion_1();
Scope_instance = new Scope();
ZIndexComparator_instance = new ZIndexComparator();
Companion_instance_19 = new Companion_4();
Companion_instance_20 = new Companion_5();
Companion_instance_21 = new Companion_6();
Companion_instance_22 = new Companion_7();
Companion_instance_23 = new Companion_8();
Companion_instance_24 = new Companion_9();
Companion_instance_25 = new Companion_10();
Companion_instance_31 = new Companion_16();
//endregion
//region block: exports
export {
  Companion_getInstance_42 as Companion_getInstance3vle38qw3uwk,
  Companion_getInstance_55 as Companion_getInstance3ur4fgjzgmjwp,
  Companion_instance_20 as Companion_instance10s1y12mqzdxm,
  Companion_instance_21 as Companion_instance8kerorzbjbkv,
  Companion_instance_22 as Companion_instancev4lanw37mf9n,
  GraphicsRenderer_GPU_getInstance as GraphicsRenderer_GPU_getInstance1cg0kq57kqo7y,
  tween as tween1evm9gy4140aa,
  renderToBitmap as renderToBitmap3m6yism7c9see,
  views as views8ixu1gnhxenz,
  Korge_0 as Korgem48lxg0vwq9x,
  set_cursor as set_cursor2bma4bfi3ugur,
  get_keys as get_keysmipauarvwdlb,
  get_mouse as get_mouse1jstwhfaumelj,
  onMouseDrag as onMouseDrag20om3ch85u2pf,
  get_AlphaTransition as get_AlphaTransition23l7sd982osvm,
  SceneContainer as SceneContainer99ijjqni12hp,
  Scene as Scenezu810y12qpqp,
  withEasing as withEasingtnol1eyyo9sf,
  UITextInput as UITextInput3hf6kt3o0p9up,
  BaseProgramProvider as BaseProgramProvider4fzf1zwbol51,
  ShaderFilter as ShaderFilter10394gibq1ewd,
  set_filter as set_filter36wgvpm5cukpc,
  Anchorable as Anchorable2p2wd2c4mob8i,
  Circle_0 as Circlepba9jsmewo4k,
  ClipContainer as ClipContainernpx31s3mxtjx,
  Container as Container7486fjmip554,
  FixedSizeContainer as FixedSizeContainersre0rworj71w,
  Image as Image1b2d7ghyim7p5,
  RoundRect as RoundRect16qm0yoxjizxs,
  SContainer as SContainerfim2zr5seafm,
  ShadedView as ShadedView18n2s98uu6wc3,
  SolidRect as SolidRect131p7hyzlx7j8,
  Text as Text3kimhvgfxflj3,
  View as View11ybmmoof9vue,
  addTo as addTo25e29vq105prw,
  addUpdater as addUpdater1la23qj9g2d42,
  anchor as anchor3c5itxst996yy,
  findFirstAscendant as findFirstAscendante8nli1jx4t64,
  position_0 as position2v5vbepn4kziz,
  position as positionu6441b7hkb4l,
  rotation as rotation29g98bv3f78wn,
  scale as scalea9fc0mbrr7ub,
  setText as setText209z1w9h7o9hy,
  size as size1ac0fubkxl72w,
  size_0 as size3ul8wgwwt88hf,
  xy_0 as xyssniz4rympby,
  xy as xy1gb51vhy014mx,
  Korge as Korge2cqygya336n5n,
};
//endregion
